module.exports = {
    BubblesData: () => {
        return [
            [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[295.833,465.745],[295.833,378.793],[229.434,467.587],[229.434,382.814]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[295.833,558.289],[295.833,471.336],[229.434,557.812],[229.434,473.038]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[295.833,561.822],[295.833,648.775],[229.434,561.257],[229.434,646.03]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[295.833,651.353],[295.833,738.305],[229.434,648.543],[229.434,733.317]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[295.833,746.174],[295.833,833.126],[229.434,740.988],[229.434,825.761]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[367.824,462.573],[367.824,371.868],[276.889,465.135],[276.889,377.461]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[367.824,559.11],[367.824,468.405],[276.889,558.447],[276.889,470.772]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[367.824,562.796],[367.824,653.501],[276.889,562.009],[276.889,649.684]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[367.824,656.191],[367.824,746.896],[276.889,652.283],[276.889,739.957]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[367.824,755.104],[367.824,845.809],[276.889,747.891],[276.889,835.565]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[367.824,462.573],[367.824,371.868],[387.302,463.248],[387.302,373.343]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[367.824,559.11],[367.824,468.405],[387.302,558.935],[387.302,469.029]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[367.824,562.796],[367.824,653.501],[387.302,562.589],[387.302,652.494]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[367.824,656.191],[367.824,746.896],[387.302,655.16],[387.302,745.066]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[367.824,755.104],[367.824,845.809],[387.302,753.201],[387.302,843.107]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[461.784,461.183],[461.784,368.834],[387.302,463.248],[387.302,373.343]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[461.784,559.47],[461.784,467.121],[387.302,558.935],[387.302,469.029]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[461.784,563.223],[461.784,655.572],[387.302,562.589],[387.302,652.494]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[461.784,658.31],[461.784,750.659],[387.302,655.16],[387.302,745.066]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[461.784,759.015],[461.784,851.364],[387.302,753.201],[387.302,843.107]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[539.349,459.768],[539.349,364.878],[461.079,461.918],[461.079,369.596]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[539.349,560.758],[539.349,465.869],[461.079,560.177],[461.079,467.854]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[539.349,564.615],[539.349,659.504],[461.079,563.928],[461.079,656.251]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[539.349,765.794],[539.349,860.683],[461.079,759.664],[461.079,851.987]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[539.349,662.318],[539.349,757.207],[461.079,658.988],[461.079,751.31]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[629.09,455.982],[629.09,356.573],[520.21,459.022],[520.21,363.241]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[629.09,561.783],[629.09,462.374],[520.21,560.96],[520.21,465.18]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[629.09,565.823],[629.09,665.232],[520.21,564.853],[520.21,660.633]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[629.09,668.179],[629.09,767.588],[520.21,663.473],[520.21,759.253]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[629.09,776.584],[629.09,875.993],[520.21,767.92],[520.21,863.701]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[629.089,455.982],[629.089,356.573],[647.261,456.758],[647.261,358.276]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[629.089,561.783],[629.089,462.374],[647.261,561.573],[647.261,463.09]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[629.089,565.823],[629.089,665.232],[647.261,565.575],[647.261,664.057]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[629.089,668.179],[629.089,767.588],[647.261,666.977],[647.261,765.459]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[629.089,776.584],[629.089,875.993],[647.261,774.371],[647.261,872.853]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[737.249,454.284],[737.249,352.849],[647.262,456.758],[647.262,358.276]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[737.249,562.242],[737.249,460.807],[647.262,561.573],[647.262,463.09]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[737.249,566.364],[737.249,667.8],[647.262,565.575],[647.262,664.057]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[737.249,670.807],[737.249,772.243],[647.262,666.977],[647.262,765.459]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[737.249,781.421],[737.249,882.857],[647.262,774.371],[647.262,872.853]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[699.027,472.252],[699.027,395.139],[713.124,472.755],[713.124,396.22]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[699.027,557.458],[699.027,634.571],[713.124,557.321],[713.124,633.856]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[699.027,636.857],[699.027,713.971],[713.124,636.125],[713.124,712.66]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[699.027,720.949],[699.027,798.062],[713.124,719.586],[713.124,796.12]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[737.098,454.335],[737.098,352.961],[814.078,457.886],[814.078,360.75]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[737.098,562.228],[737.098,460.854],[814.078,561.268],[814.078,464.132]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[737.098,566.348],[737.098,667.723],[814.078,565.215],[814.078,662.351]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[737.098,670.729],[737.098,772.103],[814.078,665.231],[814.078,762.367]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[737.098,781.277],[737.098,882.651],[814.078,771.157],[814.078,868.293]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[992.332,447.322],[992.332,337.575],[887.177,450.211],[887.177,343.913]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[992.332,564.126],[992.332,454.379],[887.177,563.344],[887.177,457.046]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[992.332,568.586],[992.332,678.333],[887.177,567.664],[887.177,673.962]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[992.332,681.587],[992.332,791.334],[887.177,677.114],[887.177,783.412]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[992.332,801.265],[992.332,911.013],[887.177,793.031],[887.177,899.329]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[946.832,466.844],[946.832,383.505],[959.602,467.411],[959.602,384.725]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[946.832,558.927],[946.832,642.266],[959.602,558.773],[959.602,641.459]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[946.832,644.737],[946.832,728.075],[959.602,643.911],[959.602,726.597]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[946.832,735.616],[946.832,818.955],[959.602,734.079],[959.602,816.765]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1122.05,442.22],[1122.05,326.381],[975.088,446.322],[975.088,335.382]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1122.05,565.506],[1122.05,449.668],[975.088,564.396],[975.088,453.456]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1122.05,570.214],[1122.05,686.052],[975.088,568.905],[975.088,679.845]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1122.05,689.487],[1122.05,805.325],[975.088,683.135],[975.088,794.075]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1122.05,815.808],[1122.05,931.646],[975.088,804.114],[975.088,915.055]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1001.83,463.706],[1001.83,376.756],[1029.03,465.009],[1029.03,379.559]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1001.83,559.78],[1001.83,646.73],[1029.03,559.426],[1029.03,644.876]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1001.83,649.308],[1001.83,736.258],[1029.03,647.409],[1029.03,732.859]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1001.83,744.126],[1001.83,831.076],[1029.03,740.592],[1029.03,826.041]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1122.05,442.22],[1122.05,326.381],[1137.84,443.272],[1137.84,328.69]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1122.05,565.506],[1122.05,449.668],[1137.84,565.222],[1137.84,450.64]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1122.05,570.214],[1122.05,686.052],[1137.84,569.878],[1137.84,684.46]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1122.05,689.487],[1122.05,805.325],[1137.84,687.857],[1137.84,802.439]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1122.05,815.808],[1122.05,931.646],[1137.84,812.808],[1137.84,927.389]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1260.26,439.907],[1260.26,321.308],[1137.84,443.272],[1137.84,328.69]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1260.26,566.132],[1260.26,447.533],[1137.84,565.222],[1137.84,450.64]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1260.26,570.952],[1260.26,689.551],[1137.84,569.878],[1137.84,684.46]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1260.26,693.067],[1260.26,811.667],[1137.84,687.857],[1137.84,802.439]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1260.26,822.399],[1260.26,940.998],[1137.84,812.808],[1137.84,927.39]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1390.07,432.56],[1390.07,309.762],[1264.13,436.149],[1264.13,317.482]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1390.07,563.253],[1390.07,440.455],[1264.13,562.445],[1264.13,443.779]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1390.07,568.243],[1390.07,691.041],[1264.13,567.268],[1264.13,685.934]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1390.07,694.681],[1390.07,817.479],[1264.13,689.453],[1264.13,808.12]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1390.07,828.591],[1390.07,951.388],[1264.13,818.858],[1264.13,937.524]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1561.03,425.89],[1561.03,295.416],[1375.59,431.26],[1375.59,306.966]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1561.03,564.753],[1561.03,434.279],[1375.59,563.545],[1375.59,439.252]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1561.03,570.055],[1561.03,700.529],[1375.59,568.596],[1375.59,692.89]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1561.03,704.398],[1561.03,834.872],[1375.59,696.575],[1375.59,820.868]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1561.03,846.679],[1561.03,977.153],[1375.59,832.116],[1375.59,956.409]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1390.02,457.121],[1390.02,362.592],[1400.56,457.849],[1400.56,364.158]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1390.02,561.569],[1390.02,656.098],[1400.56,561.371],[1400.56,655.062]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1390.02,658.901],[1390.02,753.43],[1400.56,657.84],[1400.56,751.53]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1390.02,761.984],[1390.02,856.513],[1400.56,760.009],[1400.56,853.699]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1561.04,425.89],[1561.04,295.416],[1573.45,427.273],[1573.45,298.391]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1561.04,564.753],[1561.04,434.279],[1573.45,564.442],[1573.45,435.56]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1561.04,570.055],[1561.04,700.529],[1573.45,569.68],[1573.45,698.562]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1561.04,704.398],[1561.04,834.872],[1573.45,702.383],[1573.45,831.265]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1561.04,846.679],[1561.04,977.153],[1573.45,842.928],[1573.45,971.81]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1729,422.837],[1729,288.85],[1573.44,427.273],[1573.44,298.391]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1729,565.44],[1729,431.453],[1573.44,564.442],[1573.44,435.56]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1729,570.885],[1729,704.872],[1573.44,569.68],[1573.44,698.562]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1729,708.844],[1729,842.831],[1573.44,702.383],[1573.44,831.265]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1729,854.956],[1729,988.943],[1573.44,842.928],[1573.44,971.81]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1728.99,422.837],[1728.99,288.85],[1811.65,434.17],[1811.65,313.226]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1728.99,565.44],[1728.99,431.453],[1811.65,562.89],[1811.65,441.947]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1728.99,570.885],[1728.99,704.872],[1811.65,567.805],[1811.65,688.749]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1728.99,708.844],[1728.99,842.831],[1811.65,692.335],[1811.65,813.279]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1728.99,854.956],[1728.99,988.943],[1811.65,824.223],[1811.65,945.167]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1767.03,448.85],[1767.03,344.801],[1774.94,449.731],[1774.94,346.698]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1767.03,563.817],[1767.03,667.865],[1774.94,563.577],[1774.94,666.611]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1767.03,670.95],[1767.03,774.999],[1774.94,669.666],[1774.94,772.699]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1767.03,784.414],[1767.03,888.463],[1774.94,782.023],[1774.94,885.057]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1833.46,437.159],[1833.46,319.656],[1897.8,445.981],[1897.8,338.63]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1833.46,562.218],[1833.46,444.714],[1897.8,560.234],[1897.8,452.883]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1833.46,566.993],[1833.46,684.497],[1897.8,564.596],[1897.8,671.947]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1833.46,687.981],[1833.46,805.484],[1897.8,675.13],[1897.8,782.48]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:1,
                    verts:[[1833.46,816.117],[1833.46,933.621],[1897.8,792.194],[1897.8,899.545]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[295.833,465.745],[295.833,378.793],[229.434,467.587],[229.434,382.814]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[295.833,558.289],[295.833,471.336],[229.434,557.812],[229.434,473.038]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[295.833,561.822],[295.833,648.775],[229.434,561.257],[229.434,646.03]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[295.833,651.353],[295.833,738.305],[229.434,648.543],[229.434,733.317]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[295.833,746.174],[295.833,833.126],[229.434,740.988],[229.434,825.761]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[367.824,462.573],[367.824,371.868],[276.889,465.135],[276.889,377.461]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[367.824,559.11],[367.824,468.405],[276.889,558.447],[276.889,470.772]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[367.824,562.796],[367.824,653.501],[276.889,562.009],[276.889,649.684]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[367.824,656.191],[367.824,746.896],[276.889,652.283],[276.889,739.957]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[367.824,755.104],[367.824,845.809],[276.889,747.891],[276.889,835.565]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[367.824,462.573],[367.824,371.868],[387.302,463.248],[387.302,373.343]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[367.824,559.11],[367.824,468.405],[387.302,558.935],[387.302,469.029]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[367.824,562.796],[367.824,653.501],[387.302,562.589],[387.302,652.494]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[367.824,656.191],[367.824,746.896],[387.302,655.16],[387.302,745.066]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[367.824,755.104],[367.824,845.809],[387.302,753.201],[387.302,843.107]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[461.784,461.183],[461.784,368.834],[387.302,463.248],[387.302,373.343]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[461.784,559.47],[461.784,467.121],[387.302,558.935],[387.302,469.029]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[461.784,563.223],[461.784,655.572],[387.302,562.589],[387.302,652.494]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[461.784,658.31],[461.784,750.659],[387.302,655.16],[387.302,745.066]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[461.784,759.015],[461.784,851.364],[387.302,753.201],[387.302,843.107]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[539.349,459.768],[539.349,364.878],[461.079,461.918],[461.079,369.596]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[539.349,560.758],[539.349,465.869],[461.079,560.177],[461.079,467.854]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[539.349,564.615],[539.349,659.504],[461.079,563.928],[461.079,656.251]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[539.349,765.794],[539.349,860.683],[461.079,759.664],[461.079,851.987]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[539.349,662.318],[539.349,757.207],[461.079,658.988],[461.079,751.31]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[629.09,455.982],[629.09,356.573],[520.21,459.022],[520.21,363.241]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[629.09,561.783],[629.09,462.374],[520.21,560.96],[520.21,465.18]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[629.09,565.823],[629.09,665.232],[520.21,564.853],[520.21,660.633]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[629.09,668.179],[629.09,767.588],[520.21,663.473],[520.21,759.253]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[629.09,776.584],[629.09,875.993],[520.21,767.92],[520.21,863.701]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[629.089,455.982],[629.089,356.573],[647.261,456.758],[647.261,358.276]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[629.089,561.783],[629.089,462.374],[647.261,561.573],[647.261,463.09]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[629.089,565.823],[629.089,665.232],[647.261,565.575],[647.261,664.057]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[629.089,668.179],[629.089,767.588],[647.261,666.977],[647.261,765.459]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[629.089,776.584],[629.089,875.993],[647.261,774.371],[647.261,872.853]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[737.249,454.284],[737.249,352.849],[647.262,456.758],[647.262,358.276]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[737.249,562.242],[737.249,460.807],[647.262,561.573],[647.262,463.09]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[737.249,566.364],[737.249,667.8],[647.262,565.575],[647.262,664.057]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[737.249,670.807],[737.249,772.243],[647.262,666.977],[647.262,765.459]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[737.249,781.421],[737.249,882.857],[647.262,774.371],[647.262,872.853]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[699.027,472.252],[699.027,395.139],[713.124,472.755],[713.124,396.22]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[699.027,557.458],[699.027,634.571],[713.124,557.321],[713.124,633.856]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[699.027,636.857],[699.027,713.971],[713.124,636.125],[713.124,712.66]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[699.027,720.949],[699.027,798.062],[713.124,719.586],[713.124,796.12]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[737.098,454.335],[737.098,352.961],[814.078,457.886],[814.078,360.75]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[737.098,562.228],[737.098,460.854],[814.078,561.268],[814.078,464.132]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[737.098,566.348],[737.098,667.723],[814.078,565.215],[814.078,662.351]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[737.098,670.729],[737.098,772.103],[814.078,665.231],[814.078,762.367]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[737.098,781.277],[737.098,882.651],[814.078,771.157],[814.078,868.293]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[992.332,447.322],[992.332,337.575],[887.177,450.211],[887.177,343.913]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[992.332,564.126],[992.332,454.379],[887.177,563.344],[887.177,457.046]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[992.332,568.586],[992.332,678.333],[887.177,567.664],[887.177,673.962]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[992.332,681.587],[992.332,791.334],[887.177,677.114],[887.177,783.412]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[992.332,801.265],[992.332,911.013],[887.177,793.031],[887.177,899.329]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[946.832,466.844],[946.832,383.505],[959.602,467.411],[959.602,384.725]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[946.832,558.927],[946.832,642.266],[959.602,558.773],[959.602,641.459]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[946.832,644.737],[946.832,728.075],[959.602,643.911],[959.602,726.597]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[946.832,735.616],[946.832,818.955],[959.602,734.079],[959.602,816.765]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1122.05,442.22],[1122.05,326.381],[975.088,446.322],[975.088,335.382]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1122.05,565.506],[1122.05,449.668],[975.088,564.396],[975.088,453.456]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1122.05,570.214],[1122.05,686.052],[975.088,568.905],[975.088,679.845]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1122.05,689.487],[1122.05,805.325],[975.088,683.135],[975.088,794.075]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1122.05,815.808],[1122.05,931.646],[975.088,804.114],[975.088,915.055]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1001.83,463.706],[1001.83,376.756],[1029.03,465.009],[1029.03,379.559]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1001.83,559.78],[1001.83,646.73],[1029.03,559.426],[1029.03,644.876]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1001.83,649.308],[1001.83,736.258],[1029.03,647.409],[1029.03,732.859]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1001.83,744.126],[1001.83,831.076],[1029.03,740.592],[1029.03,826.041]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1122.05,442.22],[1122.05,326.381],[1137.84,443.272],[1137.84,328.69]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1122.05,565.506],[1122.05,449.668],[1137.84,565.222],[1137.84,450.64]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1122.05,570.214],[1122.05,686.052],[1137.84,569.878],[1137.84,684.46]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1122.05,689.487],[1122.05,805.325],[1137.84,687.857],[1137.84,802.439]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1122.05,815.808],[1122.05,931.646],[1137.84,812.808],[1137.84,927.389]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1260.26,439.907],[1260.26,321.308],[1137.84,443.272],[1137.84,328.69]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1260.26,566.132],[1260.26,447.533],[1137.84,565.222],[1137.84,450.64]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1260.26,570.952],[1260.26,689.551],[1137.84,569.878],[1137.84,684.46]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1260.26,693.067],[1260.26,811.667],[1137.84,687.857],[1137.84,802.439]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1260.26,822.399],[1260.26,940.998],[1137.84,812.808],[1137.84,927.39]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1390.07,432.56],[1390.07,309.762],[1264.13,436.149],[1264.13,317.482]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1390.07,563.253],[1390.07,440.455],[1264.13,562.445],[1264.13,443.779]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1390.07,568.243],[1390.07,691.041],[1264.13,567.268],[1264.13,685.934]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1390.07,694.681],[1390.07,817.479],[1264.13,689.453],[1264.13,808.12]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1390.07,828.591],[1390.07,951.388],[1264.13,818.858],[1264.13,937.524]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1561.03,425.89],[1561.03,295.416],[1375.59,431.26],[1375.59,306.966]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1561.03,564.753],[1561.03,434.279],[1375.59,563.545],[1375.59,439.252]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1561.03,570.055],[1561.03,700.529],[1375.59,568.596],[1375.59,692.89]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1561.03,704.398],[1561.03,834.872],[1375.59,696.575],[1375.59,820.868]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1561.03,846.679],[1561.03,977.153],[1375.59,832.116],[1375.59,956.409]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1390.02,457.121],[1390.02,362.592],[1400.56,457.849],[1400.56,364.158]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1390.02,561.569],[1390.02,656.098],[1400.56,561.371],[1400.56,655.062]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1390.02,658.901],[1390.02,753.43],[1400.56,657.84],[1400.56,751.53]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1390.02,761.984],[1390.02,856.513],[1400.56,760.009],[1400.56,853.699]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1561.04,425.89],[1561.04,295.416],[1573.45,427.273],[1573.45,298.391]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1561.04,564.753],[1561.04,434.279],[1573.45,564.442],[1573.45,435.56]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1561.04,570.055],[1561.04,700.529],[1573.45,569.68],[1573.45,698.562]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1561.04,704.398],[1561.04,834.872],[1573.45,702.383],[1573.45,831.265]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1561.04,846.679],[1561.04,977.153],[1573.45,842.928],[1573.45,971.81]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1729,422.837],[1729,288.85],[1573.44,427.273],[1573.44,298.391]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1729,565.44],[1729,431.453],[1573.44,564.442],[1573.44,435.56]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1729,570.885],[1729,704.872],[1573.44,569.68],[1573.44,698.562]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1729,708.844],[1729,842.831],[1573.44,702.383],[1573.44,831.265]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1729,854.956],[1729,988.943],[1573.44,842.928],[1573.44,971.81]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1728.99,422.837],[1728.99,288.85],[1811.65,434.17],[1811.65,313.226]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1728.99,565.44],[1728.99,431.453],[1811.65,562.89],[1811.65,441.947]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1728.99,570.885],[1728.99,704.872],[1811.65,567.805],[1811.65,688.749]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1728.99,708.844],[1728.99,842.831],[1811.65,692.335],[1811.65,813.279]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1728.99,854.956],[1728.99,988.943],[1811.65,824.223],[1811.65,945.167]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1767.03,448.85],[1767.03,344.801],[1774.94,449.731],[1774.94,346.698]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1767.03,563.817],[1767.03,667.865],[1774.94,563.577],[1774.94,666.611]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1767.03,670.95],[1767.03,774.999],[1774.94,669.666],[1774.94,772.699]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1767.03,784.414],[1767.03,888.463],[1774.94,782.023],[1774.94,885.057]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1833.46,437.159],[1833.46,319.656],[1897.8,445.981],[1897.8,338.63]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1833.46,562.218],[1833.46,444.714],[1897.8,560.234],[1897.8,452.883]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1833.46,566.993],[1833.46,684.497],[1897.8,564.596],[1897.8,671.947]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1833.46,687.981],[1833.46,805.484],[1897.8,675.13],[1897.8,782.48]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:2,
                    verts:[[1833.46,816.117],[1833.46,933.621],[1897.8,792.194],[1897.8,899.545]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[263.849,464.382],[263.849,375.818],[189.7,466.052],[189.7,379.463]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[263.849,558.641],[263.849,470.077],[189.7,558.209],[189.7,471.62]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[263.849,562.241],[263.849,650.805],[189.7,561.728],[189.7,648.317]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[263.849,653.431],[263.849,741.995],[189.7,650.885],[189.7,737.474]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[263.849,750.01],[263.849,838.574],[189.7,745.31],[189.7,831.899]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[346.808,461.403],[346.808,369.314],[245.699,463.713],[245.699,374.356]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[346.808,559.413],[346.808,467.324],[245.699,558.815],[245.699,469.458]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[346.808,563.155],[346.808,655.244],[245.699,562.446],[245.699,651.803]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[346.808,657.975],[346.808,750.063],[245.699,654.452],[245.699,743.809]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[346.808,758.397],[346.808,850.485],[245.699,751.895],[245.699,841.251]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[346.808,461.403],[346.808,369.314],[365.207,462.139],[365.207,370.921]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[346.808,559.413],[346.808,467.324],[365.207,559.222],[365.207,468.004]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[346.808,563.155],[346.808,655.244],[365.207,562.929],[365.207,654.148]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[346.808,657.975],[346.808,750.063],[365.207,656.852],[365.207,748.071]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[346.808,758.397],[346.808,850.485],[365.207,756.325],[365.207,847.543]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[447.246,460.293],[447.246,366.89],[365.207,462.139],[365.207,370.921]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[447.246,559.701],[447.246,466.298],[365.207,559.222],[365.207,468.004]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[447.246,563.496],[447.246,656.899],[365.207,562.929],[365.207,654.148]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[447.246,659.668],[447.246,753.071],[365.207,656.852],[365.207,748.071]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[447.246,761.523],[447.246,854.925],[365.207,756.325],[365.207,847.543]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[532.128,459.123],[532.128,363.464],[446.465,461.034],[446.465,367.655]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[532.128,560.933],[532.128,465.274],[446.465,560.416],[446.465,467.038]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[532.128,564.82],[532.128,660.479],[446.465,564.211],[446.465,657.589]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[532.128,663.315],[532.128,758.974],[446.465,660.358],[446.465,753.736]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[532.128,767.631],[532.128,863.289],[446.465,762.186],[446.465,855.565]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[633.002,455.639],[633.002,355.82],[514.497,458.321],[514.497,361.704]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[633.002,561.876],[633.002,462.057],[514.497,561.15],[514.497,464.533]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[633.002,565.932],[633.002,665.751],[514.497,565.076],[514.497,661.693]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[633.002,668.711],[633.002,768.529],[514.497,664.558],[514.497,761.174]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[633.002,777.562],[633.002,877.381],[514.497,769.917],[514.497,866.534]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[633.001,455.639],[633.001,355.82],[649.424,456.466],[649.424,357.634]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[633.001,561.876],[633.001,462.057],[649.424,561.652],[649.424,462.821]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[633.001,565.932],[633.001,665.751],[649.424,565.668],[649.424,664.5]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[633.001,668.711],[633.001,768.529],[649.424,667.43],[649.424,766.261]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[633.001,777.562],[633.001,877.381],[649.424,775.205],[649.424,874.036]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[746.339,454.303],[746.339,352.891],[649.425,456.466],[649.425,357.634]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[746.339,562.237],[746.339,460.824],[649.425,561.652],[649.425,462.821]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[746.339,566.358],[746.339,667.771],[649.425,565.668],[649.425,664.5]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[746.339,670.778],[746.339,772.191],[649.425,667.43],[649.425,766.261]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[746.339,781.367],[746.339,882.78],[649.425,775.205],[649.425,874.036]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[656.47,471.97],[656.47,394.532],[669.5,472.506],[669.5,395.684]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[656.47,557.534],[656.47,634.973],[669.5,557.389],[669.5,634.211]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[656.47,637.269],[656.47,714.707],[669.5,636.488],[669.5,713.31]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[656.47,721.714],[656.47,799.153],[669.5,720.262],[669.5,797.084]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[746.06,454.353],[746.06,353],[814.28,458.097],[814.28,361.212]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[746.06,562.224],[746.06,460.87],[814.28,561.211],[814.28,464.326]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[746.06,566.342],[746.06,667.696],[814.28,565.148],[814.28,662.032]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[746.06,670.701],[746.06,772.054],[814.28,664.905],[814.28,761.789]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[746.06,781.226],[746.06,882.579],[814.28,770.556],[814.28,867.441]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1017.02,448.31],[1017.02,339.742],[906.083,450.784],[906.083,345.17]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1017.02,563.859],[1017.02,455.291],[906.083,563.189],[906.083,457.575]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1017.02,568.271],[1017.02,676.838],[906.083,567.481],[906.083,673.096]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1017.02,680.057],[1017.02,788.625],[906.083,676.227],[906.083,781.841]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1017.02,798.449],[1017.02,907.017],[906.083,791.398],[906.083,897.013]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[917.762,467.269],[917.762,384.421],[929.075,467.861],[929.075,385.694]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[917.762,558.812],[917.762,641.66],[929.075,558.651],[929.075,640.818]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[917.762,644.116],[917.762,726.965],[929.075,643.254],[929.075,725.421]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[917.762,734.462],[917.762,817.31],[929.075,732.856],[929.075,815.023]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[979.63,464.337],[979.63,378.114],[1003.37,465.691],[1003.37,381.026]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[979.63,559.608],[979.63,645.831],[1003.37,559.241],[1003.37,643.905]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[979.63,648.388],[979.63,734.611],[1003.37,646.416],[1003.37,731.08]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[979.63,742.413],[979.63,828.636],[1003.37,738.742],[1003.37,823.406]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1156.26,443.795],[1156.26,329.837],[1002.5,447.275],[1002.5,337.472]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1156.26,565.08],[1156.26,451.122],[1002.5,564.139],[1002.5,454.335]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1156.26,569.711],[1156.26,683.669],[1002.5,568.601],[1002.5,678.404]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1156.26,687.048],[1156.26,801.006],[1002.5,681.66],[1002.5,791.463]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1156.26,811.318],[1156.26,925.276],[1002.5,801.399],[1002.5,911.202]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1156.26,443.795],[1156.26,329.837],[1169.08,444.872],[1169.08,332.199]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1156.26,565.08],[1156.26,451.122],[1169.08,564.789],[1169.08,452.116]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1156.26,569.711],[1156.26,683.669],[1169.08,569.368],[1169.08,682.04]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1156.26,687.048],[1156.26,801.006],[1169.08,685.381],[1169.08,798.054]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1156.26,811.318],[1156.26,925.276],[1169.08,808.25],[1169.08,920.922]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1295.5,442.051],[1295.5,326.011],[1169.08,444.872],[1169.08,332.199]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1295.5,565.552],[1295.5,449.512],[1169.08,564.789],[1169.08,452.116]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1295.5,570.268],[1295.5,686.308],[1169.08,569.368],[1169.08,682.04]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1295.5,689.748],[1295.5,805.788],[1169.08,685.381],[1169.08,798.054]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1295.5,816.289],[1295.5,932.329],[1169.08,808.25],[1169.08,920.922]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1428.07,435.412],[1428.07,315.897],[1299.37,438.389],[1299.37,322.3]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1428.07,562.611],[1428.07,443.096],[1299.37,561.942],[1299.37,445.853]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1428.07,567.468],[1428.07,686.983],[1299.37,566.659],[1299.37,682.748]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1428.07,690.527],[1428.07,810.042],[1299.37,686.19],[1299.37,802.278]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1428.07,820.857],[1428.07,940.371],[1299.37,812.783],[1299.37,928.871]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1372.32,459.046],[1372.32,366.732],[1380.76,459.78],[1380.76,368.312]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1372.32,561.046],[1372.32,653.36],[1380.76,560.847],[1380.76,652.315]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1372.32,656.097],[1372.32,748.41],[1380.76,655.027],[1380.76,746.495]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1372.32,756.763],[1372.32,849.077],[1380.76,754.772],[1380.76,846.24]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1604.69,429.708],[1604.69,303.628],[1417.22,434.109],[1417.22,313.096]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1604.69,563.894],[1604.69,437.815],[1417.22,562.904],[1417.22,441.891]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1604.69,569.018],[1604.69,695.098],[1417.22,567.822],[1417.22,688.836]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1604.69,698.836],[1604.69,824.915],[1417.22,692.424],[1417.22,813.437]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1604.69,836.324],[1604.69,962.404],[1417.22,824.388],[1417.22,945.402]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1604.69,429.708],[1604.69,303.628],[1613.28,431.073],[1613.28,306.565]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1604.69,563.894],[1604.69,437.815],[1613.28,563.587],[1613.28,439.079]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1604.69,569.018],[1604.69,695.098],[1613.28,568.647],[1613.28,693.155]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1604.69,698.836],[1604.69,824.915],[1613.28,696.847],[1613.28,821.355]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1604.69,836.324],[1604.69,962.404],[1613.28,832.622],[1613.28,957.13]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1768.13,427.489],[1768.13,298.856],[1613.27,431.073],[1613.27,306.565]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1768.13,564.393],[1768.13,435.76],[1613.27,563.587],[1613.27,439.079]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1768.13,569.621],[1768.13,698.254],[1613.27,568.647],[1613.27,693.155]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1768.13,702.068],[1768.13,830.701],[1613.27,696.847],[1613.27,821.355]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1768.13,842.341],[1768.13,970.974],[1613.27,832.622],[1613.27,957.13]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1746.55,452.276],[1746.55,352.17],[1751.97,453.138],[1751.97,354.026]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1746.55,562.886],[1746.55,662.991],[1751.97,562.651],[1751.97,661.764]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1746.55,665.959],[1746.55,766.065],[1751.97,664.702],[1751.97,763.815]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1746.55,775.123],[1746.55,875.229],[1751.97,772.783],[1751.97,871.896]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1768.13,427.489],[1768.13,298.856],[1819.94,438.516],[1819.94,322.574]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1768.13,564.393],[1768.13,435.76],[1819.94,561.913],[1819.94,445.971]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1768.13,569.621],[1768.13,698.254],[1819.94,566.625],[1819.94,682.566]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1768.13,702.068],[1768.13,830.701],[1819.94,686.004],[1819.94,801.946]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1768.13,842.341],[1768.13,970.974],[1819.94,812.438],[1819.94,928.379]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1833.58,441.419],[1833.58,328.819],[1873.78,449.974],[1873.78,347.219]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1833.58,561.26],[1833.58,448.659],[1873.78,559.335],[1873.78,456.581]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1833.58,565.836],[1833.58,678.436],[1873.78,563.511],[1873.78,666.266]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1833.58,681.775],[1833.58,794.376],[1873.78,669.313],[1873.78,772.067]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:3,
                    verts:[[1833.58,804.565],[1833.58,917.165],[1873.78,781.365],[1873.78,884.12]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[235.894,462.929],[235.894,372.646],[153.985,464.403],[153.985,375.864]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[235.894,559.018],[235.894,468.734],[153.985,558.636],[153.985,470.096]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[235.894,562.687],[235.894,652.97],[153.985,562.234],[153.985,650.774]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[235.894,655.647],[235.894,745.93],[153.985,653.399],[153.985,741.938]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[235.894,754.1],[235.894,844.383],[153.985,749.95],[153.985,838.49]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[329.794,460.174],[329.794,366.632],[218.684,462.201],[218.684,371.057]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[329.794,559.731],[329.794,466.189],[218.684,559.206],[218.684,468.062]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[329.794,563.533],[329.794,657.075],[218.684,562.91],[218.684,654.055]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[329.794,659.849],[329.794,753.391],[218.684,656.757],[218.684,747.902]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[329.794,761.856],[329.794,855.398],[218.684,756.15],[218.684,847.294]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[329.794,460.174],[329.794,366.632],[346.954,460.968],[346.954,368.364]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[329.794,559.731],[329.794,466.189],[346.954,559.526],[346.954,466.922]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[329.794,563.533],[329.794,657.075],[346.954,563.289],[346.954,655.893]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[329.794,659.849],[329.794,753.391],[346.954,658.638],[346.954,751.242]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[329.794,761.856],[329.794,855.398],[346.954,759.621],[346.954,852.225]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[436.252,459.362],[436.252,364.858],[346.953,460.968],[346.953,368.364]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[436.252,559.942],[436.252,465.438],[346.953,559.526],[346.953,466.922]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[436.252,563.782],[436.252,658.286],[346.953,563.289],[346.953,655.892]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[436.252,661.088],[436.252,755.592],[346.953,658.638],[346.953,751.242]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[436.252,764.143],[436.252,858.647],[346.953,759.621],[346.953,852.225]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[528.011,458.458],[528.011,362.005],[435.398,460.109],[435.398,365.626]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[528.011,565.033],[528.011,661.486],[435.398,564.506],[435.398,658.988]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[528.011,769.526],[528.011,865.98],[435.398,764.822],[435.398,859.304]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[528.011,561.113],[528.011,464.66],[435.398,560.666],[435.398,466.184]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[528.011,664.345],[528.011,760.798],[435.398,661.79],[435.398,756.272]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[639.353,455.303],[639.353,355.084],[512.044,457.604],[512.044,360.133]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[639.353,561.966],[639.353,461.747],[512.044,561.344],[512.044,463.872]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[639.353,566.039],[639.353,666.258],[512.044,565.305],[512.044,662.777]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[639.353,669.23],[639.353,769.449],[512.044,665.667],[512.044,763.139]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[639.353,778.518],[639.353,878.737],[512.044,771.959],[512.044,869.431]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[615.931,471.579],[615.931,393.691],[627.848,472.146],[627.848,394.91]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[615.931,557.641],[615.931,635.529],[627.848,557.487],[627.848,634.723]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[615.931,637.838],[615.931,715.726],[627.848,637.013],[627.848,714.249]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[615.931,722.774],[615.931,800.662],[627.848,721.238],[627.848,798.474]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[639.352,455.303],[639.352,355.084],[653.889,456.175],[653.889,356.996]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[639.352,561.966],[639.352,461.747],[653.889,561.731],[653.889,462.552]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[639.352,566.039],[639.352,666.258],[653.889,565.761],[653.889,664.94]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[639.352,669.23],[639.352,769.449],[653.889,667.88],[653.889,767.059]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[639.352,778.518],[639.352,878.737],[653.889,776.034],[653.889,875.212]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[756.912,454.338],[756.912,352.966],[653.89,456.175],[653.89,356.996]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[756.912,562.228],[756.912,460.856],[653.89,561.731],[653.89,462.552]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[756.912,566.347],[756.912,667.719],[653.89,565.761],[653.89,664.94]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[756.912,670.725],[756.912,772.096],[653.89,667.88],[653.89,767.059]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[756.912,781.27],[756.912,882.641],[653.89,776.034],[653.89,875.212]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[756.509,454.386],[756.509,353.072],[815.536,458.29],[815.536,361.637]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[756.509,562.215],[756.509,460.9],[815.536,561.158],[815.536,464.505]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[756.509,566.332],[756.509,667.646],[815.536,565.086],[815.536,661.74]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[756.509,670.65],[756.509,771.964],[815.536,664.605],[815.536,761.259]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[756.509,781.132],[756.509,882.447],[815.536,770.005],[815.536,866.658]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[889.699,467.597],[889.699,385.126],[899.541,468.21],[899.541,386.445]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[889.699,555.371],[889.699,472.9],[899.541,555.233],[899.541,473.468]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[889.699,558.723],[889.699,641.194],[899.541,558.556],[899.541,640.322]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[889.699,643.639],[889.699,726.111],[899.541,642.746],[899.541,724.511]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[889.699,733.574],[889.699,816.045],[899.541,731.91],[899.541,813.676]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1040.33,449.327],[1040.33,341.973],[924.872,451.385],[924.872,346.487]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1040.33,563.584],[1040.33,456.229],[924.872,563.027],[924.872,458.129]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1040.33,567.946],[1040.33,675.3],[924.872,567.29],[924.872,672.187]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1040.33,678.483],[1040.33,785.838],[924.872,675.297],[924.872,780.195]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1040.33,795.552],[1040.33,902.906],[924.872,789.687],[924.872,894.584]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[957.979,464.878],[957.979,379.277],[978.261,466.273],[978.261,382.277]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[957.979,559.461],[957.979,645.062],[978.261,559.083],[978.261,643.078]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[957.979,647.6],[957.979,733.201],[978.261,645.569],[978.261,729.565]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[957.979,740.947],[957.979,826.548],[978.261,737.165],[978.261,821.161]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1187.17,445.401],[1187.17,333.361],[1028.57,448.268],[1028.57,339.65]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1187.17,564.646],[1187.17,452.605],[1028.57,563.87],[1028.57,455.252]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1187.17,569.199],[1187.17,681.239],[1028.57,568.284],[1028.57,676.902]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1187.17,684.561],[1187.17,796.601],[1028.57,680.122],[1028.57,788.74]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1187.17,806.74],[1187.17,918.78],[1028.57,798.569],[1028.57,907.187]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1187.17,445.401],[1187.17,333.361],[1197.05,446.489],[1197.05,335.748]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1187.17,564.646],[1187.17,452.605],[1197.05,564.351],[1197.05,453.61]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1187.17,569.199],[1187.17,681.239],[1197.05,568.852],[1197.05,679.593]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1187.17,684.561],[1187.17,796.601],[1197.05,682.876],[1197.05,793.618]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1187.17,806.74],[1187.17,918.78],[1197.05,803.639],[1197.05,914.38]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1325.83,444.193],[1325.83,330.71],[1197.05,446.489],[1197.05,335.748]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1325.83,564.973],[1325.83,451.49],[1197.05,564.351],[1197.05,453.61]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1325.83,569.584],[1325.83,683.067],[1197.05,568.852],[1197.05,679.593]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1325.83,686.432],[1325.83,799.915],[1197.05,682.876],[1197.05,793.618]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1325.83,810.184],[1325.83,923.667],[1197.05,803.639],[1197.05,914.38]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1459.39,438.227],[1459.39,321.952],[1329.64,440.626],[1329.64,327.112]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1459.39,561.978],[1459.39,445.703],[1329.64,561.438],[1329.64,447.925]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1459.39,566.703],[1459.39,682.978],[1329.64,566.051],[1329.64,679.565]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1459.39,686.425],[1459.39,802.7],[1329.64,682.931],[1329.64,796.444]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1459.39,813.221],[1459.39,929.496],[1329.64,806.716],[1329.64,920.23]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1352.87,460.816],[1352.87,370.541],[1359.3,461.551],[1359.3,372.12]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1352.87,560.565],[1352.87,650.841],[1359.3,560.366],[1359.3,649.796]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1352.87,653.517],[1352.87,743.793],[1359.3,652.447],[1359.3,741.878]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1352.87,751.962],[1352.87,842.237],[1359.3,749.97],[1359.3,839.401]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1638.89,433.433],[1638.89,311.642],[1451.98,436.938],[1451.98,319.179]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1638.89,563.056],[1638.89,441.264],[1451.98,562.268],[1451.98,444.509]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1638.89,568.006],[1638.89,689.797],[1451.98,567.053],[1451.98,684.812]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1638.89,693.409],[1638.89,815.2],[1451.98,688.303],[1451.98,806.062]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1638.89,826.221],[1638.89,948.013],[1451.98,816.718],[1451.98,934.477]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1638.89,433.433],[1638.89,311.642],[1643.93,434.766],[1643.93,314.507]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1638.89,563.056],[1638.89,441.264],[1643.93,562.757],[1643.93,442.498]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1638.89,568.006],[1638.89,689.797],[1643.93,567.644],[1643.93,687.902]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1638.89,693.409],[1638.89,815.2],[1643.93,691.468],[1643.93,811.727]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1638.89,826.221],[1638.89,948.013],[1643.93,822.609],[1643.93,942.867]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1796.11,431.951],[1796.11,308.452],[1643.93,434.766],[1643.93,314.507]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1796.11,563.39],[1796.11,439.891],[1643.93,562.757],[1643.93,442.498]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1796.11,568.409],[1796.11,691.907],[1643.93,567.644],[1643.93,687.902]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1796.11,695.569],[1796.11,819.067],[1643.93,691.468],[1643.93,811.726]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1796.11,830.242],[1643.93,822.609],[1796.11,953.741],[1643.93,942.867]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1722.11,455.411],[1722.11,358.914],[1725.29,456.249],[1725.29,360.717]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1722.11,562.034],[1722.11,658.531],[1725.29,561.806],[1725.29,657.338]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1722.11,661.392],[1722.11,757.889],[1725.29,660.17],[1725.29,755.702]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1722.11,766.621],[1722.11,863.118],[1725.29,764.347],[1725.29,859.879]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1796.11,431.951],[1796.11,308.452],[1820.22,442.576],[1820.22,331.308]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1796.11,563.39],[1796.11,439.891],[1820.22,561],[1820.22,449.731]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1796.11,568.409],[1796.11,691.907],[1820.22,565.521],[1820.22,676.79]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1796.11,695.569],[1796.11,819.067],[1820.22,680.089],[1820.22,791.358]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1796.11,830.242],[1796.11,953.741],[1820.22,801.426],[1820.22,912.695]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1826.57,445.372],[1826.57,337.322],[1845.26,453.608],[1845.26,355.036]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1826.57,560.371],[1826.57,452.32],[1845.26,558.518],[1845.26,459.946]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1826.57,564.762],[1826.57,672.812],[1845.26,562.524],[1845.26,661.095]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1826.57,676.016],[1826.57,784.066],[1845.26,664.018],[1845.26,762.59]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:4,
                    verts:[[1826.57,793.844],[1826.57,901.895],[1845.26,771.51],[1845.26,870.081]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[211.988,461.377],[211.988,369.257],[122.346,462.631],[122.346,371.995]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[211.988,559.42],[211.988,467.3],[122.346,559.095],[122.346,468.459]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[211.988,563.163],[211.988,655.283],[122.346,562.778],[122.346,653.414]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[211.988,658.015],[211.988,750.135],[122.346,656.102],[122.346,746.738]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[211.988,758.471],[211.988,850.591],[122.346,754.94],[122.346,845.576]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[316.75,458.877],[316.75,363.801],[195.874,460.591],[195.874,367.541]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[316.75,560.067],[316.75,464.991],[195.874,559.623],[195.874,466.574]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[316.75,563.931],[316.75,659.007],[195.874,563.405],[195.874,656.454]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[316.75,661.826],[316.75,756.903],[195.874,659.213],[195.874,752.263]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[316.75,765.506],[316.75,860.583],[195.874,760.683],[195.874,853.732]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[316.751,458.877],[316.751,363.801],[332.51,459.726],[332.51,365.654]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[316.751,560.067],[316.751,464.991],[332.51,559.847],[332.51,465.775]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[316.751,563.931],[316.751,659.007],[332.51,563.67],[332.51,657.742]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[316.751,661.826],[316.751,756.903],[332.51,660.532],[332.51,754.604]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[316.751,765.506],[316.751,860.583],[332.51,763.117],[332.51,857.189]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[428.724,458.381],[428.724,362.716],[332.509,459.726],[332.509,365.654]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[428.724,560.196],[428.724,464.532],[332.509,559.847],[332.509,465.775]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[428.724,564.083],[428.724,659.747],[332.509,563.67],[332.509,657.742]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[428.724,662.584],[428.724,758.248],[332.509,660.532],[332.509,754.604]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[428.724,766.905],[428.724,862.569],[332.509,763.117],[332.509,857.189]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[526.878,457.761],[526.878,360.476],[427.8,459.134],[427.8,363.488]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[526.878,561.301],[526.878,464.016],[427.8,560.93],[427.8,465.284]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[526.878,665.424],[526.878,762.709],[427.8,663.299],[427.8,758.944]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[526.878,565.255],[526.878,662.54],[427.8,564.817],[427.8,660.463]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[526.878,771.513],[526.878,868.798],[427.8,767.599],[427.8,863.245]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[647.96,454.962],[647.96,354.335],[512.722,456.861],[512.722,358.502]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[647.96,562.059],[647.96,461.432],[512.722,561.545],[512.722,463.186]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[647.96,566.148],[647.96,666.775],[512.722,565.542],[512.722,663.901]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[647.96,669.759],[647.96,770.386],[512.722,666.818],[512.722,765.177]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[647.96,779.491],[647.96,880.118],[512.722,774.078],[512.722,872.437]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[577.363,471.073],[577.363,392.603],[588.118,471.669],[588.118,393.884]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[577.363,557.778],[577.363,636.248],[588.118,557.616],[588.118,635.401]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[577.363,638.575],[577.363,717.045],[588.118,637.707],[588.118,715.492]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[577.363,724.146],[577.363,802.616],[588.118,722.531],[588.118,800.316]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[647.959,454.962],[647.959,354.335],[660.49,455.872],[660.49,356.331]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[647.959,562.059],[647.959,461.432],[660.49,561.813],[660.49,462.272]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[647.959,566.148],[647.959,666.775],[660.49,565.858],[660.49,665.399]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[647.959,669.759],[647.959,770.386],[660.49,668.35],[660.49,767.891]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[647.959,779.491],[647.959,880.118],[660.49,776.898],[660.49,876.439]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[768.789,454.37],[768.789,353.037],[660.491,455.872],[660.491,356.331]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[768.789,562.219],[768.789,460.886],[660.491,561.813],[660.491,462.272]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[768.789,566.337],[768.789,667.67],[660.491,565.858],[660.491,665.399]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[768.789,670.675],[768.789,772.008],[660.491,668.35],[660.491,767.891]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[768.789,781.178],[768.789,882.511],[660.491,776.898],[660.491,876.439]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[768.265,454.416],[768.265,353.138],[817.758,458.452],[817.758,361.991]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[768.265,562.206],[768.265,460.928],[817.758,561.115],[817.758,464.654]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[768.265,566.322],[768.265,667.6],[817.758,565.035],[817.758,661.495]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[768.265,670.603],[768.265,771.881],[817.758,664.356],[817.758,760.816]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[768.265,781.046],[768.265,882.324],[817.758,769.545],[817.758,866.006]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[862.657,467.82],[862.657,385.604],[871.018,468.451],[871.018,386.962]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[862.657,555.321],[862.657,473.106],[871.018,555.179],[871.018,473.69]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[862.657,558.662],[862.657,640.877],[871.018,558.491],[871.018,639.979]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[862.657,643.315],[862.657,725.53],[871.018,642.395],[871.018,723.884]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[862.657,732.97],[862.657,815.185],[871.018,731.258],[871.018,812.746]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[936.926,465.319],[936.926,380.226],[953.754,466.746],[953.754,383.295]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[936.926,555.884],[936.926,470.791],[953.754,555.563],[953.754,472.112]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[936.926,559.342],[936.926,644.435],[953.754,558.954],[953.754,642.405]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[936.926,646.958],[936.926,732.051],[953.754,644.879],[953.754,728.33]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[936.926,739.751],[936.926,824.844],[953.754,735.881],[953.754,819.332]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1062.18,450.343],[1062.18,344.201],[943.394,451.989],[943.394,347.813]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1062.18,563.309],[1062.18,457.167],[943.394,562.863],[943.394,458.687]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1062.18,567.622],[1062.18,673.763],[943.394,567.097],[943.394,671.273]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1062.18,676.91],[1062.18,783.052],[943.394,674.362],[943.394,778.538]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1062.18,792.656],[1062.18,898.798],[943.394,787.965],[943.394,892.141]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1214.82,447],[1214.82,336.868],[1053.17,449.27],[1053.17,341.849]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1214.82,564.213],[1214.82,454.081],[1053.17,563.599],[1053.17,456.177]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1214.82,568.689],[1214.82,678.821],[1053.17,567.964],[1053.17,675.386]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1214.82,682.086],[1214.82,792.218],[1053.17,678.571],[1053.17,785.992]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1214.82,802.184],[1214.82,912.315],[1053.17,795.713],[1053.17,903.134]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1214.82,447],[1214.82,336.868],[1221.83,448.089],[1221.83,339.257]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1214.82,564.213],[1214.82,454.081],[1221.83,563.919],[1221.83,455.086]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1214.82,568.689],[1214.82,678.821],[1221.83,568.341],[1221.83,677.173]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1214.82,682.086],[1214.82,792.218],[1221.83,680.4],[1221.83,789.232]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1214.82,802.184],[1214.82,912.316],[1221.83,799.081],[1221.83,907.913]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1351.51,446.291],[1351.51,335.312],[1221.83,448.089],[1221.83,339.257]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1351.51,564.405],[1351.51,453.427],[1221.83,563.919],[1221.83,455.086]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1351.51,568.915],[1351.51,679.893],[1221.83,568.341],[1221.83,677.173]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1351.51,683.184],[1351.51,794.162],[1221.83,680.4],[1221.83,789.232]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1351.51,804.205],[1351.51,915.183],[1221.83,799.08],[1221.83,907.913]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1332.01,462.426],[1332.01,374.003],[1336.54,463.156],[1336.54,375.572]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1332.01,560.128],[1332.01,648.551],[1336.54,559.93],[1336.54,647.513]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1332.01,651.173],[1332.01,739.595],[1336.54,650.11],[1336.54,737.693]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1332.01,747.597],[1332.01,836.02],[1336.54,745.618],[1336.54,833.201]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1484.56,440.957],[1484.56,327.824],[1355.23,442.816],[1355.23,331.823]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1484.56,561.364],[1484.56,448.231],[1355.23,560.946],[1355.23,449.953]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1484.56,565.961],[1484.56,679.094],[1355.23,565.456],[1355.23,676.449]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1484.56,682.449],[1484.56,795.582],[1355.23,679.74],[1355.23,790.733]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1484.56,805.819],[1484.56,918.952],[1355.23,800.777],[1355.23,911.77]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1664.63,437.008],[1664.63,319.33],[1480.39,439.692],[1480.39,325.104]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1664.63,562.252],[1664.63,444.574],[1480.39,561.648],[1480.39,447.06]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1664.63,567.034],[1664.63,684.712],[1480.39,566.305],[1480.39,680.893]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1664.63,688.201],[1664.63,805.879],[1480.39,684.291],[1480.39,798.879]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1664.63,816.528],[1664.63,934.206],[1480.39,809.249],[1480.39,923.837]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1664.63,437.008],[1664.63,319.33],[1666.45,438.296],[1666.45,322.101]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1664.63,562.252],[1664.63,444.574],[1666.45,561.962],[1666.45,445.767]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1664.63,567.034],[1664.63,684.712],[1666.45,566.684],[1666.45,682.879]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1664.63,688.201],[1664.63,805.879],[1666.45,686.325],[1666.45,802.52]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1664.63,816.528],[1664.63,934.206],[1666.45,813.034],[1666.45,929.229]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1814.46,436.167],[1666.45,438.296],[1814.46,317.523],[1666.45,322.101]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1814.46,562.441],[1814.46,443.796],[1666.45,561.962],[1666.45,445.767]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1814.46,567.263],[1666.45,566.684],[1814.46,685.908],[1666.45,682.879]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1814.46,689.425],[1666.45,686.325],[1814.46,808.07],[1666.45,802.52]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1814.46,818.807],[1666.45,813.034],[1814.46,937.452],[1666.45,929.229]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1694.61,458.259],[1694.61,365.04],[1695.75,459.07],[1695.75,366.784]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1694.61,561.26],[1694.61,654.479],[1695.75,561.04],[1695.75,653.326]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1694.61,657.243],[1694.61,750.462],[1695.75,656.062],[1695.75,748.348]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:5,
                    verts:[[1694.61,758.897],[1694.61,852.116],[1695.75,756.699],[1695.75,848.985]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[192.15,459.713],[192.15,365.625],[94.8354,460.722],[94.8354,367.828]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[192.15,559.851],[192.15,465.763],[94.8354,559.589],[94.8354,466.695]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[192.15,563.674],[192.15,657.762],[94.8354,563.364],[94.8354,656.259]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[192.15,660.552],[192.15,754.639],[94.8354,659.013],[94.8354,751.907]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[192.15,763.153],[192.15,857.241],[94.8354,760.313],[94.8354,853.208]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[307.642,457.502],[307.642,360.799],[177.294,458.871],[177.294,363.787]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[307.642,560.423],[307.642,463.72],[177.294,560.069],[177.294,464.985]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[307.642,564.353],[307.642,661.056],[177.294,563.933],[177.294,659.017]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[307.642,663.923],[307.642,760.626],[177.294,661.836],[177.294,756.921]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[307.642,769.377],[307.642,866.08],[177.294,765.525],[177.294,860.609]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[307.642,457.502],[307.642,360.799],[321.839,458.404],[321.839,362.768]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[307.642,560.423],[307.642,463.72],[321.839,560.19],[321.839,464.553]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[307.642,564.353],[307.642,661.056],[321.839,564.076],[321.839,659.713]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[307.642,663.923],[307.642,760.626],[321.839,662.548],[321.839,758.185]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[307.642,769.377],[307.642,866.08],[321.839,766.839],[321.839,862.475]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[424.581,457.339],[424.581,360.443],[321.838,458.404],[321.838,362.768]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[424.581,560.465],[424.581,463.57],[321.838,560.19],[321.838,464.553]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[424.581,564.403],[424.581,661.299],[321.838,564.076],[321.838,659.713]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[424.581,664.172],[424.581,761.068],[321.838,662.548],[321.838,758.185]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[424.581,769.836],[424.581,866.732],[321.838,766.839],[321.838,862.475]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[528.611,457.021],[528.611,358.853],[423.592,458.1],[423.592,361.219]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[528.611,561.502],[528.611,463.333],[423.592,561.21],[423.592,464.329]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[528.611,565.491],[528.611,663.659],[423.592,565.147],[423.592,662.028]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[528.611,666.57],[528.611,764.738],[423.592,664.9],[423.592,761.781]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[528.611,773.621],[528.611,871.789],[423.592,770.548],[423.592,867.429]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[658.656,454.6],[658.656,353.541],[516.404,456.08],[516.404,356.787]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[658.656,562.157],[658.656,461.098],[516.404,561.756],[516.404,462.464]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[658.656,566.264],[658.656,667.322],[516.404,565.792],[516.404,665.084]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[658.656,670.319],[658.656,771.377],[516.404,668.028],[516.404,767.32]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[658.656,780.522],[658.656,881.581],[516.404,776.305],[516.404,875.597]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[540.698,470.445],[540.698,391.252],[550.237,471.068],[550.237,392.591]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[540.698,557.949],[540.698,637.142],[550.237,557.78],[550.237,636.256]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[540.698,639.49],[540.698,718.684],[550.237,638.583],[550.237,717.06]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[540.698,725.85],[540.698,805.043],[550.237,724.161],[550.237,802.638]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[658.655,454.6],[658.655,353.541],[669.076,455.542],[669.076,355.609]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[658.655,562.157],[658.655,461.098],[669.076,561.902],[669.076,461.968]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[658.655,566.264],[658.655,667.322],[669.076,565.963],[669.076,665.897]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[658.655,670.319],[658.655,771.377],[669.076,668.86],[669.076,768.793]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[658.655,780.522],[658.655,881.581],[669.076,777.836],[669.076,877.77]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[781.812,454.384],[781.812,353.068],[669.076,455.542],[669.076,355.609]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[781.812,562.215],[781.812,460.899],[669.076,561.902],[669.076,461.968]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[781.812,566.333],[781.812,667.649],[669.076,565.963],[669.076,665.897]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[781.812,670.653],[781.812,771.969],[669.076,668.86],[669.076,768.793]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[781.812,781.137],[781.812,882.454],[669.076,777.836],[669.076,877.77]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[781.173,454.429],[781.173,353.165],[820.866,458.567],[820.866,362.244]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[781.173,562.203],[781.173,460.94],[820.866,561.083],[820.866,464.76]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[781.173,566.318],[781.173,667.582],[820.866,564.998],[820.866,661.321]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[781.173,670.584],[781.173,771.848],[820.866,664.177],[820.866,760.5]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[781.173,781.011],[781.173,882.275],[820.866,769.216],[820.866,865.54]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[836.623,467.931],[836.623,385.845],[843.493,468.578],[843.493,387.235]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[836.623,555.296],[836.623,473.209],[843.493,555.151],[843.493,473.808]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[836.623,558.632],[836.623,640.718],[843.493,558.456],[843.493,639.799]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[836.623,643.152],[836.623,725.239],[843.493,642.211],[843.493,723.553]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[836.623,732.666],[836.623,814.753],[843.493,730.914],[843.493,812.257]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[916.489,465.654],[916.489,380.947],[929.869,467.106],[929.869,384.069]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[916.489,555.808],[916.489,471.101],[929.869,555.482],[929.869,472.445]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[916.489,559.251],[916.489,643.958],[929.869,558.856],[929.869,641.893]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[916.489,646.47],[916.489,731.177],[929.869,644.355],[929.869,727.391]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[916.489,738.842],[916.489,823.55],[929.869,734.905],[929.869,817.942]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1082.53,451.333],[1082.53,346.375],[961.542,452.576],[961.542,349.101]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1082.53,563.041],[1082.53,458.082],[961.542,562.704],[961.542,459.229]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1082.53,567.306],[1082.53,672.264],[961.542,566.909],[961.542,670.385]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1082.53,675.376],[1082.53,780.335],[961.542,673.453],[961.542,776.928]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1082.53,789.832],[1082.53,894.791],[961.542,786.291],[961.542,889.767]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1239.33,448.56],[1239.33,340.291],[1076.26,450.256],[1076.26,344.012]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1239.33,563.791],[1239.33,455.522],[1076.26,563.332],[1076.26,457.088]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1239.33,568.191],[1239.33,676.46],[1076.26,567.65],[1076.26,673.894]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1239.33,679.67],[1239.33,787.94],[1076.26,677.044],[1076.26,783.289]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1239.33,797.737],[1239.33,906.006],[1076.26,792.903],[1076.26,899.147]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1239.33,448.56],[1239.33,340.291],[1243.57,449.641],[1243.57,342.662]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1239.33,563.791],[1239.33,455.522],[1243.57,563.499],[1243.57,456.519]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1239.33,568.191],[1239.33,676.46],[1243.57,567.846],[1243.57,674.825]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1239.33,679.67],[1239.33,787.94],[1243.57,677.997],[1243.57,784.976]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1239.33,797.737],[1239.33,906.006],[1243.57,794.657],[1243.57,901.636]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1372.88,448.312],[1372.88,339.747],[1243.57,449.641],[1243.57,342.662]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1372.88,563.858],[1372.88,455.293],[1243.57,563.499],[1243.57,456.519]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1372.88,568.27],[1372.88,676.835],[1243.57,567.846],[1243.57,674.825]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1372.88,680.054],[1372.88,788.619],[1243.57,677.997],[1243.57,784.976]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1372.88,798.443],[1372.88,907.008],[1243.57,794.657],[1243.57,901.636]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1310.04,463.871],[1310.04,377.112],[1312.77,464.593],[1312.77,378.664]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1310.04,559.735],[1310.04,646.494],[1312.77,559.539],[1312.77,645.468]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1310.04,649.067],[1310.04,735.826],[1312.77,648.016],[1312.77,733.945]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1310.04,743.677],[1310.04,830.436],[1312.77,741.72],[1312.77,827.649]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1504.19,443.565],[1504.19,333.435],[1376.48,444.926],[1376.48,336.361]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1504.19,560.777],[1504.19,450.647],[1376.48,560.471],[1376.48,451.906]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1504.19,565.253],[1504.19,675.383],[1376.48,564.883],[1376.48,673.448]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1504.19,678.648],[1376.48,676.667],[1504.19,788.779],[1376.48,785.232]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1504.19,798.745],[1376.48,795.056],[1504.19,908.875],[1376.48,903.621]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1682.95,440.393],[1503.03,442.334],[1682.95,326.611],[1503.03,330.787]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1682.95,561.491],[1503.03,561.054],[1682.95,447.709],[1503.03,449.507]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1682.95,566.115],[1503.03,565.587],[1682.95,679.896],[1503.03,677.134]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1682.95,683.27],[1503.03,680.442],[1682.95,797.051],[1503.03,791.989]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1682.95,807.347],[1503.03,802.083],[1682.95,921.129],[1503.03,913.63]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1681.85,441.63],[1681.85,329.273],[1824.6,440.109],[1824.6,326.001]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1681.85,681.467],[1824.6,683.683],[1681.85,793.825],[1824.6,797.791]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1681.85,803.992],[1824.6,808.117],[1681.85,916.35],[1824.6,922.225]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1681.85,561.212],[1681.85,448.855],[1824.6,561.555],[1824.6,447.446]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:6,
                    verts:[[1681.85,565.778],[1681.85,678.136],[1824.6,566.192],[1824.6,680.3]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[176.415,457.927],[176.415,361.726],[71.5271,458.663],[71.5271,363.332]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[176.415,560.313],[176.415,464.113],[71.5271,560.123],[71.5271,464.792]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[176.415,564.223],[176.415,660.423],[71.5271,563.997],[71.5271,659.327]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[176.415,663.276],[176.415,759.476],[71.5271,662.154],[71.5271,757.484]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[176.415,768.181],[176.415,864.382],[71.5271,766.11],[71.5271,861.441]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[302.448,456.039],[302.448,357.604],[162.985,457.029],[162.985,359.766]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[302.448,560.802],[302.448,462.368],[162.985,560.546],[162.985,463.283]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[302.448,564.802],[302.448,663.237],[162.985,564.498],[162.985,661.761]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[302.448,666.155],[302.448,764.59],[162.985,664.645],[162.985,761.908]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[302.448,773.497],[302.448,871.931],[162.985,770.71],[162.985,867.973]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[302.448,456.039],[302.448,357.604],[314.917,456.991],[314.917,359.682]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[302.448,560.802],[302.448,462.368],[314.917,560.556],[314.917,463.247]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[302.448,564.802],[302.448,663.237],[314.917,564.51],[314.917,661.819]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[302.448,666.155],[302.448,764.59],[314.917,664.704],[314.917,762.012]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[302.448,773.497],[302.448,871.931],[314.917,770.818],[314.917,868.126]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[423.758,456.227],[423.758,358.016],[314.917,456.991],[314.917,359.682]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[423.758,560.753],[423.758,462.542],[314.917,560.556],[314.917,463.247]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[423.758,564.744],[423.758,662.956],[314.917,564.51],[314.917,661.819]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[423.758,665.868],[423.758,764.079],[314.917,664.704],[314.917,762.012]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[423.758,772.966],[423.758,871.177],[314.917,770.818],[314.917,868.126]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[533.107,456.228],[533.107,357.113],[422.708,456.995],[422.708,358.796]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[533.107,565.744],[533.107,664.859],[422.708,565.499],[422.708,663.699]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[533.107,667.798],[533.107,766.913],[422.708,666.61],[422.708,764.81]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[533.107,775.882],[533.107,874.997],[422.708,773.696],[422.708,871.895]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[533.107,561.716],[533.107,462.601],[422.708,561.509],[422.708,463.309]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[505.856,469.686],[505.856,389.619],[514.124,470.335],[514.124,391.014]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[505.856,558.155],[505.856,638.222],[514.124,557.979],[514.124,637.299]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[505.856,640.596],[505.856,720.663],[514.124,639.651],[514.124,718.972]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[505.856,727.909],[505.856,807.976],[514.124,726.15],[514.124,805.47]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[671.295,454.206],[671.295,352.677],[522.977,455.249],[522.977,354.966]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[671.295,562.263],[671.295,460.734],[522.977,561.981],[522.977,461.698]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[671.295,566.389],[671.295,667.918],[522.977,566.056],[522.977,666.34]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[671.295,670.929],[671.295,772.458],[522.977,669.313],[522.977,769.597]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[671.295,781.645],[671.295,883.174],[522.977,778.671],[522.977,878.955]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[671.295,454.206],[671.295,352.677],[679.514,455.175],[679.514,354.803]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[671.295,562.263],[671.295,460.734],[679.514,562.001],[679.514,461.629]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[671.295,566.389],[671.295,667.918],[679.514,566.08],[679.514,666.452]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[671.295,670.929],[671.295,772.458],[679.514,669.428],[679.514,769.8]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[671.295,781.645],[671.295,883.174],[679.514,778.883],[679.514,879.255]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[795.851,454.367],[795.851,353.029],[679.515,455.175],[679.515,354.803]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[795.851,562.22],[795.851,460.883],[679.515,562.001],[679.515,461.629]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[795.851,566.338],[795.851,667.675],[679.515,566.08],[679.515,666.452]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[795.851,670.68],[795.851,772.017],[679.515,669.428],[679.515,769.8]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[795.851,781.187],[795.851,882.525],[679.515,778.883],[679.515,879.255]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[795.102,454.409],[795.102,353.121],[824.791,458.625],[824.791,362.371]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[795.102,562.209],[795.102,460.921],[824.791,561.068],[824.791,464.814]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[795.102,566.325],[795.102,667.612],[824.791,564.979],[824.791,661.234]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[795.102,670.615],[795.102,771.902],[824.791,664.087],[824.791,760.341]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[795.102,781.068],[795.102,882.355],[824.791,769.052],[824.791,865.306]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[811.563,467.927],[811.563,385.835],[816.928,468.586],[816.928,387.252]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[811.563,558.633],[811.563,640.725],[816.928,558.454],[816.928,639.788]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[811.563,643.159],[811.563,725.25],[816.928,642.199],[816.928,723.533]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[811.563,732.679],[811.563,814.771],[816.928,730.893],[816.928,812.226]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[896.661,465.877],[896.661,381.426],[906.598,467.347],[906.598,384.589]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[896.661,555.758],[896.661,471.307],[906.598,555.427],[906.598,472.669]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[896.661,559.19],[896.661,643.641],[906.598,558.79],[906.598,641.549]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[896.661,646.145],[896.661,730.596],[906.598,644.003],[906.598,726.761]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[896.661,738.238],[896.661,822.689],[906.598,734.25],[906.598,817.009]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1101.4,452.28],[1101.4,348.452],[979.241,453.129],[979.241,350.314]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1101.4,562.784],[1101.4,458.956],[979.241,562.555],[979.241,459.74]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1101.4,567.004],[1101.4,670.832],[979.241,566.733],[979.241,669.548]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1101.4,673.911],[1101.4,777.739],[979.241,672.597],[979.241,775.412]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1101.4,787.134],[1101.4,890.962],[979.241,784.715],[979.241,887.53]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1260.84,450.059],[1260.84,343.578],[1097.8,451.206],[1097.8,346.094]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1260.84,563.385],[1260.84,456.905],[1097.8,563.075],[1097.8,457.964]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1260.84,567.713],[1260.84,674.193],[1097.8,567.347],[1097.8,672.458]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1260.84,677.35],[1260.84,783.831],[1097.8,675.574],[1097.8,780.685]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1260.84,793.466],[1260.84,899.946],[1097.8,790.197],[1097.8,895.308]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1260.84,450.059],[1260.84,343.578],[1262.42,451.124],[1262.42,345.916]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1260.84,563.385],[1260.84,456.905],[1262.42,563.097],[1262.42,457.889]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1260.84,567.713],[1260.84,674.193],[1262.42,567.373],[1262.42,672.581]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1260.84,677.35],[1260.84,783.831],[1262.42,675.701],[1262.42,780.909]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1260.84,793.466],[1260.84,899.946],[1262.42,790.429],[1262.42,895.638]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1390.29,450.235],[1262.42,451.124],[1390.29,343.966],[1262.42,345.916]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1390.29,563.338],[1390.29,457.068],[1262.42,563.097],[1262.42,457.889]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1390.29,567.656],[1262.42,567.373],[1390.29,673.926],[1262.42,672.581]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1390.29,677.077],[1262.42,675.701],[1390.29,783.346],[1262.42,780.909]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1390.29,792.962],[1262.42,790.429],[1390.29,899.232],[1262.42,895.638]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1287.16,465.153],[1287.16,379.869],[1288.17,465.864],[1288.17,381.397]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1287.16,559.387],[1287.16,644.671],[1288.17,559.194],[1288.17,643.66]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1287.16,647.2],[1287.16,732.484],[1288.17,646.164],[1288.17,730.631]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1287.16,740.201],[1287.16,825.485],[1288.17,738.274],[1288.17,822.74]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1393.75,446.932],[1518.84,446.03],[1393.75,340.676],[1518.84,338.737]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1393.75,560.02],[1393.75,453.764],[1518.84,560.223],[1518.84,452.929]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1393.75,564.338],[1518.84,564.583],[1393.75,670.594],[1518.84,671.876]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1393.75,673.744],[1518.84,675.057],[1393.75,780],[1518.84,782.351]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1393.75,789.615],[1518.84,792.06],[1393.75,895.871],[1518.84,899.353]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1520.45,444.84],[1520.45,336.176],[1694.77,443.567],[1694.77,333.44]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1520.45,560.49],[1520.45,451.827],[1694.77,560.777],[1694.77,450.649]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1520.45,564.906],[1520.45,673.57],[1694.77,565.252],[1694.77,675.38]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1520.45,676.792],[1520.45,785.456],[1694.77,678.645],[1694.77,788.773]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1520.45,795.289],[1520.45,903.953],[1694.77,798.739],[1694.77,908.867]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1691.04,444.749],[1691.04,335.981],[1827.75,443.764],[1827.75,333.861]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1691.04,676.924],[1691.04,785.692],[1827.75,678.36],[1827.75,788.262]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1691.04,795.534],[1691.04,904.302],[1827.75,798.207],[1827.75,908.109]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1691.04,560.511],[1691.04,451.743],[1827.75,560.732],[1827.75,450.83]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:7,
                    verts:[[1691.04,564.931],[1691.04,673.699],[1827.75,565.199],[1827.75,675.101]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[164.858,456.005],[164.858,357.532],[52.5407,456.437],[52.5407,358.475]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[164.858,560.811],[164.858,462.337],[52.5407,560.699],[52.5407,462.736]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[164.858,564.813],[164.858,663.286],[52.5407,564.68],[52.5407,662.643]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[164.858,666.206],[164.858,764.68],[52.5407,665.547],[52.5407,763.51]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[164.858,773.591],[164.858,872.064],[52.5407,772.375],[52.5407,870.337]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[301.18,454.476],[301.18,354.193],[153.032,455.053],[153.032,355.452]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[301.18,561.207],[301.18,460.924],[153.032,561.058],[153.032,461.457]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[301.18,565.282],[301.18,665.565],[153.032,565.105],[153.032,664.706]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[301.18,668.538],[301.18,768.821],[153.032,667.659],[153.032,767.26]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[301.18,777.896],[301.18,878.178],[153.032,776.272],[153.032,875.873]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[301.18,454.476],[301.18,354.193],[311.756,455.475],[311.756,356.375]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[301.18,561.207],[301.18,460.924],[311.756,560.948],[311.756,461.848]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[301.18,565.282],[301.18,665.565],[311.756,564.975],[311.756,664.076]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[301.18,668.538],[301.18,768.821],[311.756,667.014],[311.756,766.115]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[301.18,777.896],[301.18,878.178],[311.756,775.082],[311.756,874.183]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[426.217,455.035],[426.217,355.414],[311.756,455.475],[311.756,356.375]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[426.217,561.062],[426.217,461.441],[311.756,560.948],[311.756,461.848]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[426.217,565.11],[426.217,664.732],[311.756,564.975],[311.756,664.076]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[426.217,667.685],[426.217,767.306],[311.756,667.014],[311.756,766.115]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[426.217,776.321],[426.217,875.942],[311.756,775.082],[311.756,874.183]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[540.29,561.948],[540.29,461.811],[425.11,561.829],[425.11,462.216]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[540.29,669.123],[540.29,769.26],[425.11,668.444],[425.11,768.057]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[540.29,778.322],[540.29,878.458],[425.11,777.071],[425.11,876.684]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[540.29,455.372],[540.29,355.235],[425.11,455.811],[425.11,356.198]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[540.29,566.017],[540.29,666.154],[425.11,565.877],[425.11,665.49]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[472.765,468.787],[472.765,387.685],[479.698,469.46],[479.698,389.133]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[472.765,558.399],[472.765,639.501],[479.698,558.216],[479.698,638.543]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[472.765,641.906],[472.765,723.008],[479.698,640.925],[479.698,721.252]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[472.765,730.347],[472.765,811.448],[479.698,728.521],[479.698,808.847]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[685.762,453.769],[685.762,351.719],[532.359,454.361],[532.359,353.017]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[685.762,562.382],[685.762,460.331],[532.359,562.221],[532.359,460.877]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[685.762,566.529],[685.762,668.579],[532.359,566.34],[532.359,667.684]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[685.762,671.605],[685.762,773.655],[532.359,670.689],[532.359,772.033]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[685.762,782.89],[685.762,884.94],[532.359,781.204],[532.359,882.548]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[685.761,453.769],[685.761,351.719],[691.701,454.76],[691.701,353.892]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[685.761,562.382],[685.761,460.331],[691.701,562.113],[691.701,461.246]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[685.761,566.529],[685.761,668.579],[691.701,566.213],[691.701,667.08]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[685.761,671.605],[685.761,773.655],[691.701,670.071],[691.701,770.939]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[685.761,782.89],[685.761,884.94],[691.701,780.066],[691.701,880.934]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[810.802,454.306],[810.802,352.897],[691.702,454.76],[691.702,353.892]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[810.802,562.236],[810.802,460.827],[691.702,562.113],[691.702,461.246]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[810.802,566.357],[810.802,667.767],[691.702,566.213],[691.702,667.08]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[810.802,670.774],[810.802,772.183],[691.702,670.071],[691.702,770.939]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[810.802,781.36],[810.802,882.77],[691.702,780.066],[691.702,880.934]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[787.43,467.801],[787.43,385.565],[791.276,468.47],[791.276,387.003]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[787.43,558.667],[787.43,640.904],[791.276,558.485],[791.276,639.952]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[787.43,643.342],[787.43,725.578],[791.276,642.367],[791.276,723.834]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[787.43,733.02],[787.43,815.256],[791.276,731.206],[791.276,812.673]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[809.949,454.345],[809.949,352.983],[829.479,458.616],[829.479,362.351]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[809.949,562.226],[809.949,460.863],[829.479,561.07],[829.479,464.805]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[809.949,566.345],[809.949,667.707],[829.479,564.982],[829.479,661.247]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[809.949,670.713],[809.949,772.076],[829.479,664.101],[829.479,760.366]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[809.949,781.248],[809.949,882.61],[829.479,769.077],[829.479,865.342]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[877.423,465.983],[877.423,381.655],[883.919,467.467],[883.919,384.845]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[877.423,555.734],[877.423,471.406],[883.919,555.4],[883.919,472.779]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[877.423,559.161],[877.423,643.49],[883.919,558.758],[883.919,641.379]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[877.423,645.99],[877.423,730.318],[883.919,643.829],[883.919,726.45]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[877.423,737.949],[877.423,822.278],[883.919,733.927],[883.919,816.548]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1118.81,453.168],[1118.81,350.4],[996.442,453.635],[996.442,351.423]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1118.81,562.544],[1118.81,459.776],[996.442,562.418],[996.442,460.207]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1118.81,566.72],[1118.81,669.488],[996.442,566.572],[996.442,668.783]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1118.81,672.535],[996.442,671.814],[1118.81,775.303],[996.442,774.025]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1118.81,784.603],[996.442,783.274],[1118.81,887.371],[996.442,885.486]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1117.82,452.103],[1279.53,451.479],[1117.82,348.063],[1279.53,346.695]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1117.82,562.832],[1279.53,563.001],[1117.82,458.793],[1279.53,458.217]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1117.82,567.06],[1279.53,567.259],[1117.82,671.1],[1279.53,672.044]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1117.82,674.185],[1279.53,675.15],[1117.82,778.225],[1279.53,779.935]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1117.82,787.639],[1279.53,789.417],[1117.82,891.679],[1279.53,894.201]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1278.56,452.524],[1278.56,348.986],[1404.07,452.045],[1404.07,347.936]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1278.56,673.534],[1404.07,674.274],[1278.56,777.071],[1404.07,778.383]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1278.56,786.441],[1404.07,787.804],[1278.56,889.978],[1404.07,891.913]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1278.56,562.719],[1278.56,459.181],[1404.07,562.848],[1404.07,458.739]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1278.56,566.926],[1278.56,670.464],[1404.07,567.079],[1404.07,671.188]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1407.36,448.82],[1407.36,344.736],[1529.01,448.339],[1529.01,343.703]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1407.36,559.595],[1407.36,455.512],[1529.01,559.703],[1529.01,455.067]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1407.36,563.825],[1407.36,667.908],[1529.01,563.956],[1529.01,668.592]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1407.36,670.994],[1407.36,775.077],[1529.01,671.694],[1529.01,776.331]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1407.36,784.496],[1407.36,888.579],[1529.01,785.799],[1529.01,890.435]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1533.17,447.193],[1533.17,341.238],[1700.9,446.522],[1700.9,339.795]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1533.17,559.961],[1533.17,454.006],[1700.9,560.112],[1700.9,453.385]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1533.17,564.267],[1533.17,670.222],[1700.9,564.449],[1700.9,671.177]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1533.17,673.364],[1533.17,779.319],[1700.9,674.341],[1700.9,781.069]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1533.17,788.907],[1533.17,894.862],[1700.9,790.726],[1700.9,897.454]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1694.81,447.645],[1694.81,342.211],[1824.97,447.131],[1824.97,341.104]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1694.81,672.705],[1694.81,778.139],[1824.97,673.454],[1824.97,779.481]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1694.81,787.68],[1694.81,893.115],[1824.97,789.075],[1824.97,895.102]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1694.81,559.859],[1694.81,454.425],[1824.97,559.975],[1824.97,453.948]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:8,
                    verts:[[1694.81,564.144],[1694.81,669.578],[1824.97,564.284],[1824.97,670.31]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[157.607,453.936],[157.607,353.014],[38.0594,454.03],[38.0594,353.22]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[157.607,561.347],[157.607,460.425],[38.0594,561.322],[38.0594,460.512]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[157.607,565.448],[157.607,666.37],[38.0594,565.419],[38.0594,666.229]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[157.607,669.362],[157.607,770.284],[38.0594,669.218],[38.0594,770.029]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[157.607,779.417],[157.607,880.339],[38.0594,779.151],[38.0594,879.961]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[303.895,452.805],[303.895,350.545],[147.573,452.93],[147.573,350.818]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[303.895,561.64],[303.895,459.38],[147.573,561.607],[147.573,459.495]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[303.895,565.795],[303.895,668.055],[147.573,565.757],[147.573,667.869]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[303.895,671.087],[303.895,773.347],[147.573,670.897],[147.573,773.009]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[303.895,782.6],[303.895,884.86],[147.573,782.249],[147.573,884.361]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[303.895,452.805],[303.895,350.545],[312.406,453.849],[312.406,352.825]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[303.895,561.64],[303.895,459.38],[312.406,561.369],[312.406,460.345]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[303.895,565.795],[303.895,668.055],[312.406,565.475],[312.406,666.499]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[303.895,671.087],[303.895,773.347],[312.406,669.495],[312.406,770.519]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[303.895,782.6],[303.895,884.86],[312.406,779.661],[312.406,880.685]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[431.954,453.755],[431.954,352.619],[312.406,453.849],[312.406,352.825]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[431.954,561.394],[431.954,460.258],[312.406,561.369],[312.406,460.345]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[431.954,565.504],[431.954,666.64],[312.406,565.475],[312.406,666.499]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[431.954,669.638],[431.954,770.774],[312.406,669.495],[312.406,770.519]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[431.954,779.926],[431.954,881.062],[312.406,779.661],[312.406,880.685]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[550.115,454.445],[550.115,353.202],[430.798,454.539],[430.798,353.406]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[550.115,562.199],[550.115,460.955],[430.798,562.173],[430.798,461.041]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[550.115,670.558],[550.115,771.802],[430.798,670.414],[430.798,771.546]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[550.115,780.963],[550.115,882.207],[430.798,780.697],[430.798,881.829]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[550.115,566.313],[550.115,667.556],[430.798,566.283],[430.798,667.415]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[441.365,467.738],[441.365,385.43],[446.891,468.435],[446.891,386.929]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[441.365,558.684],[441.365,640.993],[446.891,558.495],[446.891,640.001]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[441.365,643.433],[441.365,725.742],[446.891,642.418],[446.891,723.925]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[441.365,733.19],[441.365,815.499],[446.891,731.3],[446.891,812.807]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[701.967,453.282],[701.967,350.649],[544.499,453.406],[544.499,350.922]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[701.967,562.513],[701.967,459.881],[544.499,562.48],[544.499,459.996]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[701.967,566.684],[701.967,669.317],[544.499,566.645],[544.499,669.129]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[701.967,672.36],[701.967,774.993],[544.499,672.167],[544.499,774.651]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[701.967,784.28],[701.967,886.913],[544.499,783.925],[544.499,886.409]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[701.966,453.282],[701.966,350.649],[705.557,454.289],[705.557,352.858]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[701.966,562.513],[701.966,459.881],[705.557,562.241],[705.557,460.81]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[701.966,566.684],[701.966,669.317],[705.557,566.363],[705.557,667.794]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[701.966,672.36],[701.966,774.993],[705.557,670.801],[705.557,772.232]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[701.966,784.28],[701.966,886.913],[705.557,781.41],[705.557,882.841]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[826.586,454.194],[826.586,352.65],[705.558,454.289],[705.558,352.858]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[826.586,562.267],[826.586,460.723],[705.558,562.241],[705.558,460.81]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[826.586,566.393],[826.586,667.937],[705.558,566.363],[705.558,667.794]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[826.586,670.947],[826.586,772.491],[705.558,670.801],[705.558,772.232]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[826.586,781.68],[705.558,781.41],[826.586,883.223],[705.558,882.841]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[764.177,467.55],[764.177,385.024],[766.483,468.227],[766.483,386.48]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[764.177,558.736],[764.177,641.262],[766.483,558.552],[766.483,640.299]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[764.177,643.708],[764.177,726.234],[766.483,642.722],[766.483,724.469]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[764.177,733.702],[764.177,816.228],[766.483,731.866],[766.483,813.613]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[825.636,781.575],[825.636,883.075],[834.889,769.314],[834.889,865.678]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[825.636,454.231],[825.636,352.731],[834.889,458.533],[834.889,362.169]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[825.636,562.257],[825.636,460.757],[834.889,561.093],[834.889,464.729]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[825.636,566.381],[825.636,667.881],[834.889,565.009],[834.889,661.373]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[825.636,670.891],[825.636,772.391],[834.889,664.23],[834.889,760.594]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[858.748,465.969],[858.748,381.624],[861.795,467.461],[861.795,384.832]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[858.748,555.737],[858.748,471.393],[861.795,555.402],[861.795,472.773]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[858.748,559.165],[858.748,643.51],[861.795,558.76],[861.795,641.388]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[858.748,646.01],[858.748,730.355],[861.795,643.838],[861.795,726.466]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[858.748,737.988],[858.748,822.332],[861.795,733.943],[861.795,816.572]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1013.11,454.083],[1134.79,453.988],[1013.11,352.408],[1134.79,352.199]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1013.11,562.297],[1013.11,460.621],[1134.79,562.322],[1134.79,460.533]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1013.11,566.428],[1013.11,668.104],[1134.79,566.459],[1134.79,668.248]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1013.11,671.119],[1134.79,671.266],[1013.11,772.794],[1134.79,773.055]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1013.11,781.995],[1134.79,782.266],[1013.11,883.67],[1134.79,884.055]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1136.35,452.938],[1136.35,349.895],[1295.54,452.812],[1295.54,349.618]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1136.35,562.607],[1136.35,459.563],[1295.54,562.641],[1295.54,459.447]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1136.35,566.794],[1136.35,669.837],[1295.54,566.834],[1295.54,670.028]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1136.35,672.892],[1136.35,775.935],[1295.54,673.087],[1295.54,776.281]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1136.35,785.26],[1136.35,888.303],[1295.54,785.619],[1295.54,888.812]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1292.16,453.83],[1292.16,351.852],[1414.5,453.734],[1414.5,351.642]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1292.16,566.509],[1292.16,668.487],[1414.5,566.54],[1414.5,668.632]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1292.16,671.511],[1292.16,773.489],[1414.5,671.659],[1414.5,773.752]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1292.16,782.717],[1292.16,884.696],[1414.5,782.99],[1414.5,885.082]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1292.16,562.365],[1292.16,460.387],[1414.5,562.391],[1414.5,460.299]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1417.61,450.581],[1417.61,348.525],[1535.15,450.486],[1535.15,348.32]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1417.61,559.199],[1417.61,457.143],[1535.15,559.22],[1535.15,457.055]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1417.61,563.346],[1417.61,665.402],[1535.15,563.372],[1535.15,665.538]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1417.61,668.428],[1417.61,770.484],[1535.15,668.567],[1535.15,770.732]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1417.61,779.719],[1417.61,881.775],[1535.15,779.977],[1535.15,882.143]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1541.66,449.388],[1541.66,345.959],[1702.04,449.256],[1702.04,345.676]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1541.66,559.467],[1541.66,456.038],[1702.04,559.497],[1702.04,455.916]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1541.66,563.67],[1541.66,667.099],[1702.04,563.706],[1702.04,667.287]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1541.66,670.166],[1541.66,773.595],[1702.04,670.358],[1702.04,773.938]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1541.66,782.954],[1541.66,886.383],[1702.04,783.311],[1702.04,886.892]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1693.84,450.32],[1693.84,347.964],[1817.09,450.22],[1817.09,347.749]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1693.84,668.808],[1693.84,771.164],[1817.09,668.954],[1817.09,771.425]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1693.84,780.426],[1693.84,882.782],[1817.09,780.697],[1817.09,883.169]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1693.84,559.258],[1693.84,456.901],[1817.09,559.28],[1817.09,456.809]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:9,
                    verts:[[1693.84,563.417],[1693.84,665.773],[1817.09,563.444],[1817.09,665.915]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[154.871,451.706],[154.871,348.147],[28.3651,451.425],[28.3651,347.533]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[154.871,561.924],[154.871,458.365],[28.3651,561.997],[28.3651,458.105]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[154.871,566.133],[154.871,669.692],[28.3651,566.219],[28.3651,670.111]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[154.871,672.762],[154.871,776.322],[28.3651,673.191],[28.3651,777.083]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[154.871,785.693],[154.871,889.252],[28.3651,786.485],[28.3651,890.377]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[310.712,451.017],[310.712,346.643],[146.831,450.648],[146.831,345.838]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[310.712,562.103],[310.712,457.728],[146.831,562.198],[146.831,457.388]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[310.712,566.344],[310.712,670.719],[146.831,566.458],[146.831,671.268]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[310.712,673.813],[310.712,778.188],[146.831,674.376],[146.831,779.187]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[310.712,787.633],[310.712,892.007],[146.831,788.671],[146.831,893.482]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[441.02,452.379],[441.02,349.615],[316.982,452.103],[316.982,349.013]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[441.02,561.75],[441.02,458.986],[316.982,561.821],[316.982,458.732]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[441.02,565.926],[441.02,668.69],[316.982,566.011],[316.982,669.101]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[441.02,671.737],[441.02,774.501],[316.982,672.157],[316.982,775.247]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[441.02,783.8],[441.02,886.564],[316.982,784.576],[316.982,887.666]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[562.577,453.442],[562.577,351.001],[439.819,453.172],[439.819,350.408]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[562.577,783.823],[562.577,886.264],[439.819,784.594],[439.819,887.358]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[562.577,562.47],[562.577,460.029],[439.819,562.543],[439.819,459.779]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[562.577,566.633],[562.577,669.074],[439.819,566.719],[439.819,669.483]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[562.577,672.112],[562.577,774.553],[439.819,672.53],[439.819,775.294]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[719.857,452.737],[719.857,349.455],[559.389,452.38],[559.389,348.67]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[719.857,562.661],[719.857,459.378],[559.389,562.758],[559.389,459.048]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[719.857,566.858],[719.857,670.14],[559.389,566.972],[559.389,670.682]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[719.857,673.203],[719.857,776.485],[559.389,673.757],[559.389,777.466]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[719.857,785.831],[559.389,786.851],[719.857,889.113],[559.389,890.56]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[843.147,454.025],[721.037,453.756],[843.147,352.279],[721.037,351.689]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[843.147,562.312],[843.147,460.567],[721.037,562.385],[721.037,460.318]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[843.147,566.447],[721.037,566.533],[843.147,668.193],[721.037,668.6]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[843.147,671.21],[721.037,671.626],[843.147,772.955],[721.037,773.693]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[843.147,782.162],[721.037,782.929],[843.147,883.908],[721.037,884.996]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[994.422,465.999],[994.422,381.689],[990.642,467.588],[990.642,385.107]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[994.422,555.731],[994.422,471.42],[990.642,555.373],[990.642,472.892]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[994.422,559.157],[994.422,643.467],[990.642,558.725],[990.642,641.206]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[994.422,645.967],[994.422,730.277],[990.642,643.652],[990.642,726.133]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[994.422,737.906],[994.422,822.217],[990.642,733.597],[990.642,816.078]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1029.19,454.497],[1029.19,353.314],[1018.89,458.67],[1018.89,362.469]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1029.19,562.185],[1029.19,461.002],[1018.89,561.056],[1018.89,464.855]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1029.19,566.297],[1029.19,667.479],[1018.89,564.965],[1018.89,661.165]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1029.19,670.479],[1029.19,771.661],[1018.89,664.018],[1018.89,760.218]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1029.19,780.817],[1029.19,882],[1018.89,768.923],[1018.89,865.124]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1029.24,454.47],[1029.24,353.256],[1149.38,454.734],[1149.38,353.836]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1029.24,562.192],[1029.24,460.978],[1149.38,562.12],[1149.38,461.222]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1029.24,566.305],[1029.24,667.519],[1149.38,566.221],[1149.38,667.119]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1029.24,670.52],[1029.24,771.734],[1149.38,670.11],[1149.38,771.009]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1029.24,780.893],[1029.24,882.107],[1149.38,780.139],[1149.38,881.037]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1088.63,467.789],[1088.63,385.538],[1086.01,468.484],[1086.01,387.033]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1088.63,558.67],[1088.63,640.921],[1086.01,558.482],[1086.01,639.932]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1088.63,643.36],[1088.63,725.61],[1086.01,642.347],[1086.01,723.798]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1088.63,733.053],[1088.63,815.303],[1086.01,731.169],[1086.01,812.619]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1153.39,453.704],[1153.39,351.576],[1149.38,454.734],[1149.38,353.836]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1153.39,562.399],[1153.39,460.271],[1149.38,562.12],[1149.38,461.222]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1153.39,566.549],[1153.39,668.678],[1149.38,566.221],[1149.38,667.119]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1153.39,671.706],[1153.39,773.834],[1149.38,670.11],[1149.38,771.009]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1153.39,783.076],[1153.39,885.204],[1149.38,780.139],[1149.38,881.037]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1153.39,453.704],[1153.39,351.576],[1309.02,454.051],[1309.02,352.337]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1153.39,562.399],[1153.39,460.271],[1309.02,562.305],[1309.02,460.591]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1153.39,566.549],[1153.39,668.678],[1309.02,566.439],[1309.02,668.153]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1153.39,671.706],[1153.39,773.834],[1309.02,671.169],[1309.02,772.883]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1153.39,783.076],[1153.39,885.204],[1309.02,782.087],[1309.02,883.801]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1303.35,455.039],[1303.35,354.504],[1421.83,455.3],[1421.83,355.076]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1303.35,669.639],[1303.35,770.174],[1421.83,669.235],[1421.83,769.459]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1303.35,779.272],[1303.35,879.807],[1421.83,778.528],[1421.83,878.751]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1303.35,562.038],[1303.35,461.503],[1421.83,561.967],[1421.83,461.744]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1303.35,566.124],[1303.35,666.659],[1421.83,566.04],[1421.83,666.264]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1406.1,468.379],[1406.1,386.808],[1400.45,469.063],[1400.45,388.278]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1406.1,558.51],[1406.1,640.081],[1400.45,558.324],[1400.45,639.109]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1406.1,642.5],[1406.1,724.071],[1400.45,641.504],[1400.45,722.288]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1406.1,731.452],[1406.1,813.023],[1400.45,729.599],[1400.45,810.383]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1424.76,452.213],[1424.76,352.036],[1537.62,452.471],[1537.62,352.591]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1424.76,558.832],[1424.76,458.655],[1537.62,558.774],[1537.62,458.893]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1424.76,562.903],[1424.76,663.08],[1537.62,562.833],[1537.62,662.713]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1424.76,666.05],[1424.76,766.227],[1537.62,665.674],[1537.62,765.554]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1424.76,775.292],[1424.76,875.469],[1537.62,774.593],[1537.62,874.473]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1546.28,451.424],[1546.28,350.339],[1537.62,452.471],[1537.62,352.591]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1546.28,559.009],[1546.28,457.924],[1537.62,558.774],[1537.62,458.893]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1546.28,563.117],[1546.28,664.203],[1537.62,562.833],[1537.62,662.713]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1546.28,667.2],[1546.28,768.285],[1537.62,665.674],[1537.62,765.554]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1546.28,777.432],[1546.28,878.518],[1537.62,774.593],[1537.62,874.473]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1546.28,451.424],[1546.28,350.339],[1698.74,451.777],[1698.74,351.097]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1546.28,559.009],[1546.28,457.924],[1698.74,558.93],[1698.74,458.25]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1546.28,563.117],[1546.28,664.203],[1698.74,563.021],[1698.74,663.701]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1546.28,667.2],[1546.28,768.285],[1698.74,666.686],[1698.74,767.366]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1546.28,777.432],[1546.28,878.518],[1698.74,776.476],[1698.74,877.156]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1688.66,452.781],[1688.66,353.256],[1804.76,453.046],[1804.76,353.827]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1688.66,665.224],[1688.66,764.748],[1804.76,664.837],[1804.76,764.056]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1688.66,773.754],[1688.66,873.278],[1804.76,773.034],[1804.76,872.253]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1688.66,558.704],[1688.66,459.18],[1804.76,558.644],[1804.76,459.426]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:10,
                    verts:[[1688.66,562.749],[1688.66,662.273],[1804.76,562.677],[1804.76,661.895]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[156.945,449.307],[156.945,342.909],[23.849,448.607],[23.849,341.382]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[156.945,562.546],[156.945,456.148],[23.849,562.727],[23.849,455.502]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[156.945,566.869],[156.945,673.267],[23.849,567.084],[23.849,674.309]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[156.945,676.421],[156.945,782.819],[23.849,677.489],[23.849,784.714]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[156.945,792.447],[156.945,898.844],[23.849,794.417],[23.849,901.642]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[321.813,449.107],[321.813,342.474],[151.114,448.199],[151.114,340.491]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[321.813,562.597],[321.813,455.964],[151.114,562.833],[151.114,455.125]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[321.813,566.931],[321.813,673.564],[151.114,567.21],[151.114,674.918]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[321.813,676.726],[321.813,783.359],[151.114,678.111],[151.114,785.819]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[321.813,793.009],[321.813,899.642],[151.114,795.566],[151.114,903.274]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[453.508,450.903],[453.508,346.394],[325.659,450.231],[325.659,344.927]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[453.508,562.132],[453.508,457.623],[325.659,562.306],[325.659,457.002]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[453.508,566.379],[453.508,670.888],[325.659,566.586],[325.659,671.89]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[453.508,673.987],[453.508,778.496],[325.659,675.012],[325.659,780.316]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[453.508,787.953],[325.659,789.845],[453.508,892.462],[325.659,895.149]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[577.707,562.763],[577.707,459.029],[452.27,562.94],[452.27,458.426]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[577.707,566.979],[577.707,670.713],[452.27,567.187],[452.27,671.701]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[577.707,452.359],[452.27,451.706],[577.707,348.625],[452.27,347.192]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[577.707,673.788],[452.27,674.8],[577.707,777.522],[452.27,779.314]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[577.707,786.909],[452.27,788.771],[577.707,890.643],[452.27,893.285]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[577.055,451.279],[739.396,452.135],[577.055,346.255],[739.396,348.132]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[577.055,563.055],[577.055,458.031],[739.396,562.824],[739.396,458.822]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[577.055,567.323],[739.396,567.05],[577.055,672.347],[739.396,671.052]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[577.055,675.461],[739.396,674.136],[577.055,780.485],[739.396,778.138]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[577.055,789.989],[739.396,787.549],[577.055,895.013],[739.396,891.551]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[738.114,453.159],[738.114,350.379],[860.445,453.796],[860.445,351.777]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[738.114,672.551],[738.114,775.33],[860.445,671.564],[860.445,773.583]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[738.114,784.631],[860.445,782.814],[738.114,887.41],[860.445,884.833]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[738.114,562.547],[738.114,459.767],[860.445,562.374],[860.445,460.356]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[738.114,566.724],[738.114,669.503],[860.445,566.52],[860.445,668.539]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[976.357,466.132],[976.357,381.974],[968.923,467.703],[968.923,385.353]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[976.357,555.701],[976.357,471.543],[968.923,555.347],[968.923,472.998]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[976.357,559.121],[976.357,643.278],[968.923,558.694],[968.923,641.044]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[976.357,645.773],[976.357,729.931],[968.923,643.485],[968.923,725.835]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[976.357,737.547],[976.357,821.704],[968.923,733.287],[968.923,815.637]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1044.68,454.818],[1044.68,354.019],[1024.51,458.928],[1024.51,363.036]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1044.68,562.098],[1044.68,461.299],[1024.51,560.986],[1024.51,465.094]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1044.68,566.194],[1044.68,666.993],[1024.51,564.883],[1024.51,660.774]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1044.68,669.982],[1044.68,770.78],[1024.51,663.618],[1024.51,759.509]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1044.68,779.902],[1044.68,880.7],[1024.51,768.187],[1024.51,864.079]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1044.79,454.792],[1044.79,353.962],[1162.6,455.405],[1162.6,355.307]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1044.79,562.105],[1044.79,461.275],[1162.6,561.939],[1162.6,461.841]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1044.79,566.202],[1044.79,667.033],[1162.6,566.007],[1162.6,666.104]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1044.79,670.022],[1044.79,770.852],[1162.6,669.072],[1162.6,769.17]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1044.79,779.976],[1044.79,880.806],[1162.6,778.228],[1162.6,878.325]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1065.6,468.146],[1065.6,386.306],[1061.42,468.828],[1061.42,387.773]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1065.6,558.574],[1065.6,640.414],[1061.42,558.388],[1061.42,639.443]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1065.6,642.84],[1065.6,724.68],[1061.42,641.846],[1061.42,722.9]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1065.6,732.086],[1065.6,813.926],[1061.42,730.235],[1061.42,811.29]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1168.99,454.4],[1168.99,353.101],[1162.6,455.405],[1162.6,355.307]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1168.99,562.211],[1168.99,460.913],[1162.6,561.939],[1162.6,461.841]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1168.99,566.328],[1168.99,667.626],[1162.6,566.007],[1162.6,666.104]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1168.99,670.629],[1168.99,771.927],[1162.6,669.072],[1162.6,769.17]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1168.99,781.094],[1168.99,882.392],[1162.6,778.228],[1162.6,878.325]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1168.99,454.4],[1168.99,353.101],[1320.07,455.196],[1320.07,354.849]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1168.99,562.211],[1168.99,460.913],[1320.07,561.995],[1320.07,461.648]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1168.99,566.328],[1168.99,667.626],[1320.07,566.073],[1320.07,666.421]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1168.99,670.629],[1168.99,771.927],[1320.07,669.396],[1320.07,769.743]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1168.99,781.094],[1168.99,882.392],[1320.07,778.824],[1320.07,879.171]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1312.24,456.15],[1312.24,356.941],[1426.25,456.744],[1426.25,358.244]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1312.24,667.919],[1312.24,767.128],[1426.25,667],[1426.25,765.499]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1312.24,776.106],[1312.24,875.314],[1426.25,774.413],[1426.25,872.912]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1312.24,561.737],[1312.24,462.529],[1426.25,561.577],[1426.25,463.077]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1312.24,565.769],[1312.24,664.978],[1426.25,565.58],[1426.25,664.079]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1374.52,469.502],[1374.52,389.223],[1367.51,470.159],[1367.51,390.635]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1374.52,558.205],[1374.52,638.484],[1367.51,558.027],[1367.51,637.55]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1374.52,640.864],[1374.52,721.144],[1367.51,639.908],[1367.51,719.431]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1374.52,728.408],[1374.52,808.687],[1367.51,726.627],[1367.51,806.15]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1428.98,453.719],[1428.98,355.274],[1536.71,454.301],[1536.71,356.526]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1428.98,558.493],[1428.98,460.049],[1536.71,558.362],[1536.71,460.588]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1428.98,562.494],[1428.98,660.938],[1536.71,562.336],[1536.71,660.11]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1428.98,663.857],[1428.98,762.301],[1536.71,663.009],[1536.71,760.784]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1428.98,771.209],[1428.98,869.654],[1536.71,769.631],[1536.71,867.406]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1547.32,453.306],[1547.32,354.386],[1536.71,454.301],[1536.71,356.526]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1547.32,558.586],[1547.32,459.666],[1536.71,558.362],[1536.71,460.587]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1547.32,562.606],[1547.32,661.526],[1536.71,562.336],[1536.71,660.11]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1547.32,664.459],[1547.32,763.378],[1536.71,663.009],[1536.71,760.784]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1547.32,772.33],[1547.32,871.249],[1536.71,769.631],[1536.71,867.406]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1547.32,453.306],[1547.32,354.386],[1691.42,454.094],[1691.42,356.081]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1547.32,558.586],[1547.32,459.666],[1691.42,558.409],[1691.42,460.396]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1547.32,562.606],[1547.32,661.526],[1691.42,562.392],[1691.42,660.405]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1547.32,664.459],[1547.32,763.378],[1691.42,663.311],[1691.42,761.323]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1547.32,772.33],[1547.32,871.249],[1691.42,770.193],[1691.42,868.205]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1679.66,455.038],[1679.66,358.111],[1788.49,455.626],[1788.49,359.377]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1679.66,661.935],[1679.66,758.862],[1788.49,661.079],[1788.49,757.328]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1679.66,767.633],[1679.66,864.559],[1788.49,766.038],[1788.49,862.287]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1679.66,558.196],[1679.66,461.27],[1788.49,558.064],[1788.49,461.815]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:11,
                    verts:[[1679.66,562.135],[1679.66,659.062],[1788.49,561.975],[1788.49,658.225]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[164.234,446.731],[164.234,337.286],[25.0412,445.564],[25.0412,334.74]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[164.234,563.213],[164.234,453.768],[25.0412,563.515],[25.0412,452.69]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[164.234,567.66],[164.234,677.105],[25.0412,568.018],[25.0412,678.843]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[164.234,680.35],[164.234,789.795],[25.0412,682.129],[25.0412,792.954]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[164.234,799.699],[164.234,909.144],[25.0412,802.982],[25.0412,913.807]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[337.453,447.074],[337.453,338.034],[160.843,445.576],[160.843,334.764]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[337.453,563.124],[337.453,454.085],[160.843,563.512],[160.843,452.701]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[337.453,567.555],[337.453,676.594],[160.843,568.015],[160.843,678.826]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[337.453,679.827],[337.453,788.867],[160.843,682.112],[160.843,792.923]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[337.453,798.734],[160.843,802.951],[337.453,907.773],[160.843,913.762]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[469.568,449.328],[338.688,448.231],[469.568,342.954],[338.688,340.561]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[469.568,562.54],[469.568,456.167],[338.688,562.824],[338.688,455.154]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[469.568,566.863],[338.688,567.2],[469.568,673.236],[338.688,674.87]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[469.568,676.39],[338.688,678.062],[469.568,782.763],[338.688,785.732]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[469.568,792.389],[338.688,795.475],[469.568,898.762],[338.688,903.145]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[468.299,450.141],[595.575,451.197],[468.299,343.758],[595.575,346.076]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[468.299,563.363],[468.299,456.981],[595.575,563.078],[595.575,457.956]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[468.299,567.687],[468.299,674.069],[595.575,567.349],[595.575,672.471]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[468.299,677.223],[595.575,675.588],[468.299,783.606],[595.575,780.709]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[468.299,793.232],[595.575,790.221],[468.299,899.615],[595.575,895.343]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[567.877,465.061],[567.877,379.671],[566.575,465.793],[566.575,381.245]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[567.877,559.412],[567.877,644.802],[566.575,559.213],[566.575,643.761]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[567.877,647.334],[567.877,732.724],[566.575,646.268],[566.575,730.816]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[567.877,740.451],[567.877,825.841],[566.575,738.467],[566.575,823.015]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[597.559,450.104],[597.559,343.677],[595.576,451.197],[595.576,346.076]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[597.559,563.373],[597.559,456.947],[595.576,563.078],[595.576,457.956]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[597.559,567.698],[597.559,674.125],[595.576,567.349],[595.576,672.471]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[597.559,677.28],[597.559,783.707],[595.576,675.588],[595.576,780.709]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[597.559,793.337],[597.559,899.764],[595.576,790.222],[595.576,895.343]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[597.56,450.104],[597.56,343.677],[760.576,451.474],[760.576,346.683]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[597.56,563.373],[597.56,456.947],[760.576,563.003],[760.576,458.212]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[597.56,567.698],[597.56,674.125],[760.576,567.261],[760.576,672.052]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[597.56,677.28],[597.56,783.707],[760.576,675.159],[760.576,779.95]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[597.56,793.337],[597.56,899.764],[760.576,789.432],[760.576,894.223]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[756.786,452.498],[756.786,348.93],[878.451,453.508],[878.451,351.146]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[756.786,673.573],[756.786,777.141],[878.451,672.009],[878.451,774.371]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[756.786,786.513],[756.786,890.081],[878.451,783.634],[878.451,885.996]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[756.786,562.725],[756.786,459.157],[878.451,562.452],[878.451,460.09]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[756.786,566.934],[756.786,670.502],[878.451,566.612],[878.451,668.974]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[958.226,466.14],[958.226,381.992],[947.168,467.688],[947.168,385.321]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[958.226,555.699],[958.226,471.551],[947.168,555.351],[947.168,472.984]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[958.226,559.119],[958.226,643.267],[947.168,558.698],[947.168,641.065]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[958.226,645.762],[958.226,729.91],[947.168,643.507],[947.168,725.874]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[958.226,737.525],[958.226,821.673],[947.168,733.328],[947.168,815.695]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1059.58,455.075],[1059.58,354.584],[1029.73,459.103],[1029.73,363.421]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1059.58,562.028],[1059.58,461.537],[1029.73,560.938],[1029.73,465.256]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1059.58,566.112],[1059.58,666.604],[1029.73,564.827],[1029.73,660.509]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1059.58,669.583],[1059.58,770.075],[1029.73,663.346],[1029.73,759.029]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1059.58,779.168],[1059.58,879.66],[1029.73,767.687],[1029.73,863.37]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1042.24,468.369],[1042.24,386.787],[1036.52,469.038],[1036.52,388.224]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1042.24,558.513],[1042.24,640.095],[1036.52,558.331],[1036.52,639.144]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1042.24,642.514],[1042.24,724.096],[1036.52,641.541],[1036.52,722.354]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1042.24,731.479],[1042.24,813.061],[1036.52,729.667],[1036.52,810.48]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1059.76,455.049],[1059.76,354.527],[1174.47,456.002],[1174.47,356.616]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1059.76,562.035],[1059.76,461.513],[1174.47,561.778],[1174.47,462.392]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1059.76,566.12],[1059.76,666.642],[1174.47,565.816],[1174.47,665.202]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1059.76,669.623],[1059.76,770.145],[1174.47,668.149],[1174.47,767.534]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1059.76,779.241],[1059.76,879.764],[1174.47,776.528],[1174.47,875.914]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1183.13,455.025],[1183.13,354.474],[1174.47,456.002],[1174.47,356.616]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1183.13,562.042],[1183.13,461.49],[1174.47,561.778],[1174.47,462.392]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1183.13,566.128],[1183.13,666.679],[1174.47,565.816],[1174.47,665.202]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1183.13,669.661],[1183.13,770.212],[1174.47,668.149],[1174.47,767.534]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1183.13,779.311],[1183.13,879.862],[1174.47,776.528],[1174.47,875.914]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1183.13,455.025],[1183.13,354.474],[1328.77,456.249],[1328.77,357.159]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1183.13,562.042],[1183.13,461.49],[1328.77,561.711],[1328.77,462.62]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1183.13,566.128],[1183.13,666.679],[1328.77,565.737],[1328.77,664.828]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1183.13,669.661],[1183.13,770.212],[1328.77,667.766],[1328.77,766.856]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1183.13,779.311],[1183.13,879.862],[1328.77,775.823],[1328.77,874.913]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1318.91,457.165],[1318.91,359.169],[1427.91,458.07],[1427.91,361.155]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1318.91,565.445],[1318.91,663.441],[1427.91,565.156],[1427.91,662.072]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1318.91,666.347],[1318.91,764.343],[1427.91,664.945],[1427.91,761.861]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1318.91,773.21],[1318.91,871.207],[1427.91,770.631],[1427.91,867.547]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1318.91,561.463],[1318.91,463.467],[1427.91,561.218],[1427.91,464.302]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1341.92,470.46],[1341.92,391.283],[1333.63,471.089],[1333.63,392.637]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1341.92,557.945],[1341.92,637.121],[1333.63,557.774],[1333.63,636.226]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1341.92,639.469],[1341.92,718.646],[1333.63,638.552],[1333.63,717.004]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1341.92,725.81],[1341.92,804.987],[1333.63,724.103],[1333.63,802.555]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1430.43,455.102],[1430.43,358.25],[1532.62,455.982],[1532.62,360.142]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1430.43,558.182],[1430.43,461.329],[1532.62,557.984],[1532.62,462.144]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1430.43,562.118],[1430.43,658.97],[1532.62,561.879],[1532.62,657.719]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1430.43,661.842],[1430.43,758.694],[1532.62,660.56],[1532.62,756.4]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1430.43,767.458],[1430.43,864.311],[1532.62,765.073],[1532.62,860.913]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1545.02,455.04],[1545.02,358.117],[1532.62,455.982],[1532.62,360.142]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1545.02,558.196],[1545.02,461.272],[1532.62,557.984],[1532.62,462.144]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1545.02,562.135],[1545.02,659.058],[1532.62,561.879],[1532.62,657.719]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1545.02,661.932],[1545.02,758.855],[1532.62,660.56],[1532.62,756.4]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1545.02,767.626],[1545.02,864.549],[1532.62,765.073],[1532.62,860.913]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1545.02,455.04],[1545.02,358.117],[1680.41,456.22],[1680.41,360.655]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1545.02,558.196],[1545.02,461.272],[1680.41,557.93],[1680.41,462.365]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1545.02,562.135],[1545.02,659.058],[1680.41,561.814],[1680.41,657.379]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1545.02,661.932],[1545.02,758.855],[1680.41,660.212],[1680.41,755.777]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1545.02,767.626],[1545.02,864.549],[1680.41,764.425],[1680.41,859.99]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1667.15,457.105],[1667.15,362.558],[1768.64,457.979],[1768.64,364.438]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1667.15,561.574],[1667.15,656.121],[1768.64,561.336],[1768.64,654.877]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1667.15,658.924],[1667.15,753.471],[1768.64,657.651],[1768.64,751.192]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1667.15,762.027],[1667.15,856.574],[1768.64,759.656],[1768.64,853.197]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:12,
                    verts:[[1667.15,557.731],[1667.15,463.184],[1768.64,557.535],[1768.64,463.994]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[177.252,443.975],[32.6258,442.289],[177.252,331.271],[32.6258,327.589]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[177.252,563.926],[177.252,451.222],[32.6258,564.363],[32.6258,449.664]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[177.252,568.506],[177.252,681.211],[32.6258,569.024],[32.6258,683.724]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[177.252,684.552],[32.6258,687.125],[177.252,797.257],[32.6258,801.824]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[177.252,807.455],[32.6258,812.203],[177.252,920.16],[32.6258,926.902]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[176.547,442.777],[357.957,444.919],[176.547,328.655],[357.957,333.331]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[176.547,564.237],[176.547,450.115],[357.957,563.682],[357.957,452.094]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[176.547,568.874],[357.957,568.217],[176.547,682.996],[357.957,679.805]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[176.547,686.38],[357.957,683.114],[176.547,800.502],[357.957,794.702]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[176.547,810.829],[357.957,804.799],[176.547,924.951],[357.957,916.388]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[356.39,446.105],[356.39,335.92],[489.396,447.655],[489.396,339.304]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[356.39,681.305],[356.39,791.49],[489.396,678.94],[489.396,787.291]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[356.39,801.46],[489.396,797.096],[356.39,911.646],[489.396,905.447]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[356.39,563.375],[356.39,453.19],[489.396,562.973],[489.396,454.622]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[356.39,567.853],[356.39,678.038],[489.396,567.376],[489.396,675.728]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[488.106,448.479],[488.106,340.114],[616.278,449.96],[616.278,343.361]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[488.106,563.813],[488.106,455.447],[616.278,563.412],[616.278,456.814]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[488.106,568.217],[488.106,676.582],[616.278,567.744],[616.278,674.343]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[488.106,679.795],[488.106,788.161],[616.278,677.503],[616.278,784.102]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[488.106,797.967],[488.106,906.333],[616.278,793.748],[616.278,900.346]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[547.217,463.912],[547.217,377.199],[544.142,464.65],[544.142,378.787]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[547.217,559.724],[547.217,646.437],[544.142,559.523],[544.142,645.386]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[547.217,649.007],[547.217,735.72],[544.142,647.932],[544.142,733.795]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[547.217,743.567],[547.217,830.279],[544.142,741.565],[544.142,827.428]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[620.995,448.86],[620.995,340.949],[616.279,449.96],[616.279,343.361]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[620.995,563.71],[620.995,455.799],[616.279,563.412],[616.279,456.814]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[620.995,568.095],[620.995,676.006],[616.279,567.744],[616.279,674.343]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[620.995,679.206],[620.995,787.117],[616.279,677.503],[616.279,784.102]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[620.995,796.882],[620.995,904.793],[616.279,793.748],[616.279,900.346]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[620.995,448.86],[620.995,340.949],[783.398,450.76],[783.398,345.117]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[620.995,563.71],[620.995,455.799],[783.398,563.196],[783.398,457.553]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[620.995,568.095],[620.995,676.006],[783.398,567.489],[783.398,673.132]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[620.995,679.206],[620.995,787.117],[783.398,676.264],[783.398,781.907]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[620.995,796.882],[620.995,904.793],[783.398,791.466],[783.398,897.109]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[777.066,451.779],[777.066,347.352],[897.138,453.166],[897.138,350.396]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[777.066,674.687],[777.066,779.114],[897.138,672.539],[897.138,775.309]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[777.066,788.563],[777.066,892.99],[897.138,784.609],[897.138,887.38]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[777.066,562.92],[777.066,458.493],[897.138,562.545],[897.138,459.774]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[777.066,567.164],[777.066,671.591],[897.138,566.721],[897.138,669.492]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[940.012,466.026],[940.012,381.746],[925.349,467.545],[925.349,385.014]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[940.012,555.725],[940.012,471.445],[925.349,555.383],[925.349,472.852]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[940.012,559.15],[940.012,643.429],[925.349,558.737],[925.349,641.268]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[940.012,645.928],[940.012,730.208],[925.349,643.715],[925.349,726.246]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[940.012,737.834],[940.012,822.114],[925.349,733.714],[925.349,816.245]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1018.51,468.464],[1018.51,386.991],[1011.27,469.116],[1011.27,388.393]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1018.51,555.176],[1018.51,473.703],[1011.27,555.029],[1011.27,474.307]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1018.51,558.487],[1018.51,639.96],[1011.27,558.31],[1011.27,639.033]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1018.51,642.376],[1018.51,723.849],[1011.27,641.426],[1011.27,722.149]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1018.51,731.222],[1018.51,812.695],[1011.27,729.453],[1011.27,810.176]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1073.86,455.273],[1073.86,355.017],[1034.56,459.199],[1034.56,363.631]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1073.86,561.975],[1073.86,461.719],[1034.56,560.912],[1034.56,465.344]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1073.86,566.049],[1073.86,666.305],[1034.56,564.796],[1034.56,660.364]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1073.86,669.277],[1073.86,769.533],[1034.56,663.198],[1034.56,758.766]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1073.86,778.606],[1073.86,878.861],[1034.56,767.414],[1034.56,862.982]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1074.1,455.247],[1074.1,354.962],[1184.96,456.528],[1184.96,357.771]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1074.1,561.982],[1074.1,461.696],[1184.96,561.635],[1184.96,462.878]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1074.1,566.057],[1074.1,666.343],[1184.96,565.648],[1184.96,664.406]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1074.1,669.316],[1074.1,769.602],[1184.96,667.334],[1184.96,766.091]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1074.1,778.677],[1074.1,878.963],[1184.96,775.027],[1184.96,873.785]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1195.81,455.585],[1195.81,355.702],[1184.96,456.528],[1184.96,357.771]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1195.81,561.89],[1195.81,462.007],[1184.96,561.635],[1184.96,462.878]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1195.81,565.949],[1195.81,665.832],[1184.96,565.648],[1184.96,664.406]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1195.81,668.794],[1195.81,768.676],[1184.96,667.334],[1184.96,766.091]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1195.81,777.715],[1195.81,877.598],[1184.96,775.027],[1184.96,873.785]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1195.81,455.585],[1195.81,355.702],[1335.16,457.215],[1335.16,359.279]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1195.81,561.89],[1195.81,462.007],[1335.16,561.449],[1335.16,463.513]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1195.81,565.949],[1195.81,665.832],[1335.16,565.429],[1335.16,663.366]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1195.81,668.794],[1195.81,768.676],[1335.16,666.269],[1335.16,764.206]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1195.81,777.715],[1195.81,877.598],[1335.16,773.068],[1335.16,871.005]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1308.28,471.263],[1308.28,393.011],[1298.77,471.865],[1298.77,394.305]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1308.28,557.727],[1308.28,635.978],[1298.77,557.563],[1298.77,635.122]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1308.28,638.299],[1308.28,716.55],[1298.77,637.422],[1298.77,714.981]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1308.28,723.631],[1308.28,801.883],[1298.77,722],[1298.77,799.559]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1323.4,458.092],[1323.4,361.201],[1426.88,459.287],[1426.88,363.824]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1323.4,664.913],[1323.4,761.803],[1426.88,663.062],[1426.88,758.525]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1323.4,770.571],[1323.4,867.462],[1426.88,767.163],[1426.88,862.626]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1323.4,561.212],[1323.4,464.321],[1426.88,560.889],[1426.88,465.425]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1323.4,565.15],[1323.4,662.04],[1426.88,564.768],[1426.88,660.231]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1429.19,456.37],[1429.19,360.978],[1525.5,457.524],[1525.5,363.46]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1429.19,557.897],[1429.19,462.504],[1525.5,557.637],[1525.5,463.572]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1429.19,561.773],[1429.19,657.166],[1525.5,561.46],[1525.5,655.524]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1429.19,659.994],[1429.19,755.386],[1525.5,658.313],[1525.5,752.378]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1429.19,764.019],[1429.19,859.411],[1525.5,760.89],[1525.5,854.954]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1539.52,456.637],[1539.52,361.552],[1525.5,457.524],[1525.5,363.46]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1539.52,557.836],[1539.52,462.751],[1525.5,557.637],[1525.5,463.572]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1539.52,561.701],[1539.52,656.786],[1525.5,561.46],[1525.5,655.524]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1539.52,659.605],[1539.52,754.69],[1525.5,658.313],[1525.5,752.378]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1539.52,763.295],[1539.52,858.38],[1525.5,760.89],[1525.5,854.954]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1539.52,456.637],[1539.52,361.552],[1665.93,458.171],[1665.93,364.852]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1539.52,557.836],[1539.52,462.751],[1665.93,557.491],[1665.93,464.172]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1539.52,561.701],[1539.52,656.786],[1665.93,561.284],[1665.93,654.604]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1539.52,659.605],[1539.52,754.69],[1665.93,657.37],[1665.93,750.69]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1539.52,763.295],[1539.52,858.38],[1665.93,759.135],[1665.93,852.454]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1651.34,458.997],[1651.34,366.627],[1745.45,460.125],[1745.45,369.054]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1651.34,656.168],[1651.34,748.537],[1745.45,654.525],[1745.45,745.596]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1651.34,756.896],[1651.34,849.266],[1745.45,753.837],[1745.45,844.908]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1651.34,557.306],[1651.34,464.936],[1745.45,557.052],[1745.45,465.981]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:13,
                    verts:[[1651.34,561.06],[1651.34,653.429],[1745.45,560.753],[1745.45,651.824]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[43.9426,448.723],[43.9426,344.529],[41.7791,456.563],[41.7791,361.392]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[43.9426,559.617],[43.9426,455.423],[41.7791,557.853],[41.7791,462.682]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[43.9426,563.851],[43.9426,668.045],[41.7791,561.721],[41.7791,656.892]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[43.9426,671.134],[43.9426,775.328],[41.7791,659.714],[41.7791,754.885]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[43.9426,784.757],[43.9426,888.951],[41.7791,763.497],[41.7791,858.668]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[47.4569,435.989],[47.4569,317.138],[44.6759,446.066],[44.6759,338.814]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[47.4569,562.482],[47.4569,443.631],[44.6759,560.215],[44.6759,452.962]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[47.4569,567.311],[47.4569,686.162],[44.6759,564.573],[44.6759,671.825]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[47.4569,689.686],[47.4569,808.537],[44.6759,675.005],[44.6759,782.257]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[47.4569,819.292],[47.4569,938.143],[44.6759,791.963],[44.6759,899.215]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[47.4565,438.779],[196.637,441.045],[47.4565,319.928],[196.637,324.874]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[47.4565,565.272],[47.4565,446.421],[196.637,564.685],[196.637,448.514]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[47.4565,570.102],[47.4565,688.953],[196.637,569.406],[196.637,685.577]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[47.4565,692.477],[196.637,689.021],[47.4565,811.328],[196.637,805.192]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[47.4565,822.082],[196.637,815.705],[47.4565,940.933],[196.637,931.875]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[161.878,458.063],[161.878,364.618],[160.463,458.867],[160.463,366.347]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[161.878,561.313],[161.878,654.758],[160.463,561.095],[160.463,653.614]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[161.878,657.529],[161.878,750.974],[160.463,656.358],[160.463,748.877]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[161.878,759.429],[161.878,852.874],[160.463,757.249],[160.463,849.769]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[198.872,439.808],[198.872,322.175],[196.636,441.045],[196.636,324.874]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[198.872,565.005],[198.872,447.372],[196.636,564.685],[196.636,448.514]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[198.872,569.786],[198.872,687.419],[196.636,569.406],[196.636,685.577]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[198.872,690.907],[198.872,808.54],[196.636,689.021],[196.636,805.192]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[198.872,819.185],[198.872,936.818],[196.636,815.705],[196.636,931.875]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[198.873,439.808],[198.873,322.175],[383.718,442.652],[383.718,328.383]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[198.873,565.005],[198.873,447.372],[383.718,564.269],[383.718,450]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[198.873,569.786],[198.873,687.419],[383.718,568.913],[383.718,683.182]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[198.873,690.907],[198.873,808.54],[383.718,686.57],[383.718,800.84]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[198.873,819.185],[198.873,936.818],[383.718,811.18],[383.718,925.45]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[379.157,443.86],[379.157,331.019],[513.233,445.895],[513.233,335.462]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[379.157,568.542],[379.157,681.383],[513.233,567.917],[513.233,678.35]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[379.157,684.728],[379.157,797.569],[513.233,681.624],[513.233,792.057]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[379.157,807.78],[379.157,920.621],[513.233,802.051],[513.233,912.484]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[379.157,563.956],[379.157,451.115],[513.233,563.429],[513.233,452.996]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[511.933,564.286],[511.933,453.833],[639.943,563.765],[639.943,455.611]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[511.933,568.774],[511.933,679.228],[639.943,568.16],[639.943,676.315]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[511.933,682.502],[511.933,792.955],[639.943,679.521],[639.943,787.676]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[511.933,802.95],[511.933,913.403],[639.943,797.462],[639.943,905.617]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[511.933,446.731],[511.933,336.278],[639.943,448.656],[639.943,340.502]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[527.947,462.607],[527.947,374.392],[523.02,463.349],[523.02,375.988]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[527.947,560.079],[527.947,648.294],[523.02,559.877],[523.02,647.238]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[527.947,650.909],[527.947,739.124],[523.02,649.828],[523.02,737.189]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[527.947,747.106],[527.947,835.321],[523.02,745.094],[523.02,832.455]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[647.475,447.558],[647.475,338.091],[639.944,448.656],[639.944,340.502]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[647.475,564.062],[647.475,454.596],[639.944,563.765],[639.944,455.611]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[647.475,568.511],[647.475,677.977],[639.944,568.16],[639.944,676.315]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[647.475,681.223],[647.475,790.689],[639.944,679.521],[639.944,787.675]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[647.475,800.594],[647.475,910.06],[639.944,797.462],[639.944,905.617]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[647.476,447.558],[647.476,338.091],[807.868,450.002],[807.868,343.455]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[647.476,564.062],[647.476,454.596],[807.868,563.401],[807.868,456.853]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[647.476,568.511],[647.476,677.977],[807.868,567.731],[807.868,674.278]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[647.476,681.223],[647.476,790.689],[807.868,677.437],[807.868,783.985]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[647.476,800.594],[647.476,910.06],[807.868,793.626],[807.868,900.174]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[798.973,451.009],[798.973,345.663],[916.482,452.777],[916.482,349.542]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[798.973,567.41],[798.973,672.756],[916.482,566.845],[916.482,670.08]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[798.973,675.879],[798.973,781.225],[916.482,673.141],[916.482,776.376]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[798.973,790.758],[798.973,896.104],[916.482,785.718],[916.482,888.953]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[798.973,563.128],[798.973,457.782],[916.482,562.65],[916.482,459.415]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[921.706,465.793],[921.706,381.245],[903.45,467.278],[903.45,384.44]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[921.706,559.213],[921.706,643.761],[903.45,558.809],[903.45,641.648]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[921.706,646.268],[921.706,730.816],[903.45,644.104],[903.45,726.942]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[921.706,738.467],[921.706,823.015],[903.45,734.438],[903.45,817.276]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[921.706,555.777],[921.706,471.229],[903.45,555.443],[903.45,472.605]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[994.367,468.434],[994.367,386.926],[985.636,469.068],[985.636,388.289]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[994.367,555.183],[994.367,473.675],[985.636,555.04],[985.636,474.262]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[994.367,558.495],[994.367,640.003],[985.636,558.323],[985.636,639.102]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[994.367,642.42],[994.367,723.928],[985.636,641.497],[985.636,722.275]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[994.367,731.304],[994.367,812.812],[985.636,729.585],[985.636,810.364]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1087.47,455.417],[1087.47,355.333],[1038.97,459.222],[1038.97,363.681]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1087.47,561.936],[1087.47,461.852],[1038.97,560.906],[1038.97,465.365]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1087.47,566.003],[1087.47,666.087],[1038.97,564.789],[1038.97,660.33]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1087.47,669.054],[1087.47,769.138],[1038.97,663.163],[1038.97,758.703]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1087.47,778.195],[1087.47,878.278],[1038.97,767.349],[1038.97,862.89]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1087.77,455.392],[1087.77,355.28],[1194.05,456.991],[1194.05,358.787]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1087.77,561.942],[1087.77,461.83],[1194.05,561.51],[1194.05,463.306]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1087.77,566.011],[1087.77,666.124],[1194.05,565.501],[1194.05,663.705]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1087.77,669.092],[1087.77,769.205],[1194.05,666.617],[1194.05,764.821]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1087.77,778.264],[1087.77,878.377],[1194.05,773.707],[1194.05,871.911]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1206.98,456.086],[1206.98,356.802],[1194.05,456.991],[1194.05,358.787]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1206.98,561.755],[1206.98,462.47],[1194.05,561.51],[1194.05,463.306]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1206.98,565.789],[1206.98,665.074],[1194.05,565.501],[1194.05,663.705]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1206.98,668.018],[1206.98,767.302],[1194.05,666.617],[1194.05,764.821]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1206.98,776.286],[1206.98,875.571],[1194.05,773.707],[1194.05,871.911]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1206.98,456.086],[1206.98,356.802],[1339.25,458.102],[1339.25,361.225]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1206.98,561.755],[1206.98,462.47],[1339.25,561.209],[1339.25,464.332]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1206.98,565.789],[1206.98,665.074],[1339.25,565.146],[1339.25,662.024]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1206.98,668.018],[1206.98,767.302],[1339.25,664.896],[1339.25,761.774]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1206.98,776.286],[1206.98,875.571],[1339.25,770.54],[1339.25,867.418]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1273.54,471.922],[1273.54,394.428],[1262.86,472.495],[1262.86,395.66]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1273.54,557.548],[1273.54,635.042],[1262.86,557.392],[1262.86,634.226]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1273.54,637.339],[1273.54,714.833],[1262.86,636.504],[1262.86,713.338]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1273.54,721.846],[1273.54,799.34],[1262.86,720.291],[1262.86,797.126]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1325.7,458.935],[1325.7,363.052],[1423.23,460.403],[1423.23,366.271]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1325.7,663.607],[1325.7,759.49],[1423.23,661.334],[1423.23,755.466]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1325.7,768.166],[1325.7,864.05],[1423.23,763.984],[1423.23,858.115]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1325.7,560.984],[1325.7,465.1],[1423.23,560.587],[1423.23,466.455]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1325.7,564.88],[1325.7,660.764],[1423.23,564.412],[1423.23,658.544]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1425.32,457.533],[1425.32,363.479],[1515.44,458.939],[1515.44,366.503]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1425.32,557.635],[1425.32,463.581],[1515.44,557.319],[1515.44,464.883]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1425.32,561.457],[1425.32,655.512],[1515.44,561.075],[1515.44,653.511]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1425.32,658.3],[1425.32,752.354],[1515.44,656.252],[1515.44,748.688]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1425.32,760.865],[1425.32,854.92],[1515.44,757.052],[1515.44,849.488]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1530.92,458.108],[1530.92,364.716],[1515.44,458.939],[1515.44,366.503]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1530.92,557.506],[1530.92,464.113],[1515.44,557.319],[1515.44,464.883]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1530.92,561.301],[1530.92,654.694],[1515.44,561.075],[1515.44,653.511]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1530.92,657.463],[1530.92,750.855],[1515.44,656.252],[1515.44,748.688]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1530.92,759.306],[1530.92,852.699],[1515.44,757.052],[1515.44,849.489]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1530.92,458.108],[1530.92,364.716],[1648.13,459.961],[1648.13,368.702]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1530.92,557.506],[1530.92,464.113],[1648.13,557.089],[1648.13,465.829]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1530.92,561.301],[1530.92,654.694],[1648.13,560.797],[1648.13,652.057]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1530.92,657.463],[1530.92,750.855],[1648.13,654.763],[1648.13,746.023]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1530.92,759.306],[1530.92,852.699],[1648.13,754.281],[1648.13,845.54]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1632.37,460.728],[1632.37,370.351],[1719.1,462.082],[1719.1,373.263]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1632.37,560.589],[1632.37,650.966],[1719.1,560.221],[1719.1,649.04]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1632.37,653.646],[1632.37,744.023],[1719.1,651.673],[1719.1,740.492]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1632.37,752.201],[1632.37,842.578],[1719.1,748.529],[1719.1,837.348]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:14,
                    verts:[[1632.37,556.916],[1632.37,466.539],[1719.1,556.612],[1719.1,467.793]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[35.7264,445.345],[35.7264,337.264],[14.2846,453.47],[14.2846,354.74]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[35.7264,560.377],[35.7264,452.295],[14.2846,558.549],[14.2846,459.819]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[35.7264,564.769],[35.7264,672.851],[14.2846,562.561],[14.2846,661.292]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[35.7264,676.055],[35.7264,784.137],[14.2846,664.219],[14.2846,762.949]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[35.7264,793.917],[35.7264,901.999],[14.2846,771.883],[14.2846,870.614]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[70.549,432.15],[70.549,308.882],[42.9928,442.592],[42.9928,331.341]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[70.549,563.345],[70.549,440.076],[42.9928,560.996],[42.9928,449.745]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[70.549,568.354],[70.549,691.623],[42.9928,565.517],[42.9928,676.768]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[70.549,695.278],[70.549,818.546],[42.9928,680.066],[42.9928,791.317]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[70.549,829.701],[70.549,952.97],[42.9928,801.384],[42.9928,912.635]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[70.5481,435.044],[70.5481,311.776],[223.121,437.953],[223.121,318.124]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[70.5481,566.239],[70.5481,442.971],[223.121,565.486],[223.121,445.657]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[70.5481,571.249],[70.5481,694.517],[223.121,570.356],[223.121,690.184]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[70.5481,698.172],[70.5481,821.441],[223.121,693.737],[223.121,813.566]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[70.5481,832.595],[70.5481,955.864],[223.121,824.409],[223.121,944.238]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[138.432,455.398],[138.432,358.887],[134.98,456.224],[134.98,360.664]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[138.432,562.037],[138.432,658.549],[134.98,561.813],[134.98,657.374]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[138.432,661.41],[138.432,757.921],[134.98,660.207],[134.98,755.767]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[138.432,766.655],[138.432,863.166],[134.98,764.415],[134.98,859.975]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[228.564,436.686],[228.564,315.359],[223.121,437.953],[223.121,318.124]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[228.564,565.814],[228.564,444.487],[223.121,565.486],[223.121,445.657]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[228.564,570.745],[228.564,692.072],[223.121,570.356],[223.121,690.184]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[228.564,695.669],[228.564,816.996],[223.121,693.737],[223.121,813.566]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[228.564,827.975],[228.564,949.303],[223.121,824.409],[223.121,944.238]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[228.564,436.686],[228.564,315.359],[415.168,440.291],[415.168,323.228]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[228.564,565.814],[228.564,444.487],[415.168,564.881],[415.168,447.818]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[228.564,570.745],[228.564,692.072],[415.168,569.638],[415.168,686.701]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[228.564,695.669],[228.564,816.996],[415.168,690.172],[415.168,807.235]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[228.564,827.975],[228.564,949.302],[415.168,817.828],[415.168,934.891]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[407.428,441.512],[407.428,325.893],[541.34,444.063],[541.34,331.462]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[407.428,688.31],[407.428,803.928],[541.34,684.419],[541.34,797.02]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[407.428,814.391],[407.428,930.009],[541.34,807.209],[541.34,919.81]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[407.428,564.564],[407.428,448.946],[541.34,563.904],[541.34,451.303]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[407.428,569.263],[407.428,684.881],[541.34,568.48],[541.34,681.08]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[510.234,461.143],[510.234,371.244],[503.37,461.886],[503.37,372.841]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[510.234,560.476],[510.234,650.375],[503.37,560.275],[503.37,649.319]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[510.234,653.041],[510.234,742.94],[503.37,651.96],[503.37,741.005]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[510.234,751.075],[510.234,840.974],[503.37,749.062],[503.37,838.107]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[540.041,444.91],[540.041,332.284],[666.695,447.301],[666.695,337.529]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[540.041,564.779],[540.041,452.152],[666.695,564.132],[666.695,454.359]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[540.041,569.355],[540.041,681.982],[666.695,568.593],[666.695,678.365]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[540.041,685.321],[540.041,797.948],[666.695,681.619],[666.695,791.392]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[540.041,808.139],[540.041,920.766],[666.695,801.325],[666.695,911.097]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[677.112,446.211],[677.112,335.138],[666.696,447.301],[666.696,337.529]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[677.112,564.427],[677.112,453.353],[666.696,564.132],[666.696,454.359]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[677.112,568.94],[677.112,680.014],[666.696,568.593],[666.696,678.365]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[677.112,683.307],[677.112,794.38],[666.696,681.619],[666.696,791.392]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[677.112,804.431],[677.112,915.505],[666.696,801.325],[666.696,911.097]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[677.112,446.211],[677.112,335.138],[833.979,449.214],[833.979,341.725]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[677.112,564.426],[677.112,453.353],[833.979,563.614],[833.979,456.125]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[677.112,568.94],[677.112,680.014],[833.979,567.982],[833.979,675.471]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[677.112,683.307],[677.112,794.38],[833.979,678.658],[833.979,786.147]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[677.112,804.431],[677.112,915.505],[833.979,795.873],[833.979,903.362]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[822.515,450.201],[822.515,343.89],[936.439,452.352],[936.439,348.61]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[822.515,567.667],[822.515,673.978],[936.439,566.981],[936.439,670.723]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[822.515,677.13],[822.515,783.441],[936.439,673.799],[936.439,777.542]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[822.515,793.061],[822.515,899.372],[936.439,786.929],[936.439,890.672]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[822.515,563.347],[822.515,457.036],[936.439,562.765],[936.439,459.023]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[903.306,465.445],[903.306,380.497],[881.466,466.89],[881.466,383.605]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[903.306,559.307],[903.306,644.256],[881.466,558.915],[881.466,642.2]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[903.306,646.774],[903.306,731.723],[881.466,644.669],[881.466,727.954]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[903.306,739.41],[903.306,824.358],[881.466,735.49],[881.466,818.775]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[969.794,468.283],[969.794,386.601],[959.581,468.896],[959.581,387.92]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[969.794,555.217],[969.794,473.535],[959.581,555.079],[959.581,474.103]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[969.794,558.536],[969.794,640.218],[959.581,558.37],[959.581,639.345]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[969.794,642.64],[969.794,724.321],[959.581,641.746],[959.581,722.722]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[969.794,731.713],[969.794,813.395],[959.581,730.05],[959.581,811.026]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1100.35,455.517],[1100.35,355.553],[1042.94,459.18],[1042.94,363.588]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1100.35,561.909],[1100.35,461.945],[1042.94,560.918],[1042.94,465.326]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1100.35,565.971],[1100.35,665.935],[1042.94,564.802],[1042.94,660.394]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1100.35,668.899],[1100.35,768.863],[1042.94,663.228],[1042.94,758.82]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1100.35,777.908],[1100.35,877.872],[1042.94,767.47],[1042.94,863.061]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1100.7,455.494],[1100.7,355.502],[1201.69,457.4],[1201.69,359.684]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1100.7,561.915],[1100.7,461.923],[1201.69,561.399],[1201.69,463.683]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1100.7,565.978],[1100.7,665.97],[1201.69,565.37],[1201.69,663.086]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1100.7,668.935],[1100.7,768.927],[1201.69,665.983],[1201.69,763.7]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1100.7,777.975],[1100.7,877.967],[1201.69,772.542],[1201.69,870.258]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1216.58,456.538],[1216.58,357.792],[1201.69,457.4],[1201.69,359.684]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1216.58,561.633],[1216.58,462.887],[1201.69,561.399],[1201.69,463.683]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1216.58,565.645],[1216.58,664.391],[1201.69,565.37],[1201.69,663.086]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1216.58,667.319],[1216.58,766.065],[1201.69,665.983],[1201.69,763.7]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1216.58,775],[1216.58,873.746],[1201.69,772.542],[1201.69,870.258]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1216.58,456.538],[1216.58,357.792],[1341.01,458.919],[1341.01,363.017]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1216.58,561.633],[1216.58,462.887],[1341.01,560.988],[1341.01,465.086]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1216.58,565.645],[1216.58,664.391],[1341.01,564.885],[1341.01,660.788]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1216.58,667.319],[1216.58,766.065],[1341.01,663.631],[1341.01,759.534]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1216.58,775],[1216.58,873.746],[1341.01,768.212],[1341.01,864.115]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1237.61,472.444],[1237.61,395.551],[1225.81,472.988],[1225.81,396.721]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1237.61,557.406],[1237.61,634.298],[1225.81,557.258],[1225.81,633.525]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1237.61,636.578],[1237.61,713.471],[1225.81,635.786],[1225.81,712.053]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1237.61,720.429],[1237.61,797.322],[1225.81,718.955],[1225.81,795.222]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1325.81,459.706],[1325.81,364.742],[1416.94,461.427],[1416.94,368.518]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1325.81,564.635],[1325.81,659.598],[1416.94,564.085],[1416.94,656.994]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1325.81,662.414],[1325.81,757.378],[1416.94,659.749],[1416.94,752.658]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1325.81,765.971],[1325.81,860.935],[1416.94,761.065],[1416.94,853.974]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1325.81,560.775],[1325.81,465.812],[1416.94,560.31],[1416.94,467.401]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1418.81,458.6],[1418.81,365.774],[1502.47,460.238],[1502.47,369.297]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1418.81,557.395],[1418.81,464.569],[1502.47,557.027],[1502.47,466.086]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1418.81,561.167],[1418.81,653.993],[1502.47,560.722],[1502.47,651.663]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1418.81,656.746],[1418.81,749.572],[1502.47,654.359],[1502.47,745.3]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1418.81,757.971],[1418.81,850.797],[1502.47,753.529],[1502.47,844.47]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1519.27,459.464],[1519.27,367.632],[1502.47,460.238],[1502.47,369.297]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1519.27,557.201],[1519.27,465.369],[1502.47,557.027],[1502.47,466.086]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1519.27,560.933],[1519.27,652.765],[1502.47,560.722],[1502.47,651.663]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1519.27,655.487],[1519.27,747.32],[1502.47,654.359],[1502.47,745.3]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1519.27,755.629],[1519.27,847.462],[1502.47,753.53],[1502.47,844.47]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1519.27,459.464],[1519.27,367.632],[1627.09,461.605],[1627.09,372.237]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1519.27,557.201],[1519.27,465.369],[1627.09,556.719],[1627.09,467.351]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1519.27,560.933],[1519.27,652.765],[1627.09,560.351],[1627.09,649.719]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1519.27,655.487],[1519.27,747.32],[1627.09,652.369],[1627.09,741.737]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1519.27,755.629],[1519.27,847.461],[1627.09,749.824],[1627.09,839.192]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1610.31,462.313],[1610.31,373.761],[1689.67,463.868],[1689.67,377.105]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1610.31,651.336],[1610.31,739.889],[1689.67,649.071],[1689.67,735.834]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1610.31,747.902],[1610.31,836.454],[1689.67,743.686],[1689.67,830.449]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1610.31,556.56],[1610.31,468.007],[1689.67,556.21],[1689.67,469.447]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:15,
                    verts:[[1610.31,560.158],[1610.31,648.711],[1689.67,559.736],[1689.67,646.499]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[33.5536,441.683],[33.5536,329.385],[-9.33192,450.06],[-9.33192,347.404]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[33.5536,561.201],[33.5536,448.903],[-9.33192,559.316],[-9.33192,456.66]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[33.5536,565.764],[33.5536,678.062],[-9.33192,563.488],[-9.33192,666.144]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[33.5536,681.391],[33.5536,793.688],[-9.33192,669.187],[-9.33192,771.843]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[33.5536,803.85],[33.5536,916.148],[-9.33192,781.132],[-9.33192,883.788]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[103.069,428.104],[103.069,300.178],[48.073,438.846],[48.073,323.285]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[103.069,564.255],[103.069,436.329],[48.073,561.839],[48.073,446.277]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[103.069,569.454],[103.069,697.38],[48.073,566.535],[48.073,682.096]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[103.069,701.173],[103.069,829.099],[48.073,685.523],[48.073,801.084]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[103.069,840.675],[103.069,968.601],[48.073,811.542],[48.073,927.103]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[103.068,431.107],[103.068,303.181],[257.53,434.724],[257.53,311.075]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[103.068,567.259],[103.068,439.333],[257.53,566.322],[257.53,442.674]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[103.068,572.457],[103.068,700.383],[257.53,571.347],[257.53,694.995]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[103.068,704.176],[103.068,832.102],[257.53,698.662],[257.53,822.31]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[103.068,843.678],[103.068,971.604],[257.53,833.499],[257.53,957.147]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[118.477,452.469],[118.477,352.586],[112.791,453.313],[112.791,354.402]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[118.477,562.833],[118.477,662.716],[112.791,562.604],[112.791,661.515]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[118.477,665.678],[118.477,765.56],[112.791,664.447],[112.791,763.358]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[118.477,774.599],[118.477,874.482],[112.791,772.309],[112.791,871.22]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[266.438,433.436],[266.438,308.266],[257.529,434.723],[257.529,311.075]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[266.438,566.656],[266.438,441.485],[257.529,566.322],[257.529,442.674]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[266.438,571.742],[266.438,696.913],[257.529,571.347],[257.529,694.995]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[266.438,700.624],[266.438,825.795],[257.529,698.662],[257.529,822.31]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[266.438,837.122],[266.438,962.293],[257.529,833.499],[257.529,957.147]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[266.438,433.436],[266.438,308.266],[452.762,437.861],[452.762,317.924]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[266.438,566.656],[266.438,441.485],[452.762,565.51],[452.762,445.573]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[266.438,571.742],[266.438,696.913],[452.762,570.384],[452.762,690.321]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[266.438,700.624],[266.438,825.795],[452.762,693.877],[452.762,813.814]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[266.438,837.122],[266.438,962.293],[452.762,824.667],[452.762,944.603]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[441.674,439.085],[441.674,320.595],[573.985,442.181],[573.985,327.354]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[441.674,692.011],[441.674,810.5],[573.985,687.289],[573.985,802.116]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[441.674,821.222],[441.674,939.712],[573.985,812.507],[573.985,927.334]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[441.674,565.193],[441.674,446.703],[573.985,564.391],[573.985,449.564]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[441.674,570.008],[441.674,688.497],[573.985,569.057],[573.985,683.884]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[494.316,459.522],[494.316,367.758],[485.425,460.261],[485.425,369.346]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[494.316,560.917],[494.316,652.681],[485.425,560.716],[485.425,651.631]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[494.316,655.402],[494.316,747.167],[485.425,654.327],[485.425,745.242]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[494.316,755.471],[494.316,847.235],[485.425,753.469],[485.425,844.384]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[572.7,443.04],[572.7,328.182],[696.655,445.914],[696.655,334.487]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[572.7,565.284],[572.7,450.426],[696.655,564.507],[696.655,453.079]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[572.7,569.952],[572.7,684.811],[696.655,569.035],[696.655,680.463]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[572.7,688.216],[572.7,803.075],[696.655,683.767],[696.655,795.194]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[572.7,813.469],[572.7,928.327],[696.655,805.277],[696.655,916.705]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[710.001,444.843],[710.001,332.136],[696.656,445.914],[696.656,334.487]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[710.001,564.797],[710.001,452.09],[696.656,564.507],[696.656,453.079]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[710.001,569.377],[710.001,682.084],[696.656,569.035],[696.656,680.463]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[710.001,685.425],[710.001,798.132],[696.656,683.766],[696.656,795.194]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[710.001,808.331],[710.001,921.038],[696.656,805.277],[696.656,916.705]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[710.002,444.843],[710.002,332.136],[861.702,448.413],[861.702,339.967]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[710.002,564.797],[710.002,452.09],[861.702,563.831],[861.702,455.385]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[710.002,569.377],[710.002,682.084],[861.702,568.238],[861.702,676.683]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[710.002,685.425],[710.002,798.132],[861.702,679.899],[861.702,788.344]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[710.002,808.331],[710.002,921.038],[861.702,798.157],[861.702,906.603]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[847.688,449.371],[847.688,342.071],[956.951,451.906],[956.951,347.631]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[847.688,678.414],[847.688,785.715],[956.951,674.49],[956.951,778.765]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[847.688,795.424],[847.688,902.725],[956.951,788.201],[956.951,892.476]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[884.835,464.988],[884.835,379.514],[859.415,466.386],[859.415,382.52]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[884.835,559.432],[884.835,644.906],[859.415,559.052],[859.415,642.917]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[884.835,647.44],[884.835,732.914],[859.415,645.404],[859.415,729.27]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[884.835,740.649],[884.835,826.123],[859.415,736.859],[859.415,820.724]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[847.688,563.571],[847.688,456.271],[956.951,562.886],[956.951,458.611]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[847.688,567.932],[847.688,675.233],[956.951,567.123],[956.951,671.398]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[944.777,468.017],[944.777,386.029],[933.095,468.607],[933.095,387.298]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[944.777,558.609],[944.777,640.596],[933.095,558.448],[933.095,639.757]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[944.777,643.027],[944.777,725.015],[933.095,642.168],[933.095,723.477]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[944.777,732.434],[944.777,814.422],[933.095,730.835],[933.095,812.144]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1112.41,455.586],[1112.41,355.704],[1046.44,459.082],[1046.44,363.375]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1112.41,561.89],[1112.41,462.008],[1046.44,560.944],[1046.44,465.236]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1112.41,565.949],[1112.41,665.831],[1046.44,564.833],[1046.44,660.541]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1112.41,668.793],[1112.41,768.675],[1046.44,663.379],[1046.44,759.086]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1112.41,777.713],[1112.41,877.595],[1046.44,767.747],[1046.44,863.455]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1112.81,455.563],[1112.81,355.654],[1207.78,457.765],[1207.78,360.485]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1112.81,561.896],[1112.81,461.987],[1207.78,561.3],[1207.78,464.02]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1112.81,565.956],[1112.81,665.865],[1207.78,565.254],[1207.78,662.534]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1112.81,668.827],[1112.81,768.736],[1207.78,665.418],[1207.78,762.698]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1112.81,777.777],[1112.81,877.686],[1207.78,771.501],[1207.78,868.781]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1200.44,472.838],[1200.44,396.399],[1187.56,473.351],[1187.56,397.503]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1200.44,557.299],[1200.44,633.738],[1187.56,557.159],[1187.56,633.008]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1200.44,636.004],[1200.44,712.443],[1187.56,635.257],[1187.56,711.105]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1200.44,719.36],[1200.44,795.799],[1187.56,717.969],[1187.56,793.817]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1224.53,456.95],[1224.53,358.696],[1207.78,457.765],[1207.78,360.485]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1224.53,561.521],[1224.53,463.267],[1207.78,561.3],[1207.78,464.02]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1224.53,565.514],[1224.53,663.767],[1207.78,565.254],[1207.78,662.534]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1224.53,666.681],[1224.53,764.934],[1207.78,665.418],[1207.78,762.698]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1224.53,773.825],[1224.53,872.079],[1207.78,771.501],[1207.78,868.781]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1224.53,456.95],[1224.53,358.696],[1340.38,459.676],[1340.38,364.676]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1224.53,561.521],[1224.53,463.267],[1340.38,560.783],[1340.38,465.784]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1224.53,565.514],[1224.53,663.768],[1340.38,564.644],[1340.38,659.643]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1224.53,666.681],[1224.53,764.934],[1340.38,662.46],[1340.38,757.46]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1224.53,773.825],[1224.53,872.079],[1340.38,766.056],[1340.38,861.056]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1323.65,460.412],[1323.65,366.293],[1408.01,462.369],[1408.01,370.586]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1323.65,564.409],[1323.65,658.529],[1408.01,563.784],[1408.01,655.568]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1323.65,661.319],[1323.65,755.439],[1408.01,658.289],[1408.01,750.073]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1323.65,763.956],[1323.65,858.076],[1408.01,758.379],[1408.01,850.162]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1323.65,560.584],[1323.65,466.464],[1408.01,560.055],[1408.01,468.271]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1409.66,459.583],[1409.66,367.887],[1486.6,461.433],[1486.6,371.867]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1409.66,557.174],[1409.66,465.478],[1486.6,556.758],[1486.6,467.192]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1409.66,560.9],[1409.66,652.596],[1486.6,560.397],[1486.6,649.963]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1409.66,655.315],[1409.66,747.01],[1486.6,652.619],[1486.6,742.185]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1409.66,755.308],[1409.66,847.003],[1486.6,750.29],[1486.6,839.855]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1504.57,460.717],[1504.57,370.326],[1486.6,461.433],[1486.6,371.867]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1504.57,556.919],[1504.57,466.529],[1486.6,556.758],[1486.6,467.192]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1504.57,560.592],[1504.57,650.982],[1486.6,560.397],[1486.6,649.963]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1504.57,653.663],[1504.57,744.053],[1486.6,652.619],[1486.6,742.185]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1504.57,752.232],[1504.57,842.623],[1486.6,750.29],[1486.6,839.855]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1504.57,460.717],[1504.57,370.326],[1602.88,463.116],[1602.88,375.487]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1504.57,556.919],[1504.57,466.529],[1602.88,556.379],[1602.88,468.75]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1504.57,560.592],[1504.57,650.983],[1602.88,559.94],[1602.88,647.569]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1504.57,653.663],[1504.57,744.053],[1602.88,650.167],[1602.88,737.796]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1504.57,752.232],[1504.57,842.623],[1602.88,745.726],[1602.88,833.354]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1585.2,463.767],[1585.2,376.887],[1657.21,465.5],[1657.21,380.614]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1585.2,649.219],[1585.2,736.099],[1657.21,646.695],[1657.21,731.58]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1585.2,743.961],[1585.2,830.841],[1657.21,739.262],[1657.21,824.147]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1585.2,559.763],[1585.2,646.643],[1657.21,559.293],[1657.21,644.178]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:16,
                    verts:[[1585.2,556.233],[1585.2,469.353],[1657.21,555.843],[1657.21,470.958]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[38.5903,437.741],[38.5903,320.908],[-28.1099,446.319],[-28.1099,339.358]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[38.5903,562.087],[38.5903,445.254],[-28.1099,560.158],[-28.1099,453.197]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[38.5903,566.835],[38.5903,683.669],[-28.1099,564.504],[-28.1099,671.465]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[38.5903,687.133],[38.5903,803.966],[-28.1099,674.637],[-28.1099,781.598]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[38.5903,814.539],[38.5903,931.372],[-28.1099,791.276],[-28.1099,898.237]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[146.29,423.891],[146.29,291.116],[61.1278,434.843],[61.1278,314.673]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[146.29,565.203],[146.29,432.428],[61.1278,562.739],[61.1278,442.57]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[146.29,570.599],[146.29,703.373],[61.1278,567.623],[61.1278,687.792]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[146.29,707.31],[146.29,840.085],[61.1278,691.355],[61.1278,811.525]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[146.29,852.1],[146.29,984.874],[61.1278,822.399],[61.1278,942.568]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[102.786,449.269],[102.786,345.703],[94.6498,450.127],[94.6498,347.548]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[102.786,563.703],[102.786,667.269],[94.6498,563.47],[94.6498,666.048]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[102.786,670.339],[102.786,773.905],[94.6498,669.09],[94.6498,771.668]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[102.786,783.277],[102.786,886.842],[94.6498,780.951],[94.6498,883.529]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[146.289,427.008],[146.289,294.233],[300.721,431.397],[300.721,303.815]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[146.289,568.32],[146.289,435.546],[300.721,567.184],[300.721,439.601]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[146.289,573.716],[146.289,706.491],[300.721,572.368],[300.721,699.951]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[146.289,710.428],[146.289,843.202],[300.721,703.734],[300.721,831.317]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[146.289,855.217],[146.289,987.992],[300.721,842.862],[300.721,970.444]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[313.335,430.103],[313.335,300.99],[300.72,431.397],[300.72,303.815]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[313.335,567.519],[313.335,438.405],[300.72,567.184],[300.72,439.601]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[313.335,572.766],[313.335,701.879],[300.72,572.368],[300.72,699.951]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[313.335,705.707],[313.335,834.821],[300.72,703.734],[300.72,831.317]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[313.335,846.504],[313.335,975.618],[300.72,842.862],[300.72,970.444]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[313.336,430.103],[313.336,300.99],[496.929,435.402],[496.929,312.555]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[313.336,567.519],[313.336,438.405],[496.929,566.147],[496.929,443.301]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[313.336,572.766],[313.336,701.879],[496.929,571.139],[496.929,693.985]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[313.336,705.707],[313.336,834.821],[496.929,697.627],[496.929,820.474]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[313.336,846.504],[313.336,975.618],[496.929,831.59],[496.929,954.436]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[480.506,457.748],[480.506,363.941],[469.494,458.477],[469.494,365.509]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[480.506,561.399],[480.506,655.206],[469.494,561.201],[469.494,654.169]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[480.506,657.987],[480.506,751.794],[469.494,656.925],[469.494,749.893]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[480.506,760.283],[480.506,854.09],[469.494,758.306],[469.494,851.274]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[482.356,436.615],[482.356,315.203],[611.408,440.28],[611.408,323.205]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[482.356,695.778],[482.356,817.189],[611.408,690.187],[611.408,807.262]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[482.356,828.175],[482.356,949.587],[611.408,817.856],[611.408,934.931]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[482.356,570.766],[482.356,692.178],[611.408,569.641],[611.408,686.716]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[482.356,565.833],[482.356,444.421],[611.408,564.883],[611.408,447.808]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[610.152,441.152],[610.152,324.039],[729.909,444.523],[729.909,331.434]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[610.152,565.795],[610.152,448.682],[729.909,564.883],[729.909,451.794]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[610.152,570.555],[610.152,687.667],[729.909,569.479],[729.909,682.568]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[610.152,691.14],[610.152,808.253],[729.909,685.921],[729.909,799.01]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[610.152,818.85],[610.152,935.963],[729.909,809.243],[729.909,922.332]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[746.197,443.481],[746.197,329.148],[729.91,444.523],[729.91,331.434]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[746.197,565.165],[746.197,450.832],[729.91,564.883],[729.91,451.794]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[746.197,569.811],[746.197,684.144],[729.91,569.479],[729.91,682.568]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[746.197,687.534],[746.197,801.867],[729.91,685.921],[729.91,799.01]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[746.197,812.213],[746.197,926.546],[729.91,809.243],[729.91,922.332]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[746.197,443.481],[746.197,329.148],[890.971,447.621],[890.971,338.23]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[746.197,565.165],[746.197,450.832],[890.971,564.045],[890.971,454.654]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[746.197,569.812],[746.197,684.144],[890.971,568.491],[890.971,677.881]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[746.197,687.534],[746.197,801.867],[890.971,681.125],[890.971,790.516]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[746.197,812.213],[746.197,926.546],[890.971,800.414],[890.971,909.805]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[866.334,464.429],[866.334,378.311],[837.347,465.77],[837.347,381.196]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[866.334,559.584],[866.334,645.701],[837.347,559.219],[837.347,643.793]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[866.334,648.255],[866.334,734.372],[837.347,646.301],[837.347,730.875]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[866.334,742.165],[866.334,828.283],[837.347,738.528],[837.347,823.102]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[874.451,448.543],[874.451,340.253],[977.928,451.457],[977.928,346.645]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[874.451,679.697],[874.451,787.987],[977.928,675.185],[977.928,779.997]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[874.451,797.786],[874.451,906.076],[977.928,789.481],[977.928,894.292]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[874.451,563.796],[874.451,455.506],[977.928,563.007],[977.928,458.196]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[874.451,568.196],[874.451,676.487],[977.928,567.267],[977.928,672.078]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[919.327,467.641],[919.327,385.221],[906.189,468.205],[906.189,386.433]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[919.327,558.711],[919.327,641.131],[906.189,558.557],[906.189,640.329]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[919.327,643.575],[919.327,725.995],[906.189,642.754],[906.189,724.526]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[919.327,733.453],[919.327,815.873],[906.189,731.925],[906.189,813.697]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1123.54,455.636],[1123.54,355.814],[1049.41,458.943],[1049.41,363.068]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1123.54,561.876],[1123.54,462.054],[1049.41,560.982],[1049.41,465.107]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1123.54,565.933],[1123.54,665.755],[1049.41,564.878],[1049.41,660.752]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1123.54,668.715],[1123.54,768.537],[1049.41,663.595],[1049.41,759.469]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1123.54,777.57],[1123.54,877.392],[1049.41,768.145],[1049.41,864.02]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1123.99,455.615],[1123.99,355.767],[1212.24,458.099],[1212.24,361.216]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1123.99,561.882],[1123.99,462.035],[1212.24,561.21],[1212.24,464.328]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1123.99,565.94],[1123.99,665.787],[1212.24,565.147],[1212.24,662.03]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1123.99,668.748],[1123.99,768.595],[1212.24,664.902],[1212.24,761.784]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1123.99,777.63],[1123.99,877.478],[1212.24,770.551],[1212.24,867.433]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1161.95,473.112],[1161.95,396.987],[1148.05,473.592],[1148.05,398.022]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1161.95,557.224],[1161.95,633.349],[1148.05,557.094],[1148.05,632.664]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1161.95,635.606],[1161.95,711.73],[1148.05,634.905],[1148.05,710.476]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1161.95,718.618],[1161.95,794.743],[1148.05,717.314],[1148.05,792.885]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1230.71,457.335],[1230.71,359.541],[1212.24,458.099],[1212.24,361.216]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1230.71,561.417],[1230.71,463.623],[1212.24,561.21],[1212.24,464.328]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1230.71,565.391],[1230.71,663.185],[1212.24,565.147],[1212.24,662.03]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1230.71,666.084],[1230.71,763.878],[1212.24,664.902],[1212.24,761.784]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1230.71,772.727],[1230.71,870.521],[1212.24,770.551],[1212.24,867.433]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1230.71,457.335],[1230.71,359.541],[1337.29,460.383],[1337.29,366.227]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1230.71,561.417],[1230.71,463.623],[1337.29,560.592],[1337.29,466.437]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1230.71,565.391],[1230.71,663.185],[1337.29,564.418],[1337.29,658.574]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1230.71,666.084],[1230.71,763.878],[1337.29,661.365],[1337.29,755.521]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1230.71,772.727],[1230.71,870.521],[1337.29,764.041],[1337.29,858.196]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1319.18,461.067],[1319.18,367.728],[1396.4,463.241],[1396.4,372.499]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1319.18,660.306],[1319.18,753.645],[1396.4,656.94],[1396.4,747.682]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1319.18,762.091],[1319.18,855.43],[1396.4,755.894],[1396.4,846.636]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1319.18,560.407],[1319.18,467.068],[1396.4,559.819],[1396.4,469.076]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1319.18,564.2],[1319.18,657.539],[1396.4,563.506],[1396.4,654.249]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1397.81,460.491],[1397.81,369.841],[1467.82,462.535],[1467.82,374.237]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1397.81,556.97],[1397.81,466.32],[1467.82,556.51],[1467.82,468.212]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1397.81,560.654],[1397.81,651.304],[1467.82,560.098],[1467.82,648.396]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1397.81,653.991],[1397.81,744.642],[1467.82,651.014],[1467.82,739.312]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1397.81,752.845],[1397.81,843.495],[1467.82,747.302],[1467.82,835.599]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1486.83,461.877],[1486.83,372.823],[1467.82,462.535],[1467.82,374.237]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1486.83,556.658],[1486.83,467.604],[1467.82,556.51],[1467.82,468.212]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1486.83,560.277],[1486.83,649.331],[1467.82,560.098],[1467.82,648.396]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1486.83,651.971],[1486.83,741.026],[1467.82,651.014],[1467.82,739.312]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1486.83,749.084],[1486.83,838.138],[1467.82,747.302],[1467.82,835.599]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1486.83,461.877],[1486.83,372.823],[1575.51,464.508],[1575.51,378.481]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1486.83,556.658],[1486.83,467.604],[1575.51,556.066],[1575.51,470.039]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1486.83,560.277],[1486.83,649.331],[1575.51,559.562],[1575.51,645.589]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1486.83,651.971],[1486.83,741.026],[1575.51,648.14],[1575.51,734.167]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1486.83,749.084],[1486.83,838.138],[1575.51,741.951],[1575.51,827.979]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1557.06,465.1],[1557.06,379.756],[1621.77,466.991],[1621.77,383.821]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1557.06,647.276],[1557.06,732.621],[1621.77,644.523],[1621.77,727.692]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1557.06,740.344],[1557.06,825.689],[1621.77,735.218],[1621.77,818.387]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1557.06,555.933],[1557.06,470.588],[1621.77,555.508],[1621.77,472.338]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:17,
                    verts:[[1557.06,559.401],[1557.06,644.746],[1621.77,558.887],[1621.77,642.057]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[52.2043,433.542],[52.2043,311.876],[-40.8333,442.245],[-40.8333,330.595]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[52.2043,563.032],[52.2043,441.365],[-40.8333,561.074],[-40.8333,449.424]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[52.2043,567.976],[52.2043,689.642],[-40.8333,565.611],[-40.8333,677.261]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[52.2043,693.25],[52.2043,814.916],[-40.8333,680.572],[-40.8333,792.221]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[52.2043,825.926],[52.2043,947.592],[-40.8333,802.325],[-40.8333,913.975]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[92.3251,445.801],[92.3251,338.243],[81.5098,446.665],[81.5098,340.101]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[92.3251,560.274],[92.3251,452.717],[81.5098,560.08],[81.5098,453.517]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[92.3251,564.645],[92.3251,672.203],[81.5098,564.41],[81.5098,670.974]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[92.3251,675.392],[92.3251,782.949],[81.5098,674.133],[81.5098,780.697]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[92.3251,792.682],[92.3251,900.239],[81.5098,790.34],[81.5098,896.903]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[201.502,419.577],[201.502,281.837],[83.5414,430.611],[83.5414,305.571]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[201.502,566.173],[201.502,428.433],[83.5414,563.691],[83.5414,438.651]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[201.502,571.771],[201.502,709.511],[83.5414,568.773],[83.5414,693.813]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[201.502,713.595],[201.502,851.334],[83.5414,697.52],[83.5414,822.56]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[201.502,863.799],[201.502,1001.54],[83.5414,833.875],[83.5414,958.915]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[201.502,422.811],[201.502,285.071],[353.517,428.032],[353.517,296.468]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[201.502,569.407],[201.502,431.667],[353.517,568.055],[353.517,436.491]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[201.502,575.005],[201.502,712.745],[353.517,573.402],[353.517,704.966]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[201.502,716.829],[201.502,854.568],[353.517,708.867],[353.517,840.431]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[201.502,867.033],[201.502,1004.77],[353.517,852.336],[353.517,983.9]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[370.038,426.748],[370.038,293.665],[353.516,428.032],[353.516,296.467]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[370.038,568.388],[370.038,435.305],[353.516,568.055],[353.516,436.491]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[370.038,573.796],[370.038,706.879],[353.516,573.402],[353.516,704.966]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[370.038,710.824],[370.038,843.907],[353.516,708.867],[353.516,840.431]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[370.038,855.95],[370.038,989.033],[353.516,852.336],[353.516,983.9]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[370.038,426.748],[370.038,293.665],[548.017,432.963],[548.017,307.232]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[370.038,568.388],[370.038,435.305],[548.017,566.778],[548.017,441.047]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[370.038,573.796],[370.038,706.879],[548.017,571.888],[548.017,697.619]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[370.038,710.824],[370.038,843.907],[548.017,701.347],[548.017,827.078]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[370.038,855.95],[370.038,989.032],[548.017,838.455],[548.017,964.186]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[469.191,455.828],[469.191,359.811],[455.967,456.541],[455.967,361.345]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[469.191,561.921],[469.191,657.938],[455.967,561.727],[455.967,656.923]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[469.191,660.784],[469.191,756.801],[455.967,659.746],[455.967,754.942]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[469.191,765.49],[469.191,861.507],[455.967,763.556],[455.967,858.752]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[529.865,434.149],[529.865,309.822],[653.778,438.403],[653.778,319.106]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[529.865,571.523],[529.865,695.851],[653.778,570.217],[653.778,689.514]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[529.865,699.537],[529.865,823.865],[653.778,693.051],[653.778,812.347]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[529.865,835.115],[529.865,959.443],[653.778,823.142],[653.778,942.439]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[529.865,566.471],[529.865,442.144],[653.778,565.369],[653.778,446.073]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[652.568,439.286],[652.568,319.946],[766.481,443.16],[766.481,328.445]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[652.568,566.3],[652.568,446.96],[766.481,565.252],[766.481,450.536]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[652.568,571.15],[652.568,690.491],[766.481,569.914],[766.481,684.63]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[652.568,824.169],[652.568,943.509],[766.481,813.127],[766.481,927.843]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[652.568,694.029],[652.568,813.37],[766.481,688.031],[766.481,802.746]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[785.678,442.16],[785.678,326.251],[766.482,443.16],[766.482,328.445]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[785.678,565.523],[785.678,449.613],[766.482,565.252],[766.482,450.536]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[785.678,570.233],[785.678,686.143],[766.482,569.914],[766.482,684.629]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[785.678,689.579],[785.678,805.489],[766.482,688.031],[766.482,802.746]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[785.678,815.977],[785.678,931.887],[766.482,813.127],[766.482,927.843]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[785.678,442.16],[785.678,326.251],[921.662,446.865],[921.662,336.572]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[785.678,565.523],[785.678,449.613],[921.662,564.25],[921.662,453.957]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[785.678,570.233],[785.678,686.143],[921.662,568.732],[921.662,679.025]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[785.678,689.579],[785.678,805.489],[921.662,682.295],[921.662,792.587]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[785.678,815.977],[785.678,931.887],[921.662,802.568],[921.662,912.861]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[847.875,463.775],[847.875,376.905],[815.34,465.051],[815.34,379.648]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[847.875,559.761],[847.875,646.631],[815.34,559.415],[815.34,644.817]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[847.875,649.207],[847.875,736.076],[815.34,647.349],[815.34,732.751]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[847.875,743.937],[847.875,830.807],[815.34,740.479],[815.34,825.881]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[893.484,467.163],[893.484,384.192],[878.905,467.696],[878.905,385.339]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[893.484,558.841],[893.484,641.811],[878.905,558.696],[878.905,641.053]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[893.484,644.271],[893.484,727.242],[878.905,643.495],[878.905,725.852]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[893.484,734.75],[893.484,817.721],[878.905,733.305],[878.905,815.662]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[902.716,447.74],[902.716,338.493],[999.245,451.025],[999.245,345.699]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[902.716,568.452],[902.716,677.7],[999.245,567.404],[999.245,672.731]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[902.716,680.939],[902.716,790.187],[999.245,675.853],[999.245,781.18]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[902.716,800.073],[902.716,909.321],[999.245,790.711],[999.245,896.037]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[902.716,564.013],[902.716,454.765],[999.245,563.124],[999.245,457.798]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1133.61,455.683],[1133.61,355.918],[1051.81,458.774],[1051.81,362.699]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1133.61,561.864],[1133.61,462.098],[1051.81,561.027],[1051.81,464.952]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1133.61,565.918],[1133.61,665.684],[1051.81,564.932],[1051.81,661.007]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1133.61,668.642],[1133.61,768.407],[1051.81,663.856],[1051.81,759.931]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1133.61,777.435],[1133.61,877.201],[1051.81,768.625],[1051.81,864.7]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1122.13,473.271],[1122.13,397.331],[1107.23,473.718],[1107.23,398.292]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1122.13,557.181],[1122.13,633.121],[1107.23,557.059],[1107.23,632.486]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1122.13,635.373],[1122.13,711.314],[1107.23,634.722],[1107.23,710.148]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1122.13,718.186],[1122.13,794.126],[1107.23,716.974],[1107.23,792.4]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1134.12,455.663],[1134.12,355.874],[1214.96,458.413],[1214.96,361.906]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1134.12,561.869],[1134.12,462.08],[1214.96,561.125],[1214.96,464.618]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1134.12,565.924],[1134.12,665.714],[1214.96,565.047],[1214.96,661.554]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1134.12,668.672],[1134.12,768.461],[1214.96,664.415],[1214.96,760.922]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1134.12,777.491],[1134.12,877.281],[1214.96,769.655],[1214.96,866.162]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1235,457.706],[1235,360.356],[1214.96,458.413],[1214.96,361.906]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1235,561.316],[1235,463.966],[1214.96,561.125],[1214.96,464.618]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1235,565.272],[1235,662.623],[1214.96,565.047],[1214.96,661.554]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1235,665.509],[1235,762.86],[1214.96,664.415],[1214.96,760.922]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1235,771.669],[1235,869.019],[1214.96,769.655],[1214.96,866.162]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1235,457.706],[1235,360.356],[1331.68,461.051],[1331.68,367.694]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1235,561.316],[1235,463.966],[1331.68,560.411],[1331.68,467.054]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1235,565.272],[1235,662.623],[1331.68,564.205],[1331.68,657.563]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1235,665.509],[1235,762.86],[1331.68,660.331],[1331.68,753.688]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1235,771.669],[1235,869.02],[1331.68,762.136],[1331.68,855.494]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1312.32,461.679],[1312.32,369.072],[1382.07,464.053],[1382.07,374.278]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1312.32,659.358],[1312.32,751.966],[1382.07,655.684],[1382.07,745.458]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1312.32,760.346],[1312.32,852.953],[1382.07,753.581],[1382.07,843.356]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1312.32,560.241],[1312.32,467.634],[1382.07,559.599],[1382.07,469.825]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1312.32,564.005],[1312.32,656.612],[1382.07,563.247],[1382.07,653.022]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1383.25,461.336],[1383.25,371.658],[1446.13,463.554],[1446.13,376.429]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1383.25,556.78],[1383.25,467.102],[1446.13,556.281],[1446.13,469.156]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1383.25,560.424],[1383.25,650.102],[1446.13,559.821],[1446.13,646.946]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1383.25,652.761],[1383.25,742.439],[1446.13,649.529],[1446.13,736.654]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1383.25,750.554],[1383.25,840.232],[1446.13,744.538],[1446.13,831.662]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1466.03,462.957],[1466.03,375.145],[1446.13,463.554],[1446.13,376.429]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1466.03,556.415],[1466.03,468.603],[1446.13,556.281],[1446.13,469.156]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1466.03,559.983],[1466.03,647.795],[1446.13,559.821],[1446.13,646.946]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1466.03,650.399],[1466.03,738.21],[1446.13,649.529],[1446.13,736.654]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1466.03,746.156],[1466.03,833.968],[1446.13,744.538],[1446.13,831.662]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1466.03,462.957],[1466.03,375.145],[1545,465.791],[1545,381.242]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1466.03,556.415],[1466.03,468.603],[1545,555.777],[1545,471.228]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1466.03,559.983],[1466.03,647.795],[1545,559.213],[1545,643.763]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1466.03,650.399],[1466.03,738.21],[1545,646.27],[1545,730.82]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1466.03,746.156],[1466.03,833.968],[1545,738.47],[1545,823.02]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1525.91,466.326],[1525.91,382.392],[1583.36,468.354],[1583.36,386.754]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1525.91,645.491],[1525.91,729.425],[1583.36,642.536],[1583.36,724.136]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1525.91,737.02],[1525.91,820.954],[1583.36,731.52],[1583.36,813.12]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1525.91,555.657],[1525.91,471.723],[1583.36,555.201],[1583.36,473.601]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:18,
                    verts:[[1525.91,559.068],[1525.91,643.002],[1583.36,558.517],[1583.36,640.117]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[75.9303,429.126],[75.9303,302.377],[-46.0153,437.847],[-46.0153,321.135]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[75.9303,564.025],[75.9303,437.276],[-46.0153,562.063],[-46.0153,445.351]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[75.9303,569.176],[75.9303,695.925],[-46.0153,566.806],[-46.0153,683.518]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[75.9303,699.684],[75.9303,826.433],[-46.0153,686.979],[-46.0153,803.691]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[75.9303,837.902],[75.9303,964.652],[-46.0153,814.252],[-46.0153,930.964]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[88.2595,442.078],[88.2595,330.235],[74.5273,442.937],[74.5273,332.084]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[88.2595,565.657],[88.2595,677.5],[74.5273,565.423],[74.5273,676.277]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[88.2595,680.816],[88.2595,792.659],[74.5273,679.563],[74.5273,790.417]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[88.2595,802.779],[88.2595,914.622],[74.5273,800.448],[74.5273,911.301]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[88.2595,561.112],[88.2595,449.269],[74.5273,560.918],[74.5273,450.065]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[269.89,415.255],[269.89,272.541],[116.817,426.202],[116.817,296.087]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[269.89,567.145],[269.89,424.431],[116.817,564.683],[116.817,434.568]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[269.89,572.945],[269.89,715.659],[116.817,569.971],[116.817,700.085]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[269.89,719.891],[269.89,862.605],[116.817,703.943],[116.817,834.058]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[269.89,875.519],[269.89,1018.23],[116.817,845.832],[116.817,975.947]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[269.889,418.606],[269.889,275.891],[416.601,424.704],[416.601,289.203]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[269.889,570.496],[269.889,427.782],[416.601,568.917],[416.601,433.416]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[269.889,576.296],[269.889,719.01],[416.601,574.424],[416.601,709.924]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[269.889,723.242],[269.889,865.956],[416.601,713.942],[416.601,849.442]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[269.889,878.87],[269.889,1021.58],[416.601,861.704],[416.601,997.205]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[437.159,423.452],[437.159,286.47],[416.6,424.704],[416.6,289.203]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[437.159,569.241],[437.159,432.259],[416.6,568.917],[416.6,433.416]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[437.159,574.808],[437.159,711.79],[416.6,574.424],[416.6,709.924]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[437.159,715.852],[437.159,852.834],[416.6,713.942],[416.6,849.443]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[437.159,865.229],[437.159,1002.21],[416.6,861.704],[416.6,997.205]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[437.159,423.452],[437.159,286.47],[606.212,430.609],[606.212,302.093]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[437.159,569.241],[437.159,432.259],[606.212,567.388],[606.212,438.872]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[437.159,574.808],[437.159,711.79],[606.212,572.611],[606.212,701.127]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[437.159,715.852],[437.159,852.833],[606.212,704.937],[606.212,833.453]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[437.159,865.229],[437.159,1002.21],[606.212,845.082],[606.212,973.599]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[460.836,453.776],[460.836,355.397],[445.316,454.465],[445.316,356.88]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[460.836,562.478],[460.836,660.857],[445.316,562.291],[445.316,659.876]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[460.836,663.774],[460.836,762.152],[445.316,662.77],[445.316,760.355]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[460.836,771.055],[460.836,869.433],[445.316,769.186],[445.316,866.771]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[584.46,431.75],[584.46,304.584],[701.146,436.597],[701.146,315.165]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[584.46,572.26],[584.46,699.426],[701.146,570.772],[701.146,692.204]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[584.46,703.196],[584.46,830.362],[701.146,695.804],[701.146,817.236]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[584.46,841.869],[584.46,969.035],[701.146,828.225],[701.146,949.657]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[584.46,567.092],[584.46,439.927],[701.146,565.837],[701.146,444.405]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[700.002,437.492],[700.002,316.009],[806.295,441.866],[806.295,325.606]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[700.002,566.786],[700.002,445.303],[806.295,565.602],[806.295,449.342]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[700.002,571.723],[700.002,693.206],[806.295,570.327],[806.295,686.587]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[700.002,696.807],[700.002,818.29],[806.295,690.034],[806.295,806.294]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[700.002,829.283],[700.002,950.766],[806.295,816.815],[806.295,933.075]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[829.562,463.038],[829.562,375.319],[793.514,464.236],[793.514,377.895]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[829.562,559.962],[829.562,647.68],[793.514,559.636],[793.514,645.976]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[829.562,650.281],[829.562,738],[793.514,648.536],[793.514,734.876]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[829.562,745.938],[829.562,833.657],[793.514,742.689],[793.514,829.029]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[828.315,440.922],[828.315,323.534],[806.295,441.866],[806.295,325.606]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[828.315,565.858],[828.315,448.47],[806.295,565.602],[806.295,449.342]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[828.315,570.628],[828.315,688.016],[806.295,570.327],[806.295,686.587]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[828.315,691.496],[828.315,808.884],[806.295,690.034],[806.295,806.294]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[828.315,819.507],[828.315,936.895],[806.295,816.815],[806.295,933.075]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[828.316,440.922],[828.316,323.534],[953.577,446.176],[953.577,335.061]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[828.316,565.858],[828.316,448.47],[953.577,564.436],[953.577,453.321]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[828.316,570.628],[828.316,688.016],[953.577,568.951],[953.577,680.067]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[828.316,691.496],[828.316,808.884],[953.577,683.361],[953.577,794.476]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[828.316,819.507],[828.316,936.895],[953.577,804.531],[953.577,915.646]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[867.324,466.589],[867.324,382.958],[851.325,467.088],[851.325,384.031]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[867.324,558.996],[867.324,642.628],[851.325,558.861],[851.325,641.918]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[867.324,645.107],[867.324,728.738],[851.325,644.381],[851.325,727.438]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[867.324,736.306],[867.324,819.937],[851.325,734.954],[851.325,818.011]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[932.327,446.994],[932.327,336.856],[1020.73,450.635],[1020.73,344.843]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[932.327,568.69],[932.327,678.829],[1020.73,567.529],[1020.73,673.321]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[932.327,682.094],[932.327,792.233],[1020.73,676.457],[1020.73,782.25]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[932.327,802.199],[932.327,912.338],[1020.73,791.823],[1020.73,897.615]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[932.327,564.215],[932.327,454.076],[1020.73,563.229],[1020.73,457.437]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1142.49,455.744],[1142.49,356.051],[1053.57,458.593],[1053.57,362.301]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1142.49,561.847],[1142.49,462.154],[1053.57,561.076],[1053.57,464.784]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1142.49,565.899],[1142.49,665.591],[1053.57,564.99],[1053.57,661.282]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1142.49,668.547],[1142.49,768.24],[1053.57,664.137],[1053.57,760.429]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1142.49,777.261],[1142.49,876.954],[1053.57,769.142],[1053.57,865.434]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1080.94,473.323],[1080.94,397.442],[1065.09,473.734],[1065.09,398.326]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1080.94,557.167],[1080.94,633.048],[1065.09,557.055],[1065.09,632.463]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1080.94,635.298],[1080.94,711.178],[1065.09,634.699],[1065.09,710.107]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1080.94,718.045],[1080.94,793.926],[1065.09,716.931],[1065.09,792.339]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1143.04,455.726],[1143.04,356.011],[1215.82,458.722],[1215.82,362.583]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1143.04,561.852],[1143.04,462.137],[1215.82,561.042],[1215.82,464.903]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1143.04,565.904],[1143.04,665.619],[1215.82,564.948],[1215.82,661.087]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1143.04,668.576],[1143.04,768.29],[1215.82,663.937],[1215.82,760.076]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1143.04,777.313],[1143.04,877.028],[1215.82,768.775],[1215.82,864.913]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1237.28,458.077],[1237.28,361.169],[1215.82,458.722],[1215.82,362.583]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1237.28,561.216],[1237.28,464.308],[1215.82,561.042],[1215.82,464.903]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1237.28,565.154],[1237.28,662.062],[1215.82,564.948],[1215.82,661.087]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1237.28,664.936],[1237.28,761.844],[1215.82,663.937],[1215.82,760.076]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1237.28,770.613],[1237.28,867.521],[1215.82,768.775],[1215.82,864.913]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1237.28,458.077],[1237.28,361.169],[1323.45,461.691],[1323.45,369.098]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1237.28,561.216],[1237.28,464.308],[1323.45,560.238],[1323.45,467.645]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1237.28,565.154],[1237.28,662.062],[1323.45,564.001],[1323.45,656.594]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1237.28,664.936],[1237.28,761.844],[1323.45,659.339],[1323.45,751.932]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1237.28,770.613],[1237.28,867.521],[1323.45,760.311],[1323.45,852.904]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1303.01,462.26],[1303.01,370.347],[1364.98,464.813],[1364.98,375.946]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1303.01,658.458],[1303.01,750.372],[1364.98,654.507],[1364.98,743.373]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1303.01,758.689],[1303.01,850.603],[1364.98,751.415],[1364.98,840.282]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1303.01,563.819],[1303.01,655.733],[1364.98,563.005],[1364.98,651.872]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1303.01,560.084],[1303.01,468.17],[1364.98,559.394],[1364.98,470.527]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1365.92,462.127],[1365.92,373.359],[1421.52,464.5],[1421.52,378.465]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1365.92,556.602],[1365.92,467.834],[1421.52,556.068],[1421.52,470.032]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1365.92,560.209],[1365.92,648.977],[1421.52,559.564],[1421.52,645.6]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1365.92,651.608],[1365.92,740.376],[1421.52,648.151],[1421.52,734.186]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1365.92,748.408],[1365.92,837.176],[1421.52,741.972],[1421.52,828.007]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1442.17,463.965],[1442.17,377.313],[1421.52,464.5],[1421.52,378.465]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1442.17,556.188],[1442.17,469.537],[1421.52,556.068],[1421.52,470.032]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1442.17,559.71],[1442.17,646.361],[1421.52,559.564],[1421.52,645.6]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1442.17,648.93],[1442.17,735.582],[1421.52,648.151],[1421.52,734.186]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1442.17,743.423],[1442.17,830.075],[1421.52,741.972],[1421.52,828.007]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1442.17,463.965],[1442.17,377.313],[1511.39,466.977],[1511.39,383.792]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1442.17,556.188],[1442.17,469.537],[1511.39,555.511],[1511.39,472.326]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1442.17,559.71],[1442.17,646.361],[1511.39,558.891],[1511.39,642.076]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1442.17,648.93],[1442.17,735.582],[1511.39,644.543],[1511.39,727.728]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1442.17,743.423],[1442.17,830.075],[1511.39,735.255],[1511.39,818.441]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1491.77,467.453],[1491.77,384.817],[1542.03,469.601],[1542.03,389.435]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1491.77,643.848],[1491.77,726.485],[1542.03,640.721],[1542.03,720.886]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1491.77,733.963],[1491.77,816.599],[1542.03,728.14],[1542.03,808.305]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1491.77,558.762],[1491.77,641.398],[1542.03,558.178],[1542.03,638.344]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:19,
                    verts:[[1491.77,555.403],[1491.77,472.767],[1542.03,554.92],[1542.03,474.755]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[111.397,424.557],[111.397,292.55],[-41.9027,433.152],[-41.9027,311.036]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[111.397,565.053],[111.397,433.045],[-41.9027,563.12],[-41.9027,441.004]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[111.397,570.417],[111.397,702.425],[-41.9027,568.082],[-41.9027,690.198]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[111.397,706.339],[111.397,838.347],[-41.9027,693.819],[-41.9027,815.934]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[111.397,850.292],[111.397,982.3],[-41.9027,826.984],[-41.9027,949.1]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[91.941,438.127],[91.941,321.737],[75.0606,438.969],[75.0606,323.549]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[91.941,566.73],[91.941,683.12],[75.0606,566.501],[75.0606,681.922]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[91.941,686.571],[91.941,802.961],[75.0606,685.344],[75.0606,800.764]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[91.941,813.494],[91.941,929.884],[75.0606,811.209],[75.0606,926.629]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[352.343,411.049],[352.343,263.494],[162.482,421.693],[162.482,286.389]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[352.343,568.092],[352.343,420.536],[162.482,565.697],[162.482,430.393]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[352.343,574.088],[352.343,721.643],[162.482,571.196],[162.482,706.5]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[352.343,726.018],[352.343,873.573],[162.482,710.511],[162.482,845.815]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[352.343,886.926],[352.343,1034.48],[162.482,858.059],[162.482,993.363]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[352.343,414.513],[352.343,266.958],[490.386,421.512],[490.386,282.236]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[352.343,571.556],[352.343,424.001],[490.386,569.744],[490.386,430.467]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[352.343,577.552],[352.343,725.108],[490.386,575.404],[490.386,714.68]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[352.343,729.483],[352.343,877.038],[490.386,718.809],[490.386,858.085]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[352.343,890.39],[352.343,1037.95],[490.386,870.689],[490.386,1009.96]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[455.973,451.612],[455.973,350.743],[438.091,452.268],[438.091,352.153]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[455.973,563.066],[455.973,663.935],[438.091,562.888],[438.091,663.003]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[455.973,666.926],[455.973,767.796],[438.091,665.971],[438.091,766.086]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[455.973,776.923],[455.973,877.792],[438.091,775.145],[438.091,875.26]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[515.008,420.316],[515.008,279.626],[490.385,421.512],[490.385,282.236]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[515.008,570.053],[515.008,429.363],[490.385,569.744],[490.385,430.467]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[515.008,575.771],[515.008,716.461],[490.385,575.404],[490.385,714.68]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[515.008,720.633],[515.008,861.323],[490.385,718.809],[490.385,858.086]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[515.008,874.054],[515.008,1014.74],[490.385,870.689],[490.385,1009.96]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[515.008,420.317],[515.008,279.626],[671.462,428.415],[671.462,297.305]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[515.008,570.053],[515.008,429.363],[671.462,567.956],[671.462,436.846]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[515.008,575.771],[515.008,716.461],[671.462,573.284],[671.462,704.395]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[515.008,720.633],[515.008,861.323],[671.462,708.282],[671.462,839.392]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[515.008,874.054],[515.008,1014.74],[671.462,851.257],[671.462,982.367]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[646.18,429.491],[646.18,299.652],[753.392,434.922],[753.392,311.509]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[646.18,706.642],[646.18,836.48],[753.392,698.358],[753.392,821.772]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[646.18,848.229],[646.18,978.068],[753.392,832.939],[753.392,956.352]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[646.18,572.954],[646.18,702.792],[753.392,571.286],[753.392,694.699]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[646.18,567.677],[646.18,437.839],[753.392,566.271],[753.392,442.858]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[752.333,567.236],[752.333,443.766],[849.149,565.921],[849.149,448.253]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[752.333,572.254],[752.333,695.724],[849.149,570.703],[849.149,688.372]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[752.333,699.385],[752.333,822.855],[849.149,691.86],[849.149,809.529]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[752.333,834.028],[752.333,957.499],[849.149,820.177],[849.149,937.845]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[752.333,435.827],[752.333,312.356],[849.149,440.687],[849.149,323.018]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[811.536,462.228],[811.536,373.577],[772.036,463.336],[772.036,375.96]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[811.536,560.182],[811.536,648.833],[772.036,559.88],[772.036,647.256]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[811.536,651.461],[811.536,740.112],[772.036,649.847],[772.036,737.223]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[811.536,748.134],[811.536,836.785],[772.036,745.13],[772.036,832.505]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[840.968,465.929],[840.968,381.538],[823.576,466.389],[823.576,382.526]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[840.968,559.176],[840.968,643.567],[823.576,559.051],[823.576,642.913]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[840.968,646.069],[840.968,730.46],[823.576,645.4],[823.576,729.262]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[840.968,738.097],[840.968,822.488],[823.576,736.851],[823.576,820.713]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[873.842,439.813],[873.842,321.1],[849.15,440.687],[849.15,323.018]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[873.842,566.158],[873.842,447.446],[849.15,565.921],[849.15,448.253]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[873.842,570.982],[873.842,689.694],[849.15,570.703],[849.15,688.372]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[873.842,693.214],[873.842,811.926],[849.15,691.86],[849.15,809.529]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[873.842,822.669],[873.842,941.381],[849.15,820.177],[849.15,937.845]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[873.842,439.813],[873.842,321.1],[986.436,445.587],[986.436,333.769]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[873.842,566.158],[873.842,447.446],[986.436,564.595],[986.436,452.777]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[873.842,570.982],[873.842,689.694],[986.436,569.139],[986.436,680.958]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[873.842,693.214],[873.842,811.926],[986.436,684.273],[986.436,796.091]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[873.842,822.669],[873.842,941.381],[986.436,806.21],[986.436,918.028]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[963.052,446.337],[963.052,335.414],[1042.17,450.312],[1042.17,344.133]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[963.052,683.112],[963.052,794.035],[1042.17,676.958],[1042.17,783.137]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[963.052,804.072],[963.052,914.995],[1042.17,792.745],[1042.17,898.923]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[963.052,568.9],[963.052,679.823],[1042.17,567.632],[1042.17,673.81]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[963.052,564.392],[963.052,453.469],[1042.17,563.317],[1042.17,457.139]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1038.45,473.273],[1038.45,397.334],[1021.67,473.645],[1021.67,398.135]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1038.45,557.18],[1038.45,633.119],[1021.67,557.079],[1021.67,632.589]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1038.45,635.371],[1038.45,711.309],[1021.67,634.828],[1021.67,710.339]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1038.45,718.181],[1038.45,794.12],[1021.67,717.171],[1021.67,792.682]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1150.01,455.835],[1150.01,356.251],[1054.64,458.415],[1054.64,361.91]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1150.01,561.823],[1150.01,462.239],[1054.64,561.125],[1054.64,464.62]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1150.01,565.869],[1150.01,665.453],[1054.64,565.046],[1054.64,661.551]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1150.01,668.406],[1150.01,767.99],[1054.64,664.413],[1054.64,760.917]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1150.01,777.001],[1150.01,876.585],[1054.64,769.65],[1054.64,866.155]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1150.59,455.819],[1150.59,356.215],[1214.72,459.038],[1214.72,363.277]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1150.59,561.827],[1150.59,462.223],[1214.72,560.956],[1214.72,465.195]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1150.59,565.875],[1150.59,665.478],[1214.72,564.848],[1214.72,660.608]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1150.59,668.432],[1150.59,768.035],[1214.72,663.448],[1214.72,759.209]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1150.59,777.048],[1150.59,876.652],[1214.72,767.874],[1214.72,863.635]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1237.42,458.46],[1237.42,362.009],[1214.72,459.038],[1214.72,363.277]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1237.42,561.112],[1237.42,464.661],[1214.72,560.956],[1214.72,465.195]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1237.42,565.032],[1237.42,661.483],[1214.72,564.848],[1214.72,660.608]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1237.42,664.343],[1237.42,760.794],[1214.72,663.448],[1214.72,759.208]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1237.42,769.522],[1237.42,865.973],[1214.72,767.874],[1214.72,863.635]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1237.42,458.46],[1237.42,362.009],[1312.56,462.314],[1312.56,370.464]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1237.42,561.112],[1237.42,464.661],[1312.56,560.07],[1312.56,468.22]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1237.42,565.032],[1237.42,661.483],[1312.56,563.802],[1312.56,655.652]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1237.42,664.343],[1237.42,760.794],[1312.56,658.376],[1312.56,750.226]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1237.42,769.522],[1237.42,865.973],[1312.56,758.537],[1312.56,850.387]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1291.18,462.82],[1291.18,371.575],[1345.12,465.53],[1345.12,377.52]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1291.18,563.641],[1291.18,654.886],[1345.12,562.776],[1345.12,650.786]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1291.18,657.591],[1291.18,748.836],[1345.12,653.395],[1345.12,741.405]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1291.18,757.093],[1291.18,848.338],[1345.12,749.369],[1345.12,837.379]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1291.18,559.932],[1291.18,468.687],[1345.12,559.199],[1345.12,471.189]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1345.83,462.873],[1345.83,374.965],[1394,465.382],[1394,380.361]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1345.83,556.434],[1345.83,468.525],[1394,555.87],[1394,470.848]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1345.83,560.006],[1345.83,647.914],[1394,559.325],[1394,644.346]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1345.83,650.521],[1345.83,738.429],[1394,646.866],[1394,731.888]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1345.83,746.384],[1345.83,834.292],[1394,739.581],[1394,824.602]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1415.28,464.909],[1415.28,379.345],[1394,465.382],[1394,380.361]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1415.28,555.976],[1415.28,470.411],[1394,555.87],[1394,470.848]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1415.28,559.453],[1415.28,645.018],[1394,559.325],[1394,644.346]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1415.28,647.555],[1415.28,733.119],[1394,646.866],[1394,731.888]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1415.28,740.862],[1415.28,826.427],[1394,739.581],[1394,824.602]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1415.28,464.909],[1415.28,379.345],[1474.74,468.072],[1474.74,386.148]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1415.28,555.976],[1415.28,470.411],[1474.74,555.264],[1474.74,473.34]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1415.28,559.453],[1415.28,645.018],[1474.74,558.594],[1474.74,640.518]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1415.28,647.555],[1415.28,733.119],[1474.74,642.947],[1474.74,724.871]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1415.28,740.862],[1415.28,826.427],[1474.74,732.284],[1474.74,814.208]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1454.7,468.491],[1454.7,387.048],[1497.84,470.739],[1497.84,391.883]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1454.7,558.48],[1454.7,639.922],[1497.84,557.869],[1497.84,636.724]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1454.7,642.337],[1454.7,723.78],[1497.84,639.062],[1497.84,717.918]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1454.7,731.149],[1454.7,812.592],[1497.84,725.053],[1497.84,803.909]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:20,
                    verts:[[1454.7,555.17],[1454.7,473.728],[1497.84,554.664],[1497.84,475.809]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[160.2,419.931],[160.2,282.598],[-26.5246,428.212],[-26.5246,300.41]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[160.2,566.094],[160.2,428.761],[-26.5246,564.231],[-26.5246,436.429]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[160.2,571.675],[160.2,709.007],[-26.5246,569.424],[-26.5246,697.226]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[160.2,713.079],[160.2,850.412],[-26.5246,701.015],[-26.5246,828.817]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[160.2,862.839],[160.2,1000.17],[-26.5246,840.382],[-26.5246,968.183]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[104.863,433.995],[104.863,312.85],[84.6288,434.803],[84.6288,314.588]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[104.863,567.853],[104.863,688.998],[84.6288,567.633],[84.6288,687.849]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[104.863,692.59],[104.863,813.736],[84.6288,691.413],[84.6288,811.628]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[104.863,824.698],[104.863,945.844],[84.6288,822.506],[84.6288,942.722]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[449.232,407.113],[449.232,255.027],[221.93,417.193],[221.93,276.71]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[449.232,568.977],[449.232,416.891],[221.93,566.709],[221.93,426.226]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[449.232,575.158],[449.232,727.243],[221.93,572.419],[221.93,712.902]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[449.232,731.753],[449.232,883.838],[221.93,717.067],[221.93,857.551]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[449.232,897.601],[449.232,1049.69],[221.93,870.263],[221.93,1010.75]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[455.188,449.364],[455.188,345.907],[434.902,449.974],[434.902,347.221]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[455.188,563.677],[455.188,667.134],[434.902,563.511],[434.902,666.265]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[455.188,670.201],[455.188,773.658],[434.902,669.312],[434.902,772.065]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[455.188,783.02],[455.188,886.477],[434.902,781.364],[434.902,884.118]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[449.232,410.683],[449.232,258.598],[574.855,418.574],[574.855,275.822]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[449.232,572.548],[449.232,420.462],[574.855,570.505],[574.855,427.753]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[449.232,578.728],[449.232,730.814],[574.855,576.306],[574.855,719.058]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[449.232,735.323],[449.232,887.409],[574.855,723.29],[574.855,866.042]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[449.232,901.172],[449.232,1053.26],[574.855,878.96],[574.855,1021.71]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[603.428,417.463],[603.428,273.398],[574.855,418.574],[574.855,275.822]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[603.428,570.792],[603.428,426.727],[574.855,570.505],[574.855,427.753]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[603.428,576.647],[603.428,720.712],[574.855,576.306],[574.855,719.058]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[603.428,724.984],[603.428,869.049],[574.855,723.29],[574.855,866.042]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[603.428,882.086],[603.428,1026.15],[574.855,878.96],[574.855,1021.71]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[603.428,417.463],[603.428,273.398],[743.384,426.469],[743.384,293.056]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[603.428,570.792],[603.428,426.727],[743.384,568.46],[743.384,435.047]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[603.428,576.647],[603.428,720.712],[743.384,573.882],[743.384,707.294]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[603.428,724.984],[603.428,869.049],[743.384,711.25],[743.384,844.662]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[603.428,882.086],[603.428,1026.15],[743.384,856.735],[743.384,990.148]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[714.755,427.455],[714.755,295.209],[810.167,433.443],[810.167,308.28]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[714.755,573.579],[714.755,705.825],[810.167,571.74],[810.167,696.903]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[714.755,709.746],[714.755,841.992],[810.167,700.614],[810.167,825.777]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[714.755,853.959],[714.755,986.205],[810.167,837.103],[810.167,962.266]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[714.755,568.205],[714.755,435.959],[810.167,566.654],[810.167,441.491]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[793.976,461.359],[793.976,371.708],[751.116,462.363],[751.116,373.868]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[793.976,560.418],[793.976,650.068],[751.116,560.145],[751.116,648.64]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[793.976,652.727],[793.976,742.377],[751.116,651.263],[751.116,739.758]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[793.976,750.49],[793.976,840.141],[751.116,747.766],[751.116,836.261]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[814.584,465.192],[814.584,379.953],[795.835,465.607],[795.835,380.846]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[814.584,559.376],[814.584,644.615],[795.835,559.263],[795.835,644.024]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[814.584,647.142],[814.584,732.381],[795.835,646.538],[795.835,731.299]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[809.216,434.356],[809.216,309.13],[894.685,439.671],[894.685,320.789]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[809.216,567.634],[809.216,442.408],[894.685,566.196],[894.685,447.315]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[809.216,572.723],[809.216,697.949],[894.685,571.027],[894.685,689.909]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[809.216,701.662],[809.216,826.888],[894.685,693.434],[894.685,812.315]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[809.216,838.22],[809.216,963.446],[894.685,823.073],[894.685,941.954]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[921.824,438.882],[921.824,319.058],[894.685,439.671],[894.685,320.789]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[921.824,566.41],[921.824,446.586],[894.685,566.196],[894.685,447.315]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[921.824,571.279],[921.824,691.103],[894.685,571.027],[894.685,689.909]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[921.824,694.655],[921.824,814.479],[894.685,693.434],[894.685,812.315]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[921.824,825.322],[921.824,945.145],[894.685,823.073],[894.685,941.954]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[921.824,438.882],[921.824,319.058],[1019.87,445.132],[1019.87,332.771]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[921.824,566.41],[921.824,446.586],[1019.87,564.718],[1019.87,452.357]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[921.824,571.279],[921.824,691.103],[1019.87,569.285],[1019.87,681.646]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[921.824,694.655],[921.824,814.479],[1019.87,684.977],[1019.87,797.339]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[921.824,825.321],[921.824,945.145],[1019.87,807.506],[1019.87,919.867]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[994.722,473.126],[994.722,397.018],[977.07,473.457],[977.07,397.731]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[994.722,557.22],[994.722,633.328],[977.07,557.13],[977.07,632.857]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[994.722,635.585],[994.722,711.692],[977.07,635.102],[977.07,710.829]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[994.57,445.803],[994.57,334.243],[1063.29,450.08],[1063.29,343.625]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[994.57,569.071],[994.57,680.631],[1063.29,567.706],[1063.29,674.161]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[994.57,683.939],[994.57,795.499],[1063.29,677.317],[1063.29,783.772]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[994.57,805.594],[994.57,917.155],[1063.29,793.405],[1063.29,899.86]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[994.57,564.537],[994.57,452.976],[1063.29,563.38],[1063.29,456.925]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1156,455.973],[1156,356.554],[1054.94,458.257],[1054.94,361.563]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1156,565.825],[1156,665.245],[1054.94,565.097],[1054.94,661.79]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1156,668.192],[1156,767.612],[1054.94,664.657],[1054.94,761.351]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1156,776.608],[1156,876.027],[1054.94,770.101],[1054.94,866.794]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1156,561.785],[1156,462.366],[1054.94,561.167],[1054.94,464.474]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1156.63,455.959],[1156.63,356.522],[1211.55,459.374],[1211.55,364.014]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1156.63,561.789],[1156.63,462.352],[1211.55,560.865],[1211.55,465.505]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1156.63,565.83],[1156.63,665.267],[1211.55,564.74],[1211.55,660.1]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1156.63,668.215],[1156.63,767.652],[1211.55,662.927],[1211.55,758.287]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1156.63,776.65],[1156.63,876.086],[1211.55,766.916],[1211.55,862.276]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1235.3,458.867],[1235.3,362.902],[1211.55,459.374],[1211.55,364.014]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1235.3,561.002],[1235.3,465.037],[1211.55,560.865],[1211.55,465.505]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1235.3,564.902],[1235.3,660.867],[1211.55,564.74],[1211.55,660.1]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1235.3,663.712],[1235.3,759.677],[1211.55,662.927],[1211.55,758.287]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1235.3,768.361],[1235.3,864.326],[1211.55,766.916],[1211.55,862.276]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1235.29,458.867],[1235.29,362.902],[1298.97,462.927],[1298.97,371.808]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1235.29,561.002],[1235.29,465.037],[1298.97,559.904],[1298.97,468.785]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1235.29,564.902],[1235.29,660.867],[1298.97,563.607],[1298.97,654.725]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1235.29,663.712],[1235.29,759.677],[1298.97,657.427],[1298.97,748.545]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1235.29,768.361],[1235.29,864.326],[1298.97,756.79],[1298.97,847.909]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1276.81,463.368],[1276.81,372.777],[1322.52,466.213],[1322.52,379.018]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1276.81,563.466],[1276.81,654.057],[1322.52,562.558],[1322.52,649.753]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1276.81,656.743],[1276.81,747.334],[1322.52,652.338],[1322.52,739.534]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1276.81,755.531],[1276.81,846.123],[1322.52,747.424],[1322.52,834.619]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1276.81,559.784],[1276.81,469.193],[1322.52,559.015],[1322.52,471.82]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1322.99,463.583],[1322.99,376.491],[1363.66,466.205],[1363.66,382.132]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1322.99,556.274],[1322.99,469.182],[1363.66,555.684],[1363.66,471.611]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1322.99,559.813],[1322.99,646.905],[1363.66,559.101],[1363.66,643.174]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1322.99,649.488],[1322.99,736.579],[1363.66,645.667],[1363.66,729.74]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1322.99,744.46],[1322.99,831.552],[1363.66,737.348],[1363.66,821.421]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1385.43,465.797],[1385.43,381.254],[1363.66,466.205],[1363.66,382.132]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1385.43,555.776],[1385.43,471.233],[1363.66,555.684],[1363.66,471.611]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1385.43,559.212],[1385.43,643.755],[1363.66,559.101],[1363.66,643.174]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1385.43,646.262],[1385.43,730.805],[1363.66,645.667],[1363.66,729.74]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1385.43,738.455],[1385.43,822.999],[1363.66,737.348],[1363.66,821.421]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1385.43,465.797],[1385.43,381.254],[1435.14,469.085],[1435.14,388.326]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1385.43,555.776],[1385.43,471.233],[1435.14,555.036],[1435.14,474.278]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1385.43,559.212],[1385.43,643.755],[1435.14,558.318],[1435.14,639.077]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1385.43,646.262],[1385.43,730.805],[1435.14,641.472],[1435.14,722.231]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1385.43,738.455],[1385.43,822.999],[1435.14,729.539],[1435.14,810.298]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1414.79,469.445],[1414.79,389.1],[1450.9,471.776],[1450.9,394.114]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1414.79,640.947],[1414.79,721.292],[1450.9,637.552],[1450.9,715.214]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1414.79,728.562],[1414.79,808.907],[1450.9,722.241],[1450.9,799.903]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1414.79,554.956],[1414.79,474.611],[1450.9,554.431],[1450.9,476.769]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:21,
                    verts:[[1414.79,558.221],[1414.79,638.565],[1450.9,557.587],[1450.9,635.249]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[223.705,415.374],[223.705,272.796],[2.2084,423.109],[2.2084,289.434]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[223.705,567.119],[223.705,424.541],[2.2084,565.379],[2.2084,431.704]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[223.705,572.913],[223.705,715.49],[2.2084,570.811],[2.2084,704.486]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[223.705,719.718],[223.705,862.295],[2.2084,708.45],[2.2084,842.125]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[223.705,875.197],[223.705,1017.77],[2.2084,854.221],[2.2084,987.896]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[128.581,429.752],[128.581,303.724],[104.842,430.505],[104.842,305.343]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[128.581,569.006],[128.581,695.035],[104.842,568.801],[104.842,693.963]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[128.581,698.771],[128.581,824.8],[104.842,697.674],[104.842,822.836]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[128.581,836.204],[128.581,962.233],[104.842,834.162],[104.842,959.324]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[560.151,403.624],[560.151,247.524],[296.209,412.842],[296.209,267.35]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[560.151,569.762],[560.151,413.661],[296.209,567.688],[296.209,422.197]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[560.151,576.105],[560.151,732.206],[296.209,573.601],[296.209,719.093]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[560.151,736.834],[560.151,892.934],[296.209,723.406],[296.209,868.898]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[560.151,907.06],[560.151,1063.16],[296.209,882.064],[296.209,1027.56]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[459.091,447.068],[459.091,340.968],[436.398,447.621],[436.398,342.158]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[459.091,564.301],[459.091,670.401],[436.398,564.151],[436.398,669.614]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[459.091,673.546],[459.091,779.646],[436.398,672.741],[436.398,778.204]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[459.091,789.247],[459.091,895.346],[436.398,787.747],[436.398,893.21]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[560.15,407.289],[560.15,251.189],[669.407,416.021],[669.407,270.248]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[560.15,573.427],[560.15,417.327],[669.407,571.166],[669.407,425.394]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[560.15,579.771],[560.15,735.871],[669.407,577.09],[669.407,722.862]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[560.15,740.499],[560.15,896.599],[669.407,727.184],[669.407,872.956]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[560.15,910.725],[560.15,1066.83],[669.407,886.147],[669.407,1031.92]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[701.644,415.026],[701.644,268.076],[669.406,416.02],[669.406,270.248]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[701.644,571.423],[701.644,424.474],[669.406,571.166],[669.406,425.394]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[701.644,577.395],[701.644,724.344],[669.406,577.09],[669.406,722.862]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[701.644,728.701],[701.644,875.651],[669.406,727.184],[669.406,872.956]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[701.644,888.948],[669.406,886.147],[701.644,1035.9],[669.406,1031.92]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[701.644,415.026],[701.644,268.077],[821.189,424.862],[821.189,289.548]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[701.644,571.423],[701.644,424.474],[821.189,568.876],[821.189,433.562]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[701.644,577.395],[701.644,724.344],[821.189,574.375],[821.189,709.689]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[701.644,728.701],[701.644,875.651],[821.189,713.701],[821.189,849.015]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[701.644,888.948],[701.644,1035.9],[821.189,861.26],[821.189,996.574]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[777.098,460.448],[777.098,369.748],[731.012,461.334],[731.012,371.653]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[777.098,560.665],[777.098,651.365],[731.012,560.425],[731.012,650.105]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[777.098,654.054],[777.098,744.754],[731.012,652.764],[731.012,742.444]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[788.392,464.391],[788.392,378.229],[768.337,464.756],[768.337,379.014]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[788.392,559.594],[788.392,645.756],[768.337,559.495],[768.337,645.236]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[788.392,648.31],[788.392,734.472],[768.337,647.778],[768.337,733.52]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[789.53,425.735],[789.53,291.455],[870.858,432.228],[870.858,305.627]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[789.53,574.107],[789.53,708.387],[870.858,572.113],[870.858,698.714]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[789.53,712.369],[789.53,846.649],[870.858,702.467],[870.858,829.068]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[789.53,858.8],[789.53,993.081],[870.858,840.524],[870.858,967.124]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[789.53,568.65],[789.53,434.369],[870.858,566.969],[870.858,440.368]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[870.034,433.147],[870.034,306.478],[942.363,438.868],[942.363,319.029]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[870.034,567.961],[870.034,441.292],[942.363,566.413],[942.363,446.574]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[870.034,573.109],[870.034,699.778],[942.363,571.283],[942.363,691.123]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[870.034,703.534],[870.034,830.203],[942.363,694.676],[942.363,814.515]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[870.034,841.665],[870.034,968.335],[942.363,825.36],[942.363,945.199]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[949.915,472.888],[949.915,396.505],[931.428,473.175],[931.428,397.123]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[949.915,557.285],[949.915,633.667],[931.428,557.207],[931.428,633.259]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[949.915,635.932],[949.915,712.314],[931.428,635.514],[931.428,711.565]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[971.643,438.179],[971.643,317.518],[942.364,438.868],[942.364,319.029]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[971.643,566.6],[971.643,445.938],[942.364,566.413],[942.364,446.574]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[971.643,571.503],[971.643,692.165],[942.364,571.283],[942.364,691.123]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[971.643,695.743],[971.643,816.404],[942.364,694.676],[942.364,814.515]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[971.643,827.323],[942.364,825.36],[971.643,947.985],[942.364,945.199]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[971.644,438.179],[971.644,317.518],[1053.41,444.845],[1053.41,332.141]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[971.644,566.6],[971.644,445.938],[1053.41,564.796],[1053.41,452.092]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[971.644,571.503],[971.644,692.165],[1053.41,569.376],[1053.41,682.081]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[971.644,695.743],[971.644,816.404],[1053.41,685.422],[1053.41,798.127]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[971.644,827.323],[971.644,947.985],[1053.41,808.325],[1053.41,921.03]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1026.47,445.426],[1026.47,333.415],[1083.8,449.965],[1083.8,343.373]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1026.47,569.191],[1026.47,681.202],[1083.8,567.742],[1083.8,674.334]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1026.47,684.523],[1026.47,796.534],[1083.8,677.495],[1083.8,784.086]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1026.47,806.67],[1026.47,918.681],[1083.8,793.732],[1083.8,900.324]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1026.47,564.639],[1026.47,452.628],[1083.8,563.411],[1083.8,456.819]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1160.33,456.173],[1160.33,356.992],[1054.43,458.135],[1054.43,361.297]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1160.33,565.762],[1160.33,664.942],[1054.43,565.136],[1054.43,661.974]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1160.33,667.883],[1160.33,767.064],[1054.43,664.845],[1054.43,761.683]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1160.33,776.039],[1160.33,875.219],[1054.43,770.446],[1054.43,867.285]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1160.33,561.731],[1160.33,462.55],[1054.43,561.2],[1054.43,464.362]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1160.98,456.161],[1160.98,356.965],[1206.24,459.741],[1206.24,364.819]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1160.98,561.734],[1160.98,462.539],[1206.24,560.766],[1206.24,465.844]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1160.98,565.766],[1160.98,664.961],[1206.24,564.623],[1206.24,659.545]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1160.98,667.902],[1160.98,767.098],[1206.24,662.359],[1206.24,757.281]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1160.98,776.075],[1160.98,875.27],[1206.24,765.87],[1206.24,860.792]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1230.83,459.309],[1230.83,363.872],[1206.24,459.741],[1206.24,364.819]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1230.83,560.883],[1230.83,465.446],[1206.24,560.766],[1206.24,465.844]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1230.83,564.761],[1230.83,660.198],[1206.24,564.623],[1206.24,659.545]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1230.83,663.028],[1230.83,758.464],[1206.24,662.359],[1206.24,757.281]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1230.83,767.101],[1206.24,765.87],[1230.83,862.538],[1206.24,860.792]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1230.83,459.309],[1230.83,363.872],[1282.7,463.537],[1282.7,373.148]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1230.83,560.883],[1230.83,465.446],[1282.7,559.739],[1282.7,469.349]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1230.83,564.761],[1230.83,660.198],[1282.7,563.412],[1282.7,653.801]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1230.83,663.028],[1230.83,758.465],[1282.7,656.481],[1282.7,746.87]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1230.83,767.101],[1230.83,862.538],[1282.7,755.05],[1282.7,845.439]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1259.94,463.912],[1259.94,373.969],[1297.26,466.867],[1297.26,380.452]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1259.94,563.292],[1259.94,653.235],[1297.26,562.35],[1297.26,648.764]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1259.94,655.902],[1259.94,745.844],[1297.26,651.327],[1297.26,737.741]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1259.94,753.983],[1259.94,843.926],[1297.26,745.561],[1297.26,831.976]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1259.94,559.637],[1259.94,469.695],[1297.26,558.838],[1297.26,472.423]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1297.5,464.261],[1297.5,377.95],[1330.59,466.976],[1330.59,383.79]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1297.5,556.122],[1297.5,469.811],[1330.59,555.511],[1330.59,472.325]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1297.5,559.629],[1297.5,645.94],[1330.59,558.891],[1330.59,642.077]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1297.5,648.499],[1297.5,734.81],[1330.59,644.544],[1330.59,727.73]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1297.5,742.62],[1297.5,828.931],[1330.59,735.257],[1330.59,818.443]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1352.71,466.633],[1352.71,383.051],[1330.59,466.976],[1330.59,383.79]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1352.71,555.588],[1352.71,472.007],[1330.59,555.511],[1330.59,472.325]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1352.71,558.985],[1352.71,642.566],[1330.59,558.891],[1330.59,642.077]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1352.71,645.044],[1352.71,728.626],[1330.59,644.544],[1330.59,727.73]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1352.71,736.189],[1330.59,735.257],[1352.71,819.771],[1330.59,818.443]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1352.71,466.632],[1352.71,383.051],[1392.76,470.018],[1392.76,390.334]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1352.71,555.588],[1352.71,472.007],[1392.76,554.826],[1392.76,475.142]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1352.71,558.985],[1352.71,642.566],[1392.76,558.065],[1392.76,637.749]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1352.71,645.044],[1352.71,728.626],[1392.76,640.112],[1392.76,719.796]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1352.71,736.189],[1352.71,819.771],[1392.76,727.007],[1392.76,806.691]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1372.2,470.32],[1372.2,390.983],[1401.37,472.716],[1401.37,396.137]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1372.2,639.672],[1372.2,719.009],[1401.37,636.182],[1401.37,712.761]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1372.2,726.188],[1372.2,805.525],[1401.37,719.691],[1401.37,796.27]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1372.2,557.983],[1372.2,637.32],[1401.37,557.332],[1401.37,633.911]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:22,
                    verts:[[1372.2,554.759],[1372.2,475.422],[1401.37,554.22],[1401.37,477.64]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[302.812,411.045],[302.812,263.486],[46.3323,417.96],[46.3323,278.36]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[302.812,568.092],[302.812,420.533],[46.3323,566.537],[46.3323,426.937]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[302.812,574.089],[302.812,721.648],[46.3323,572.21],[46.3323,711.81]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[302.812,726.023],[302.812,873.583],[46.3323,715.949],[46.3323,855.55]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[302.812,886.936],[302.812,1034.49],[46.3323,868.182],[46.3323,1007.78]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[164.586,425.494],[164.586,294.564],[137.277,426.167],[137.277,296.011]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[164.586,570.163],[164.586,701.093],[137.277,569.98],[137.277,700.136]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[164.586,704.975],[164.586,835.905],[137.277,703.995],[137.277,834.15]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[164.586,847.753],[164.586,978.683],[137.277,845.928],[137.277,976.083]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[683.695,400.776],[683.695,241.397],[385.769,408.809],[385.769,258.675]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[683.695,570.403],[683.695,411.024],[385.769,568.596],[385.769,418.462]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[683.695,576.879],[683.695,736.258],[385.769,574.697],[385.769,724.83]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[683.695,740.984],[683.695,900.363],[385.769,729.282],[385.769,879.415]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[683.695,914.785],[683.695,1074.16],[385.769,893.001],[385.769,1043.13]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[468.272,444.769],[468.272,336.023],[443.224,445.25],[443.224,337.058]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[468.272,564.926],[468.272,673.671],[443.224,564.795],[443.224,672.987]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[468.272,676.895],[468.272,785.641],[443.224,676.195],[443.224,784.386]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[468.272,795.481],[468.272,904.227],[443.224,794.177],[443.224,902.369]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[683.694,404.518],[683.694,245.139],[772.725,413.988],[772.725,265.812]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[683.694,574.145],[683.694,414.766],[772.725,571.692],[772.725,423.516]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[683.694,580.622],[683.694,740],[772.725,577.714],[772.725,725.89]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[683.694,744.726],[683.694,904.105],[772.725,730.283],[772.725,878.459]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[683.694,918.527],[683.694,1077.91],[772.725,891.868],[772.725,1040.04]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[761.155,459.512],[761.155,367.735],[712.024,460.263],[712.024,369.351]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[761.155,560.92],[761.155,652.697],[712.024,560.715],[712.024,651.628]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[761.155,655.418],[761.155,747.195],[712.024,654.323],[712.024,745.235]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[762.663,463.537],[762.663,376.393],[741.368,463.846],[741.368,377.058]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[762.663,559.826],[762.663,646.97],[741.368,559.742],[741.368,646.53]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[762.663,649.554],[762.663,736.698],[741.368,649.104],[741.368,735.892]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[808.148,413.139],[808.148,263.958],[772.725,413.988],[772.725,265.812]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[808.148,571.912],[808.148,422.731],[772.725,571.692],[772.725,423.516]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[808.148,577.974],[808.148,727.155],[772.725,577.714],[772.725,725.89]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[808.148,731.578],[808.148,880.759],[772.725,730.283],[772.725,878.459]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[808.148,894.259],[772.725,891.868],[808.148,1043.44],[772.725,1040.04]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[808.148,413.139],[808.148,263.958],[903.638,423.683],[903.638,286.974]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[808.148,571.912],[808.148,422.731],[903.638,569.182],[903.638,432.473]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[808.148,577.974],[808.148,727.155],[903.638,574.737],[903.638,711.446]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[808.148,731.578],[808.148,880.759],[903.638,715.499],[903.638,852.207]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[808.148,894.258],[808.148,1043.44],[903.638,864.578],[903.638,1001.29]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[869.408,424.421],[869.408,288.587],[934.555,431.342],[934.555,303.695]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[869.408,574.51],[869.408,710.345],[934.555,572.385],[934.555,700.033]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[869.408,714.373],[869.408,850.207],[934.555,703.818],[934.555,831.466]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[869.408,862.499],[869.408,998.334],[934.555,843.017],[934.555,970.664]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[904.239,472.563],[904.239,395.807],[884.964,472.803],[884.964,396.323]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[904.239,557.373],[904.239,634.129],[884.964,557.308],[884.964,633.788]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[869.408,568.99],[869.408,433.155],[934.555,567.198],[934.555,439.55]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[904.239,636.405],[904.239,713.161],[884.964,636.056],[884.964,712.535]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[933.878,432.266],[933.878,304.544],[991.466,438.327],[991.466,317.842]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[933.878,568.2],[933.878,440.478],[991.466,566.56],[991.466,446.074]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[933.878,573.39],[933.878,701.112],[991.466,571.456],[991.466,691.941]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[933.878,704.898],[933.878,832.62],[991.466,695.513],[991.466,815.999]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[933.878,844.177],[933.878,971.899],[991.466,826.901],[991.466,947.386]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1022.5,437.752],[1022.5,316.58],[991.467,438.327],[991.467,317.842]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1022.5,566.715],[1022.5,445.543],[991.467,566.56],[991.467,446.074]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1022.5,571.639],[1022.5,692.812],[991.467,571.456],[991.467,691.941]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1022.5,696.404],[1022.5,817.576],[991.467,695.513],[991.467,815.998]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1022.5,828.541],[991.467,826.901],[1022.5,949.713],[991.467,947.386]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1022.5,437.752],[1022.5,316.58],[1086.51,444.755],[1086.51,331.942]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1022.5,566.715],[1022.5,445.543],[1086.51,564.821],[1086.51,452.008]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1022.5,571.64],[1022.5,692.812],[1086.51,569.405],[1086.51,682.217]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1022.5,696.404],[1022.5,817.576],[1086.51,685.562],[1086.51,798.374]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1022.5,828.541],[1022.5,949.713],[1086.51,808.583],[1086.51,921.395]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1162.85,456.448],[1162.85,357.595],[1053.06,458.067],[1053.06,361.146]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1162.85,565.674],[1162.85,664.527],[1053.06,565.157],[1053.06,662.078]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1162.85,667.458],[1162.85,766.311],[1053.06,664.951],[1053.06,761.872]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1162.85,775.256],[1162.85,874.109],[1053.06,770.642],[1053.06,867.562]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1058.26,445.237],[1058.26,333],[1103.35,449.989],[1103.35,343.426]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1058.26,569.251],[1058.26,681.488],[1103.35,567.735],[1103.35,674.298]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1058.26,684.816],[1058.26,797.053],[1103.35,677.458],[1103.35,784.021]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1058.26,807.209],[1058.26,919.446],[1103.35,793.664],[1103.35,900.227]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1058.26,564.69],[1058.26,452.453],[1103.35,563.404],[1103.35,456.841]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1162.85,561.657],[1162.85,462.804],[1053.06,561.219],[1053.06,464.299]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1163.52,456.437],[1163.52,357.572],[1198.77,460.148],[1198.77,365.711]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1163.52,561.66],[1163.52,462.794],[1198.77,560.656],[1198.77,466.22]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1163.52,565.677],[1163.52,664.543],[1198.77,564.493],[1198.77,658.93]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1163.52,667.474],[1163.52,766.34],[1198.77,661.73],[1198.77,756.166]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1163.52,775.286],[1163.52,874.152],[1198.77,764.711],[1198.77,859.147]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1223.99,459.794],[1223.99,364.937],[1198.77,460.148],[1198.77,365.711]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1223.99,560.751],[1223.99,465.894],[1198.77,560.656],[1198.77,466.22]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1223.99,564.606],[1223.99,659.464],[1198.77,564.493],[1198.77,658.93]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1223.99,662.276],[1223.99,757.134],[1198.77,661.729],[1198.77,756.166]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1223.99,765.717],[1198.77,764.711],[1223.99,860.575],[1198.77,859.147]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1223.99,459.794],[1223.99,364.937],[1263.81,464.151],[1263.81,374.495]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1223.99,560.751],[1223.99,465.894],[1263.81,559.573],[1263.81,469.916]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1223.99,564.606],[1223.99,659.464],[1263.81,563.216],[1263.81,652.873]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1223.99,662.276],[1223.99,757.134],[1263.81,655.531],[1263.81,745.187]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1223.99,765.718],[1223.99,860.575],[1263.81,753.3],[1263.81,842.957]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1240.62,464.456],[1240.62,375.163],[1269.46,467.495],[1269.46,381.831]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1240.62,563.119],[1240.62,652.411],[1269.46,562.149],[1269.46,647.813]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1240.62,655.059],[1240.62,744.352],[1269.46,650.353],[1269.46,736.017]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1240.62,752.432],[1240.62,841.724],[1269.46,743.769],[1269.46,829.433]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1240.62,559.49],[1240.62,470.197],[1269.46,558.668],[1269.46,473.003]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1269.47,464.913],[1269.47,379.353],[1294.97,467.698],[1294.97,385.343]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1269.47,555.975],[1269.47,470.415],[1294.97,555.348],[1294.97,472.993]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1269.47,559.452],[1269.47,645.012],[1294.97,558.695],[1294.97,641.05]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1269.47,647.549],[1269.47,733.109],[1294.97,643.492],[1294.97,725.847]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1269.47,740.852],[1269.47,826.412],[1294.97,733.299],[1294.97,815.654]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1317.33,467.42],[1317.33,384.744],[1294.97,467.698],[1294.97,385.343]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1317.33,555.411],[1317.33,472.736],[1294.97,555.348],[1294.97,472.993]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1317.33,558.771],[1317.33,641.446],[1294.97,558.695],[1294.97,641.05]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1317.33,643.897],[1317.33,726.573],[1294.97,643.492],[1294.97,725.847]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1317.33,734.054],[1294.97,733.299],[1317.33,816.729],[1294.97,815.654]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1317.33,467.42],[1317.33,384.744],[1347.79,470.877],[1347.79,392.18]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1317.33,555.411],[1317.33,472.736],[1347.79,554.633],[1347.79,475.937]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1317.33,558.771],[1317.33,641.446],[1347.79,557.831],[1347.79,636.528]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1317.33,643.897],[1317.33,726.573],[1347.79,638.861],[1347.79,717.558]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1317.33,734.054],[1317.33,816.729],[1347.79,724.679],[1347.79,803.375]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1327.12,471.121],[1327.12,392.705],[1349.47,473.564],[1349.47,397.96]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1327.12,638.506],[1327.12,716.922],[1349.47,634.947],[1349.47,710.55]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1327.12,724.018],[1327.12,802.434],[1349.47,717.392],[1349.47,792.995]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1327.12,557.765],[1327.12,636.181],[1349.47,557.101],[1349.47,632.705]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:23,
                    verts:[[1327.12,554.579],[1327.12,476.163],[1349.47,554.029],[1349.47,478.425]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[397.663,407.131],[397.663,255.066],[107.574,412.923],[107.574,267.524]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[397.663,568.973],[397.663,416.908],[107.574,567.67],[107.574,422.272]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[397.663,575.153],[397.663,727.218],[107.574,573.579],[107.574,718.977]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[397.663,731.726],[397.663,883.791],[107.574,723.288],[107.574,868.687]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[397.663,897.552],[397.663,1049.62],[107.574,881.844],[107.574,1027.24]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[214.117,421.341],[214.117,285.632],[183.302,421.906],[183.302,286.847]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[214.117,571.291],[214.117,707],[183.302,571.138],[183.302,706.197]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[214.117,711.024],[214.117,846.733],[183.302,710.201],[183.302,845.26]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[214.117,859.013],[183.302,857.482],[214.117,994.722],[183.302,992.541]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[483.253,442.52],[483.253,331.187],[455.965,442.914],[455.965,332.034]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[483.253,561.012],[483.253,449.679],[455.965,560.924],[455.965,450.044]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[483.253,565.536],[483.253,676.87],[455.965,565.43],[455.965,676.309]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[483.253,680.171],[483.253,791.504],[455.965,679.597],[455.965,790.477]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[483.253,801.578],[483.253,912.911],[455.965,800.51],[455.965,911.39]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[817.324,398.751],[817.324,237.043],[490.183,405.283],[490.183,251.092]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[817.324,570.858],[817.324,409.149],[490.183,569.389],[490.183,415.198]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[817.324,577.429],[817.324,739.138],[490.183,575.655],[490.183,729.846]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[817.324,743.933],[817.324,905.641],[490.183,734.417],[490.183,888.608]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[817.324,920.275],[817.324,1081.98],[490.183,902.561],[490.183,1056.75]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[746.421,458.57],[746.421,365.709],[694.486,459.172],[694.486,367.003]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[746.421,561.175],[746.421,654.036],[694.486,561.012],[694.486,653.18]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[746.421,656.79],[746.421,749.65],[694.486,655.913],[694.486,748.082]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[817.324,402.548],[817.324,240.839],[882.726,412.605],[882.726,262.793]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[817.324,574.655],[817.324,412.946],[882.726,572.05],[882.726,422.238]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[817.324,581.226],[817.324,742.935],[882.726,578.138],[882.726,727.951]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[817.324,747.73],[817.324,909.439],[882.726,732.393],[882.726,882.205]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[817.324,924.072],[817.324,1085.78],[882.726,895.761],[882.726,1045.57]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[857.972,472.157],[857.972,394.933],[837.962,472.346],[837.962,395.341]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[857.972,557.484],[857.972,634.707],[837.962,557.432],[837.962,634.437]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[857.972,721.208],[857.972,798.432],[837.962,720.694],[837.962,797.699]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[920.66,411.929],[920.66,261.316],[882.725,412.605],[882.725,262.793]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[920.66,572.225],[920.66,421.613],[882.725,572.05],[882.725,422.238]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[920.66,578.346],[920.66,728.959],[882.725,578.138],[882.725,727.951]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[920.66,733.424],[882.725,732.393],[920.66,884.037],[882.725,882.205]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[920.66,897.666],[882.725,895.762],[920.66,1048.28],[882.725,1045.57]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[920.66,411.929],[920.66,261.316],[989.052,423.012],[989.052,285.51]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[920.66,572.225],[920.66,421.613],[989.052,569.355],[989.052,431.853]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[920.66,578.346],[920.66,728.959],[989.052,574.943],[989.052,712.445]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[920.66,733.424],[920.66,884.037],[989.052,716.522],[989.052,854.023]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[920.66,897.666],[920.66,1048.28],[989.052,866.466],[989.052,1003.97]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[952.842,423.596],[952.842,286.785],[1000.07,430.845],[1000.07,302.609]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[952.842,574.764],[952.842,711.575],[1000.07,572.538],[1000.07,700.774]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[952.842,715.631],[952.842,852.442],[1000.07,704.576],[1000.07,832.812]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[952.842,864.823],[952.842,1001.63],[1000.07,844.416],[1000.07,972.652]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[952.842,569.204],[952.842,432.393],[1000.07,567.327],[1000.07,439.091]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[999.556,431.77],[999.556,303.457],[1041.11,438.089],[1041.11,317.319]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[999.556,568.334],[999.556,440.021],[1041.11,566.624],[1041.11,445.854]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[999.556,573.548],[999.556,701.862],[1041.11,571.532],[1041.11,692.302]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[999.556,705.666],[999.556,833.979],[1041.11,695.883],[1041.11,816.653]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[999.556,845.59],[999.556,973.904],[1041.11,827.581],[1041.11,948.351]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1073.45,437.638],[1073.45,316.331],[1041.11,438.089],[1041.11,317.319]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1073.45,566.746],[1073.45,445.438],[1041.11,566.624],[1041.11,445.854]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1073.45,571.676],[1073.45,692.983],[1041.11,571.532],[1041.11,692.302]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1073.45,696.58],[1041.11,695.883],[1073.45,817.888],[1041.11,816.652]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1073.45,828.865],[1041.11,827.581],[1073.45,950.173],[1041.11,948.351]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1163.45,456.807],[1163.45,358.382],[1050.8,458.065],[1050.8,361.142]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1163.45,565.56],[1163.45,663.984],[1050.8,565.158],[1050.8,662.081]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1163.45,666.902],[1163.45,765.327],[1050.8,664.955],[1050.8,761.877]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1163.45,774.233],[1163.45,872.658],[1050.8,770.648],[1050.8,867.571]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1073.45,437.638],[1073.45,316.331],[1118.58,444.886],[1118.58,332.23]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1073.45,566.746],[1073.45,445.438],[1118.58,564.785],[1118.58,452.129]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1073.45,571.676],[1073.45,692.984],[1118.58,569.363],[1118.58,682.019]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1073.45,696.58],[1073.45,817.888],[1118.58,685.359],[1118.58,798.016]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1073.45,828.865],[1073.45,950.173],[1118.58,808.21],[1118.58,920.866]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1089.38,445.261],[1089.38,333.053],[1121.6,450.17],[1121.6,343.822]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1089.38,569.244],[1089.38,681.451],[1121.6,567.677],[1121.6,674.025]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1089.38,684.778],[1089.38,796.986],[1121.6,677.178],[1121.6,783.526]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1089.38,807.14],[1089.38,919.347],[1121.6,793.15],[1121.6,899.497]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1089.38,564.684],[1089.38,452.476],[1121.6,563.355],[1121.6,457.008]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1163.45,561.56],[1163.45,463.135],[1050.8,561.219],[1050.8,464.297]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1164.13,456.798],[1164.13,358.364],[1189.14,460.601],[1189.14,366.705]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1164.13,561.562],[1164.13,463.128],[1189.14,560.533],[1189.14,466.638]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1164.13,565.562],[1164.13,663.996],[1189.14,564.349],[1189.14,658.244]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1164.13,666.915],[1164.13,765.349],[1189.14,661.028],[1189.14,754.923]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1164.13,774.257],[1164.13,872.691],[1189.14,763.42],[1189.14,857.315]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1214.77,460.329],[1214.77,366.109],[1189.14,460.601],[1189.14,366.705]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1214.77,560.607],[1214.77,466.387],[1189.14,560.533],[1189.14,466.638]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1214.77,564.436],[1214.77,658.656],[1189.14,564.349],[1189.14,658.244]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1214.77,661.449],[1189.14,661.028],[1214.77,755.669],[1189.14,754.923]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1214.77,764.195],[1189.14,763.42],[1214.77,858.415],[1189.14,857.315]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1214.77,460.329],[1214.77,366.108],[1242.44,464.771],[1242.44,375.855]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1214.77,560.607],[1214.77,466.387],[1242.44,559.405],[1242.44,470.488]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1214.77,564.436],[1214.77,658.656],[1242.44,563.018],[1242.44,651.935]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1214.77,661.449],[1214.77,755.669],[1242.44,654.571],[1242.44,743.487]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1214.77,764.195],[1214.77,858.416],[1242.44,751.533],[1242.44,840.449]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1218.98,465.005],[1218.98,376.369],[1239.31,468.102],[1239.31,383.163]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1218.98,562.943],[1218.98,651.58],[1239.31,561.955],[1239.31,646.895]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1218.98,654.208],[1218.98,742.845],[1239.31,649.413],[1239.31,734.353]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1218.98,750.866],[1218.98,839.503],[1239.31,742.039],[1239.31,826.979]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1239.09,465.542],[1239.09,380.705],[1257.04,468.373],[1257.04,386.796]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1239.09,559.281],[1239.09,644.118],[1257.04,558.512],[1257.04,640.089]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1239.09,646.633],[1239.09,731.47],[1257.04,642.508],[1257.04,724.086]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1239.09,739.147],[1239.09,823.983],[1257.04,731.468],[1257.04,813.046]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1239.09,555.833],[1239.09,470.997],[1257.04,555.196],[1257.04,473.619]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.5,468.16],[1279.5,386.338],[1257.04,468.373],[1257.04,386.796]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.5,555.244],[1279.5,473.422],[1257.04,555.196],[1257.04,473.619]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.5,558.57],[1279.5,640.392],[1257.04,558.512],[1257.04,640.089]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.5,642.818],[1257.04,642.508],[1279.5,724.641],[1257.04,724.086]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.5,732.045],[1257.04,731.468],[1279.5,813.868],[1257.04,813.046]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.5,468.16],[1279.5,386.338],[1300.52,471.662],[1300.52,393.869]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.5,555.244],[1279.5,473.422],[1300.52,554.457],[1300.52,476.664]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.5,558.57],[1279.5,640.392],[1300.52,557.618],[1300.52,635.411]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.5,642.818],[1279.5,724.641],[1300.52,637.718],[1300.52,715.511]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.5,732.045],[1279.5,813.868],[1300.52,722.551],[1300.52,800.344]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.83,471.848],[1279.83,394.268],[1295.48,474.321],[1295.48,399.589]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.83,557.568],[1279.83,635.147],[1295.48,556.896],[1295.48,631.628]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.83,637.447],[1279.83,715.026],[1295.48,633.843],[1295.48,708.576]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:24,
                    verts:[[1279.83,722.046],[1279.83,799.625],[1295.48,715.338],[1295.48,790.07]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[507.388,403.828],[507.388,247.962],[187.038,408.185],[187.038,257.334]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[507.388,569.716],[507.388,413.85],[187.038,568.736],[187.038,417.885]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[507.388,576.05],[507.388,731.916],[187.038,574.866],[187.038,725.717]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[507.388,736.538],[507.388,892.403],[187.038,730.19],[187.038,881.041]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[507.388,906.508],[507.388,1062.37],[187.038,894.691],[187.038,1045.54]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[277.952,417.44],[277.952,277.241],[243.86,417.867],[243.86,278.16]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[277.952,572.351],[277.952,712.55],[243.86,572.235],[243.86,711.943]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[277.952,716.707],[277.952,856.906],[243.86,716.085],[243.86,855.793]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[277.952,869.593],[243.86,868.435],[277.952,1009.79],[243.86,1008.14]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[504.424,440.383],[504.424,326.59],[475.092,440.674],[475.092,327.217]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[504.424,566.117],[504.424,679.91],[475.092,566.038],[475.092,679.496]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[504.424,683.284],[504.424,797.077],[475.092,682.86],[475.092,796.318]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[504.424,807.375],[475.092,806.584],[504.424,921.168],[475.092,920.042]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[957.397,397.707],[957.397,234.796],[607.943,402.46],[607.943,245.02]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[957.397,571.093],[957.397,408.182],[607.943,570.024],[607.943,412.583]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[957.397,577.713],[957.397,740.624],[607.943,576.422],[607.943,733.862]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[957.397,745.454],[957.397,908.365],[607.943,738.53],[607.943,895.97]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[957.397,923.107],[957.397,1086.02],[607.943,910.217],[607.943,1067.66]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[733.188,457.643],[733.188,363.716],[678.752,458.08],[678.752,364.654]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[733.188,561.427],[733.188,655.355],[678.752,561.309],[678.752,654.734]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[733.188,658.14],[733.188,752.067],[678.752,657.504],[678.752,750.929]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[811.458,471.675],[811.458,393.896],[790.772,471.811],[790.772,394.189]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[811.458,557.615],[811.458,635.393],[790.772,557.578],[790.772,635.199]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[811.458,722.515],[790.772,722.146],[811.458,800.294],[790.772,799.767]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[957.397,401.532],[957.397,238.621],[996.612,411.975],[996.612,261.418]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[957.397,574.918],[957.397,412.007],[996.612,572.213],[996.612,421.656]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[957.397,581.538],[957.397,744.449],[996.612,578.332],[996.612,728.889]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[957.397,749.279],[957.397,912.19],[996.612,733.353],[996.612,883.91]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[957.397,926.932],[957.397,1089.84],[996.612,897.534],[996.612,1048.09]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1036.22,411.493],[996.612,411.975],[1036.22,260.365],[996.612,261.418]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1036.22,572.338],[1036.22,421.21],[996.612,572.213],[996.612,421.656]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1036.22,578.48],[1036.22,729.608],[996.612,578.332],[996.612,728.889]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1036.22,734.089],[996.612,733.353],[1036.22,885.217],[996.612,883.91]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1036.22,898.893],[996.612,897.534],[1036.22,1050.02],[996.612,1048.09]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1036.22,411.493],[1036.22,260.365],[1075.38,422.91],[1075.38,285.287]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1036.22,572.338],[1036.22,421.21],[1075.38,569.382],[1075.38,431.759]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1036.22,578.48],[1036.22,729.608],[1075.38,574.974],[1075.38,712.598]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1036.22,734.089],[1036.22,885.217],[1075.38,716.678],[1075.38,854.301]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1036.22,898.893],[1036.22,1050.02],[1075.38,866.755],[1075.38,1004.38]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1037.9,423.324],[1037.9,286.191],[1065.99,430.781],[1065.99,302.47]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1037.9,574.847],[1037.9,711.98],[1065.99,572.558],[1065.99,700.869]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1037.9,716.046],[1037.9,853.179],[1065.99,704.674],[1065.99,832.985]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1037.9,865.588],[1037.9,1002.72],[1065.99,844.596],[1065.99,972.908]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1162.07,565.416],[1162.07,663.304],[1047.64,565.134],[1047.64,661.967]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1065.64,431.705],[1065.64,303.313],[1090.28,438.183],[1090.28,317.526]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1065.64,573.569],[1065.64,701.961],[1090.28,571.502],[1090.28,692.159]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1065.64,705.768],[1065.64,834.159],[1090.28,695.736],[1090.28,816.393]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1065.64,845.777],[1065.64,974.169],[1090.28,827.312],[1090.28,947.969]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1162.07,457.256],[1162.07,359.368],[1047.64,458.14],[1047.64,361.308]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1065.64,568.352],[1065.64,439.96],[1090.28,566.599],[1090.28,445.942]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1162.07,666.207],[1162.07,764.095],[1047.64,664.838],[1047.64,761.67]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1162.07,772.953],[1162.07,870.841],[1047.64,770.432],[1047.64,867.265]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1123.41,437.866],[1090.28,438.184],[1123.41,316.829],[1090.28,317.526]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1123.41,566.685],[1123.41,445.648],[1090.28,566.599],[1090.28,445.942]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1123.41,571.603],[1123.41,692.64],[1090.28,571.502],[1090.28,692.159]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1123.41,696.228],[1090.28,695.736],[1123.41,817.265],[1090.28,816.393]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1123.41,828.217],[1090.28,827.312],[1123.41,949.254],[1090.28,947.969]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1119.24,445.517],[1119.24,333.615],[1138.2,450.518],[1138.2,344.587]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1119.24,569.162],[1119.24,681.064],[1138.2,567.566],[1138.2,673.498]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1119.24,684.382],[1119.24,796.284],[1138.2,676.638],[1138.2,782.57]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1119.24,806.41],[1119.24,918.312],[1138.2,792.156],[1138.2,898.087]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1123.41,437.866],[1123.41,316.829],[1148.99,445.253],[1148.99,333.036]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1123.41,566.685],[1123.41,445.648],[1148.99,564.686],[1148.99,452.469]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1123.41,571.603],[1123.41,692.64],[1148.99,569.246],[1148.99,681.463]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1123.41,696.228],[1123.41,817.265],[1148.99,684.79],[1148.99,797.007]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1123.41,828.217],[1123.41,949.253],[1148.99,807.162],[1148.99,919.379]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1162.07,561.438],[1162.07,463.55],[1047.64,561.199],[1047.64,464.366]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1162.77,457.25],[1162.77,359.355],[1177.42,461.104],[1177.42,367.809]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1162.77,561.44],[1162.77,463.545],[1177.42,560.397],[1177.42,467.102]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1162.77,565.418],[1162.77,663.313],[1177.42,564.188],[1177.42,657.483]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1162.77,666.216],[1162.77,764.111],[1177.42,660.249],[1177.42,753.544]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1162.77,772.969],[1162.77,870.865],[1177.42,761.986],[1177.42,855.281]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1203.23,460.914],[1177.42,461.104],[1203.23,367.393],[1177.42,367.809]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1203.23,560.448],[1203.23,466.927],[1177.42,560.397],[1177.42,467.102]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1203.23,564.249],[1203.23,657.77],[1177.42,564.188],[1177.42,657.483]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1203.23,660.543],[1177.42,660.249],[1203.23,754.064],[1177.42,753.544]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1203.23,762.527],[1177.42,761.986],[1203.23,856.048],[1177.42,855.281]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1195.22,465.562],[1195.22,377.589],[1207.07,468.688],[1207.07,384.448]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1195.22,562.766],[1195.22,650.739],[1207.07,561.768],[1207.07,646.008]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1195.22,653.347],[1195.22,741.32],[1207.07,648.506],[1207.07,732.746]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1195.22,749.28],[1195.22,837.253],[1207.07,740.369],[1207.07,824.609]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1203.23,460.914],[1203.23,367.393],[1218.76,465.399],[1218.76,377.231]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1203.23,560.448],[1203.23,466.927],[1218.76,559.235],[1218.76,471.068]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1203.23,564.249],[1203.23,657.77],[1218.76,562.818],[1218.76,650.985]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1203.23,660.543],[1203.23,754.064],[1218.76,653.599],[1218.76,741.767]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1203.23,762.527],[1203.23,856.048],[1218.76,749.745],[1218.76,837.912]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1206.63,466.148],[1206.63,382.01],[1217.09,469.003],[1217.09,388.15]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1206.63,559.116],[1206.63,643.255],[1217.09,558.341],[1217.09,639.194]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1206.63,645.75],[1206.63,729.888],[1217.09,641.591],[1217.09,722.444]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1206.63,737.502],[1206.63,821.641],[1217.09,729.761],[1217.09,810.614]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1239.54,468.855],[1217.09,469.003],[1239.54,387.832],[1217.09,388.15]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1239.54,558.381],[1239.54,639.404],[1217.09,558.341],[1217.09,639.194]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1239.54,641.806],[1217.09,641.591],[1239.54,722.83],[1217.09,722.444]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1239.54,730.162],[1217.09,729.761],[1239.54,811.185],[1217.09,810.614]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1239.54,555.088],[1239.54,474.065],[1217.09,555.055],[1217.09,474.202]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1230.66,472.503],[1230.66,395.677],[1239.75,474.989],[1239.75,401.026]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1230.66,557.39],[1230.66,634.215],[1239.75,556.714],[1239.75,630.677]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1230.66,636.493],[1230.66,713.318],[1239.75,632.87],[1239.75,706.834]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1230.66,720.27],[1230.66,797.096],[1239.75,713.527],[1239.75,787.49]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1239.54,468.855],[1239.54,387.832],[1251.29,472.374],[1251.29,395.4]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1239.54,555.088],[1239.54,474.065],[1251.29,554.297],[1251.29,477.323]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1239.54,558.381],[1239.54,639.404],[1251.29,557.425],[1251.29,634.398]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1239.54,641.806],[1239.54,722.83],[1251.29,636.681],[1251.29,713.654]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:25,
                    verts:[[1239.54,730.162],[1239.54,811.185],[1251.29,720.62],[1251.29,797.593]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[629.931,401.328],[629.931,242.585],[284.86,403.962],[284.86,248.25]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[629.931,570.278],[629.931,411.535],[284.86,569.686],[284.86,413.974]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[629.931,576.729],[629.931,735.473],[284.86,576.014],[284.86,731.725]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[629.931,740.179],[629.931,898.923],[284.86,736.342],[284.86,892.054]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[629.931,913.287],[629.931,1072.03],[284.86,906.144],[284.86,1061.86]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[356.172,413.951],[356.172,269.735],[319.227,414.211],[319.227,270.295]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[356.172,573.3],[356.172,717.515],[319.227,573.229],[319.227,717.145]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[356.172,721.791],[319.227,721.412],[356.172,866.007],[319.227,865.328]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[356.172,879.057],[319.227,878.351],[356.172,1023.27],[319.227,1022.27]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[531.978,438.42],[531.978,322.368],[500.884,438.595],[500.884,322.743]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[531.978,566.651],[531.978,682.703],[500.884,566.603],[500.884,682.455]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[531.978,686.144],[500.884,685.889],[531.978,802.196],[500.884,801.741]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[531.978,812.698],[500.884,812.224],[531.978,928.75],[500.884,928.076]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[721.743,456.753],[721.743,361.8],[665.178,457.01],[665.178,362.353]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[721.743,557.811],[721.743,462.858],[665.178,557.753],[665.178,463.096]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[721.743,561.669],[721.743,656.622],[665.178,561.6],[665.178,656.256]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[721.743,659.437],[721.743,754.39],[665.178,659.063],[665.178,753.72]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[721.743,762.982],[721.743,857.935],[665.178,762.286],[665.178,856.942]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[691.609,460.813],[691.609,370.535],[667.195,460.919],[667.195,370.762]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[691.609,560.566],[691.609,650.845],[667.195,560.537],[667.195,650.694]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[691.609,653.521],[667.195,653.368],[691.609,743.8],[667.195,743.525]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[691.609,751.97],[667.195,751.683],[691.609,842.249],[667.195,841.841]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1099.41,397.744],[1099.41,234.876],[736.355,400.516],[736.355,240.837]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1099.41,571.085],[1099.41,408.216],[736.355,570.461],[736.355,410.783]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1099.41,577.703],[1099.41,740.571],[736.355,576.95],[736.355,736.628]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1099.41,745.4],[1099.41,908.268],[736.355,741.363],[736.355,901.041]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1099.41,923.006],[1099.41,1085.87],[736.355,915.49],[736.355,1075.17]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[765.097,471.123],[765.097,392.709],[743.802,471.202],[743.802,392.88]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[765.097,557.765],[765.097,636.178],[743.802,557.743],[743.802,636.065]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[765.097,724.013],[743.802,723.797],[765.097,802.426],[743.802,802.118]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1158.7,457.797],[1158.7,360.556],[1043.61,458.302],[1043.61,361.662]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1158.7,565.243],[1158.7,662.485],[1043.61,565.083],[1043.61,661.722]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1158.7,665.368],[1158.7,762.61],[1043.61,664.588],[1043.61,761.228]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1099.41,401.568],[1099.41,238.7],[1111.06,412.165],[1111.06,261.831]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1099.41,574.909],[1099.41,412.04],[1111.06,572.164],[1111.06,421.831]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1099.41,581.527],[1099.41,744.395],[1111.06,578.274],[1111.06,728.607]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1099.41,749.224],[1099.41,912.092],[1111.06,733.064],[1111.06,883.398]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1099.41,926.83],[1099.41,1089.7],[1111.06,897.001],[1111.06,1047.33]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1151.38,411.888],[1111.06,412.165],[1151.38,261.228],[1111.06,261.831]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1151.38,572.236],[1111.06,572.164],[1151.38,421.576],[1111.06,421.831]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1151.38,578.358],[1111.06,578.274],[1151.38,729.019],[1111.06,728.607]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1151.38,733.486],[1111.06,733.064],[1151.38,884.146],[1111.06,883.398]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1151.38,897.779],[1111.06,897.002],[1151.38,1048.44],[1111.06,1047.33]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1122.38,423.644],[1122.38,286.89],[1130.74,431.175],[1130.74,303.33]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1122.38,574.749],[1122.38,711.503],[1130.74,572.436],[1130.74,700.282]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1122.38,715.558],[1122.38,852.312],[1130.74,704.072],[1130.74,831.918]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1122.38,864.687],[1122.38,1001.44],[1130.74,843.487],[1130.74,971.332]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1130.58,432.094],[1130.58,304.168],[1137.91,438.627],[1137.91,318.499]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1130.58,573.445],[1130.58,701.371],[1137.91,571.36],[1137.91,691.488]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1130.58,705.164],[1130.58,833.091],[1137.91,695.05],[1137.91,815.177]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1130.58,844.667],[1130.58,972.593],[1137.91,826.048],[1137.91,946.175]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1171.3,438.446],[1137.91,438.627],[1171.3,318.103],[1137.91,318.499]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1171.3,571.418],[1137.91,571.36],[1171.3,691.762],[1137.91,691.488]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1171.3,695.33],[1137.91,695.05],[1171.3,815.673],[1137.91,815.177]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1171.3,826.563],[1137.91,826.048],[1171.3,946.907],[1137.91,946.175]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1151.38,411.888],[1151.38,261.228],[1160.36,423.408],[1160.36,286.373]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1151.38,572.236],[1151.38,421.576],[1160.36,569.253],[1160.36,432.219]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1151.38,578.358],[1151.38,729.019],[1160.36,574.822],[1160.36,711.856]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1151.38,733.486],[1151.38,884.146],[1160.36,715.919],[1160.36,852.953]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1151.38,897.779],[1151.38,1048.44],[1160.36,865.353],[1160.36,1002.39]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1159.4,565.245],[1159.4,662.49],[1163.74,564.012],[1163.74,656.646]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1159.4,457.794],[1159.4,360.548],[1163.74,461.657],[1163.74,369.024]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1171.3,566.528],[1137.91,566.479],[1171.3,446.184],[1137.91,446.351]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1159.4,665.374],[1159.4,762.62],[1163.74,659.392],[1163.74,752.026]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1159.4,771.419],[1159.4,868.665],[1163.74,760.408],[1163.74,853.042]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1189.51,461.55],[1163.74,461.657],[1189.51,368.788],[1163.74,369.024]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1189.51,564.046],[1163.74,564.012],[1189.51,656.808],[1163.74,656.645]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1189.51,659.558],[1163.74,659.392],[1189.51,752.321],[1163.74,752.026]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1189.51,760.715],[1163.74,760.408],[1189.51,853.477],[1163.74,853.042]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1171.3,438.446],[1171.3,318.103],[1177.14,445.864],[1177.14,334.375]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1171.3,566.528],[1171.3,446.184],[1177.14,564.521],[1177.14,453.032]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1171.3,571.418],[1171.3,691.762],[1177.14,569.051],[1177.14,680.54]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1171.3,695.33],[1171.3,815.673],[1177.14,683.845],[1177.14,795.334]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1171.3,826.563],[1171.3,946.907],[1177.14,805.422],[1177.14,916.911]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1197.81,469.503],[1175.49,469.587],[1197.81,389.225],[1175.49,389.405]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1189.51,560.276],[1163.74,560.247],[1189.51,467.514],[1163.74,467.614]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1197.81,558.205],[1175.49,558.182],[1197.81,638.482],[1175.49,638.364]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1197.81,640.863],[1175.49,640.741],[1197.81,721.14],[1175.49,720.922]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1197.81,728.405],[1175.49,728.178],[1197.81,808.682],[1175.49,808.36]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1189.51,461.55],[1189.51,368.788],[1193.04,466.032],[1193.04,378.622]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1189.51,560.276],[1189.51,467.514],[1193.04,559.063],[1193.04,471.653]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1189.51,564.046],[1189.51,656.808],[1193.04,562.616],[1193.04,650.026]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1189.51,659.559],[1189.51,752.321],[1193.04,652.618],[1193.04,740.029]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1189.51,760.715],[1189.51,853.477],[1193.04,747.938],[1193.04,835.349]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1197.81,554.942],[1175.49,554.924],[1197.81,474.665],[1175.49,474.742]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1197.81,469.503],[1197.81,389.225],[1200.47,473.013],[1200.47,396.774]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1197.81,554.942],[1197.81,474.665],[1200.47,554.153],[1200.47,477.915]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1197.81,558.205],[1197.81,638.482],[1200.47,557.251],[1200.47,633.489]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1197.81,640.863],[1197.81,721.14],[1200.47,635.75],[1200.47,711.988]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:26,
                    verts:[[1197.81,728.405],[1197.81,808.682],[1200.47,718.887],[1200.47,795.125]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[762.046,399.79],[762.046,239.277],[399.915,400.471],[399.915,240.742]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[762.046,570.624],[762.046,410.111],[399.915,570.471],[399.915,410.742]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[762.046,577.147],[762.046,737.661],[399.915,576.962],[399.915,736.692]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[762.046,742.42],[762.046,902.933],[399.915,741.427],[399.915,901.157]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[762.046,917.458],[762.046,1077.97],[399.915,915.611],[399.915,1075.34]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[447.975,411.034],[408.81,411.102],[447.975,263.461],[408.81,263.607]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[447.975,574.092],[447.975,721.665],[408.81,574.074],[408.81,721.568]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[447.975,726.04],[408.81,725.941],[447.975,873.613],[408.81,873.436]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[447.975,886.967],[408.81,886.783],[447.975,1034.54],[408.81,1034.28]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[565.857,436.696],[533.37,436.741],[565.857,318.658],[533.37,318.755]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[565.857,567.119],[565.857,685.156],[533.37,567.107],[533.37,685.092]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[565.857,688.656],[533.37,688.591],[565.857,806.693],[533.37,806.576]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[565.857,817.375],[533.37,817.252],[565.857,935.412],[533.37,935.238]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[671.216,459.906],[646.042,459.933],[671.216,368.582],[646.042,368.64]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[671.216,560.813],[671.216,652.136],[646.042,560.805],[646.042,652.097]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[671.216,654.844],[646.042,654.804],[671.216,746.167],[646.042,746.097]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[712.354,455.918],[712.354,360.004],[654.099,455.983],[654.099,360.145]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[712.354,561.896],[712.354,657.81],[654.099,561.878],[654.099,657.716]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[712.354,660.653],[712.354,756.567],[654.099,660.558],[654.099,756.396]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[719.335,470.506],[697.509,470.527],[719.335,391.384],[697.509,391.427]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[719.335,557.932],[719.335,637.055],[697.509,557.927],[697.509,637.026]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[719.335,725.683],[697.509,725.629],[719.335,804.806],[697.509,804.728]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[871.654,399.584],[1238.44,398.894],[871.654,238.833],[1238.44,237.349]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[871.654,570.671],[871.654,409.92],[1238.44,570.826],[1238.44,409.281]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[871.654,577.203],[1238.44,577.391],[871.654,737.954],[1238.44,738.935]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[871.654,742.72],[1238.44,743.725],[871.654,903.471],[1238.44,905.27]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[871.654,918.017],[1238.44,919.888],[871.654,1078.77],[1238.44,1081.43]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1038.75,458.553],[1153.39,458.428],[1038.75,362.212],[1153.39,361.94]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1038.75,565.002],[1038.75,661.343],[1153.39,565.042],[1153.39,661.531]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1038.75,664.199],[1153.39,664.392],[1038.75,760.539],[1153.39,760.88]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1148.27,462.259],[1173.79,462.233],[1148.27,370.343],[1173.79,370.285]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1148.27,563.82],[1173.79,563.828],[1148.27,655.735],[1173.79,655.775]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1148.27,658.461],[1173.79,658.501],[1148.27,750.376],[1173.79,750.448]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1182.94,439.419],[1216.05,439.375],[1182.94,320.237],[1216.05,320.14]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1182.94,571.108],[1216.05,571.122],[1182.94,690.289],[1216.05,690.357]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1182.94,693.823],[1216.05,693.892],[1182.94,813.005],[1216.05,813.127]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1182.94,823.79],[1216.05,823.916],[1182.94,942.972],[1216.05,943.151]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1222.52,413.19],[1262.55,413.122],[1222.52,264.069],[1262.55,263.921]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1222.52,571.899],[1222.52,422.778],[1262.55,571.916],[1262.55,422.716]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1222.52,731.501],[1262.55,731.604],[1222.52,880.622],[1262.55,880.805]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1222.52,894.116],[1262.55,894.307],[1222.52,1043.24],[1262.55,1043.51]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:27,
                    verts:[[1222.52,577.959],[1262.55,577.98],[1222.52,727.08],[1262.55,727.181]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[551.583,408.835],[511.02,408.693],[551.583,258.733],[511.02,258.426]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[551.583,568.59],[551.583,418.487],[511.02,568.622],[511.02,418.355]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[551.583,574.689],[511.02,574.728],[551.583,724.792],[511.02,724.995]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[551.583,729.243],[511.02,729.45],[551.583,879.345],[511.02,879.717]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[551.583,892.928],[511.02,893.315],[551.583,1043.03],[511.02,1043.58]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[899.517,399.318],[529.677,397.91],[899.517,238.262],[529.677,235.233]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[899.517,570.73],[899.517,409.674],[529.677,571.047],[529.677,408.37]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[899.517,577.275],[899.517,738.332],[529.677,577.658],[529.677,740.335]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[899.517,743.107],[529.677,745.158],[899.517,904.163],[529.677,907.835]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[899.517,918.737],[529.677,922.556],[899.517,1079.79],[529.677,1085.23]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[605.715,435.267],[572.286,435.173],[605.715,315.586],[572.286,315.384]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[605.715,567.507],[572.286,567.533],[605.715,687.189],[572.286,687.322]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[605.715,690.737],[572.286,690.874],[605.715,810.418],[572.286,810.663]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[605.715,821.248],[572.286,821.503],[605.715,940.929],[572.286,941.292]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[653.095,459.026],[627.343,458.97],[653.095,366.69],[627.343,366.57]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[653.095,561.052],[627.343,561.067],[653.095,653.388],[627.343,653.467]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[653.095,656.125],[627.343,656.207],[653.095,748.462],[627.343,748.607]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[705.253,455.158],[645.81,455.022],[705.253,358.37],[645.81,358.079]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[705.253,562.103],[705.253,658.891],[645.81,562.139],[645.81,659.083]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[705.253,661.761],[645.81,661.958],[705.253,758.549],[645.81,758.902]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1009.31,399.736],[1009.31,239.161],[1369.7,401.109],[1369.7,242.113]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1009.31,570.636],[1009.31,410.061],[1369.7,570.328],[1369.7,411.332]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1009.31,577.162],[1009.31,737.737],[1369.7,576.789],[1369.7,735.785]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1009.31,742.498],[1009.31,903.073],[1369.7,740.499],[1369.7,899.495]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1009.31,917.604],[1009.31,1078.18],[1369.7,913.882],[1369.7,1072.88]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1033.13,458.893],[1033.13,362.96],[1146.24,459.141],[1146.24,363.504]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1033.13,564.894],[1033.13,660.827],[1146.24,564.815],[1146.24,660.452]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1033.13,663.672],[1033.13,759.605],[1146.24,663.287],[1146.24,758.924]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1131.25,462.903],[1156.31,462.955],[1131.25,371.756],[1156.31,371.871]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1131.25,563.614],[1131.25,654.761],[1156.31,563.597],[1156.31,654.682]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1131.25,657.463],[1156.31,657.382],[1131.25,748.61],[1156.31,748.466]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1224.43,440.543],[1256.74,440.63],[1224.43,322.703],[1256.74,322.895]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1224.43,570.749],[1224.43,688.589],[1256.74,570.721],[1256.74,688.457]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1224.43,692.083],[1256.74,691.948],[1224.43,809.924],[1256.74,809.683]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1224.43,820.587],[1256.74,820.337],[1224.43,938.427],[1256.74,938.073]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1327.58,415.014],[1366.38,415.147],[1327.58,268.051],[1366.38,268.34]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1327.58,571.427],[1327.58,424.463],[1366.38,571.392],[1366.38,424.586]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1327.58,728.719],[1366.38,728.517],[1327.58,875.682],[1366.38,875.323]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:28,
                    verts:[[1327.58,888.981],[1366.38,888.607],[1327.58,1035.94],[1366.38,1035.41]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[608.905,469.002],[631.518,469.108],[608.905,388.148],[631.518,388.376]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[608.905,555.055],[631.518,555.031],[608.905,474.201],[631.518,474.299]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[608.905,558.341],[631.518,558.312],[608.905,639.195],[631.518,639.044]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[608.905,641.592],[631.518,641.438],[608.905,722.446],[631.518,722.169]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[608.905,729.763],[631.518,729.475],[608.905,810.617],[631.518,810.207]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[611.452,458.047],[611.452,364.584],[610.36,462.745],[610.36,374.69]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[611.452,557.519],[611.452,464.057],[610.36,556.463],[610.36,468.407]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[611.452,561.318],[611.452,654.78],[610.36,560.041],[610.36,648.097]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[611.452,657.552],[611.452,751.014],[610.36,650.707],[610.36,738.763]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[611.452,759.472],[611.452,852.934],[610.36,746.731],[610.36,834.787]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[611.452,458.047],[637.58,458.189],[611.452,364.584],[637.58,364.889]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[611.452,557.519],[637.58,557.488],[611.452,464.057],[637.58,464.188]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[611.452,561.318],[637.58,561.279],[611.452,654.78],[637.58,654.579]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[611.452,657.552],[637.58,657.345],[611.452,751.014],[637.58,750.645]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[611.452,759.472],[637.58,759.088],[611.452,852.935],[637.58,852.387]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[617.055,433.944],[617.055,312.74],[615.25,441.712],[615.25,329.448]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[617.055,562.941],[617.055,441.737],[615.25,561.194],[615.25,448.93]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[617.055,567.867],[617.055,689.071],[615.25,565.756],[615.25,678.02]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[617.055,692.664],[617.055,813.868],[615.25,681.349],[615.25,793.613]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[617.055,824.836],[617.055,946.04],[615.25,803.771],[615.25,916.035]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[617.055,433.944],[650.909,434.182],[617.055,312.74],[650.909,313.253]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[617.055,562.941],[650.909,562.888],[617.055,441.737],[650.909,441.958]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[617.055,567.867],[650.909,567.802],[617.055,689.071],[650.909,688.732]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[617.055,692.664],[650.909,692.317],[617.055,813.868],[650.909,813.247]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[617.055,824.836],[650.909,824.19],[617.055,946.04],[650.909,945.12]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[623.295,407.106],[623.295,255.012],[620.504,419.111],[620.504,280.835]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[623.295,568.979],[623.295,416.885],[620.504,566.278],[620.504,428.002]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[623.295,575.159],[623.295,727.253],[620.504,571.897],[620.504,710.173]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[623.295,731.763],[623.295,883.856],[620.504,714.273],[620.504,852.549]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[623.295,897.619],[623.295,1049.71],[620.504,865.062],[620.504,1003.34]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[623.295,407.106],[664.29,407.468],[623.295,255.012],[664.29,255.791]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[623.295,568.979],[664.29,568.897],[623.295,416.885],[664.29,417.22]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[623.295,575.159],[664.29,575.061],[623.295,727.253],[664.29,726.738]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[623.295,731.763],[664.29,731.235],[623.295,883.856],[664.29,882.912]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[623.295,897.619],[664.29,896.637],[623.295,1049.71],[664.29,1048.31]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[654.705,427.346],[654.705,298.547],[650.909,434.182],[650.909,313.253]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[654.705,569.66],[654.705,698.458],[650.909,567.802],[650.909,688.732]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[654.705,702.277],[654.705,831.075],[650.909,692.317],[650.909,813.247]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[654.705,842.73],[654.705,971.529],[650.909,824.19],[650.909,945.12]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[659.104,419.421],[659.104,281.502],[654.785,427.201],[654.785,298.236]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[640.538,562.378],[700.614,562.285],[640.538,660.33],[700.614,659.844]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[659.104,571.813],[659.104,709.732],[654.785,569.699],[654.785,698.664]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[659.104,713.822],[659.104,851.741],[654.785,702.488],[654.785,831.453]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[659.104,864.221],[659.104,1002.14],[654.785,843.123],[654.785,972.088]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[640.538,454.146],[700.614,454.488],[640.538,356.193],[700.614,356.929]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[640.538,663.235],[700.614,662.736],[640.538,761.187],[700.614,760.295]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[670.298,396.427],[670.298,232.044],[664.29,407.468],[664.29,255.791]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[670.298,571.381],[670.298,406.997],[664.29,568.897],[664.29,417.22]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[670.298,578.061],[670.298,742.445],[664.29,575.061],[664.29,726.738]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[670.298,747.318],[670.298,911.702],[664.29,731.235],[664.29,882.912]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[670.298,926.577],[670.298,1090.96],[664.29,896.637],[664.29,1048.31]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[670.298,396.428],[670.298,232.044],[1037.58,399.944],[1037.58,239.609]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[670.298,571.381],[670.298,406.997],[1037.58,570.59],[1037.58,410.254]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[670.298,578.061],[670.298,742.445],[1037.58,577.105],[1037.58,737.441]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[670.298,747.318],[670.298,911.702],[1037.58,742.195],[1037.58,902.53]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[670.298,926.577],[670.298,1090.96],[1037.58,917.039],[1037.58,1077.38]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1026.84,459.319],[1026.84,363.894],[1137.39,459.926],[1137.39,365.226]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1026.84,564.758],[1026.84,660.183],[1137.39,564.564],[1137.39,659.265]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1026.84,663.012],[1026.84,758.437],[1137.39,662.072],[1137.39,756.773]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1026.84,560.88],[1026.84,465.455],[1137.39,560.716],[1137.39,466.015]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1026.84,767.072],[1026.84,862.497],[1137.39,765.342],[1137.39,860.043]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1044.82,471.047],[1044.82,392.546],[1066.13,471.147],[1066.13,392.761]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1044.82,557.785],[1044.82,636.286],[1066.13,557.758],[1066.13,636.144]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1044.82,638.613],[1066.13,638.468],[1044.82,717.114],[1066.13,716.853]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1044.82,724.218],[1066.13,723.946],[1044.82,802.718],[1066.13,802.332]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1112.94,463.582],[1112.94,373.245],[1137.35,463.709],[1137.35,373.525]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1112.94,563.398],[1112.94,653.734],[1137.35,563.357],[1137.35,653.541]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1112.94,656.413],[1137.35,656.215],[1112.94,746.749],[1137.35,746.399]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1112.94,754.924],[1137.35,754.56],[1112.94,845.26],[1137.35,844.744]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1144.52,400.969],[1144.52,241.812],[1489.09,404.268],[1489.09,248.909]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1144.52,570.359],[1144.52,411.202],[1489.09,569.617],[1489.09,414.257]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1144.52,576.827],[1144.52,735.984],[1489.09,575.93],[1489.09,731.29]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1144.52,740.703],[1144.52,899.86],[1489.09,735.896],[1489.09,891.256]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1144.52,914.262],[1144.52,1073.42],[1489.09,905.314],[1489.09,1060.67]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1261.59,441.965],[1261.59,325.823],[1292.64,442.176],[1292.64,326.286]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1261.59,570.295],[1261.59,686.437],[1292.64,570.228],[1292.64,686.118]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1261.59,689.881],[1292.64,689.554],[1261.59,806.023],[1292.64,805.444]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1261.59,816.532],[1292.64,815.931],[1261.59,932.674],[1292.64,931.822]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1423.31,417.552],[1423.31,273.59],[1460.05,417.867],[1460.05,274.279]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1423.31,570.769],[1423.31,426.808],[1460.05,570.688],[1460.05,427.1]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1423.31,724.849],[1460.05,724.368],[1423.31,868.81],[1460.05,867.956]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:29,
                    verts:[[1423.31,881.838],[1460.05,880.949],[1423.31,1025.8],[1460.05,1024.54]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[567.575,468.167],[567.575,386.352],[557.503,471.727],[557.503,394.01]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[567.575,555.243],[567.575,473.428],[557.503,554.442],[557.503,476.725]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[567.575,558.568],[567.575,640.383],[557.503,557.6],[557.503,635.318]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[567.575,642.808],[567.575,724.624],[557.503,637.622],[557.503,715.34]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[567.575,732.027],[567.575,813.842],[557.503,722.372],[557.503,800.09]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[567.575,468.167],[590.421,468.339],[567.575,386.352],[590.421,386.722]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[567.575,555.243],[567.575,473.428],[590.421,555.204],[590.421,473.587]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[567.575,558.568],[590.421,558.521],[567.575,640.383],[590.421,640.138]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[567.575,642.808],[590.421,642.558],[567.575,724.624],[590.421,724.175]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[567.575,732.027],[590.421,731.56],[567.575,813.842],[590.421,813.177]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[578.491,471.877],[578.491,394.333],[570.579,474.392],[570.579,399.74]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[578.491,557.56],[578.491,635.104],[570.579,556.876],[570.579,631.528]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[578.491,637.404],[578.491,714.948],[570.579,633.741],[570.579,708.392]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[578.491,721.966],[578.491,799.51],[570.579,715.147],[570.579,789.799]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[598.665,457.178],[598.665,362.715],[585.341,461.888],[585.341,372.845]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[598.665,557.715],[598.665,463.252],[585.341,556.656],[585.341,467.613]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[598.665,561.554],[598.665,656.017],[585.341,560.274],[585.341,649.317]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[598.665,658.818],[598.665,753.281],[585.341,651.957],[585.341,740.999]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[598.665,761.829],[598.665,856.292],[585.341,749.057],[585.341,838.099]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[599.859,465.351],[599.859,380.294],[590.421,468.339],[590.421,386.722]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[599.859,559.333],[599.859,644.39],[590.421,558.521],[590.421,640.138]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[599.859,646.912],[599.859,731.969],[590.421,642.558],[590.421,724.175]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[599.859,739.666],[599.859,824.723],[590.421,731.56],[590.421,813.177]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[598.665,457.178],[624.946,457.407],[598.665,362.715],[624.946,363.208]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[609.309,462.084],[609.309,373.268],[598.986,465.365],[598.986,380.324]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[598.665,557.715],[598.665,463.252],[624.946,557.663],[624.946,463.464]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[609.309,560.221],[609.309,649.037],[598.986,559.329],[598.986,644.37]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[598.665,561.554],[624.946,561.491],[598.665,656.017],[624.946,655.691]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[609.309,651.67],[609.309,740.486],[598.986,646.891],[598.986,731.932]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[598.665,658.818],[624.946,658.484],[598.665,753.281],[624.946,752.683]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[609.309,748.523],[609.309,837.339],[598.986,739.627],[598.986,824.668]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[598.665,761.829],[624.946,761.207],[598.665,856.292],[624.946,855.406]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[637.719,453.363],[637.719,354.508],[624.946,457.407],[624.946,363.208]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[637.719,558.573],[637.719,459.719],[624.946,557.663],[624.946,463.464]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[637.719,562.59],[637.719,661.445],[624.946,561.491],[624.946,655.691]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[637.719,664.376],[637.719,763.23],[624.946,658.484],[624.946,752.683]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[637.719,772.176],[637.719,871.03],[624.946,761.207],[624.946,855.406]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[638.431,453.37],[638.431,354.523],[698.544,453.921],[698.544,355.709]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[638.431,558.572],[638.431,459.725],[698.544,558.448],[698.544,460.236]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[638.431,562.589],[638.431,661.435],[698.544,562.439],[698.544,660.651]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[638.431,664.366],[638.431,763.212],[698.544,663.563],[698.544,761.775]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[638.431,772.157],[698.544,770.662],[638.431,871.003],[698.544,868.874]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[666.812,433.09],[666.812,310.904],[644.889,440.839],[644.889,327.571]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[666.812,563.133],[666.812,440.947],[644.889,561.39],[644.889,448.122]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[666.812,568.099],[666.812,690.286],[644.889,565.993],[644.889,679.261]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[666.812,693.908],[666.812,816.095],[644.889,682.62],[644.889,795.888]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[666.812,827.152],[666.812,949.339],[644.889,806.137],[644.889,919.405]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[675.164,441.158],[675.164,328.256],[658.673,446.398],[658.673,339.528]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[675.164,565.907],[675.164,678.808],[658.673,564.483],[658.673,671.353]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[675.164,682.156],[675.164,795.058],[658.673,674.522],[658.673,781.392]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[675.164,805.274],[675.164,918.176],[658.673,791.063],[658.673,897.933]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[666.812,433.09],[700.532,433.474],[666.812,310.904],[700.532,311.728]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[666.812,563.133],[666.812,440.947],[700.532,563.047],[700.532,441.302]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[666.812,568.099],[700.532,567.995],[666.812,690.286],[700.532,689.74]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[666.812,693.908],[700.532,693.35],[666.812,816.095],[700.532,815.096]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[666.812,827.152],[700.532,826.112],[666.812,949.339],[700.532,947.858]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[721.979,426.683],[721.979,297.121],[700.532,433.474],[700.532,311.728]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[721.979,564.575],[721.979,435.013],[700.532,563.047],[700.532,441.302]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[721.979,569.84],[721.979,699.401],[700.532,567.995],[700.532,689.74]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[721.979,703.243],[721.979,832.804],[700.532,693.35],[700.532,815.095]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[721.979,844.529],[721.979,974.09],[700.532,826.112],[700.532,947.858]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[742.283,406.414],[742.283,253.524],[708.576,418.328],[708.576,279.15]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[742.283,569.134],[742.283,416.244],[708.576,566.454],[708.576,427.277]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[742.283,575.348],[742.283,728.238],[708.576,572.11],[708.576,711.288]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[742.283,732.771],[742.283,885.661],[708.576,715.414],[708.576,854.591]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[742.283,899.496],[742.283,1052.39],[708.576,867.186],[708.576,1006.36]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[746.795,418.825],[746.795,280.22],[722.433,426.539],[722.433,296.812]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[746.795,571.975],[746.795,710.58],[722.433,569.879],[722.433,699.606]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[746.795,714.69],[746.795,853.295],[722.433,703.452],[722.433,833.179]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[746.795,865.838],[746.795,1004.44],[722.433,844.918],[722.433,974.645]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[742.283,406.414],[782.678,406.993],[742.283,253.523],[782.678,254.769]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[742.283,569.134],[742.283,416.244],[782.678,569.004],[782.678,416.781]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[742.283,575.348],[782.678,575.19],[742.283,728.238],[782.678,727.414]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[742.283,732.771],[782.678,731.927],[742.283,885.661],[782.678,884.151]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[742.283,899.496],[782.678,897.925],[742.283,1052.39],[782.678,1050.15]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[816.956,396.1],[816.956,231.34],[782.678,406.993],[782.678,254.769]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[816.956,571.454],[816.956,406.694],[782.678,569.004],[782.678,416.781]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[816.956,578.15],[816.956,742.91],[782.678,575.19],[782.678,727.414]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[816.956,747.795],[816.956,912.555],[782.678,731.927],[782.678,884.15]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[816.956,927.465],[816.956,1092.22],[782.678,897.925],[782.678,1050.15]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[816.956,396.1],[816.956,231.34],[1171.45,401.622],[1171.45,243.218]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[816.956,571.454],[816.956,406.694],[1171.45,570.212],[1171.45,411.808]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[816.956,578.15],[816.956,742.91],[1171.45,576.649],[1171.45,735.054]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[816.956,747.795],[816.956,912.555],[1171.45,739.75],[1171.45,898.155]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[816.956,927.464],[816.956,1092.22],[1171.45,912.489],[1171.45,1070.89]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1000.76,471.43],[1000.76,393.369],[1021.56,471.586],[1021.56,393.706]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1000.76,557.681],[1000.76,635.741],[1021.56,557.639],[1021.56,635.519]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1000.76,723.18],[1021.56,722.755],[1000.76,801.24],[1021.56,800.635]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1019.99,459.822],[1019.99,364.997],[1127.05,460.768],[1127.05,367.073]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1019.99,564.597],[1019.99,659.422],[1127.05,564.295],[1127.05,657.99]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1019.99,662.234],[1019.99,757.058],[1127.05,660.768],[1127.05,754.464]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1272.78,403.201],[1272.78,246.613],[1593.59,408.198],[1593.59,257.362]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1272.78,569.857],[1272.78,413.269],[1593.59,568.733],[1593.59,417.897]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1272.78,576.22],[1272.78,732.808],[1593.59,574.863],[1593.59,725.698]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1272.78,737.451],[1272.78,894.039],[1593.59,730.171],[1593.59,881.007]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1272.78,908.208],[1272.78,1064.8],[1593.59,894.656],[1593.59,1045.49]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1293.87,443.642],[1293.87,329.501],[1323.26,443.964],[1323.26,330.209]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1293.87,569.76],[1293.87,683.901],[1323.26,569.657],[1323.26,683.413]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1293.87,687.285],[1293.87,801.426],[1323.26,686.786],[1323.26,800.541]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1293.87,811.754],[1323.26,810.835],[1293.87,925.895],[1323.26,924.591]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1507.56,420.68],[1507.56,280.419],[1541.56,421.154],[1541.56,281.455]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1507.56,569.959],[1507.56,429.699],[1541.56,569.836],[1541.56,430.137]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1507.56,720.078],[1507.56,860.339],[1541.56,719.355],[1541.56,859.054]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:30,
                    verts:[[1507.56,873.031],[1541.56,871.696],[1507.56,1013.29],[1541.56,1011.4]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[528.838,467.293],[528.838,384.471],[509.219,470.841],[509.219,392.104]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[528.838,555.44],[528.838,472.618],[509.219,554.641],[509.219,475.904]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[528.838,558.805],[528.838,641.627],[509.219,557.841],[509.219,636.578]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[528.838,644.083],[528.838,726.905],[509.219,638.913],[509.219,717.65]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[528.838,734.399],[528.838,817.221],[509.219,724.775],[509.219,803.512]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[530.365,471.05],[530.365,392.553],[515.695,473.556],[515.695,397.943]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[530.365,557.784],[530.365,636.281],[515.695,557.104],[515.695,632.717]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[530.365,638.609],[530.365,717.105],[515.695,634.959],[515.695,710.572]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[530.365,724.209],[530.365,802.705],[515.695,717.414],[515.695,793.027]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[528.838,467.293],[551.795,467.532],[528.838,384.471],[551.795,384.985]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[528.838,555.44],[528.838,472.618],[551.795,555.386],[551.795,472.839]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[528.838,558.805],[528.838,641.627],[551.795,558.74],[551.795,641.287]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[528.838,644.083],[551.795,643.734],[528.838,726.905],[551.795,726.281]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[528.838,734.399],[551.795,733.75],[528.838,817.221],[551.795,816.297]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[569.215,464.562],[569.215,378.598],[551.795,467.532],[551.795,384.985]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[569.215,556.054],[569.215,470.09],[551.795,555.386],[551.795,472.839]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[569.215,559.547],[569.215,645.511],[551.795,558.74],[551.795,641.287]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[569.215,648.06],[569.215,734.024],[551.795,643.734],[551.795,726.281]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[569.215,741.803],[569.215,827.767],[551.795,733.75],[551.795,816.297]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[589.197,456.374],[589.197,360.986],[563.366,461.047],[563.366,371.036]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[589.197,557.896],[589.197,462.507],[563.366,556.845],[563.366,466.834]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[589.197,561.772],[589.197,657.16],[563.366,560.503],[563.366,650.513]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[589.197,659.989],[589.197,755.377],[563.366,653.182],[563.366,743.192]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[589.197,764.009],[589.197,859.397],[563.366,751.337],[563.366,841.348]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[587.34,461.32],[587.34,371.623],[568.285,464.574],[568.285,378.623]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[587.34,560.428],[587.34,650.125],[568.285,559.544],[568.285,645.495]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[587.34,652.784],[587.34,742.481],[568.285,648.043],[568.285,733.994]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[587.34,750.597],[587.34,840.294],[568.285,741.772],[568.285,827.723]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[589.197,456.374],[615.392,456.691],[589.197,360.986],[615.392,361.668]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[589.197,557.896],[589.197,462.507],[615.392,557.824],[615.392,462.801]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[589.197,561.772],[589.197,657.16],[615.392,561.686],[615.392,656.709]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[589.197,659.989],[615.392,659.527],[589.197,755.377],[615.392,754.55]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[589.197,764.009],[615.392,763.149],[589.197,859.397],[615.392,858.172]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[638.838,452.695],[638.838,353.072],[615.392,456.691],[615.392,361.668]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[638.838,558.723],[638.838,459.1],[615.392,557.824],[615.392,462.801]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[638.838,562.772],[638.838,662.395],[615.392,561.686],[615.392,656.709]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[638.838,665.349],[638.838,764.971],[615.392,659.527],[615.392,754.55]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[638.838,773.986],[638.838,873.609],[615.392,763.148],[615.392,858.172]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[639.544,452.704],[639.544,353.092],[699.073,453.462],[699.073,354.723]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[639.544,558.721],[639.544,459.109],[699.073,558.551],[699.073,459.811]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[639.544,562.769],[639.544,662.381],[699.073,562.563],[699.073,661.303]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[639.544,665.335],[639.544,764.947],[699.073,664.23],[699.073,762.97]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[639.544,773.961],[639.544,873.573],[699.073,771.905],[699.073,870.644]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[720.457,432.63],[720.457,309.914],[678.385,440.241],[678.385,326.284]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[708.202,440.678],[708.202,327.223],[678.049,445.827],[678.049,338.3]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[720.457,563.237],[720.457,440.521],[678.385,561.525],[678.385,447.568]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[708.202,566.037],[708.202,679.491],[678.049,564.638],[678.049,672.165]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[720.457,568.224],[720.457,690.94],[678.385,566.156],[678.385,680.113]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[708.202,682.855],[708.202,796.309],[678.049,675.353],[678.049,782.88]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[720.457,694.578],[720.457,817.295],[678.385,683.492],[678.385,797.449]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[708.202,806.576],[708.202,920.03],[678.049,792.61],[678.049,900.137]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[720.457,828.399],[720.457,951.115],[678.385,807.761],[678.385,921.718]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[720.457,432.63],[753.475,433.155],[720.457,309.914],[753.475,311.042]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[720.457,563.237],[720.457,440.521],[753.475,563.119],[753.475,441.006]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[720.457,568.224],[720.457,690.94],[753.475,568.081],[753.475,690.194]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[720.457,694.578],[753.475,693.815],[720.457,817.295],[753.475,815.927]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[720.457,828.399],[753.475,826.977],[720.457,951.115],[753.475,949.09]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[792.369,426.525],[792.369,296.782],[753.475,433.155],[753.475,311.042]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[792.369,564.61],[792.369,434.867],[753.475,563.119],[753.475,441.006]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[792.369,569.883],[792.369,699.626],[753.475,568.081],[753.475,690.194]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[792.369,703.473],[792.369,833.216],[753.475,693.815],[753.475,815.927]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[792.369,844.956],[792.369,974.699],[753.475,826.977],[753.475,949.09]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[837.217,418.88],[837.217,280.339],[793.191,426.385],[793.191,296.481]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[837.217,566.33],[837.217,427.788],[793.191,564.642],[793.191,434.737]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[837.217,571.96],[837.217,710.501],[793.191,569.921],[793.191,699.825]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[837.217,714.609],[837.217,853.151],[793.191,703.677],[793.191,833.581]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[837.217,865.687],[837.217,1004.23],[793.191,845.336],[793.191,975.24]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[864.178,406.632],[864.178,253.994],[800.202,418.205],[800.202,278.886]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[864.178,569.085],[864.178,416.447],[800.202,566.482],[800.202,427.163]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[864.178,575.288],[864.178,727.926],[800.202,572.143],[800.202,711.462]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[864.178,732.452],[864.178,885.09],[800.202,715.593],[800.202,854.912]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[864.178,898.903],[864.178,1051.54],[800.202,867.519],[800.202,1006.84]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[864.178,406.632],[902.958,407.415],[864.178,253.994],[902.958,255.678]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[864.178,569.085],[864.178,416.447],[902.958,568.909],[902.958,417.172]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[864.178,575.288],[864.178,727.926],[902.958,575.075],[902.958,726.813]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[864.178,732.452],[902.958,731.312],[864.178,885.091],[902.958,883.049]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[864.178,898.903],[902.958,896.78],[864.178,1051.54],[902.958,1048.52]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[964.395,396.922],[964.395,233.108],[902.958,407.415],[902.958,255.678]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[964.395,571.269],[964.395,407.455],[902.958,568.909],[902.958,417.172]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[964.395,577.927],[964.395,741.74],[902.958,575.075],[902.958,726.813]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[964.395,746.598],[964.395,910.411],[902.958,731.312],[902.958,883.049]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[964.395,925.235],[964.395,1089.05],[902.958,896.78],[902.958,1048.52]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[957.161,471.756],[957.161,394.071],[977.362,471.966],[977.362,394.524]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[957.161,557.593],[957.161,635.278],[977.362,557.535],[977.362,634.978]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[957.161,722.296],[977.362,721.725],[957.161,799.981],[977.362,799.167]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[964.395,396.922],[964.395,233.108],[1296.9,404.237],[1296.9,248.841]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[964.395,571.269],[964.395,407.455],[1296.9,569.624],[1296.9,414.228]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[964.395,577.926],[964.395,741.74],[1296.9,575.939],[1296.9,731.335]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[964.395,746.597],[964.395,910.411],[1296.9,735.942],[1296.9,891.338]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[964.395,925.235],[964.395,1089.05],[1296.9,905.399],[1296.9,1060.79]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1012.7,460.39],[1012.7,366.244],[1115.43,461.652],[1115.43,369.012]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1012.7,564.416],[1012.7,658.562],[1115.43,564.013],[1115.43,656.654]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1012.7,661.354],[1012.7,755.5],[1115.43,659.401],[1115.43,752.041]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1320.94,445.519],[1320.94,333.619],[1348.36,445.939],[1348.36,334.541]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1320.94,564.614],[1320.94,452.714],[1348.36,564.5],[1348.36,453.102]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1320.94,569.161],[1320.94,681.061],[1348.36,569.027],[1348.36,680.425]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1320.94,684.379],[1320.94,796.279],[1348.36,683.728],[1348.36,795.126]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1320.94,806.405],[1348.36,805.206],[1320.94,918.305],[1348.36,916.604]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1390.32,406.292],[1390.32,253.261],[1681.48,412.696],[1681.48,267.037]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1390.32,569.162],[1390.32,416.131],[1681.48,567.721],[1681.48,422.062]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1390.32,575.381],[1390.32,728.411],[1681.48,573.64],[1681.48,719.299]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1390.32,732.948],[1390.32,885.979],[1681.48,723.618],[1681.48,869.277]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1390.32,899.826],[1390.32,1052.86],[1681.48,882.458],[1681.48,1028.12]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1579.01,424.254],[1579.01,288.222],[1609.83,424.86],[1609.83,289.543]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1579.01,569.033],[1579.01,433.001],[1609.83,568.877],[1609.83,433.56]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1579.01,714.627],[1579.01,850.659],[1609.83,713.704],[1609.83,849.02]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:31,
                    verts:[[1579.01,862.969],[1609.83,861.265],[1579.01,999.001],[1609.83,996.581]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[493.093,466.384],[493.093,382.516],[463.667,469.892],[463.667,390.062]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[484.875,470.161],[484.875,390.64],[463.248,472.639],[463.248,395.971]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[493.093,555.644],[493.093,471.776],[463.667,554.855],[463.667,475.025]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[484.875,558.026],[484.875,637.547],[463.248,557.353],[463.248,634.021]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[493.093,559.052],[493.093,642.92],[463.667,558.099],[463.667,637.929]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[484.875,639.904],[484.875,719.425],[463.248,636.294],[463.248,712.962]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[493.093,645.407],[493.093,729.275],[463.667,640.296],[463.667,720.126]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[484.875,726.621],[484.875,806.141],[463.248,719.9],[463.248,796.568]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[493.093,736.864],[493.093,820.732],[463.667,727.349],[463.667,807.179]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[493.093,466.384],[493.093,382.516],[516.028,466.691],[516.028,383.176]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[493.093,555.644],[493.093,471.776],[516.028,555.575],[516.028,472.06]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[493.093,559.052],[493.093,642.92],[516.028,558.969],[516.028,642.484]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[493.093,645.407],[493.093,729.275],[516.028,644.96],[516.028,728.474]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[493.093,736.864],[516.028,736.032],[493.093,820.732],[516.028,819.546]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[541.577,463.767],[541.577,376.887],[516.028,466.691],[516.028,383.176]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[541.577,556.233],[541.577,469.353],[516.028,555.575],[516.028,472.06]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[541.577,559.763],[541.577,646.643],[516.028,558.969],[516.028,642.484]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[541.577,649.219],[541.577,736.098],[516.028,644.96],[516.028,728.474]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[541.577,743.96],[541.577,830.84],[516.028,736.031],[516.028,819.546]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[568.498,460.578],[568.498,370.029],[540.595,463.776],[540.595,376.906]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[568.498,556.95],[568.498,466.4],[540.595,556.231],[540.595,469.361]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[568.498,560.63],[568.498,651.179],[540.595,559.761],[540.595,646.63]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[568.498,653.864],[568.498,744.414],[540.595,649.206],[540.595,736.076]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[568.498,752.607],[568.498,843.157],[540.595,743.936],[540.595,830.806]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[583.173,455.643],[583.173,359.414],[544.707,460.23],[544.707,369.279]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[583.173,558.06],[583.173,461.831],[544.707,557.028],[544.707,466.078]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[583.173,561.971],[583.173,658.2],[544.707,560.724],[544.707,651.675]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[583.173,661.053],[583.173,757.283],[544.707,654.372],[544.707,745.323]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[583.173,765.991],[583.173,862.22],[544.707,753.553],[544.707,844.503]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[583.173,455.643],[583.173,359.414],[609.037,456.047],[609.037,360.282]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[583.173,558.06],[583.173,461.831],[609.037,557.969],[609.037,462.205]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[583.173,561.971],[583.173,658.2],[609.037,561.861],[609.037,657.626]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[583.173,661.053],[583.173,757.283],[609.037,660.465],[609.037,756.23]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[583.173,765.991],[609.037,764.895],[583.173,862.22],[609.037,860.66]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[643.144,452.144],[643.144,351.887],[609.037,456.047],[609.037,360.282]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[643.144,558.847],[643.144,458.59],[609.037,557.969],[609.037,462.205]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[643.144,562.922],[643.144,663.178],[609.037,561.861],[609.037,657.626]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[643.144,666.151],[643.144,766.408],[609.037,660.465],[609.037,756.23]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[643.144,775.48],[643.144,875.737],[609.037,764.895],[609.037,860.66]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[643.835,452.156],[643.835,351.913],[702.158,453.116],[702.158,353.977]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[643.835,558.845],[643.835,458.601],[702.158,558.629],[702.158,459.49]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[643.835,562.918],[643.835,663.161],[702.158,562.658],[702.158,661.796]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[643.835,666.134],[643.835,766.377],[702.158,664.736],[702.158,763.874]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[643.835,775.448],[643.835,875.691],[702.158,772.846],[702.158,871.984]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[743.973,440.47],[743.973,326.777],[700.437,445.459],[700.437,337.508]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[743.973,561.473],[743.973,447.78],[700.437,560.351],[700.437,452.4]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[743.973,566.094],[743.973,679.786],[700.437,564.738],[700.437,672.689]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[743.973,683.157],[743.973,796.85],[700.437,675.89],[700.437,783.841]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[743.973,807.138],[743.973,920.831],[700.437,793.609],[700.437,901.56]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[776.745,432.563],[776.745,309.77],[715.044,439.92],[715.044,325.594]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[776.745,563.252],[776.745,440.459],[715.044,561.597],[715.044,447.271]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[776.745,568.242],[776.745,691.035],[715.044,566.243],[715.044,680.569]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[776.745,694.676],[776.745,817.469],[715.044,683.959],[715.044,798.285]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[776.745,828.581],[776.745,951.374],[715.044,808.63],[715.044,922.956]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[776.745,432.563],[776.745,309.77],[808.513,433.22],[808.513,311.183]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[776.745,563.252],[776.745,440.459],[808.513,563.104],[808.513,441.067]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[776.745,568.242],[776.745,691.035],[808.513,568.064],[808.513,690.101]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[776.745,694.676],[776.745,817.469],[808.513,693.719],[808.513,815.757]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[776.745,828.581],[808.513,826.8],[776.745,951.374],[808.513,948.837]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[864.1,426.859],[864.1,297.5],[808.513,433.22],[808.513,311.183]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[864.1,564.535],[864.1,435.177],[808.513,563.104],[808.513,441.067]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[864.1,569.792],[864.1,699.151],[808.513,568.064],[808.513,690.101]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[864.1,702.986],[864.1,832.345],[808.513,693.719],[808.513,815.756]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[864.1,844.05],[864.1,973.409],[808.513,826.8],[808.513,948.837]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[927.872,419.561],[927.872,281.803],[865.272,426.725],[865.272,297.212]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[927.872,566.177],[927.872,428.419],[865.272,564.565],[865.272,435.052]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[927.872,571.775],[927.872,709.533],[865.272,569.828],[865.272,699.341]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[927.872,713.617],[927.872,851.375],[865.272,703.181],[865.272,832.694]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[927.872,863.841],[927.872,1001.6],[865.272,844.414],[865.272,973.927]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[985.119,407.719],[985.119,256.33],[892.818,418.724],[892.818,280.002]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[985.119,568.841],[985.119,417.453],[892.818,566.365],[892.818,427.643]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[985.119,574.993],[985.119,726.381],[892.818,572.003],[892.818,710.724]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[985.119,730.87],[985.119,882.258],[892.818,714.838],[892.818,853.559]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[985.119,895.957],[985.119,1047.35],[892.818,866.112],[892.818,1004.83]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[914.378,472.022],[914.378,394.644],[933.908,472.284],[933.908,395.206]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[914.378,557.52],[914.378,634.898],[933.908,557.449],[933.908,634.527]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[914.378,721.573],[914.378,798.951],[933.908,720.864],[933.908,797.942]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[985.119,407.718],[985.119,256.33],[1021.38,408.681],[1021.38,258.402]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[985.119,568.841],[985.119,417.453],[1021.38,568.624],[1021.38,418.344]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[985.119,574.993],[985.119,726.381],[1021.38,574.731],[1021.38,725.011]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[985.119,730.87],[985.119,882.258],[1021.38,729.467],[1021.38,879.747]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[985.119,895.957],[1021.38,893.346],[985.119,1047.35],[1021.38,1043.63]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1005.1,461.01],[1005.1,367.603],[1102.77,462.559],[1102.77,371.002]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1005.1,564.218],[1005.1,657.625],[1102.77,563.724],[1102.77,655.281]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1005.1,660.394],[1005.1,753.801],[1102.77,657.996],[1102.77,749.552]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1107.55,398.807],[1107.55,237.163],[1021.38,408.682],[1021.38,258.402]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1107.55,570.845],[1107.55,409.201],[1021.38,568.624],[1021.38,418.344]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1107.55,577.414],[1107.55,739.059],[1021.38,574.731],[1021.38,725.011]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1107.55,743.852],[1107.55,905.496],[1021.38,729.467],[1021.38,879.747]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1107.55,920.123],[1107.55,1081.77],[1021.38,893.345],[1021.38,1043.63]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1107.55,398.807],[1107.55,237.163],[1410.65,407.621],[1410.65,256.12]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1107.55,570.845],[1107.55,409.201],[1410.65,568.863],[1410.65,417.362]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1107.55,577.414],[1107.55,739.059],[1410.65,575.019],[1410.65,726.52]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1107.55,743.851],[1107.55,905.496],[1410.65,731.012],[1410.65,882.513]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1107.55,920.123],[1107.55,1081.77],[1410.65,896.222],[1410.65,1047.72]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1342.73,447.539],[1342.73,338.052],[1367.96,448.043],[1367.96,339.157]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1342.73,568.517],[1342.73,678.004],[1367.96,568.356],[1367.96,677.242]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1342.73,681.251],[1342.73,790.738],[1367.96,680.471],[1367.96,789.357]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1342.73,800.646],[1342.73,910.134],[1367.96,799.21],[1367.96,908.097]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1494.5,410.059],[1494.5,261.365],[1752.28,417.555],[1752.28,277.488]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1494.5,568.314],[1494.5,419.62],[1752.28,566.628],[1752.28,426.561]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1494.5,574.357],[1494.5,723.051],[1752.28,572.32],[1752.28,712.387]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1494.5,727.46],[1494.5,876.154],[1752.28,716.54],[1752.28,856.607]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1494.5,889.609],[1494.5,1038.3],[1752.28,869.282],[1752.28,1009.35]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1637.26,428.125],[1637.26,296.672],[1664.62,428.833],[1664.62,298.216]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1637.26,568.031],[1637.26,436.578],[1664.62,567.848],[1664.62,437.231]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1637.26,708.724],[1637.26,840.177],[1664.62,707.645],[1664.62,838.262]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:32,
                    verts:[[1637.26,852.072],[1637.26,983.526],[1664.62,850.082],[1664.62,980.698]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[442.389,469.212],[442.389,388.6],[413.627,471.644],[413.627,393.83]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[442.389,555.008],[442.389,474.396],[413.627,554.461],[413.627,476.647]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[442.389,558.284],[442.389,638.896],[413.627,557.623],[413.627,635.437]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[442.389,641.286],[442.389,721.898],[413.627,637.744],[413.627,715.557]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[442.389,729.193],[442.389,809.805],[413.627,722.599],[413.627,800.413]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[460.673,465.445],[460.673,380.496],[421.226,468.883],[421.226,387.892]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[460.673,555.855],[460.673,470.907],[421.226,555.082],[421.226,474.091]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[460.673,559.307],[460.673,644.256],[421.226,558.373],[421.226,639.364]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[460.673,646.775],[460.673,731.723],[421.226,641.766],[421.226,722.757]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[460.673,739.41],[460.673,824.359],[421.226,730.086],[421.226,811.077]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[460.673,465.445],[460.673,380.496],[483.444,465.819],[483.444,381.302]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[460.673,555.855],[460.673,470.907],[483.444,555.771],[483.444,471.254]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[460.673,559.307],[460.673,644.256],[483.444,559.206],[483.444,643.723]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[460.673,646.775],[460.673,731.723],[483.444,646.229],[483.444,730.746]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[460.673,739.41],[483.444,738.394],[460.673,824.359],[483.444,822.911]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[517.208,462.968],[517.208,375.169],[483.444,465.819],[483.444,381.302]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[517.208,556.412],[517.208,468.613],[483.444,555.771],[483.444,471.254]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[517.208,559.98],[517.208,647.78],[483.444,559.206],[483.444,643.723]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[517.208,650.383],[517.208,738.182],[483.444,646.229],[483.444,730.746]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[517.208,746.127],[517.208,833.926],[483.444,738.394],[483.444,822.911]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[552.963,459.864],[552.963,368.493],[516.181,462.974],[516.181,375.181]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[552.963,557.111],[552.963,465.739],[516.181,556.411],[516.181,468.619]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[552.963,560.824],[552.963,652.195],[516.181,559.979],[516.181,647.771]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[552.963,654.904],[552.963,746.276],[516.181,650.374],[516.181,738.167]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[552.963,754.544],[552.963,845.916],[516.181,746.111],[516.181,833.904]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[580.627,454.989],[580.627,358.006],[529.55,459.441],[529.55,367.583]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[580.627,558.207],[580.627,461.225],[529.55,557.206],[529.55,465.347]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[580.627,562.149],[580.627,659.131],[529.55,560.939],[529.55,652.797]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[580.627,662.007],[580.627,758.989],[529.55,655.521],[529.55,747.379]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[580.627,767.765],[580.627,864.748],[529.55,755.692],[529.55,847.55]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[580.627,454.989],[580.627,358.006],[605.911,455.477],[605.911,359.056]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[580.627,558.207],[580.627,461.225],[605.911,558.098],[605.911,461.677]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[580.627,562.149],[580.627,659.131],[605.911,562.016],[605.911,658.437]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[580.627,662.007],[580.627,758.989],[605.911,661.296],[605.911,757.717]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[580.627,767.765],[605.911,766.442],[580.627,864.748],[605.911,862.863]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[650.508,451.711],[650.508,350.955],[605.91,455.477],[605.91,359.056]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[650.508,558.945],[650.508,458.189],[605.91,558.098],[605.91,461.677]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[650.508,563.039],[650.508,663.795],[605.91,562.016],[605.91,658.437]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[650.508,666.782],[650.508,767.538],[605.91,661.296],[605.91,757.716]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[650.508,776.656],[650.508,877.411],[605.91,766.442],[605.91,862.863]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[651.178,451.725],[651.178,350.985],[707.682,452.876],[707.682,353.462]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[651.178,558.942],[651.178,458.202],[707.682,558.683],[707.682,459.269]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[651.178,563.036],[651.178,663.775],[707.682,562.723],[707.682,662.137]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[651.178,666.762],[651.178,767.501],[707.682,665.084],[707.682,764.498]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[651.178,776.617],[651.178,877.357],[707.682,773.494],[707.682,872.908]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[781.724,440.524],[781.724,326.894],[725.376,445.288],[725.376,337.14]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[781.724,561.461],[781.724,447.831],[725.376,560.39],[725.376,452.242]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[781.724,566.079],[781.724,679.709],[725.376,564.784],[725.376,672.932]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[781.724,683.079],[781.724,796.709],[725.376,676.139],[725.376,784.286]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[781.724,806.992],[781.724,920.622],[725.376,794.073],[725.376,902.221]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[834.386,432.87],[834.386,310.429],[754.088,439.869],[754.088,325.484]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[834.386,563.183],[834.386,440.743],[754.088,561.609],[754.088,447.224]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[834.386,568.159],[834.386,690.599],[754.088,566.257],[754.088,680.642]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[834.386,694.229],[834.386,816.67],[754.088,684.033],[754.088,798.418]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[834.386,827.75],[834.386,950.19],[754.088,808.769],[754.088,923.153]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[834.386,432.87],[834.386,310.429],[864.406,433.647],[864.406,312.1]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[834.386,563.183],[834.386,440.743],[864.406,563.008],[864.406,441.462]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[834.386,568.159],[834.386,690.599],[864.406,567.948],[864.406,689.494]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[834.386,694.229],[834.386,816.67],[864.406,693.098],[864.406,814.644]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[834.386,827.75],[864.406,825.643],[834.386,950.19],[864.406,947.19]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[935.447,427.647],[935.447,299.195],[864.405,433.647],[864.405,312.1]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[935.447,564.358],[935.447,435.906],[864.405,563.008],[864.405,441.462]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[935.447,569.578],[935.447,698.03],[864.405,567.948],[864.405,689.494]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[935.447,701.838],[935.447,830.29],[864.405,693.098],[864.405,814.644]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[935.447,841.913],[935.447,970.365],[864.405,825.643],[864.405,947.19]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[872.732,472.226],[872.732,395.082],[891.52,472.535],[891.52,395.747]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[872.732,557.465],[872.732,634.609],[891.52,557.381],[891.52,634.169]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[872.732,636.896],[872.732,714.04],[891.52,636.446],[891.52,713.234]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1016.43,420.808],[1016.43,284.485],[936.94,427.521],[936.94,298.924]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1016.43,565.896],[1016.43,429.573],[936.94,564.386],[936.94,435.789]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1016.43,571.436],[1016.43,707.759],[936.94,569.612],[936.94,698.209]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1016.43,711.801],[1016.43,848.124],[936.94,702.022],[936.94,830.619]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1016.43,860.46],[1016.43,996.782],[936.94,842.255],[936.94,970.852]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1101.6,409.578],[1101.6,260.33],[983.983,419.83],[983.983,282.382]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1101.6,568.422],[1101.6,419.175],[983.983,566.116],[983.983,428.668]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1101.6,574.488],[1101.6,723.735],[983.983,571.702],[983.983,709.15]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1101.6,728.161],[1101.6,877.408],[983.983,713.226],[983.983,850.674]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1101.6,890.914],[1101.6,1040.16],[983.983,863.112],[983.983,1000.56]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[997.304,461.665],[997.304,369.04],[1089.31,463.473],[1089.31,373.006]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[997.304,564.009],[997.304,656.634],[1089.31,563.432],[1089.31,653.899]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[997.304,659.38],[997.304,752.005],[1089.31,656.581],[1089.31,747.048]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1101.6,409.578],[1101.6,260.33],[1134.6,410.692],[1134.6,262.725]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1101.6,568.422],[1101.6,419.175],[1134.6,568.172],[1134.6,420.206]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1101.6,574.488],[1101.6,723.735],[1134.6,574.185],[1134.6,722.152]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1101.6,728.161],[1101.6,877.408],[1134.6,726.539],[1134.6,874.505]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1101.6,890.914],[1134.6,887.895],[1101.6,1040.16],[1134.6,1035.86]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1242.09,401.604],[1242.09,243.179],[1134.6,410.692],[1134.6,262.725]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1242.09,570.216],[1242.09,411.791],[1134.6,568.172],[1134.6,420.206]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1242.09,576.654],[1242.09,735.079],[1134.6,574.185],[1134.6,722.151]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1242.09,739.777],[1242.09,898.202],[1134.6,726.539],[1134.6,874.505]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1242.09,912.538],[1242.09,1070.96],[1134.6,887.895],[1134.6,1035.86]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1242.09,401.604],[1242.09,243.179],[1510.55,411.582],[1510.55,264.641]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1242.09,570.216],[1242.09,411.791],[1510.55,567.972],[1510.55,421.03]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1242.09,576.654],[1242.09,735.079],[1510.55,573.943],[1510.55,720.884]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1242.09,739.777],[1242.09,898.202],[1510.55,725.241],[1510.55,872.183]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1242.09,912.538],[1242.09,1070.96],[1510.55,885.479],[1510.55,1032.42]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1359.37,449.647],[1359.37,342.676],[1382.27,450.219],[1382.27,343.931]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1359.37,567.844],[1359.37,674.816],[1382.27,567.661],[1382.27,673.95]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1359.37,677.987],[1359.37,784.959],[1382.27,677.101],[1382.27,783.39]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1359.37,794.639],[1359.37,901.61],[1382.27,793.008],[1382.27,899.297]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1583.84,414.306],[1583.84,270.5],[1806.54,422.583],[1806.54,288.302]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1583.84,567.359],[1583.84,423.553],[1806.54,565.497],[1806.54,431.217]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1583.84,573.203],[1583.84,717.009],[1806.54,570.954],[1806.54,705.234]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1583.84,721.273],[1583.84,865.079],[1806.54,709.216],[1806.54,843.496]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1583.84,878.092],[1583.84,1021.9],[1806.54,855.647],[1806.54,989.928]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1682.6,432.152],[1682.6,305.461],[1706.41,432.933],[1706.41,307.168]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1682.6,566.988],[1682.6,440.298],[1706.41,566.786],[1706.41,441.02]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1682.6,702.583],[1682.6,829.274],[1706.41,701.392],[1706.41,827.157]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:33,
                    verts:[[1682.6,840.738],[1682.6,967.428],[1706.41,838.538],[1706.41,964.304]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[403.209,468.206],[403.209,386.436],[367.154,470.572],[367.154,391.524]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[403.209,555.234],[403.209,473.464],[367.154,554.702],[367.154,475.654]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[403.209,558.557],[403.209,640.327],[367.154,557.914],[367.154,636.962]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[403.209,642.752],[403.209,724.522],[367.154,639.306],[367.154,718.354]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[403.209,731.921],[403.209,813.691],[367.154,725.507],[367.154,804.555]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[431.83,464.478],[431.83,378.418],[382.206,467.816],[382.206,385.598]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[431.83,556.073],[431.83,470.012],[382.206,555.322],[382.206,473.103]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[431.83,559.57],[431.83,645.631],[382.206,558.663],[382.206,640.882]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[431.83,648.182],[431.83,734.243],[382.206,643.32],[382.206,725.538]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[431.83,742.031],[431.83,828.092],[382.206,732.978],[382.206,815.197]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[431.83,464.478],[431.83,378.418],[454.287,464.92],[454.287,379.368]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[431.83,556.073],[431.83,470.012],[454.287,555.973],[454.287,470.421]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[431.83,559.57],[431.83,645.631],[454.287,559.45],[454.287,645.002]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[431.83,648.182],[431.83,734.243],[454.287,647.539],[454.287,733.091]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[431.83,742.031],[431.83,828.092],[454.287,740.832],[454.287,826.385]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[496.294,462.167],[496.294,373.446],[454.287,464.92],[454.287,379.368]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[496.294,556.593],[496.294,467.872],[454.287,555.973],[454.287,470.421]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[496.294,560.198],[496.294,648.919],[454.287,559.45],[454.287,645.002]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[496.294,651.55],[496.294,740.271],[454.287,647.539],[454.287,733.091]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[496.294,748.299],[496.294,837.02],[454.287,740.832],[454.287,826.385]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[540.834,459.178],[540.834,367.016],[495.226,462.17],[495.226,373.452]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[540.834,557.265],[540.834,465.103],[495.226,556.592],[495.226,467.874]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[540.834,561.01],[540.834,653.172],[495.226,560.197],[495.226,648.915]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[540.834,655.905],[540.834,748.066],[495.226,651.546],[495.226,740.264]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[540.834,756.406],[540.834,848.568],[495.226,748.292],[495.226,837.01]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[581.502,454.41],[581.502,356.761],[517.997,458.682],[517.997,365.95]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[581.502,558.337],[581.502,460.689],[517.997,557.377],[517.997,464.645]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[581.502,562.306],[581.502,659.955],[517.997,561.145],[517.997,653.877]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[581.502,662.85],[581.502,760.498],[517.997,656.627],[517.997,749.359]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[581.502,769.335],[581.502,866.983],[517.997,757.75],[517.997,850.482]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[581.502,454.41],[581.502,356.761],[605.96,454.979],[605.96,357.984]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[581.502,558.338],[581.502,460.689],[605.96,558.21],[605.96,461.215]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[581.502,562.306],[581.502,659.955],[605.96,562.151],[605.96,659.146]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[581.502,662.85],[581.502,760.498],[605.96,662.022],[605.96,759.016]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[581.502,769.335],[581.502,866.984],[605.96,767.793],[605.96,864.787]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[660.726,451.389],[660.726,350.263],[605.96,454.979],[605.96,357.984]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[660.726,559.017],[660.726,457.891],[605.96,558.21],[605.96,461.215]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[660.726,563.127],[660.726,664.253],[605.96,562.151],[605.96,659.146]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[660.726,667.251],[660.726,768.377],[605.96,662.021],[605.96,759.016]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[660.726,777.528],[660.726,878.654],[605.96,767.793],[605.96,864.787]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[661.367,451.405],[661.367,350.298],[715.475,452.737],[715.475,353.162]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[661.367,559.013],[661.367,457.906],[715.475,558.714],[715.475,459.139]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[661.367,563.122],[661.367,664.229],[715.475,562.76],[715.475,662.335]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[661.367,667.227],[661.367,768.334],[715.475,665.288],[715.475,764.862]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[661.367,777.484],[661.367,878.591],[715.475,773.873],[715.475,873.448]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[820.694,440.818],[820.694,327.525],[752.36,445.301],[752.36,337.167]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[820.694,561.395],[820.694,448.102],[752.36,560.387],[752.36,452.254]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[820.694,565.999],[820.694,679.292],[752.36,564.781],[752.36,672.914]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[820.694,682.651],[820.694,795.944],[752.36,676.12],[752.36,784.254]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[820.694,806.196],[820.694,919.489],[752.36,794.039],[752.36,902.172]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[892.144,433.514],[892.144,311.814],[794.713,440.068],[794.713,325.912]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[892.144,563.038],[892.144,441.339],[794.713,561.564],[794.713,447.408]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[892.144,567.984],[892.144,689.683],[794.713,566.203],[794.713,680.359]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[892.144,693.291],[892.144,814.991],[794.713,683.744],[794.713,797.899]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[892.144,826.003],[892.144,947.703],[794.713,808.229],[794.713,922.385]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[832.476,472.363],[832.476,395.377],[850.458,472.717],[850.458,396.138]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[832.476,557.428],[832.476,634.414],[850.458,557.332],[850.458,633.91]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[832.476,636.697],[832.476,713.683],[850.458,636.181],[850.458,712.76]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[892.145,433.514],[892.145,311.814],[919.986,434.395],[919.986,313.711]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[892.145,563.038],[892.145,441.339],[919.986,562.84],[919.986,442.155]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[892.145,567.984],[892.145,689.683],[919.986,567.744],[919.986,688.429]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[892.145,693.291],[892.145,814.991],[919.986,692.007],[919.986,812.692]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[892.145,826.003],[892.145,947.703],[919.986,823.613],[919.986,944.297]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1004.87,428.832],[1004.87,301.743],[919.986,434.395],[919.986,313.711]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1004.87,564.091],[1004.87,437.003],[919.986,562.84],[919.986,442.155]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1004.87,569.256],[1004.87,696.344],[919.986,567.744],[919.986,688.429]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1004.87,700.112],[1004.87,827.2],[919.986,692.007],[919.986,812.692]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1004.87,838.701],[1004.87,965.789],[919.986,823.612],[919.986,944.297]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[989.419,462.338],[989.419,370.517],[1075.26,464.374],[1075.26,374.985]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[989.419,563.795],[989.419,655.616],[1075.26,563.145],[1075.26,652.535]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[989.419,658.338],[989.419,750.16],[1075.26,655.185],[1075.26,744.575]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[989.419,758.468],[989.419,850.29],[1075.26,752.664],[1075.26,842.054]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[989.419,560.063],[989.419,468.242],[1075.26,559.512],[1075.26,470.122]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1100.89,422.538],[1100.89,288.205],[1006.65,428.715],[1006.65,301.493]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1100.89,565.507],[1100.89,431.175],[1006.65,564.118],[1006.65,436.895]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1100.89,570.966],[1100.89,705.299],[1006.65,569.288],[1006.65,696.51]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1100.89,709.281],[1100.89,843.614],[1006.65,700.282],[1006.65,827.504]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1100.89,855.769],[1100.89,990.102],[1006.65,839.017],[1006.65,966.239]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1210.75,412.082],[1210.75,265.715],[1071.57,421.444],[1071.57,285.854]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1210.75,567.859],[1210.75,421.493],[1071.57,565.753],[1071.57,430.163]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1210.75,573.807],[1210.75,720.174],[1071.57,571.263],[1071.57,706.854]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1210.75,724.513],[1210.75,870.88],[1071.57,710.874],[1071.57,846.465]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1210.75,884.125],[1210.75,1030.49],[1071.57,858.734],[1071.57,994.325]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1210.75,412.082],[1210.75,265.715],[1239.97,413.312],[1239.97,268.361]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1210.75,567.859],[1210.75,421.493],[1239.97,567.583],[1239.97,422.632]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1210.75,573.807],[1210.75,720.174],[1239.97,573.473],[1239.97,718.424]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1210.75,724.514],[1210.75,870.88],[1239.97,722.722],[1239.97,867.672]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1210.75,884.125],[1239.97,880.789],[1210.75,1030.49],[1239.97,1025.74]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1364.79,405.123],[1364.79,250.748],[1239.97,413.312],[1239.97,268.361]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1364.79,569.425],[1364.79,415.049],[1239.97,567.583],[1239.97,422.632]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1364.79,575.698],[1364.79,730.073],[1239.97,573.473],[1239.97,718.424]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1364.79,734.65],[1364.79,889.026],[1239.97,722.722],[1239.97,867.672]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1364.79,902.995],[1364.79,1057.37],[1239.97,880.789],[1239.97,1025.74]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1364.78,405.123],[1364.78,250.748],[1595.63,415.924],[1595.63,273.981]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1364.78,569.425],[1364.78,415.049],[1595.63,566.995],[1595.63,425.051]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1364.78,575.698],[1364.78,730.073],[1595.63,572.763],[1595.63,714.707]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1364.78,734.65],[1364.78,889.026],[1595.63,718.915],[1595.63,860.859]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1364.78,902.995],[1364.78,1057.37],[1595.63,873.703],[1595.63,1015.65]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1371.15,451.789],[1371.15,347.375],[1391.64,452.416],[1391.64,348.75]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1371.15,567.16],[1371.15,671.575],[1391.64,566.961],[1391.64,670.627]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1371.15,674.67],[1371.15,779.084],[1391.64,673.701],[1391.64,777.367]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1371.15,788.533],[1371.15,892.947],[1391.64,786.748],[1391.64,890.414]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1657.96,418.841],[1657.96,280.254],[1845.55,427.618],[1845.55,299.133]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1657.96,566.339],[1657.96,427.752],[1845.55,564.364],[1845.55,435.879]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1657.96,571.971],[1657.96,710.558],[1845.55,569.586],[1845.55,698.071]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1657.96,714.667],[1657.96,853.254],[1845.55,701.88],[1845.55,830.365]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1657.96,865.795],[1657.96,1004.38],[1845.55,841.992],[1845.55,970.477]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1715.91,436.211],[1715.91,314.321],[1736.2,437.042],[1736.2,316.136]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1715.91,696.394],[1715.91,818.283],[1736.2,695.126],[1736.2,816.032]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1715.91,829.313],[1715.91,951.202],[1736.2,826.972],[1736.2,947.878]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1715.91,565.937],[1715.91,444.048],[1736.2,565.722],[1736.2,444.816]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:34,
                    verts:[[1715.91,570.891],[1715.91,692.78],[1736.2,570.635],[1736.2,691.541]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[367.565,467.143],[367.565,384.149],[324.09,469.422],[324.09,389.051]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[367.565,555.473],[367.565,472.479],[324.09,554.961],[324.09,474.59]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[367.565,558.846],[367.565,641.84],[324.09,558.227],[324.09,638.598]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[367.565,644.301],[367.565,727.295],[324.09,640.981],[324.09,721.351]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[367.565,734.805],[367.565,817.799],[324.09,728.624],[324.09,808.995]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[406.741,463.485],[406.741,376.28],[346.844,466.693],[346.844,383.18]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[406.741,556.296],[406.741,469.092],[346.844,555.575],[346.844,472.062]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[406.741,559.84],[406.741,647.044],[346.844,558.968],[346.844,642.481]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[406.741,649.63],[406.741,736.834],[346.844,644.957],[346.844,728.469]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[406.741,744.725],[406.741,831.93],[346.844,736.026],[346.844,819.538]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[406.741,463.485],[406.741,376.28],[428.73,463.993],[428.73,377.373]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[406.741,556.296],[406.741,469.092],[428.73,556.182],[428.73,469.562]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[406.741,559.84],[406.741,647.044],[428.73,559.702],[428.73,646.321]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[406.741,649.63],[406.741,736.834],[428.73,648.89],[428.73,735.509]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[406.741,744.725],[406.741,831.93],[428.73,743.348],[428.73,829.967]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[478.938,461.363],[478.938,371.716],[428.729,463.993],[428.729,377.373]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[478.938,556.774],[478.938,467.127],[428.729,556.182],[428.729,469.562]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[478.938,560.417],[478.938,650.063],[428.729,559.702],[428.729,646.321]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[478.938,652.721],[478.938,742.368],[428.729,648.89],[428.729,735.509]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[478.938,750.48],[478.938,840.127],[428.729,743.348],[428.729,829.967]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[532.132,458.516],[532.132,365.593],[477.837,461.362],[477.837,371.715]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[532.132,557.414],[532.132,464.491],[477.837,556.774],[477.837,467.126]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[532.132,561.19],[532.132,654.113],[477.837,560.417],[477.837,650.064]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[532.132,656.868],[532.132,749.791],[477.837,652.722],[477.837,742.369]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[532.132,758.2],[532.132,851.123],[477.837,750.481],[477.837,840.129]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[585.667,453.902],[585.667,355.669],[510.065,457.951],[510.065,364.378]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[585.667,558.452],[585.667,460.218],[510.065,557.541],[510.065,463.968]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[585.667,562.444],[585.667,660.677],[510.065,561.344],[510.065,654.917]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[585.667,663.59],[585.667,761.823],[510.065,657.691],[510.065,751.265]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[585.667,770.713],[585.667,868.946],[510.065,759.732],[510.065,853.306]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[585.667,453.902],[585.667,355.669],[609.065,454.546],[609.065,357.054]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[585.667,558.452],[585.667,460.218],[609.065,558.307],[609.065,460.815]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[585.667,562.444],[585.667,660.677],[609.065,562.269],[609.065,659.761]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[585.667,663.59],[585.667,761.823],[609.065,662.651],[609.065,760.143]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[585.667,770.713],[585.667,868.946],[609.065,768.966],[609.065,866.458]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[673.539,451.169],[673.539,349.79],[609.065,454.546],[609.065,357.054]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[673.539,559.067],[673.539,457.688],[609.065,558.307],[609.065,460.815]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[673.539,563.187],[673.539,664.566],[609.065,562.269],[609.065,659.761]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[673.539,667.571],[673.539,768.951],[609.065,662.651],[609.065,760.143]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[673.539,778.124],[673.539,879.503],[609.065,768.965],[609.065,866.457]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[674.145,451.187],[674.145,349.829],[725.325,452.684],[725.325,353.049]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[674.145,559.063],[674.145,457.704],[725.325,558.726],[725.325,459.09]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[674.145,563.182],[674.145,664.54],[725.325,562.775],[725.325,662.41]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[674.145,667.545],[674.145,768.903],[725.325,665.364],[725.325,765]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[674.145,778.075],[674.145,879.433],[725.325,774.016],[725.325,873.651]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[860.161,441.32],[860.161,328.605],[780.87,445.477],[780.87,337.546]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[860.161,561.282],[860.161,448.567],[780.87,560.347],[780.87,452.416]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[860.161,565.863],[860.161,678.578],[780.87,564.733],[780.87,672.664]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[860.161,681.919],[860.161,794.634],[780.87,675.864],[780.87,783.795]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[860.161,804.834],[860.161,917.549],[780.87,793.562],[780.87,901.492]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[793.805,472.429],[793.805,395.52],[810.922,472.825],[810.922,396.37]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[793.805,557.41],[793.805,634.319],[810.922,557.302],[810.922,633.757]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[793.805,636.6],[793.805,713.509],[810.922,636.023],[810.922,712.478]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[793.805,720.469],[793.805,797.379],[810.922,719.396],[810.922,795.851]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[948.918,434.448],[948.918,313.823],[836.143,440.487],[836.143,326.814]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[948.918,562.828],[948.918,442.204],[836.143,561.469],[836.143,447.796]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[948.918,567.73],[948.918,688.355],[836.143,566.089],[836.143,679.762]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[948.918,691.931],[948.918,812.556],[836.143,683.132],[836.143,796.805]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[948.918,823.471],[948.918,944.096],[836.143,807.092],[836.143,920.765]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[948.918,434.448],[948.918,313.823],[974.239,435.417],[974.239,315.909]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[948.918,562.828],[948.918,442.204],[974.239,562.61],[974.239,443.102]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[948.918,567.73],[948.918,688.355],[974.239,567.467],[974.239,686.975]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[948.918,691.931],[948.918,812.556],[974.239,690.518],[974.239,810.027]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[948.918,823.471],[948.918,944.096],[974.239,820.841],[974.239,940.35]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1071.1,430.344],[1071.1,304.995],[974.239,435.417],[974.239,315.909]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1071.1,563.751],[1071.1,438.403],[974.239,562.61],[974.239,443.102]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1071.1,568.845],[1071.1,694.193],[974.239,567.467],[974.239,686.975]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1071.1,697.91],[1071.1,823.258],[974.239,690.518],[974.239,810.027]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1071.1,834.601],[1071.1,959.949],[974.239,820.841],[974.239,940.35]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[981.543,463.012],[981.543,371.996],[1060.84,465.248],[1060.84,376.901]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[981.543,563.579],[981.543,654.596],[1060.84,562.866],[1060.84,651.213]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[981.543,657.294],[981.543,748.311],[1060.84,653.833],[1060.84,742.18]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[981.543,756.547],[981.543,847.564],[1060.84,750.174],[1060.84,838.521]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1179.75,424.652],[1179.75,292.754],[1073.12,430.238],[1073.12,304.768]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1179.75,565.032],[1179.75,433.133],[1073.12,563.775],[1073.12,438.305]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1179.75,570.392],[1179.75,702.29],[1073.12,568.874],[1073.12,694.344]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1179.75,706.201],[1179.75,838.099],[1073.12,698.064],[1073.12,823.534]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1179.75,850.035],[1179.75,981.933],[1073.12,834.888],[1073.12,960.358]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1310.53,415.081],[1310.53,272.166],[1153.89,423.47],[1153.89,290.21]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1310.53,567.185],[1310.53,424.27],[1153.89,565.297],[1153.89,432.038]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1310.53,572.992],[1310.53,715.907],[1153.89,570.713],[1153.89,703.972]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1310.53,720.144],[1310.53,863.059],[1153.89,707.923],[1153.89,841.183]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1310.53,875.991],[1310.53,1018.91],[1153.89,853.241],[1153.89,986.501]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1310.53,415.081],[1310.53,272.166],[1335.64,416.394],[1335.64,274.99]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1310.53,567.185],[1310.53,424.27],[1335.64,566.889],[1335.64,425.486]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1310.53,572.992],[1310.53,715.907],[1335.64,572.636],[1335.64,714.039]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1310.53,720.144],[1310.53,863.059],[1335.64,718.232],[1335.64,859.635]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1310.53,875.991],[1310.53,1018.91],[1335.64,872.431],[1335.64,1013.83]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1473.64,409.16],[1473.64,259.431],[1335.64,416.394],[1335.64,274.991]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1473.64,568.517],[1473.64,418.787],[1335.64,566.889],[1335.64,425.486]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1473.64,574.601],[1473.64,724.331],[1335.64,572.636],[1335.64,714.039]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1473.64,728.77],[1473.64,878.499],[1335.64,718.232],[1335.64,859.635]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1473.64,892.048],[1473.64,1041.78],[1335.64,872.43],[1335.64,1013.83]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1378.49,453.92],[1378.49,352.049],[1396.54,454.588],[1396.54,353.514]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1378.49,566.481],[1378.49,668.352],[1396.54,566.268],[1396.54,667.341]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1378.49,671.372],[1378.49,773.243],[1396.54,670.338],[1396.54,771.412]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1378.49,782.461],[1378.49,884.332],[1396.54,780.558],[1396.54,881.632]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1473.64,409.16],[1473.64,259.431],[1665.9,420.468],[1665.9,283.753]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1473.64,568.517],[1473.64,418.787],[1665.9,565.973],[1665.9,429.258]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1473.64,574.601],[1473.64,724.331],[1665.9,571.529],[1665.9,708.243]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1473.64,728.77],[1473.64,878.499],[1665.9,712.297],[1665.9,849.011]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1473.64,892.048],[1473.64,1041.78],[1665.9,861.382],[1665.9,998.097]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1717.35,423.494],[1717.35,290.263],[1871.05,432.534],[1871.05,309.707]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1717.35,565.292],[1717.35,432.061],[1871.05,563.259],[1871.05,440.432]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1717.35,570.706],[1717.35,703.938],[1871.05,568.25],[1871.05,691.077]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1717.35,707.888],[1717.35,841.12],[1871.05,694.719],[1871.05,817.546]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1717.35,853.176],[1717.35,986.407],[1871.05,828.661],[1871.05,951.488]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1738.39,440.202],[1738.39,323.034],[1755.3,441.062],[1755.3,324.912]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1738.39,569.665],[1738.39,686.833],[1755.3,569.401],[1755.3,685.551]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1738.39,690.307],[1738.39,807.474],[1755.3,688.995],[1755.3,805.145]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:35,
                    verts:[[1738.39,818.077],[1738.39,935.245],[1755.3,815.655],[1755.3,931.805]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[335.614,466.021],[335.614,381.735],[284.622,468.193],[284.622,386.409]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[335.614,555.726],[335.614,471.44],[284.622,555.237],[284.622,473.452]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[335.614,559.151],[335.614,643.437],[284.622,558.561],[284.622,640.346]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[335.614,645.936],[335.614,730.221],[284.622,642.77],[284.622,724.555]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[335.614,737.848],[335.614,822.134],[284.622,731.956],[284.622,813.741]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[385.506,462.462],[385.506,374.081],[315.304,465.51],[315.304,380.637]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[385.506,556.526],[385.506,468.145],[315.304,555.841],[315.304,470.967]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[385.506,560.118],[385.506,648.499],[315.304,559.29],[315.304,644.163]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[385.506,651.12],[385.506,739.501],[315.304,646.679],[315.304,731.553]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[385.506,747.499],[385.506,835.88],[315.304,739.233],[315.304,824.106]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[385.506,462.462],[385.506,374.081],[406.867,463.035],[406.867,375.313]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[385.506,556.526],[385.506,468.145],[406.867,556.397],[406.867,468.675]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[385.506,560.118],[385.506,648.499],[406.867,559.962],[406.867,647.684]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[385.506,651.12],[385.506,739.501],[406.867,650.285],[406.867,738.007]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[385.506,747.499],[385.506,835.88],[406.867,745.945],[406.867,833.668]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[465.172,460.552],[465.172,369.973],[406.867,463.035],[406.867,375.313]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[465.172,556.956],[465.172,466.376],[406.867,556.397],[406.867,468.675]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[465.172,560.637],[465.172,651.216],[406.867,559.962],[406.867,647.684]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[465.172,653.902],[465.172,744.482],[406.867,650.285],[406.867,738.007]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[465.172,752.678],[465.172,843.258],[406.867,745.945],[406.867,833.668]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[526.806,457.874],[526.806,364.212],[464.045,460.548],[464.045,369.964]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[526.806,557.558],[526.806,463.896],[464.045,556.957],[464.045,466.373]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[526.806,561.365],[526.806,655.026],[464.045,560.638],[464.045,651.222]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[526.806,657.803],[526.806,751.465],[464.045,653.908],[464.045,744.492]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[526.806,759.941],[526.806,853.603],[464.045,752.689],[464.045,843.272]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[592.93,453.456],[592.93,354.709],[505.701,457.243],[505.701,362.855]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[592.93,558.552],[592.93,459.805],[505.701,557.7],[505.701,463.312]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[592.93,562.565],[592.93,661.312],[505.701,561.536],[505.701,655.924]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[592.93,664.24],[592.93,762.987],[505.701,658.723],[505.701,753.111]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[592.93,771.923],[592.93,870.67],[505.701,761.652],[505.701,856.04]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[592.93,453.456],[592.93,354.709],[615.049,454.17],[615.049,356.246]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[592.93,558.552],[592.93,459.805],[615.049,558.391],[615.049,460.467]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[592.93,562.565],[592.93,661.312],[615.049,562.371],[615.049,660.296]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[592.93,664.24],[592.93,762.987],[615.049,663.199],[615.049,761.124]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[592.93,771.923],[592.93,870.67],[615.049,769.985],[615.049,867.91]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[688.652,451.036],[688.652,349.504],[615.048,454.17],[615.048,356.246]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[688.652,559.096],[688.652,457.565],[615.048,558.391],[615.048,460.467]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[688.652,563.223],[688.652,664.755],[615.048,562.371],[615.048,660.296]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[688.652,667.765],[688.652,769.297],[615.048,663.199],[615.048,761.124]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[688.652,778.485],[688.652,880.017],[615.048,769.985],[615.048,867.91]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[689.218,451.056],[689.218,349.547],[736.992,452.702],[736.992,353.088]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[689.218,559.092],[689.218,457.583],[736.992,558.722],[736.992,459.107]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[689.218,563.217],[689.218,664.726],[736.992,562.77],[736.992,662.384]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[689.218,667.736],[689.218,769.245],[736.992,665.338],[736.992,764.952]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[689.218,778.43],[689.218,879.939],[736.992,773.966],[736.992,873.58]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[756.848,472.421],[756.848,395.501],[773.043,472.855],[773.043,396.435]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[756.848,554.286],[756.848,477.366],[773.043,554.188],[773.043,477.769]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[756.848,557.412],[756.848,634.332],[773.043,557.294],[773.043,633.714]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[756.848,636.612],[756.848,713.532],[773.043,635.98],[773.043,712.399]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[756.848,720.492],[756.848,797.412],[773.043,719.315],[773.043,795.734]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[899.481,441.995],[899.481,330.057],[810.407,445.79],[810.407,338.22]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[899.481,561.13],[899.481,449.192],[810.407,560.277],[810.407,452.707]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[899.481,565.679],[899.481,677.617],[810.407,564.648],[810.407,672.218]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[899.481,680.936],[899.481,792.874],[810.407,675.407],[810.407,782.977]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[899.481,803.004],[899.481,914.942],[810.407,792.711],[810.407,900.281]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1003.79,435.616],[1003.79,316.337],[877.678,441.092],[877.678,328.115]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1003.79,562.565],[1003.79,443.286],[877.678,561.333],[877.678,448.357]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1003.79,567.413],[1003.79,686.692],[877.678,565.925],[877.678,678.901]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1003.79,690.228],[1003.79,809.508],[877.678,682.251],[877.678,795.228]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1003.79,820.302],[1003.79,939.581],[877.678,805.451],[877.678,918.428]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[972.029,468.339],[972.029,383.682],[988.304,468.846],[988.304,384.794]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[972.029,561.88],[972.029,646.537],[988.304,561.718],[988.304,645.77]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[972.029,649.047],[972.029,733.704],[988.304,648.262],[988.304,732.314]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[972.029,741.365],[972.029,826.022],[988.304,739.92],[988.304,823.972]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[973.755,463.67],[973.755,373.44],[1046.22,466.078],[1046.22,378.722]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[973.755,563.369],[973.755,653.6],[1046.22,562.601],[1046.22,649.958]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[973.755,656.275],[973.755,746.506],[1046.22,652.548],[1046.22,739.904]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[973.755,754.671],[973.755,844.901],[1046.22,747.809],[1046.22,835.165]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1003.79,435.616],[1003.79,316.337],[1026.34,436.657],[1026.34,318.575]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1003.79,562.565],[1003.79,443.286],[1026.34,562.331],[1026.34,444.25]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1003.79,567.413],[1003.79,686.692],[1026.34,567.13],[1026.34,685.211]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1003.79,690.228],[1003.79,809.508],[1026.34,688.712],[1026.34,806.794]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1003.79,820.302],[1003.79,939.581],[1026.34,817.479],[1026.34,935.561]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1133.19,432.107],[1133.19,308.789],[1026.34,436.657],[1026.34,318.575]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1133.19,563.355],[1133.19,440.036],[1026.34,562.331],[1026.34,444.25]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1133.19,568.366],[1133.19,691.684],[1026.34,567.13],[1026.34,685.211]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1133.19,695.341],[1133.19,818.659],[1026.34,688.712],[1026.34,806.794]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1133.19,829.818],[1133.19,953.136],[1026.34,817.479],[1026.34,935.561]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1251.96,427.05],[1251.96,297.911],[1135.41,432.013],[1135.41,308.586]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1251.96,564.492],[1251.96,435.353],[1135.41,563.376],[1135.41,439.949]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1251.96,569.74],[1251.96,698.879],[1135.41,568.392],[1135.41,691.818]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1251.96,702.708],[1251.96,831.846],[1135.41,695.478],[1135.41,818.905]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1251.96,843.532],[1251.96,972.671],[1135.41,830.074],[1135.41,953.501]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1399.72,418.426],[1399.72,279.361],[1229.78,425.804],[1229.78,295.231]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1399.72,566.432],[1399.72,427.367],[1229.78,564.772],[1229.78,434.2]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1399.72,572.084],[1399.72,711.149],[1229.78,570.079],[1229.78,700.651]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1399.72,715.272],[1399.72,854.337],[1229.78,704.523],[1229.78,835.095]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1399.72,866.921],[1399.72,1005.99],[1229.78,846.911],[1229.78,977.484]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1381.84,455.999],[1381.84,356.611],[1397.49,456.697],[1397.49,358.141]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1381.84,565.817],[1381.84,665.206],[1397.49,565.595],[1397.49,664.15]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1381.84,668.152],[1381.84,767.541],[1397.49,667.072],[1397.49,765.628]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1381.84,776.535],[1381.84,875.923],[1397.49,774.546],[1397.49,873.101]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1399.72,418.426],[1399.72,279.361],[1420.6,419.79],[1420.6,282.296]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1399.72,566.432],[1399.72,427.367],[1420.6,566.125],[1420.6,428.631]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1399.72,572.084],[1399.72,711.149],[1420.6,571.713],[1420.6,709.207]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1399.72,715.272],[1399.72,854.337],[1420.6,713.284],[1420.6,850.778]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1399.72,866.921],[1399.72,1005.99],[1420.6,863.22],[1420.6,1000.71]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1567.79,413.519],[1567.79,268.806],[1420.6,419.79],[1420.6,282.296]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1567.79,567.536],[1567.79,422.823],[1420.6,566.125],[1420.6,428.631]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1567.79,573.417],[1567.79,718.129],[1420.6,571.713],[1420.6,709.207]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1567.79,722.42],[1567.79,867.133],[1420.6,713.284],[1420.6,850.778]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1567.79,880.228],[1567.79,1024.94],[1420.6,863.22],[1420.6,1000.71]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1567.79,413.519],[1567.79,268.806],[1722.09,425.059],[1722.09,293.629]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1567.79,567.536],[1567.79,422.824],[1722.09,564.94],[1722.09,433.51]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1567.79,573.417],[1567.79,718.129],[1722.09,570.281],[1722.09,701.711]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1567.79,722.42],[1567.79,867.133],[1722.09,705.608],[1722.09,837.038]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1567.79,880.228],[1567.79,1024.94],[1722.09,848.931],[1722.09,980.361]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1751.42,444.05],[1751.42,331.435],[1765.15,444.923],[1765.15,333.34]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1751.42,563.907],[1751.42,451.291],[1765.15,563.681],[1765.15,452.098]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1751.42,568.483],[1751.42,681.099],[1765.15,568.215],[1765.15,679.799]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1751.42,684.438],[1751.42,797.053],[1765.15,683.107],[1765.15,794.691]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1751.42,807.244],[1751.42,919.86],[1765.15,804.788],[1765.15,916.371]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1763.11,428.127],[1763.11,300.227],[1884.94,437.239],[1884.94,319.826]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1763.11,564.25],[1763.11,436.351],[1884.94,562.2],[1884.94,444.788]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1763.11,569.448],[1763.11,697.347],[1884.94,566.972],[1884.94,684.384]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1763.11,701.139],[1763.11,829.039],[1884.94,687.865],[1884.94,805.277]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:36,
                    verts:[[1763.11,840.612],[1763.11,968.512],[1884.94,815.902],[1884.94,933.315]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[307.449,464.835],[307.449,379.186],[248.876,466.882],[248.876,383.587]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[307.449,555.992],[307.449,470.343],[248.876,555.532],[248.876,472.237]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[307.449,559.473],[307.449,645.123],[248.876,558.917],[248.876,642.212]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[307.449,647.662],[307.449,733.312],[248.876,644.681],[248.876,727.976]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[307.449,741.062],[307.449,826.712],[248.876,735.513],[248.876,818.808]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[368.157,461.406],[368.157,371.809],[287.684,464.265],[287.684,377.959]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[368.157,556.764],[368.157,467.167],[287.684,556.121],[287.684,469.815]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[368.157,560.405],[368.157,650.002],[287.684,559.628],[287.684,645.934]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[368.157,652.658],[368.157,742.255],[287.684,648.493],[287.684,734.799]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[368.157,750.363],[368.157,839.96],[287.684,742.609],[287.684,828.915]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[368.157,461.406],[368.157,371.809],[388.731,462.042],[388.731,373.177]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[368.157,556.764],[368.157,467.167],[388.731,556.621],[388.731,467.756]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[368.157,560.405],[368.157,650.002],[388.731,560.232],[388.731,649.097]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[368.157,652.658],[368.157,742.255],[388.731,651.732],[388.731,740.597]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[368.157,750.363],[368.157,839.96],[388.731,748.639],[388.731,837.504]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[454.967,459.729],[454.967,368.202],[388.73,462.042],[388.73,373.177]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[454.967,557.141],[454.967,465.614],[388.73,556.621],[388.73,467.756]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[454.967,560.86],[454.967,652.387],[388.73,560.232],[388.73,649.097]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[454.967,655.101],[454.967,746.628],[388.73,651.732],[388.73,740.597]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[454.967,754.91],[454.967,846.437],[388.73,748.639],[388.73,837.504]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[524.754,457.244],[524.754,362.857],[453.82,459.722],[453.82,368.187]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[524.754,557.7],[524.754,463.313],[453.82,557.143],[453.82,465.608]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[524.754,561.536],[524.754,655.923],[453.82,560.862],[453.82,652.397]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[524.754,658.721],[524.754,753.108],[453.82,655.111],[453.82,746.646]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[524.754,761.649],[524.754,856.037],[453.82,754.929],[453.82,846.464]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[603.059,453.059],[603.059,353.856],[504.792,456.551],[504.792,361.366]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[603.059,558.641],[603.059,459.438],[504.792,557.856],[504.792,462.671]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[603.059,562.673],[603.059,661.876],[504.792,561.724],[504.792,656.909]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[603.059,664.817],[603.059,764.021],[504.792,659.731],[504.792,754.915]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[603.059,772.998],[603.059,872.201],[504.792,763.529],[504.792,858.714]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[603.059,453.059],[603.059,353.856],[623.696,453.838],[623.696,355.531]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[603.059,558.641],[603.059,459.438],[623.696,558.466],[623.696,460.159]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[603.059,562.673],[603.059,661.876],[623.696,562.461],[623.696,660.768]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[603.059,664.817],[603.059,764.021],[623.696,663.683],[623.696,761.99]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[603.059,772.998],[603.059,872.201],[623.696,770.886],[623.696,869.192]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[705.76,450.973],[705.76,349.369],[623.696,453.838],[623.696,355.531]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[705.76,559.111],[705.76,457.506],[623.696,558.466],[623.696,460.159]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[705.76,563.24],[705.76,664.844],[623.696,562.461],[623.696,660.768]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[705.76,667.857],[705.76,769.461],[623.696,663.683],[623.696,761.99]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[705.76,778.655],[705.76,880.26],[623.696,770.885],[623.696,869.192]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[706.28,450.995],[706.28,349.415],[750.233,452.774],[750.233,353.241]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[706.28,559.106],[706.28,457.526],[750.233,558.706],[750.233,459.173]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[706.28,563.234],[706.28,664.813],[750.233,562.75],[750.233,662.283]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[706.28,667.825],[706.28,769.405],[750.233,665.234],[750.233,764.766]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[706.28,778.597],[706.28,880.176],[750.233,773.773],[750.233,873.305]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[721.678,472.332],[721.678,395.309],[736.9,472.802],[736.9,396.321]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[721.678,557.436],[721.678,634.458],[736.9,557.308],[736.9,633.789]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[721.678,636.742],[721.678,713.764],[736.9,636.057],[736.9,712.537]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[721.678,720.734],[721.678,797.756],[736.9,719.458],[736.9,795.939]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[938.117,442.803],[938.117,331.796],[840.521,446.213],[840.521,339.13]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[938.117,560.948],[938.117,449.941],[840.521,560.181],[840.521,453.098]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[938.117,565.46],[938.117,676.467],[840.521,564.533],[840.521,671.616]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[938.117,679.758],[938.117,790.766],[840.521,674.791],[840.521,781.875]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[938.117,800.811],[938.117,911.818],[840.521,791.565],[840.521,898.648]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1056.08,436.963],[1056.08,319.234],[918.719,441.844],[918.719,329.731]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1056.08,562.262],[1056.08,444.533],[918.719,561.164],[918.719,449.052]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1056.08,567.047],[1056.08,684.776],[918.719,565.721],[918.719,677.833]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1056.08,688.267],[1056.08,805.996],[918.719,681.157],[918.719,793.269]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1056.08,816.649],[1056.08,934.379],[918.719,803.414],[918.719,915.526]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[952.753,468.873],[952.753,384.853],[967.576,469.412],[967.576,386.036]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[952.753,561.709],[952.753,645.729],[967.576,561.537],[967.576,644.913]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[952.753,648.22],[952.753,732.24],[967.576,647.385],[967.576,730.761]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[952.753,739.843],[952.753,823.862],[967.576,738.306],[967.576,821.681]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[966.116,464.297],[966.116,374.815],[1031.55,466.85],[1031.55,380.416]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[966.116,563.169],[966.116,652.652],[1031.55,562.355],[1031.55,648.789]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[966.116,655.305],[966.116,744.787],[1031.55,651.352],[1031.55,737.786]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[966.116,752.884],[966.116,842.367],[1031.55,745.607],[1031.55,832.042]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1056.08,436.963],[1056.08,319.234],[1075.68,438.058],[1075.68,321.589]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1056.08,562.262],[1056.08,444.533],[1075.68,562.016],[1075.68,445.547]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1056.08,567.047],[1056.08,684.776],[1075.68,566.749],[1075.68,683.218]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1056.08,688.267],[1056.08,805.996],[1075.68,686.671],[1075.68,803.141]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1056.08,816.649],[1056.08,934.379],[1075.68,813.68],[1075.68,930.149]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1190.52,434.048],[1190.52,312.964],[1075.68,438.058],[1075.68,321.589]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1190.52,562.918],[1190.52,441.834],[1075.68,562.016],[1075.68,445.547]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1190.52,567.839],[1190.52,688.923],[1075.68,566.749],[1075.68,683.218]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1190.52,692.513],[1190.52,813.597],[1075.68,686.671],[1075.68,803.141]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1190.52,824.554],[1190.52,945.638],[1075.68,813.68],[1075.68,930.149]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1316.96,429.634],[1316.96,303.469],[1192.9,433.965],[1192.9,312.786]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1316.96,563.911],[1316.96,437.746],[1192.9,562.937],[1192.9,441.757]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1316.96,569.038],[1316.96,695.203],[1192.9,567.861],[1192.9,689.04]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1316.96,698.944],[1316.96,825.108],[1192.9,692.633],[1192.9,813.813]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1316.96,836.525],[1316.96,962.69],[1192.9,824.778],[1192.9,945.958]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1477.84,421.977],[1477.84,287],[1298.54,428.348],[1298.54,300.703]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1477.84,565.633],[1477.84,430.656],[1298.54,564.2],[1298.54,436.555]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1477.84,571.119],[1477.84,706.096],[1298.54,569.388],[1298.54,697.033]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1477.84,710.098],[1477.84,845.076],[1298.54,700.817],[1298.54,828.462]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1477.84,857.29],[1477.84,992.267],[1298.54,840.013],[1298.54,967.658]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1381.7,457.996],[1381.7,360.991],[1395,458.714],[1395,362.567]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1381.7,565.18],[1381.7,662.185],[1395,564.951],[1395,661.098]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1381.7,665.061],[1381.7,762.065],[1395,663.949],[1395,760.096]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1381.7,770.843],[1381.7,867.848],[1395,768.797],[1395,864.944]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1477.84,421.977],[1477.84,287],[1494.53,423.366],[1494.53,289.986]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1477.84,565.633],[1477.84,430.656],[1494.53,565.321],[1494.53,431.942]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1477.84,571.119],[1477.84,706.096],[1494.53,570.741],[1494.53,704.12]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1477.84,710.098],[1477.84,845.076],[1494.53,708.075],[1494.53,841.454]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1477.84,857.29],[1477.84,992.267],[1494.53,853.524],[1494.53,986.903]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1647.31,418.028],[1647.31,278.506],[1494.53,423.366],[1494.53,289.987]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1647.31,566.522],[1647.31,426.999],[1494.53,565.321],[1494.53,431.942]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1647.31,572.192],[1647.31,711.714],[1494.53,570.741],[1494.53,704.12]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1647.31,715.851],[1647.31,855.373],[1494.53,708.075],[1494.53,841.454]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1647.31,867.998],[1647.31,1007.52],[1494.53,853.524],[1494.53,986.903]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1647.31,418.028],[1647.31,278.506],[1765.43,429.578],[1765.43,303.348]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1647.31,566.522],[1647.31,426.999],[1765.43,563.924],[1765.43,437.694]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1647.31,572.192],[1647.31,711.714],[1765.43,569.053],[1765.43,695.283]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1647.31,715.851],[1647.31,855.373],[1765.43,699.026],[1765.43,825.255]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1647.31,867.998],[1647.31,1007.52],[1765.43,836.678],[1765.43,962.907]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1756.4,447.702],[1756.4,339.406],[1767.17,448.574],[1767.17,341.309]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1756.4,567.362],[1756.4,675.658],[1767.17,567.094],[1767.17,674.359]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1756.4,678.869],[1756.4,787.165],[1767.17,677.539],[1767.17,784.804]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1756.4,796.965],[1756.4,905.261],[1767.17,794.511],[1767.17,901.775]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1756.4,562.961],[1756.4,454.665],[1767.17,562.735],[1767.17,455.471]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1796.67,432.633],[1796.67,309.919],[1889.1,441.671],[1889.1,329.36]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1796.67,563.236],[1796.67,440.523],[1889.1,561.203],[1889.1,448.892]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1796.67,568.223],[1796.67,690.936],[1889.1,565.767],[1889.1,678.078]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1796.67,694.575],[1796.67,817.288],[1889.1,681.408],[1889.1,793.719]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:37,
                    verts:[[1796.67,828.393],[1796.67,951.106],[1889.1,803.882],[1889.1,916.193]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[283.107,463.581],[283.107,376.488],[216.922,465.481],[216.922,380.573]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[283.107,556.275],[283.107,469.181],[216.922,555.847],[216.922,470.94]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[283.107,559.814],[283.107,646.907],[216.922,559.298],[216.922,644.205]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[283.107,649.489],[283.107,736.583],[216.922,646.722],[216.922,731.63]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[283.107,744.464],[283.107,831.557],[216.922,739.313],[216.922,824.22]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[354.672,460.31],[354.672,369.452],[264.027,462.952],[264.027,375.135]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[354.672,557.01],[354.672,466.152],[264.027,556.416],[264.027,468.599]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[354.672,560.703],[354.672,651.561],[264.027,559.985],[264.027,647.802]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[354.672,654.255],[354.672,745.113],[264.027,650.406],[264.027,738.223]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[354.672,753.335],[354.672,844.193],[264.027,746.17],[264.027,833.987]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[354.672,460.31],[354.672,369.452],[374.298,461.007],[374.298,370.951]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[354.672,557.01],[354.672,466.152],[374.298,556.854],[374.298,466.797]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[354.672,560.703],[354.672,651.561],[374.298,560.513],[374.298,650.569]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[354.672,654.255],[354.672,745.113],[374.298,653.24],[374.298,743.296]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[354.672,753.335],[354.672,844.193],[374.298,751.445],[374.298,841.501]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[448.243,458.886],[448.243,366.389],[374.297,461.007],[374.297,370.951]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[448.243,557.331],[448.243,464.834],[374.297,556.854],[374.297,466.797]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[448.243,561.09],[448.243,653.587],[374.297,560.513],[374.297,650.569]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[448.243,656.329],[448.243,748.826],[374.297,653.24],[374.297,743.296]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[448.243,757.196],[448.243,849.694],[374.297,751.445],[374.297,841.501]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[525.833,456.616],[525.833,361.505],[447.084,458.876],[447.084,366.366]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[525.833,557.841],[525.833,462.731],[447.084,557.333],[447.084,464.824]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[525.833,561.707],[525.833,656.817],[447.084,561.092],[447.084,653.602]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[525.833,659.637],[525.833,754.747],[447.084,656.345],[447.084,748.854]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[525.833,763.354],[525.833,858.464],[447.084,757.225],[447.084,849.734]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[615.802,452.699],[615.802,353.081],[507.186,455.865],[507.186,359.89]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[615.802,558.723],[615.802,459.104],[507.186,558.01],[507.186,462.036]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[615.802,562.771],[615.802,662.389],[507.186,561.911],[507.186,657.885]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[615.802,665.343],[615.802,764.961],[507.186,660.731],[507.186,756.705]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[615.802,773.975],[615.802,873.594],[507.186,765.39],[507.186,861.364]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[615.802,452.699],[615.802,353.081],[634.777,453.536],[634.777,354.881]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[615.802,558.723],[615.802,459.104],[634.777,558.534],[634.777,459.879]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[615.802,562.771],[615.802,662.389],[634.777,562.543],[634.777,661.198]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[615.802,665.343],[615.802,764.961],[634.777,664.123],[634.777,762.778]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[615.802,773.975],[615.802,873.594],[634.777,771.706],[634.777,870.361]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[724.561,450.961],[724.561,349.342],[634.777,453.536],[634.777,354.881]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[724.561,559.113],[724.561,457.495],[634.777,558.534],[634.777,459.879]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[724.561,563.243],[724.561,664.862],[634.777,562.543],[634.777,661.198]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[724.561,667.875],[724.561,769.494],[634.777,664.123],[634.777,762.778]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[724.561,778.689],[724.561,880.308],[634.777,771.706],[634.777,870.36]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[688.32,472.156],[688.32,394.933],[702.516,472.66],[702.516,396.017]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[688.32,557.484],[688.32,634.708],[702.516,557.347],[702.516,633.99]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[688.32,636.997],[688.32,714.221],[702.516,636.263],[702.516,712.906]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[688.32,721.209],[688.32,798.433],[702.516,719.842],[702.516,796.486]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[725.031,450.984],[725.031,349.392],[764.811,452.879],[764.811,353.467]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[725.031,559.108],[725.031,457.516],[764.811,558.682],[764.811,459.271]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[725.031,563.237],[725.031,664.829],[764.811,562.722],[764.811,662.133]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[725.031,667.841],[725.031,769.433],[764.811,665.081],[764.811,764.492]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[725.031,778.627],[725.031,880.219],[764.811,773.488],[764.811,872.899]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[975.646,443.707],[975.646,333.74],[870.821,446.715],[870.821,340.21]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[975.646,560.745],[975.646,450.778],[870.821,560.068],[870.821,453.563]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[975.646,565.214],[975.646,675.181],[870.821,564.397],[870.821,670.902]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[975.646,678.442],[975.646,788.409],[870.821,674.06],[870.821,780.565]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[975.646,798.36],[975.646,908.328],[870.821,790.202],[870.821,896.707]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[934.091,469.337],[934.091,385.872],[947.431,469.905],[947.431,387.117]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[934.091,561.561],[934.091,645.026],[947.431,561.38],[947.431,644.168]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[934.091,647.501],[934.091,730.966],[947.431,646.623],[947.431,729.411]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[934.091,738.519],[934.091,821.984],[947.431,736.902],[947.431,819.69]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[958.673,464.878],[958.673,376.088],[1016.93,467.553],[1016.93,381.958]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[958.673,562.984],[958.673,651.773],[1016.93,562.13],[1016.93,647.726]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[958.673,654.406],[958.673,743.195],[1016.93,650.264],[1016.93,735.859]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[958.673,751.23],[958.673,840.019],[1016.93,743.604],[1016.93,829.2]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1105.28,438.432],[1105.28,322.394],[958.787,442.702],[958.787,331.578]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1105.28,561.932],[1105.28,445.893],[958.787,560.971],[958.787,449.847]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1105.28,566.647],[1105.28,682.686],[958.787,565.487],[958.787,676.611]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1105.28,686.126],[1105.28,802.165],[958.787,679.906],[958.787,791.031]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1105.28,812.665],[1105.28,928.704],[958.787,801.086],[958.787,912.21]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1105.28,438.432],[1105.28,322.394],[1121.84,439.566],[1121.84,324.832]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1105.28,561.932],[1105.28,445.893],[1121.84,561.677],[1121.84,446.943]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1105.28,566.647],[1105.28,682.686],[1121.84,566.339],[1121.84,681.073]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1105.28,686.126],[1105.28,802.165],[1121.84,684.475],[1121.84,799.208]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1105.28,812.665],[1105.28,928.704],[1121.84,809.591],[1121.84,924.324]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1242.76,436.098],[1242.76,317.372],[1121.84,439.566],[1121.84,324.832]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1242.76,562.457],[1242.76,443.732],[1121.84,561.677],[1121.84,446.943]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1242.76,567.282],[1242.76,686.007],[1121.84,566.339],[1121.84,681.073]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1242.76,689.527],[1242.76,808.253],[1121.84,684.475],[1121.84,799.208]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1242.76,818.996],[1242.76,937.721],[1121.84,809.591],[1121.84,924.324]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1374.6,432.316],[1374.6,309.239],[1245.25,436.026],[1245.25,317.219]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1374.6,563.308],[1374.6,440.23],[1245.25,562.473],[1245.25,443.665]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1374.6,568.309],[1374.6,691.387],[1245.25,567.301],[1245.25,686.109]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1374.6,695.036],[1374.6,818.113],[1245.25,689.631],[1245.25,808.439]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1374.6,829.25],[1374.6,952.328],[1245.25,819.19],[1245.25,937.997]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1545.01,425.615],[1545.01,294.825],[1359.9,431.011],[1359.9,306.43]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1545.01,564.815],[1545.01,434.025],[1359.9,563.601],[1359.9,439.021]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1545.01,570.13],[1545.01,700.92],[1359.9,568.664],[1359.9,693.244]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1545.01,704.798],[1545.01,835.588],[1359.9,696.938],[1359.9,821.518]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1545.01,847.423],[1545.01,978.213],[1359.9,832.792],[1359.9,957.372]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1378.53,459.886],[1378.53,365.139],[1389.57,460.617],[1389.57,366.741]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1378.53,564.577],[1378.53,659.325],[1389.57,564.344],[1389.57,658.22]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1378.53,662.134],[1378.53,756.882],[1389.57,661.003],[1389.57,754.879]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1378.53,765.455],[1378.53,860.203],[1389.57,763.374],[1389.57,857.25]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1545.01,425.615],[1545.01,294.825],[1557.64,427.005],[1557.64,297.815]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1545.01,564.815],[1545.01,434.025],[1557.64,564.502],[1557.64,435.312]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1545.01,570.13],[1545.01,700.92],[1557.64,569.752],[1557.64,698.943]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1545.01,704.798],[1545.01,835.588],[1557.64,702.773],[1557.64,831.964]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1545.01,847.423],[1545.01,978.213],[1557.64,843.654],[1557.64,972.844]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1712.95,422.548],[1712.95,288.228],[1557.64,427.005],[1557.64,297.815]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1712.95,565.505],[1712.95,431.185],[1557.64,564.502],[1557.64,435.312]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1712.95,570.963],[1712.95,705.284],[1557.64,569.752],[1557.64,698.943]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1712.95,709.266],[1712.95,843.586],[1557.64,702.773],[1557.64,831.964]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1712.95,855.741],[1712.95,990.061],[1557.64,843.654],[1557.64,972.844]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1712.95,422.548],[1712.95,288.228],[1797.36,433.935],[1797.36,312.719]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1712.95,565.505],[1712.95,431.185],[1797.36,562.943],[1797.36,441.728]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1712.95,570.963],[1712.95,705.284],[1797.36,567.87],[1797.36,689.085]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1712.95,709.266],[1712.95,843.586],[1797.36,692.679],[1797.36,813.894]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1712.95,855.741],[1712.95,990.061],[1797.36,824.862],[1797.36,946.077]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1754.65,451.123],[1754.65,346.874],[1762.69,451.984],[1762.69,348.754]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1754.65,566.312],[1754.65,670.561],[1762.69,566.047],[1762.69,669.278]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1754.65,673.652],[1754.65,777.901],[1762.69,672.339],[1762.69,775.569]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1754.65,787.335],[1754.65,891.584],[1762.69,784.91],[1762.69,888.141]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1819.62,436.937],[1819.62,319.177],[1885.28,445.795],[1885.28,338.231]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1819.62,562.268],[1819.62,444.509],[1885.28,560.276],[1885.28,452.711]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1819.62,567.054],[1819.62,684.813],[1885.28,564.647],[1885.28,672.211]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1819.62,688.305],[1819.62,806.064],[1885.28,675.4],[1885.28,782.964]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:38,
                    verts:[[1819.62,816.721],[1819.62,934.48],[1885.28,792.698],[1885.28,900.262]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[262.586,462.25],[262.586,373.625],[188.792,463.982],[188.792,377.35]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[262.586,556.574],[262.586,467.949],[188.792,556.184],[188.792,469.552]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[262.586,560.176],[262.586,648.801],[188.792,559.705],[188.792,646.337]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[262.586,651.429],[262.586,740.054],[188.792,648.906],[188.792,735.538]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[262.586,748.074],[262.586,836.699],[188.792,743.377],[188.792,830.009]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[344.993,459.166],[344.993,366.991],[244.333,461.563],[244.333,372.146]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[344.993,557.268],[344.993,465.093],[244.333,556.729],[244.333,467.312]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[344.993,561.014],[344.993,653.188],[244.333,560.362],[244.333,649.779]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[344.993,655.921],[344.993,748.096],[244.333,652.43],[244.333,741.846]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[344.993,756.437],[344.993,848.612],[244.333,749.937],[244.333,839.354]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[344.993,459.166],[344.993,366.991],[363.512,459.922],[363.512,368.617]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[344.993,557.268],[344.993,465.093],[363.512,557.098],[363.512,465.793]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[344.993,561.014],[344.993,653.188],[363.512,560.808],[363.512,652.113]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[344.993,655.921],[344.993,748.096],[363.512,654.82],[363.512,746.125]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[344.993,756.437],[344.993,848.612],[363.512,754.388],[363.512,845.693]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[444.893,458.013],[444.893,364.511],[363.512,459.922],[363.512,368.617]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[444.893,557.527],[444.893,464.025],[363.512,557.098],[363.512,465.793]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[444.893,561.327],[444.893,654.829],[363.512,560.808],[363.512,652.113]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[444.893,657.601],[444.893,751.103],[363.512,654.82],[363.512,746.125]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[444.893,759.564],[444.893,853.066],[363.512,754.388],[363.512,845.693]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[529.88,455.977],[529.88,360.132],[443.731,457.999],[443.731,364.481]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[529.88,557.985],[529.88,462.14],[443.731,557.53],[443.731,464.012]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[529.88,561.88],[529.88,657.725],[443.731,561.331],[443.731,654.849]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[529.88,660.567],[529.88,756.411],[443.731,657.621],[443.731,751.139]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[529.88,765.085],[529.88,860.93],[443.731,759.602],[443.731,853.12]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[630.907,452.359],[630.907,352.349],[512.708,455.173],[512.708,358.402]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[630.907,558.799],[630.907,458.789],[512.708,558.166],[512.708,461.395]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[630.907,562.863],[630.907,662.873],[512.708,562.099],[512.708,658.869]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[630.907,665.838],[630.907,765.848],[512.708,661.739],[512.708,758.509]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[630.907,774.898],[630.907,874.908],[512.708,767.266],[512.708,864.037]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[630.907,452.359],[630.907,352.349],[648.059,453.248],[648.059,354.261]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[630.907,558.799],[630.907,458.789],[648.059,558.599],[648.059,459.612]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[630.907,562.863],[630.907,662.873],[648.059,562.622],[648.059,661.608]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[630.907,665.838],[630.907,765.848],[648.059,664.543],[648.059,763.53]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[630.907,774.898],[630.907,874.908],[648.059,772.488],[648.059,871.474]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[744.778,450.979],[744.778,349.381],[648.058,453.248],[648.058,354.261]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[744.778,559.109],[744.778,457.512],[648.058,558.599],[648.058,459.612]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[744.778,563.238],[744.778,664.836],[648.058,562.622],[648.058,661.608]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[744.778,667.848],[744.778,769.446],[648.058,664.543],[648.058,763.53]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[744.778,778.64],[744.778,880.237],[648.058,772.487],[648.058,871.474]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[656.755,471.889],[656.755,394.357],[669.878,472.424],[669.878,395.509]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[656.755,557.557],[656.755,635.088],[669.878,557.411],[669.878,634.327]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[656.755,637.387],[656.755,714.919],[669.878,636.607],[669.878,713.523]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[656.755,721.935],[656.755,799.467],[669.878,720.483],[669.878,797.399]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[745.194,451.003],[745.194,349.433],[780.509,452.998],[780.509,353.724]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[745.194,559.104],[745.194,457.534],[780.509,558.655],[780.509,459.381]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[745.194,563.232],[745.194,664.801],[780.509,562.69],[780.509,661.963]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[745.194,667.813],[745.194,769.383],[780.509,664.907],[780.509,764.181]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[745.194,778.574],[745.194,880.144],[780.509,773.164],[780.509,872.438]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1011.76,444.669],[1011.76,335.808],[900.988,447.268],[900.988,341.4]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1011.76,560.529],[1011.76,451.668],[900.988,559.944],[900.988,454.075]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1011.76,564.953],[1011.76,673.813],[900.988,564.246],[900.988,670.115]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1011.76,677.041],[1011.76,785.901],[900.988,673.254],[900.988,779.123]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1011.76,795.752],[1011.76,904.613],[900.988,788.703],[900.988,894.571]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[916.086,469.723],[916.086,386.718],[927.921,470.314],[927.921,388.016]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[916.086,561.438],[916.086,644.443],[927.921,561.249],[927.921,643.548]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[916.086,646.904],[916.086,729.909],[927.921,645.988],[927.921,728.287]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[916.086,737.42],[916.086,820.425],[927.921,735.734],[927.921,818.033]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[951.455,465.399],[951.455,377.231],[1002.44,468.176],[1002.44,383.324]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[951.455,562.818],[951.455,650.985],[1002.44,561.932],[1002.44,646.784]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[951.455,653.599],[951.455,741.766],[1002.44,649.3],[1002.44,734.152]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[951.455,749.745],[951.455,837.912],[1002.44,741.83],[1002.44,826.682]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1151.11,439.973],[1151.11,325.707],[997.524,443.63],[997.524,333.573]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1151.11,561.585],[1151.11,447.32],[997.524,560.763],[997.524,450.706]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1151.11,566.229],[1151.11,680.494],[997.524,565.235],[997.524,675.292]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1151.11,683.882],[1151.11,798.147],[997.524,678.555],[997.524,788.611]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1151.11,808.487],[1151.11,922.753],[997.524,798.57],[997.524,908.627]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1151.11,439.973],[1151.11,325.707],[1164.61,441.131],[1164.61,328.2]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1151.11,561.585],[1151.11,447.32],[1164.61,561.325],[1164.61,448.393]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1151.11,566.229],[1151.11,680.494],[1164.61,565.914],[1164.61,678.846]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1151.11,683.882],[1151.11,798.147],[1164.61,682.194],[1164.61,795.126]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1151.11,808.487],[1151.11,922.753],[1164.61,805.345],[1164.61,918.277]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1289.82,438.194],[1289.82,321.883],[1164.61,441.132],[1164.61,328.2]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1289.82,561.985],[1289.82,445.673],[1164.61,561.325],[1164.61,448.393]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1289.82,566.712],[1289.82,683.024],[1164.61,565.914],[1164.61,678.846]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1289.82,686.473],[1289.82,802.784],[1164.61,682.194],[1164.61,795.126]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1289.82,813.31],[1289.82,929.622],[1164.61,805.345],[1164.61,918.276]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1425,435.024],[1425,315.062],[1292.38,438.134],[1292.38,321.753]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1425,562.698],[1425,442.737],[1292.38,561.999],[1292.38,445.617]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1425,567.574],[1425,687.535],[1292.38,566.728],[1292.38,683.109]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1425,691.092],[1425,811.053],[1292.38,686.56],[1292.38,802.941]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1425,821.908],[1425,941.87],[1292.38,813.473],[1292.38,929.854]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1372.78,461.653],[1372.78,369.014],[1381.64,462.389],[1381.64,370.628]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1372.78,564.013],[1372.78,656.652],[1381.64,563.778],[1381.64,655.539]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1372.78,659.399],[1372.78,752.038],[1381.64,658.259],[1381.64,750.02]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1372.78,760.421],[1372.78,853.06],[1381.64,758.323],[1381.64,850.084]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1601.75,429.243],[1601.75,302.628],[1413.92,433.715],[1413.92,312.248]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1601.75,563.999],[1601.75,437.384],[1413.92,562.993],[1413.92,441.525]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1601.75,569.144],[1601.75,695.759],[1413.92,567.929],[1413.92,689.396]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1601.75,699.513],[1601.75,826.128],[1413.92,692.998],[1413.92,814.465]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1601.75,837.585],[1601.75,964.2],[1413.92,825.457],[1413.92,946.924]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1601.76,429.243],[1601.76,302.628],[1610.56,430.616],[1610.56,305.582]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1601.76,563.999],[1601.76,437.384],[1610.56,563.69],[1610.56,438.656]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1601.76,569.144],[1601.76,695.759],[1610.56,568.771],[1610.56,693.805]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1601.76,699.513],[1601.76,826.128],[1610.56,697.513],[1610.56,822.547]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1601.76,837.585],[1601.76,964.2],[1610.56,833.861],[1610.56,958.896]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1765.87,426.972],[1765.87,297.743],[1610.56,430.616],[1610.56,305.582]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1765.87,564.51],[1765.87,435.281],[1610.56,563.69],[1610.56,438.656]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1765.87,569.761],[1765.87,698.99],[1610.56,568.771],[1610.56,693.805]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1765.87,702.822],[1765.87,832.051],[1610.56,697.513],[1610.56,822.547]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1765.87,843.745],[1765.87,972.974],[1610.56,833.861],[1610.56,958.896]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1747.33,454.294],[1747.33,353.796],[1752.89,455.138],[1752.89,355.639]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1747.33,565.338],[1747.33,665.836],[1752.89,565.079],[1752.89,664.579]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1747.33,668.816],[1747.33,769.313],[1752.89,667.529],[1752.89,767.028]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1747.33,778.407],[1747.33,878.905],[1752.89,776.032],[1752.89,875.532]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1765.86,426.972],[1765.86,297.743],[1819.4,438.069],[1819.4,321.613]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1765.86,564.51],[1765.86,435.281],[1819.4,562.013],[1819.4,445.557]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1765.86,569.761],[1765.86,698.99],[1819.4,566.746],[1819.4,683.202]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1765.86,702.822],[1765.86,832.051],[1819.4,686.655],[1819.4,803.112]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1765.86,843.745],[1765.86,972.974],[1819.4,813.65],[1819.4,930.106]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1833.49,440.99],[1833.49,327.895],[1875,449.596],[1875,346.406]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1833.49,561.356],[1833.49,448.262],[1875,559.421],[1875,456.231]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1833.49,565.952],[1833.49,679.047],[1875,563.614],[1875,666.804]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1833.49,682.4],[1833.49,795.495],[1875,669.864],[1875,773.053]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:39,
                    verts:[[1833.49,805.729],[1833.49,918.823],[1875,782.391],[1875,885.581]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[245.859,460.832],[245.859,370.574],[164.488,462.375],[164.488,373.893]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[245.859,556.893],[245.859,466.635],[164.488,556.546],[164.488,468.064]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[245.859,560.561],[245.859,650.818],[164.488,560.142],[164.488,648.623]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[245.859,653.495],[245.859,743.752],[164.488,651.247],[164.488,739.728]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[245.859,751.919],[245.859,842.177],[164.488,747.735],[164.488,836.217]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[339.039,457.964],[339.039,364.405],[228.58,460.087],[228.58,368.973]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[339.039,557.538],[339.039,463.98],[228.58,557.061],[228.58,465.946]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[339.039,561.34],[339.039,654.899],[228.58,560.763],[228.58,651.878]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[339.039,657.673],[339.039,751.231],[228.58,654.579],[228.58,745.694]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[339.039,759.697],[339.039,853.256],[228.58,753.939],[228.58,845.054]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[339.039,457.964],[339.039,364.405],[356.294,458.776],[356.294,366.153]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[339.039,557.538],[339.039,463.98],[356.294,557.355],[356.294,464.732]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[339.039,561.34],[339.039,654.899],[356.294,561.119],[356.294,653.743]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[339.039,657.673],[339.039,751.231],[356.294,656.489],[356.294,749.112]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[339.039,759.697],[339.039,853.256],[356.294,757.494],[356.294,850.117]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[444.793,457.099],[444.793,362.545],[356.293,458.776],[356.293,366.153]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[444.793,557.733],[444.793,463.179],[356.293,557.355],[356.293,464.732]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[444.793,561.575],[444.793,656.129],[356.293,561.119],[356.293,653.743]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[444.793,658.932],[444.793,753.486],[356.293,656.489],[356.293,749.112]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[444.793,762.042],[444.793,856.596],[356.293,757.494],[356.293,850.117]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[536.725,455.317],[536.725,358.711],[443.635,457.082],[443.635,362.508]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[536.725,558.134],[536.725,461.528],[443.635,557.737],[443.635,463.163]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[536.725,562.059],[536.725,658.665],[443.635,561.58],[443.635,656.154]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[536.725,661.529],[536.725,758.135],[443.635,658.958],[443.635,753.531]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[536.725,766.876],[536.725,863.482],[443.635,762.089],[443.635,856.663]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[648.131,452.022],[648.131,351.626],[521.177,454.463],[521.177,356.875]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[648.131,558.875],[648.131,458.478],[521.177,558.326],[521.177,460.738]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[648.131,562.955],[648.131,663.351],[521.177,562.292],[521.177,659.88]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[648.131,666.328],[648.131,766.725],[521.177,662.773],[521.177,760.361]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[648.131,775.81],[648.131,876.206],[521.177,769.192],[521.177,866.78]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[626.937,471.521],[626.937,393.566],[638.936,472.086],[638.936,394.782]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[626.937,557.656],[626.937,635.611],[638.936,557.503],[638.936,634.807]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[626.937,637.923],[626.937,715.877],[638.936,637.099],[638.936,714.404]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[626.937,722.932],[626.937,800.886],[638.936,721.399],[638.936,798.704]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[648.131,452.022],[648.131,351.626],[663.32,452.957],[663.32,353.637]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[648.131,558.875],[648.131,458.478],[663.32,558.664],[663.32,459.344]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[648.131,562.955],[648.131,663.351],[663.32,562.701],[663.32,662.021]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[648.131,666.328],[648.131,766.725],[663.32,664.966],[663.32,764.287]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[648.131,775.81],[648.131,876.206],[663.32,773.274],[663.32,872.595]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[766.161,451.008],[766.161,349.444],[663.32,452.957],[663.32,353.637]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[766.161,559.103],[766.161,457.539],[663.32,558.664],[663.32,459.344]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[766.161,563.23],[766.161,664.794],[663.32,562.701],[663.32,662.021]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[766.161,667.805],[766.161,769.369],[663.32,664.966],[663.32,764.287]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[766.161,778.56],[766.161,880.124],[663.32,773.274],[663.32,872.595]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[766.519,451.034],[766.519,349.499],[797.132,453.113],[797.132,353.971]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[766.519,559.097],[766.519,457.562],[797.132,558.629],[797.132,459.488]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[766.519,563.223],[766.519,664.758],[797.132,562.658],[797.132,661.8]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[766.519,667.769],[766.519,769.303],[797.132,664.739],[797.132,763.881]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[766.519,778.491],[766.519,880.026],[797.132,772.852],[797.132,871.994]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[898.753,470.022],[898.753,387.373],[909.065,470.634],[909.065,388.716]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[898.753,557.984],[898.753,475.336],[909.065,557.819],[909.065,475.901]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[898.753,561.343],[898.753,643.991],[909.065,561.148],[909.065,643.065]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[898.753,646.442],[898.753,729.09],[909.065,645.494],[909.065,727.412]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[898.753,736.569],[898.753,819.217],[909.065,734.824],[909.065,816.742]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1046.25,445.655],[1046.25,337.93],[930.773,447.845],[930.773,342.64]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1046.25,560.307],[1046.25,452.582],[930.773,559.814],[930.773,454.609]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1046.25,564.685],[1046.25,672.41],[930.773,564.09],[930.773,669.295]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1046.25,675.604],[1046.25,783.329],[930.773,672.414],[930.773,777.619]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1046.25,793.077],[1046.25,900.802],[930.773,787.139],[930.773,892.344]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[944.479,465.849],[944.479,378.219],[988.151,468.709],[988.151,384.493]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[944.479,562.674],[944.479,650.304],[988.151,561.762],[988.151,645.977]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[944.479,652.903],[944.479,740.533],[988.151,648.474],[988.151,732.69]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[944.479,748.462],[944.479,836.092],[988.151,740.31],[988.151,824.526]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1193.44,441.54],[1193.44,329.079],[1034.68,444.592],[1034.68,335.644]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1193.44,561.233],[1193.44,448.772],[1034.68,560.546],[1034.68,451.598]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1193.44,565.803],[1193.44,678.264],[1034.68,564.974],[1034.68,673.922]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1193.44,681.598],[1193.44,794.059],[1034.68,677.152],[1034.68,786.101]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1193.44,804.236],[1193.44,916.697],[1034.68,795.96],[1034.68,904.908]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1193.44,441.54],[1193.44,329.079],[1203.89,442.712],[1203.89,331.6]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1193.44,561.233],[1193.44,448.772],[1203.89,560.969],[1203.89,449.856]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1193.44,565.803],[1193.44,678.264],[1203.89,565.484],[1203.89,676.597]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1193.44,681.598],[1193.44,794.059],[1203.89,679.891],[1203.89,791.004]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1193.44,804.236],[1193.44,916.697],[1203.89,801.059],[1203.89,912.171]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1331.78,440.288],[1331.78,326.386],[1203.89,442.712],[1203.89,331.6]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1331.78,561.514],[1331.78,447.612],[1203.89,560.969],[1203.89,449.856]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1331.78,566.143],[1331.78,680.045],[1203.89,565.484],[1203.89,676.597]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1331.78,683.422],[1331.78,797.325],[1203.89,679.891],[1203.89,791.004]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1331.78,807.632],[1331.78,921.534],[1203.89,801.058],[1203.89,912.171]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1468.52,437.697],[1468.52,320.812],[1334.39,440.239],[1334.39,326.28]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1468.52,562.097],[1468.52,445.212],[1334.39,561.525],[1334.39,447.566]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1468.52,566.847],[1468.52,683.732],[1334.39,566.156],[1334.39,680.116]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1468.52,687.198],[1468.52,804.083],[1334.39,683.494],[1334.39,797.453]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1468.52,814.66],[1468.52,931.544],[1334.39,807.766],[1334.39,921.725]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1364.82,463.283],[1364.82,372.591],[1371.61,464.02],[1371.61,374.206]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1364.82,563.493],[1364.82,654.185],[1371.61,563.258],[1371.61,653.071]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1364.82,656.874],[1364.82,747.567],[1371.61,655.734],[1371.61,745.547]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1364.82,755.773],[1364.82,846.466],[1371.61,753.675],[1371.61,843.488]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1648.85,432.786],[1648.85,310.25],[1460.89,436.399],[1460.89,318.021]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1648.85,563.202],[1648.85,440.665],[1460.89,562.389],[1460.89,444.011]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1648.85,568.181],[1648.85,690.718],[1460.89,567.2],[1460.89,685.578]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1648.85,694.351],[1648.85,816.888],[1460.89,689.088],[1460.89,807.466]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1648.85,827.976],[1648.85,950.512],[1460.89,818.178],[1460.89,936.556]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1648.86,432.786],[1648.86,310.25],[1654.11,434.129],[1654.11,313.138]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1648.86,563.202],[1648.86,440.665],[1654.11,562.9],[1654.11,441.909]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1648.86,568.181],[1648.86,690.718],[1654.11,567.817],[1654.11,688.808]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1648.86,694.351],[1648.86,816.888],[1654.11,692.395],[1654.11,813.386]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1648.86,827.976],[1648.86,950.512],[1654.11,824.335],[1654.11,945.326]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1807.39,431.223],[1807.39,306.886],[1654.11,434.129],[1654.11,313.138]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1807.39,563.554],[1807.39,439.217],[1654.11,562.9],[1654.11,441.909]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1807.39,568.606],[1807.39,692.943],[1654.11,567.817],[1654.11,688.808]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1807.39,696.629],[1807.39,820.966],[1654.11,692.395],[1654.11,813.386]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1807.39,832.217],[1807.39,956.553],[1654.11,824.335],[1654.11,945.326]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1735.46,457.209],[1735.46,360.159],[1738.77,458.03],[1738.77,361.952]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1735.46,564.443],[1735.46,661.493],[1738.77,564.191],[1738.77,660.269]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1735.46,664.371],[1735.46,761.421],[1738.77,663.118],[1738.77,759.196]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1735.46,770.203],[1735.46,867.253],[1738.77,767.89],[1738.77,863.968]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1807.39,431.223],[1807.39,306.886],[1832.98,441.944],[1832.98,329.948]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1807.39,563.554],[1807.39,439.217],[1832.98,561.142],[1832.98,449.146]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1807.39,568.606],[1807.39,692.943],[1832.98,565.693],[1832.98,677.689]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1807.39,696.629],[1807.39,820.965],[1832.98,681.01],[1832.98,793.006]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1807.39,832.217],[1807.39,956.553],[1832.98,803.14],[1832.98,915.136]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1839.71,444.765],[1839.71,336.015],[1859.54,453.07],[1859.54,353.88]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1839.71,560.507],[1839.71,451.757],[1859.54,558.639],[1859.54,459.448]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1839.71,564.927],[1839.71,673.677],[1859.54,562.67],[1859.54,661.861]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1839.71,676.901],[1839.71,785.651],[1859.54,664.802],[1859.54,763.992]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:40,
                    verts:[[1839.71,795.492],[1839.71,904.242],[1859.54,772.968],[1859.54,872.159]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[232.894,459.315],[232.894,367.312],[144.009,460.647],[144.009,370.177]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[232.894,557.234],[232.894,465.231],[144.009,556.935],[144.009,466.464]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[232.894,560.973],[232.894,652.976],[144.009,560.611],[144.009,651.082]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[232.894,655.704],[232.894,747.707],[144.009,653.764],[144.009,744.234]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[232.894,756.033],[232.894,848.036],[144.009,752.421],[144.009,842.892]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[336.729,456.692],[336.729,361.67],[216.738,458.514],[216.738,365.588]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[336.729,557.824],[336.729,462.802],[216.738,557.414],[216.738,464.489]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[336.729,561.686],[336.729,656.708],[216.738,561.191],[216.738,654.117]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[336.729,659.525],[336.729,754.547],[216.738,656.872],[216.738,749.798]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[336.729,763.146],[336.729,858.168],[216.738,758.206],[216.738,851.132]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[336.729,456.692],[336.729,361.67],[352.562,457.559],[352.562,363.535]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[336.729,557.824],[336.729,462.802],[352.562,557.629],[352.562,463.605]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[336.729,561.686],[336.729,656.708],[352.562,561.45],[352.562,655.474]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[336.729,659.525],[336.729,754.547],[352.562,658.262],[352.562,752.286]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[336.729,763.146],[336.729,858.168],[352.562,760.794],[352.562,854.818]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[447.822,456.133],[447.822,360.467],[352.561,457.559],[352.561,363.535]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[447.822,557.95],[447.822,462.284],[352.561,557.629],[352.561,463.605]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[447.822,561.838],[447.822,657.504],[352.561,561.45],[352.561,655.474]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[447.822,660.34],[447.822,756.006],[352.561,658.262],[352.561,752.286]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[447.822,764.663],[447.822,860.329],[352.561,760.794],[352.561,854.818]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[546.209,454.621],[546.209,357.214],[446.675,456.112],[446.675,360.422]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[546.209,558.29],[546.209,460.884],[446.675,557.955],[446.675,462.265]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[546.209,562.249],[546.209,659.655],[446.675,561.843],[446.675,657.533]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[546.209,662.543],[546.209,759.95],[446.675,660.371],[446.675,756.061]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[546.209,768.764],[546.209,866.171],[446.675,764.72],[446.675,860.41]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[667.261,451.675],[667.261,350.878],[532.423,453.722],[532.423,355.28]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[667.261,558.953],[667.261,458.156],[532.423,558.492],[532.423,460.051]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[667.261,563.049],[667.261,663.846],[532.423,562.493],[532.423,660.934]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[667.261,666.835],[667.261,767.632],[532.423,663.853],[532.423,762.294]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[667.261,776.753],[667.261,877.55],[532.423,771.202],[532.423,869.643]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[598.795,471.046],[598.795,392.545],[609.621,471.639],[609.621,393.82]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[598.795,557.785],[598.795,636.287],[609.621,557.624],[609.621,635.443]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[598.795,638.614],[598.795,717.116],[609.621,637.751],[609.621,715.57]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[598.795,724.22],[598.795,802.721],[609.621,722.612],[609.621,800.431]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[667.261,451.675],[667.261,350.878],[680.365,452.65],[680.365,352.975]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[667.261,558.953],[667.261,458.156],[680.365,558.733],[680.365,459.059]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[667.261,563.049],[667.261,663.846],[680.365,562.784],[680.365,662.459]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[667.261,666.835],[667.261,767.631],[680.365,665.414],[680.365,765.088]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[667.261,776.753],[667.261,877.55],[680.365,774.108],[680.365,873.783]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[788.501,451.03],[788.501,349.492],[680.364,452.65],[680.364,352.975]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[788.501,559.098],[788.501,457.559],[680.364,558.733],[680.364,459.059]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[788.501,563.224],[788.501,664.763],[680.364,562.784],[680.364,662.459]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[788.501,667.773],[788.501,769.312],[680.364,665.414],[680.364,765.088]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[788.501,778.5],[788.501,880.039],[680.364,774.108],[680.364,873.783]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[788.8,451.057],[788.8,349.548],[814.522,453.206],[814.522,354.172]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[788.8,559.092],[788.8,457.583],[814.522,558.608],[814.522,459.574]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[788.8,563.217],[788.8,664.725],[814.522,562.633],[814.522,661.667]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[788.8,667.735],[788.8,769.244],[814.522,664.603],[814.522,763.638]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[788.8,778.429],[788.8,879.938],[814.522,772.599],[814.522,871.633]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[882.085,470.226],[882.085,387.821],[890.86,470.856],[890.86,389.203]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[882.085,557.929],[882.085,475.524],[890.86,557.759],[890.86,476.106]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[882.085,561.278],[882.085,643.682],[890.86,561.077],[890.86,642.729]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[882.085,646.125],[882.085,728.53],[890.86,645.15],[890.86,726.803]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[882.085,735.987],[882.085,818.391],[890.86,734.192],[890.86,815.845]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[937.752,466.217],[937.752,379.028],[974.085,469.145],[974.085,385.451]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[937.752,559.013],[937.752,471.824],[974.085,558.221],[974.085,474.527]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[937.752,562.557],[937.752,649.747],[974.085,561.622],[974.085,645.317]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[937.752,652.332],[937.752,739.521],[974.085,647.798],[974.085,731.493]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[937.752,747.411],[937.752,834.601],[974.085,739.067],[974.085,822.761]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1078.99,446.638],[1078.99,340.043],[959.993,448.421],[959.993,343.878]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1078.99,560.086],[1078.99,453.491],[959.993,559.685],[959.993,455.143]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1078.99,564.418],[1078.99,671.012],[959.993,563.933],[959.993,668.476]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1078.99,674.173],[1078.99,780.767],[959.993,671.575],[959.993,776.117]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1078.99,790.413],[1078.99,897.007],[959.993,785.578],[959.993,890.12]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1232.26,443.098],[1232.26,332.43],[1070.09,445.56],[1070.09,337.725]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1232.26,560.882],[1232.26,450.214],[1070.09,560.328],[1070.09,452.494]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1232.26,565.38],[1232.26,676.048],[1070.09,564.711],[1070.09,672.545]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1232.26,679.329],[1232.26,789.997],[1070.09,675.743],[1070.09,783.577]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1232.26,800.011],[1232.26,910.679],[1070.09,793.335],[1070.09,901.17]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1232.26,443.098],[1232.26,332.43],[1239.73,444.272],[1239.73,334.956]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1232.26,560.882],[1232.26,450.214],[1239.73,560.618],[1239.73,451.301]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1232.26,565.38],[1232.26,676.048],[1239.73,565.06],[1239.73,674.377]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1232.26,679.329],[1232.26,789.997],[1239.73,677.618],[1239.73,786.935]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1232.26,800.011],[1232.26,910.679],[1239.73,796.827],[1239.73,906.143]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1368.86,442.339],[1368.86,330.796],[1239.73,444.273],[1239.73,334.956]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1368.86,561.053],[1368.86,449.511],[1239.73,560.618],[1239.73,451.301]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1368.86,565.586],[1368.86,677.128],[1239.73,565.06],[1239.73,674.377]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1368.86,680.436],[1368.86,791.978],[1239.73,677.618],[1239.73,786.935]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1368.86,802.072],[1368.86,913.614],[1239.73,796.827],[1239.73,906.143]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1354.99,464.771],[1354.99,375.854],[1359.8,465.504],[1359.8,377.461]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1354.99,563.018],[1354.99,651.935],[1359.8,562.784],[1359.8,650.827]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1354.99,654.571],[1354.99,743.488],[1359.8,653.437],[1359.8,741.479]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1354.99,751.534],[1354.99,840.45],[1359.8,749.446],[1359.8,837.488]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1505.61,440.29],[1505.61,326.391],[1371.48,442.299],[1371.48,330.712]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1505.61,561.514],[1505.61,447.614],[1371.48,561.062],[1371.48,449.474]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1505.61,566.142],[1505.61,680.042],[1371.48,565.597],[1371.48,677.184]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1505.61,683.419],[1505.61,797.319],[1371.48,680.493],[1371.48,792.08]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1505.61,807.626],[1505.61,921.525],[1371.48,802.178],[1371.48,913.766]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1687.21,436.192],[1687.21,317.576],[1501.25,439.015],[1501.25,323.647]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1687.21,562.436],[1687.21,443.819],[1501.25,561.801],[1501.25,446.433]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1687.21,567.256],[1687.21,685.873],[1501.25,566.489],[1501.25,681.857]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1687.21,689.389],[1687.21,808.006],[1501.25,685.277],[1501.25,800.645]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1687.21,818.74],[1687.21,937.356],[1501.25,811.084],[1501.25,926.452]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1687.21,436.192],[1687.21,317.576],[1689.19,437.495],[1689.19,320.377]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1687.21,562.436],[1687.21,443.819],[1689.19,562.143],[1689.19,445.025]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1687.21,567.256],[1687.21,685.873],[1689.19,566.902],[1689.19,684.02]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1687.21,689.389],[1687.21,808.006],[1689.19,687.492],[1689.19,804.61]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1687.21,818.74],[1687.21,937.356],[1689.19,815.208],[1689.19,932.325]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1838.89,435.252],[1689.19,437.495],[1838.89,315.552],[1689.19,320.377]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1838.89,562.647],[1838.89,442.948],[1689.19,562.143],[1689.19,445.025]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1838.89,567.512],[1838.89,687.211],[1689.19,566.902],[1689.19,684.02]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1838.89,690.76],[1689.19,687.492],[1838.89,810.459],[1689.19,804.61]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1838.89,821.291],[1689.19,815.208],[1838.89,940.99],[1689.19,932.325]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1719.88,459.868],[1719.88,365.963],[1721.13,460.664],[1721.13,367.702]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1719.88,563.627],[1719.88,657.531],[1721.13,563.382],[1721.13,656.345]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1719.88,660.316],[1719.88,754.22],[1721.13,659.101],[1721.13,752.064]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1719.88,762.718],[1719.88,856.622],[1721.13,760.476],[1721.13,853.439]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1838.89,435.252],[1838.89,315.552],[1839.4,445.542],[1839.4,337.686]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1838.89,562.647],[1838.89,442.948],[1839.4,560.332],[1839.4,452.477]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1838.89,567.512],[1838.89,687.211],[1839.4,564.716],[1839.4,672.571]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1838.89,690.76],[1838.89,810.459],[1839.4,675.769],[1839.4,783.625]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:41,
                    verts:[[1838.89,821.291],[1838.89,940.99],[1839.4,793.384],[1839.4,901.24]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[223.666,457.687],[223.666,363.809],[127.362,458.784],[127.362,366.168]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[223.666,557.6],[223.666,463.723],[127.362,557.354],[127.362,464.739]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[223.666,561.415],[223.666,655.293],[127.362,561.117],[127.362,653.733]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[223.666,658.077],[223.666,751.954],[127.362,656.479],[127.362,749.094]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[223.666,760.449],[223.666,854.327],[127.362,757.475],[127.362,850.09]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[337.991,455.339],[337.991,358.759],[208.79,456.829],[208.79,361.964]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[337.991,558.129],[337.991,461.549],[208.79,557.793],[208.79,462.929]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[337.991,562.053],[337.991,658.633],[208.79,561.649],[208.79,656.513]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[337.991,661.497],[337.991,758.077],[208.79,659.326],[208.79,754.191]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[337.991,766.816],[337.991,863.396],[208.79,762.775],[208.79,857.64]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[337.992,455.339],[337.992,358.759],[352.246,456.259],[352.246,360.737]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[337.992,558.129],[337.992,461.549],[352.246,557.922],[352.246,462.401]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[337.992,562.053],[337.992,658.633],[352.246,561.804],[352.246,657.325]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[337.992,661.497],[337.992,758.077],[352.246,660.157],[352.246,755.678]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[337.992,766.816],[337.992,863.396],[352.246,764.322],[352.246,859.843]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[453.873,455.102],[453.873,358.249],[352.246,456.259],[352.246,360.737]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[453.873,558.182],[453.873,461.329],[352.246,557.922],[352.246,462.401]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[453.873,562.118],[453.873,658.971],[352.246,561.803],[352.246,657.325]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[453.873,661.842],[453.873,758.695],[352.246,660.157],[352.246,755.678]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[453.873,767.459],[453.873,864.312],[352.246,764.322],[352.246,859.843]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[558.191,453.876],[558.191,355.614],[452.745,455.077],[452.745,358.197]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[558.191,558.458],[558.191,460.195],[452.745,558.187],[452.745,461.307]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[558.191,562.451],[558.191,660.714],[452.745,562.125],[452.745,659.005]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[558.191,663.627],[558.191,761.89],[452.745,661.878],[452.745,758.758]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[558.191,770.782],[558.191,869.045],[452.745,767.525],[452.745,864.406]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[688.11,451.301],[688.11,350.073],[546.296,452.936],[546.296,353.591]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[688.11,559.037],[688.11,457.81],[546.296,558.669],[546.296,459.324]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[688.11,563.151],[688.11,664.378],[546.296,562.706],[546.296,662.051]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[688.11,667.379],[688.11,768.607],[546.296,664.997],[546.296,764.342]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[688.11,777.767],[688.11,878.995],[546.296,773.331],[546.296,872.676]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[572.253,470.455],[572.253,391.274],[581.853,471.075],[581.853,392.607]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[572.253,557.946],[572.253,637.127],[581.853,557.778],[581.853,636.246]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[572.253,639.475],[572.253,718.657],[581.853,638.573],[581.853,717.041]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[572.253,725.822],[572.253,805.003],[581.853,724.142],[581.853,802.61]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[688.11,451.301],[688.11,350.073],[699.023,452.311],[699.023,352.246]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[688.11,559.037],[688.11,457.81],[699.023,558.81],[699.023,458.745]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[688.11,563.151],[688.11,664.378],[699.023,562.876],[699.023,662.941]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[688.11,667.379],[688.11,768.607],[699.023,665.908],[699.023,765.973]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[688.11,777.767],[688.11,878.995],[699.023,775.028],[699.023,875.093]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[811.627,451.029],[811.627,349.488],[699.022,452.311],[699.022,352.246]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[811.627,559.098],[811.627,457.558],[699.022,558.81],[699.022,458.745]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[811.627,563.225],[811.627,664.765],[699.022,562.876],[699.022,662.941]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[811.627,667.776],[811.627,769.316],[699.022,665.908],[699.022,765.973]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[811.627,778.505],[811.627,880.045],[699.022,775.028],[699.022,875.093]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[811.866,451.056],[811.866,349.546],[832.547,453.262],[832.547,354.293]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[811.866,559.092],[811.866,457.582],[832.547,558.596],[832.547,459.626]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[811.866,563.217],[811.866,664.727],[832.547,562.618],[832.547,661.587]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[811.866,667.737],[811.866,769.246],[832.547,664.522],[832.547,763.491]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[811.866,778.432],[811.866,879.942],[832.547,772.447],[832.547,871.417]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[866.061,470.329],[866.061,388.048],[873.285,470.974],[873.285,389.462]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[866.061,557.901],[866.061,475.62],[873.285,557.727],[873.285,476.215]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[866.061,561.245],[866.061,643.526],[873.285,561.039],[873.285,642.551]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[866.061,645.966],[866.061,728.247],[873.285,644.967],[873.285,726.479]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[866.061,735.693],[866.061,817.974],[873.285,733.855],[873.285,815.367]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[931.272,466.497],[931.272,379.64],[960.253,469.478],[960.253,386.182]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[931.272,558.938],[931.272,472.081],[960.253,558.131],[960.253,474.834]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[931.272,562.468],[931.272,649.324],[960.253,561.516],[960.253,644.813]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[931.272,651.9],[931.272,738.756],[960.253,647.283],[960.253,730.58]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[931.272,746.616],[931.272,833.473],[960.253,738.117],[960.253,821.414]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1109.93,447.592],[1109.93,342.097],[988.52,448.975],[988.52,345.071]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1109.93,559.871],[1109.93,454.375],[988.52,559.56],[988.52,455.656]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1109.93,564.158],[1109.93,669.654],[988.52,563.783],[988.52,667.687]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1109.93,672.782],[1109.93,778.278],[988.52,670.767],[988.52,774.671]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1109.93,787.824],[1109.93,893.32],[988.52,784.074],[988.52,887.978]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1267.64,444.617],[1267.64,335.696],[1103.68,446.508],[1103.68,339.764]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1267.64,560.541],[1267.64,451.62],[1103.68,560.115],[1103.68,453.371]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1267.64,564.967],[1267.64,673.887],[1103.68,564.453],[1103.68,671.197]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1267.64,677.117],[1267.64,786.037],[1103.68,674.362],[1103.68,781.106]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1267.64,795.893],[1267.64,904.813],[1103.68,790.765],[1103.68,897.509]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1267.64,444.617],[1267.64,335.696],[1272.22,445.785],[1272.22,338.209]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1267.64,560.541],[1267.64,451.62],[1272.22,560.278],[1272.22,452.702]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1267.64,564.967],[1267.64,673.887],[1272.22,564.649],[1272.22,672.225]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1267.64,677.117],[1267.64,786.037],[1272.22,675.415],[1272.22,782.99]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1267.64,795.893],[1267.64,904.814],[1272.22,792.725],[1272.22,900.301]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1401.34,444.315],[1401.34,335.047],[1272.21,445.785],[1272.21,338.209]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1401.34,560.608],[1401.34,451.341],[1272.21,560.278],[1272.21,452.702]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1401.34,565.049],[1401.34,674.316],[1272.21,564.649],[1272.21,672.225]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1401.34,677.556],[1401.34,786.824],[1272.21,675.415],[1272.21,782.99]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1401.34,796.711],[1401.34,905.979],[1272.21,792.725],[1272.21,900.301]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1343.56,466.112],[1343.56,378.796],[1346.48,466.837],[1346.48,380.388]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1343.56,562.59],[1343.56,649.906],[1346.48,562.359],[1346.48,648.809]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1343.56,652.495],[1343.56,739.811],[1346.48,651.372],[1346.48,737.821]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1343.56,747.712],[1343.56,835.028],[1346.48,745.644],[1346.48,832.094]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1536.8,442.773],[1536.8,331.73],[1403.94,444.285],[1403.94,334.984]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1536.8,560.955],[1536.8,449.913],[1403.94,560.615],[1403.94,451.313]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1536.8,565.468],[1536.8,676.51],[1403.94,565.057],[1403.94,674.359]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1536.8,679.803],[1403.94,677.599],[1536.8,790.845],[1403.94,786.901]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1536.8,800.894],[1403.94,796.792],[1536.8,911.936],[1403.94,906.094]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1717.72,439.426],[1535.49,441.528],[1717.72,324.531],[1535.49,329.052]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1717.72,561.708],[1535.49,561.235],[1717.72,446.813],[1535.49,448.76]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1717.72,566.377],[1535.49,565.806],[1717.72,681.272],[1535.49,678.282]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1717.72,684.679],[1535.49,681.617],[1717.72,799.574],[1535.49,794.093]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1717.72,809.971],[1535.49,804.271],[1717.72,924.866],[1535.49,916.747]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1716.73,440.681],[1716.73,327.231],[1861.68,439.03],[1861.68,323.68]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1716.73,682.85],[1861.68,685.255],[1716.73,796.3],[1861.68,800.606]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1716.73,806.566],[1861.68,811.044],[1716.73,920.017],[1861.68,926.394]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1716.73,561.426],[1716.73,447.976],[1861.68,561.797],[1861.68,446.447]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:42,
                    verts:[[1716.73,566.036],[1716.73,679.486],[1861.68,566.485],[1861.68,681.835]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[218.186,455.932],[218.186,360.036],[114.588,456.768],[114.588,361.834]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[218.186,557.995],[218.186,462.098],[114.588,557.807],[114.588,462.873]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[218.186,561.892],[218.186,657.789],[114.588,561.665],[114.588,656.599]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[218.186,660.632],[218.186,756.529],[114.588,659.414],[114.588,754.349]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[218.186,765.207],[218.186,861.104],[114.588,762.939],[114.588,857.874]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[342.788,453.891],[342.788,355.646],[204.751,455.019],[204.751,358.071]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[342.788,558.454],[342.788,460.208],[204.751,558.201],[204.751,461.253]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[342.788,562.447],[342.788,660.693],[204.751,562.14],[204.751,659.088]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[342.788,663.606],[342.788,761.851],[204.751,661.963],[204.751,758.911]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[342.788,770.742],[342.788,868.987],[204.751,767.683],[204.751,864.631]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[342.788,453.891],[342.788,355.646],[355.307,454.862],[355.307,357.733]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[342.788,558.454],[342.788,460.208],[355.307,558.236],[355.307,461.107]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[342.788,562.447],[342.788,660.693],[355.307,562.183],[355.307,659.312]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[342.788,663.606],[342.788,761.851],[355.307,662.192],[355.307,759.321]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[342.788,770.742],[342.788,868.987],[355.307,768.11],[355.307,865.239]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[462.867,453.994],[462.867,355.867],[355.307,454.862],[355.307,357.733]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[462.867,558.431],[462.867,460.304],[355.307,558.236],[355.307,461.107]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[462.867,562.419],[462.867,660.546],[355.307,562.183],[355.307,659.312]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[462.867,663.456],[462.867,761.583],[355.307,662.192],[355.307,759.321]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[462.867,770.463],[462.867,868.59],[355.307,768.11],[355.307,865.239]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[572.562,453.072],[572.562,353.884],[461.768,453.966],[461.768,355.807]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[572.562,558.638],[572.562,459.45],[461.768,558.437],[461.768,460.278]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[572.562,562.669],[572.562,661.858],[461.768,562.426],[461.768,660.586]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[572.562,664.799],[572.562,763.987],[461.768,663.496],[461.768,761.655]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[572.562,772.963],[572.562,872.151],[461.768,770.538],[461.768,868.697]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[547.23,469.74],[547.23,389.734],[555.549,470.385],[555.549,391.122]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[547.23,558.14],[547.23,638.146],[555.549,557.965],[555.549,637.228]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[547.23,640.518],[547.23,720.523],[555.549,639.578],[555.549,718.841]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[547.23,727.763],[547.23,807.768],[555.549,726.014],[555.549,805.277]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[710.535,450.887],[710.535,349.183],[562.679,452.095],[562.679,351.782]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[710.535,559.13],[710.535,457.426],[562.679,558.858],[562.679,458.545]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[710.535,563.263],[710.535,664.967],[562.679,562.935],[562.679,663.248]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[710.535,667.982],[710.535,769.686],[562.679,666.223],[562.679,766.536]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[710.535,778.889],[710.535,880.593],[562.679,775.613],[562.679,875.927]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[710.536,450.887],[710.536,349.183],[719.164,451.927],[719.164,351.419]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[710.536,559.13],[710.536,457.426],[719.164,558.896],[719.164,458.389]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[710.536,563.263],[710.536,664.967],[719.164,562.981],[719.164,663.488]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[710.536,667.982],[710.536,769.686],[719.164,666.468],[719.164,766.975]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[710.536,778.889],[710.536,880.593],[719.164,776.07],[719.164,876.577]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[835.411,450.989],[835.411,349.402],[719.163,451.927],[719.163,351.419]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[835.411,559.107],[835.411,457.521],[719.163,558.896],[719.163,458.389]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[835.411,563.235],[835.411,664.822],[719.163,562.981],[719.163,663.488]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[835.411,667.834],[835.411,769.42],[719.163,666.468],[719.163,766.975]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[835.411,778.613],[835.411,880.199],[719.163,776.07],[719.163,876.577]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[835.587,451.016],[835.587,349.461],[851.113,453.268],[851.113,354.305]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[835.587,559.101],[835.587,457.546],[851.113,558.594],[851.113,459.631]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[835.587,563.228],[835.587,664.783],[851.113,562.616],[851.113,661.579]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[835.587,667.794],[835.587,769.349],[851.113,664.513],[851.113,763.477]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[835.587,778.539],[835.587,880.094],[851.113,772.432],[851.113,871.395]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[850.649,470.325],[850.649,388.039],[856.309,470.983],[856.309,389.482]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[850.649,561.246],[850.649,643.532],[856.309,561.036],[856.309,642.537]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[850.649,645.972],[850.649,728.258],[856.309,644.954],[856.309,726.455]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[850.649,735.704],[850.649,817.99],[856.309,733.83],[856.309,815.331]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[850.649,557.902],[850.649,475.616],[856.309,557.724],[856.309,476.223]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[925.032,466.679],[925.032,380.04],[946.655,469.703],[946.655,386.674]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[925.032,558.889],[925.032,472.249],[946.655,558.07],[946.655,475.041]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[925.032,562.41],[925.032,649.049],[946.655,561.445],[946.655,644.473]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[925.032,651.617],[925.032,738.257],[946.655,646.935],[946.655,729.964]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[925.032,746.097],[925.032,832.736],[946.655,737.477],[946.655,820.506]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1139.07,448.5],[1139.07,344.05],[1016.28,449.491],[1016.28,346.181]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1139.07,559.667],[1139.07,455.216],[1016.28,559.444],[1016.28,456.134]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1139.07,563.912],[1139.07,668.362],[1016.28,563.642],[1016.28,666.952]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1139.07,671.459],[1139.07,775.91],[1016.28,670.015],[1016.28,773.325]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1139.07,785.361],[1139.07,889.812],[1016.28,782.674],[1016.28,885.984]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1299.71,446.074],[1299.71,338.83],[1135.43,447.416],[1135.43,341.717]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1299.71,560.213],[1299.71,452.969],[1135.43,559.911],[1135.43,454.212]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1299.71,564.571],[1299.71,671.814],[1135.43,564.206],[1135.43,669.905]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1299.71,674.994],[1299.71,782.238],[1135.43,673.039],[1135.43,778.738]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1299.71,791.942],[1299.71,899.186],[1135.43,788.302],[1135.43,894.001]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1299.71,446.074],[1299.71,338.83],[1301.49,447.229],[1301.49,341.315]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1299.71,560.213],[1299.71,452.969],[1301.49,559.953],[1301.49,454.039]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1299.71,564.571],[1299.71,671.814],[1301.49,564.257],[1301.49,670.171]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1299.71,674.994],[1299.71,782.238],[1301.49,673.311],[1301.49,779.225]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1299.71,791.942],[1299.71,899.186],[1301.49,788.809],[1301.49,894.723]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1429.51,446.196],[1301.49,447.229],[1429.51,339.094],[1301.49,341.315]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1429.51,560.185],[1429.51,453.083],[1301.49,559.953],[1301.49,454.039]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1429.51,564.538],[1429.51,671.64],[1301.49,564.257],[1301.49,670.171]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1429.51,674.816],[1301.49,673.311],[1429.51,781.918],[1301.49,779.225]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1429.51,791.61],[1301.49,788.809],[1429.51,898.712],[1301.49,894.723]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1330.72,467.305],[1330.72,381.414],[1331.84,468.021],[1331.84,382.985]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1330.72,562.21],[1330.72,648.101],[1331.84,561.981],[1331.84,647.018]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1330.72,650.648],[1330.72,736.539],[1331.84,649.539],[1331.84,734.575]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1330.72,744.311],[1330.72,830.203],[1331.84,742.27],[1331.84,827.307]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1432.08,446.176],[1562.6,445.123],[1432.08,339.049],[1562.6,336.784]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1432.08,560.19],[1432.08,453.064],[1562.6,560.427],[1562.6,452.089]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1432.08,564.543],[1562.6,564.829],[1432.08,671.67],[1562.6,673.168]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1432.08,674.846],[1562.6,676.38],[1432.08,781.972],[1562.6,784.718]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1432.08,791.666],[1562.6,794.521],[1432.08,898.793],[1562.6,902.859]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1564.12,443.914],[1564.12,334.184],[1741.27,442.466],[1741.27,331.071]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1564.12,560.699],[1564.12,450.969],[1741.27,561.024],[1741.27,449.629]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1564.12,565.158],[1564.12,674.888],[1741.27,565.551],[1741.27,676.946]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1564.12,678.141],[1564.12,787.871],[1741.27,680.249],[1741.27,791.645]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1564.12,797.8],[1741.27,801.725],[1564.12,907.53],[1741.27,913.12]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1737.57,443.67],[1737.57,333.66],[1876.91,442.546],[1876.91,331.242]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1737.57,678.496],[1737.57,788.505],[1876.91,680.134],[1876.91,791.438]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1737.57,798.46],[1737.57,908.47],[1876.91,801.51],[1876.91,912.814]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1737.57,560.753],[1737.57,450.744],[1876.91,561.006],[1876.91,449.702]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:43,
                    verts:[[1737.57,565.224],[1737.57,675.234],[1876.91,565.53],[1876.91,676.834]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[216.507,454.038],[216.507,355.96],[105.779,454.584],[105.779,357.136]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[216.507,558.421],[216.507,460.344],[105.779,558.298],[105.779,460.85]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[216.507,562.407],[216.507,660.485],[105.779,562.259],[105.779,659.707]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[216.507,663.393],[216.507,761.47],[105.779,662.596],[105.779,760.045]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[216.507,770.345],[216.507,868.423],[105.779,768.863],[105.779,866.311]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[351.119,452.338],[351.119,352.303],[204.681,453.069],[204.681,353.877]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[351.119,558.804],[351.119,458.77],[204.681,558.639],[204.681,459.447]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[351.119,562.869],[351.119,662.903],[204.681,562.67],[204.681,661.862]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[351.119,665.869],[351.119,765.903],[204.681,664.803],[204.681,763.995]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[351.119,774.955],[351.119,874.99],[204.681,772.971],[204.681,872.163]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[351.119,452.338],[351.119,352.303],[361.743,453.357],[361.743,354.496]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[351.119,558.804],[351.119,458.77],[361.743,558.575],[361.743,459.713]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[351.119,562.869],[351.119,662.903],[361.743,562.592],[361.743,661.453]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[351.119,665.869],[351.119,765.903],[361.743,664.384],[361.743,763.245]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[351.119,774.955],[351.119,874.99],[361.743,772.192],[361.743,871.053]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[474.764,452.799],[474.764,353.296],[361.743,453.357],[361.743,354.496]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[474.764,558.7],[474.764,459.197],[361.743,558.575],[361.743,459.713]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[474.764,562.744],[474.764,662.247],[361.743,562.592],[361.743,661.453]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[474.764,665.197],[474.764,764.7],[361.743,664.384],[361.743,763.245]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[474.764,773.704],[474.764,873.207],[361.743,772.192],[361.743,871.053]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[589.247,452.197],[589.247,352.002],[473.701,452.768],[473.701,353.229]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[589.247,558.835],[589.247,458.64],[473.701,558.707],[473.701,459.168]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[589.247,562.907],[589.247,663.102],[473.701,562.752],[473.701,662.291]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[589.247,666.073],[589.247,766.269],[473.701,665.242],[473.701,764.781]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[589.247,775.335],[589.247,875.531],[473.701,773.788],[473.701,873.327]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[523.658,468.889],[523.658,387.905],[530.636,469.559],[530.636,389.345]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[523.658,558.372],[523.658,639.356],[530.636,558.19],[530.636,638.403]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[523.658,641.757],[523.658,722.741],[530.636,640.781],[530.636,720.995]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[523.658,730.069],[523.658,811.053],[530.636,728.253],[530.636,808.467]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[734.424,450.422],[734.424,348.184],[581.49,451.187],[581.49,349.828]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[734.424,559.235],[734.424,456.996],[581.49,559.063],[581.49,457.704]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[734.424,563.389],[734.424,665.628],[581.49,563.182],[581.49,664.541]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[734.424,668.659],[734.424,770.897],[581.49,667.546],[581.49,768.905]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[734.424,780.149],[734.424,882.387],[581.49,778.077],[581.49,879.436]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[734.425,450.422],[734.425,348.184],[740.688,451.487],[740.688,350.473]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[734.425,559.235],[734.425,456.996],[740.688,558.995],[740.688,457.982]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[734.425,563.389],[734.425,665.628],[740.688,563.1],[740.688,664.114]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[734.425,668.659],[734.425,770.897],[740.688,667.109],[740.688,768.122]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[734.425,780.149],[734.425,882.387],[740.688,777.263],[740.688,878.276]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[859.755,450.899],[859.755,349.21],[740.687,451.487],[740.687,350.473]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[859.755,559.127],[859.755,457.438],[740.687,558.995],[740.687,457.982]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[859.755,563.26],[859.755,664.949],[740.687,563.1],[740.687,664.113]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[859.755,667.964],[859.755,769.654],[740.687,667.109],[740.687,768.122]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[859.755,778.856],[859.755,880.546],[740.687,777.263],[740.687,878.276]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[835.813,470.209],[835.813,387.784],[839.892,470.877],[839.892,389.25]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[835.813,561.283],[835.813,643.708],[839.892,561.07],[839.892,642.697]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[835.813,646.152],[835.813,728.577],[839.892,645.117],[839.892,726.744]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[835.813,736.035],[835.813,818.46],[839.892,734.13],[839.892,815.757]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[859.867,450.927],[859.867,349.269],[870.148,453.213],[870.148,354.186]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[859.867,559.121],[859.867,457.463],[870.148,558.607],[870.148,459.58]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[859.867,563.252],[859.867,664.91],[870.148,562.631],[870.148,661.658]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[859.867,667.924],[859.867,769.582],[870.148,664.594],[870.148,763.621]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[859.867,778.781],[859.867,880.439],[870.148,772.582],[870.148,871.609]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[919.022,466.758],[919.022,380.214],[933.276,469.814],[933.276,386.919]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[919.022,558.867],[919.022,472.323],[933.276,558.04],[933.276,475.144]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[919.022,562.384],[919.022,648.928],[933.276,561.409],[933.276,644.305]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[919.022,651.494],[919.022,738.039],[933.276,646.763],[933.276,729.658]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[919.022,745.87],[919.022,832.414],[933.276,737.159],[933.276,820.055]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1166.42,449.348],[1166.42,345.873],[1043.21,449.956],[1043.21,347.181]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1166.42,559.476],[1166.42,456.001],[1043.21,559.339],[1043.21,456.565]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1166.42,563.681],[1166.42,667.156],[1043.21,563.516],[1043.21,666.291]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1166.42,670.224],[1043.21,669.338],[1166.42,773.699],[1043.21,772.113]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1166.42,783.062],[1043.21,781.413],[1166.42,886.537],[1043.21,884.188]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1328.61,447.454],[1165.33,448.269],[1328.61,341.799],[1165.33,343.553]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1328.61,559.902],[1165.33,559.719],[1328.61,454.247],[1165.33,455.003]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1328.61,564.196],[1165.33,563.974],[1328.61,669.851],[1165.33,668.691]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1328.61,672.984],[1165.33,671.795],[1328.61,778.639],[1165.33,776.512]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1328.61,788.2],[1165.33,785.987],[1328.61,893.855],[1165.33,890.704]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1327.73,448.59],[1327.73,344.242],[1453.69,447.968],[1453.69,342.905]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1327.73,671.329],[1453.69,672.234],[1327.73,775.676],[1453.69,777.297]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1327.73,785.119],[1453.69,786.804],[1327.73,889.466],[1453.69,891.867]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1327.73,559.647],[1327.73,455.299],[1453.69,559.787],[1453.69,454.724]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1327.73,563.887],[1327.73,668.235],[1453.69,564.056],[1453.69,669.119]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1456.21,447.956],[1456.21,342.879],[1583.49,447.328],[1583.49,341.528]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1456.21,559.789],[1456.21,454.712],[1583.49,559.931],[1583.49,454.131]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1456.21,564.06],[1456.21,669.137],[1583.49,564.23],[1583.49,670.03]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1456.21,672.252],[1456.21,777.329],[1583.49,673.167],[1583.49,778.967]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1456.21,786.838],[1456.21,891.915],[1583.49,788.541],[1583.49,894.341]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1587.63,446.16],[1587.63,339.015],[1758.61,445.305],[1758.61,337.177]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1587.63,560.193],[1587.63,453.049],[1758.61,560.386],[1758.61,452.258]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1587.63,564.548],[1587.63,671.692],[1758.61,564.78],[1758.61,672.908]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1587.63,674.869],[1587.63,782.014],[1758.61,676.114],[1758.61,784.241]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1587.63,791.709],[1587.63,898.854],[1758.61,794.026],[1758.61,902.154]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1752.47,446.455],[1752.47,339.65],[1885.57,445.798],[1885.57,338.237]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1752.47,564.467],[1752.47,671.272],[1885.57,564.646],[1885.57,672.207]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1752.47,674.439],[1752.47,781.244],[1885.57,675.396],[1885.57,782.957]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1752.47,790.909],[1752.47,897.713],[1885.57,792.69],[1885.57,900.251]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:44,
                    verts:[[1752.47,560.127],[1752.47,453.322],[1885.57,560.275],[1885.57,452.714]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[218.743,451.988],[218.743,351.551],[101.095,452.213],[101.095,352.035]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[218.743,558.882],[218.743,458.446],[101.095,558.832],[101.095,458.654]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[218.743,562.964],[218.743,663.401],[101.095,562.903],[101.095,663.081]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[218.743,666.379],[218.743,766.816],[101.095,666.051],[101.095,766.229]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[218.743,775.904],[218.743,876.341],[101.095,775.294],[101.095,875.472]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[363.037,450.666],[363.037,348.708],[208.705,450.965],[208.705,349.35]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[363.037,559.18],[363.037,457.222],[208.705,559.113],[208.705,457.498]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[363.037,563.323],[363.037,665.281],[208.705,563.242],[208.705,664.856]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[363.037,668.304],[363.037,770.262],[208.705,667.869],[208.705,769.483]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[363.037,779.489],[363.037,881.447],[208.705,778.678],[208.705,880.293]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[363.037,450.666],[363.037,348.708],[371.602,451.732],[371.602,351]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[363.037,559.18],[363.037,457.222],[371.602,558.94],[371.602,458.209]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[363.037,563.323],[363.037,665.281],[371.602,563.034],[371.602,663.765]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[363.037,668.304],[363.037,770.262],[371.602,666.752],[371.602,767.483]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[363.037,779.489],[363.037,881.447],[371.602,776.598],[371.602,877.33]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[489.565,451.506],[489.565,350.515],[371.601,451.732],[371.601,351]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[489.565,558.991],[489.565,458],[371.601,558.94],[371.601,458.209]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[489.565,563.095],[489.565,664.086],[371.601,563.034],[371.601,663.765]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[489.565,667.08],[489.565,768.071],[371.601,666.752],[371.601,767.483]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[489.565,777.21],[489.565,878.201],[371.601,776.598],[371.601,877.329]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[608.208,451.243],[608.208,349.948],[488.546,451.472],[488.546,350.441]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[608.208,559.05],[608.208,457.756],[488.546,558.999],[488.546,457.968]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[608.208,563.166],[608.208,664.461],[488.546,563.104],[488.546,664.135]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[608.208,667.464],[608.208,768.758],[488.546,667.131],[488.546,768.161]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[608.208,777.924],[608.208,879.219],[488.546,777.304],[488.546,878.334]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[501.485,467.894],[501.485,385.765],[507.056,468.587],[507.056,387.256]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[501.485,558.642],[501.485,640.771],[507.056,558.454],[507.056,639.785]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[501.485,643.206],[501.485,725.336],[507.056,642.197],[507.056,723.528]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[501.485,732.768],[501.485,814.897],[507.056,730.888],[507.056,812.22]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[759.702,449.898],[759.702,347.056],[602.689,450.202],[602.689,347.71]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[759.702,559.353],[759.702,456.511],[602.689,559.284],[602.689,456.792]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[759.702,563.532],[759.702,666.374],[602.689,563.449],[602.689,665.941]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[759.702,669.423],[759.702,772.265],[602.689,668.98],[602.689,771.472]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[759.702,781.571],[759.702,884.412],[602.689,780.746],[602.689,883.238]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[759.703,449.898],[759.703,347.056],[763.528,450.982],[763.528,349.389]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[759.703,559.353],[759.703,456.511],[763.528,559.109],[763.528,457.515]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[759.703,563.532],[759.703,666.374],[763.528,563.237],[763.528,664.831]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[759.703,669.423],[759.703,772.265],[763.528,667.843],[763.528,769.437]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[759.703,781.571],[759.703,884.412],[763.528,778.63],[763.528,880.224]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[884.591,450.751],[884.591,348.891],[763.527,450.982],[763.527,349.389]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[884.591,559.161],[884.591,457.3],[763.527,559.109],[763.527,457.515]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[884.591,563.3],[884.591,665.16],[763.527,563.237],[763.527,664.831]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[884.591,668.18],[884.591,770.041],[763.527,667.843],[763.527,769.437]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[884.591,779.258],[884.591,881.118],[763.527,778.63],[763.527,880.224]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[821.517,469.975],[821.517,387.271],[823.995,470.653],[823.995,388.758]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[821.517,561.358],[821.517,644.062],[823.995,561.141],[823.995,643.036]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[821.517,646.514],[821.517,729.218],[823.995,645.465],[823.995,727.36]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[821.517,736.702],[821.517,819.406],[823.995,734.77],[823.995,816.665]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[884.638,450.779],[884.638,348.951],[889.604,453.088],[889.604,353.917]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[884.638,559.154],[884.638,457.326],[889.604,558.635],[889.604,459.464]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[884.638,563.293],[884.638,665.121],[889.604,562.665],[889.604,661.836]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[884.638,668.14],[884.638,769.968],[889.604,664.776],[889.604,763.947]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[884.638,779.182],[884.638,881.01],[889.604,772.921],[889.604,872.092]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[913.23,466.73],[913.23,380.153],[920.095,469.809],[920.095,386.908]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[913.23,558.875],[913.23,472.297],[920.095,558.042],[920.095,475.14]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[913.23,562.393],[913.23,648.97],[920.095,561.411],[920.095,644.312]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[913.23,651.537],[913.23,738.115],[920.095,646.77],[920.095,729.672]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[913.23,745.949],[913.23,832.526],[920.095,737.174],[920.095,820.075]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1069.3,450.361],[1192.02,450.126],[1069.3,348.051],[1192.02,347.547]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1069.3,559.248],[1069.3,456.939],[1192.02,559.301],[1192.02,456.722]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1069.3,563.406],[1192.02,563.47],[1069.3,665.715],[1192.02,666.049]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1069.3,668.749],[1192.02,669.091],[1069.3,771.058],[1192.02,771.67]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1069.3,780.316],[1192.02,780.953],[1069.3,882.626],[1192.02,883.532]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1193.42,449.059],[1193.42,345.251],[1354.5,448.747],[1354.5,344.58]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1193.42,559.541],[1193.42,455.733],[1354.5,559.612],[1354.5,455.445]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1193.42,563.76],[1193.42,667.568],[1354.5,563.845],[1354.5,668.012]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1193.42,670.646],[1193.42,774.454],[1354.5,671.1],[1354.5,775.267]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1193.42,783.847],[1193.42,887.655],[1354.5,784.693],[1354.5,888.86]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1351.06,449.859],[1351.06,346.972],[1474.14,449.624],[1474.14,346.466]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1351.06,563.542],[1351.06,666.429],[1474.14,563.606],[1474.14,666.764]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1351.06,669.48],[1351.06,772.367],[1474.14,669.823],[1474.14,772.98]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1351.06,781.677],[1351.06,884.563],[1474.14,782.315],[1474.14,885.472]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1351.06,559.361],[1351.06,456.475],[1474.14,559.414],[1474.14,456.257]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1476.59,449.619],[1476.59,346.456],[1599.89,449.383],[1599.89,345.949]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1476.59,559.415],[1476.59,456.252],[1599.89,559.468],[1599.89,456.034]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1476.59,563.608],[1476.59,666.771],[1599.89,563.672],[1599.89,667.106]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1476.59,669.829],[1476.59,772.992],[1599.89,670.173],[1599.89,773.607]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1476.59,782.328],[1476.59,885.49],[1599.89,782.967],[1599.89,886.401]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1606.45,448.259],[1606.45,343.531],[1770.4,447.942],[1770.4,342.848]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1606.45,559.721],[1606.45,454.993],[1770.4,559.793],[1770.4,454.699]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1606.45,563.977],[1606.45,668.705],[1770.4,564.063],[1770.4,669.157]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1606.45,671.81],[1606.45,776.539],[1770.4,672.273],[1770.4,777.366]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1606.45,786.015],[1606.45,890.744],[1770.4,786.876],[1770.4,891.969]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1762.07,449.036],[1762.07,345.201],[1888.48,448.794],[1888.48,344.681]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1762.07,670.679],[1762.07,774.514],[1888.48,671.032],[1888.48,775.144]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1762.07,783.91],[1762.07,887.744],[1888.48,784.565],[1888.48,888.678]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1762.07,559.547],[1762.07,455.712],[1888.48,559.601],[1888.48,455.488]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:45,
                    verts:[[1762.07,563.766],[1762.07,667.601],[1888.48,563.832],[1888.48,667.945]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[225.086,449.769],[225.086,346.778],[100.792,449.636],[100.792,346.492]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[225.086,559.382],[225.086,456.391],[100.792,559.412],[100.792,456.268]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[225.086,563.567],[225.086,666.558],[100.792,563.603],[100.792,666.747]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[225.086,669.611],[225.086,772.602],[100.792,669.805],[100.792,772.949]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[225.086,781.922],[225.086,884.913],[100.792,782.283],[100.792,885.427]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[378.657,448.867],[378.657,344.838],[217.029,448.692],[217.029,344.461]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[378.657,559.585],[378.657,455.556],[217.029,559.624],[217.029,455.394]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[378.657,563.812],[378.657,667.841],[217.029,563.86],[217.029,668.09]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[378.657,670.925],[378.657,774.954],[217.029,671.18],[217.029,775.411]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[378.657,784.368],[378.657,888.396],[217.029,784.842],[217.029,889.073]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[507.321,450.108],[507.321,347.508],[384.993,449.977],[384.993,347.226]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[507.321,559.305],[507.321,456.705],[384.993,559.335],[384.993,456.584]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[507.321,563.475],[507.321,666.075],[384.993,563.51],[384.993,666.261]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[507.321,669.117],[507.321,771.718],[384.993,669.308],[384.993,772.059]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[507.321,781.002],[507.321,883.602],[384.993,781.357],[384.993,884.108]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[629.449,450.201],[629.449,347.709],[506.355,450.07],[506.355,347.425]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[629.449,559.284],[629.449,456.792],[506.355,559.314],[506.355,456.67]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[629.449,563.449],[629.449,665.942],[506.355,563.485],[506.355,666.13]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[629.449,668.981],[629.449,771.474],[506.355,669.173],[506.355,771.817]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[629.449,780.748],[629.449,883.241],[506.355,781.105],[506.355,883.75]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[786.326,449.308],[786.326,345.788],[626.274,449.135],[626.274,345.415]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[786.326,559.485],[786.326,455.965],[626.274,559.524],[626.274,455.804]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[786.326,563.692],[786.326,667.213],[626.274,563.739],[626.274,667.459]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[786.326,670.282],[786.326,773.803],[626.274,670.535],[626.274,774.255]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[786.326,783.17],[626.274,783.64],[786.326,886.691],[626.274,887.361]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[909.874,450.539],[787.648,450.408],[909.874,348.434],[787.648,348.153]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[909.874,559.208],[909.874,457.104],[787.648,559.238],[787.648,456.983]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[909.874,563.358],[787.648,563.393],[909.874,665.462],[787.648,665.649]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[909.874,668.49],[787.648,668.68],[909.874,770.594],[787.648,770.935]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[909.874,779.834],[787.648,780.189],[909.874,881.939],[787.648,882.444]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1067.71,466.673],[1067.71,380.027],[1060.17,469.831],[1060.17,386.955]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1067.71,558.89],[1067.71,472.244],[1060.17,558.036],[1060.17,475.16]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1067.71,562.411],[1067.71,649.057],[1060.17,561.404],[1060.17,644.279]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1067.71,651.626],[1067.71,738.272],[1060.17,646.737],[1060.17,729.612]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1067.71,746.113],[1067.71,832.758],[1060.17,737.112],[1060.17,819.988]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1095.48,450.738],[1095.48,348.862],[1090.56,452.904],[1090.56,353.521]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1095.48,559.164],[1095.48,457.288],[1090.56,558.676],[1090.56,459.294]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1095.48,563.304],[1095.48,665.179],[1090.56,562.715],[1090.56,662.097]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1095.48,668.2],[1095.48,770.075],[1090.56,665.044],[1090.56,764.426]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1095.48,779.294],[1095.48,881.169],[1090.56,773.42],[1090.56,872.802]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1094.53,450.699],[1094.53,348.779],[1215.9,450.829],[1215.9,349.059]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1094.53,559.172],[1094.53,457.253],[1215.9,559.143],[1215.9,457.373]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1094.53,563.314],[1094.53,665.234],[1215.9,563.279],[1215.9,665.049]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1094.53,668.256],[1094.53,770.175],[1215.9,668.067],[1215.9,769.837]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1094.53,779.398],[1094.53,881.318],[1215.9,779.046],[1215.9,880.816]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1158,469.937],[1158,387.188],[1155.51,470.593],[1155.51,388.627]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1158,561.37],[1158,644.119],[1155.51,561.16],[1155.51,643.127]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1158,646.573],[1158,729.322],[1155.51,645.557],[1155.51,727.523]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1158,736.81],[1158,819.56],[1155.51,734.94],[1155.51,816.907]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1219.72,449.778],[1219.72,346.797],[1215.9,450.829],[1215.9,349.059]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1219.72,559.38],[1219.72,456.399],[1215.9,559.143],[1215.9,457.373]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1219.72,563.565],[1219.72,666.545],[1215.9,563.279],[1215.9,665.049]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1219.72,669.598],[1219.72,772.578],[1215.9,668.067],[1215.9,769.837]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1219.72,781.897],[1219.72,884.878],[1215.9,779.046],[1215.9,880.816]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1219.72,449.778],[1219.72,346.797],[1377.5,449.949],[1377.5,347.165]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1219.72,559.38],[1219.72,456.399],[1377.5,559.341],[1377.5,456.557]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1219.72,563.565],[1219.72,666.545],[1377.5,563.518],[1377.5,666.302]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1219.72,669.598],[1219.72,772.578],[1377.5,669.349],[1377.5,772.133]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1219.72,781.897],[1219.72,884.878],[1377.5,781.434],[1377.5,884.217]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1371.63,451.033],[1371.63,349.496],[1491.09,451.16],[1491.09,349.771]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1371.63,667.77],[1371.63,769.306],[1491.09,667.584],[1491.09,768.973]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1371.63,778.494],[1371.63,880.03],[1491.09,778.148],[1491.09,879.537]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1371.63,559.097],[1371.63,457.561],[1491.09,559.069],[1491.09,457.68]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1371.63,563.224],[1371.63,664.76],[1491.09,563.189],[1491.09,664.578]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1478.98,469.548],[1478.98,387.094],[1473.28,470.228],[1473.28,388.579]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1478.98,560.655],[1478.98,643.109],[1473.28,560.446],[1473.28,642.095]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1478.98,645.553],[1478.98,728.008],[1473.28,644.516],[1473.28,726.165]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1478.98,735.469],[1478.98,817.923],[1473.28,733.554],[1473.28,815.203]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1493.46,451.163],[1493.46,349.777],[1612.14,451.29],[1612.14,350.05]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1493.46,559.068],[1493.46,457.682],[1612.14,559.039],[1612.14,457.799]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1493.46,563.188],[1493.46,664.574],[1612.14,563.154],[1612.14,664.393]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1493.46,667.58],[1493.46,768.966],[1612.14,667.395],[1612.14,768.635]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1493.46,778.141],[1493.46,879.527],[1612.14,777.796],[1612.14,879.036]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1620.93,450.212],[1620.93,347.732],[1612.14,451.29],[1612.14,350.05]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1620.93,559.282],[1620.93,456.802],[1612.14,559.039],[1612.14,457.799]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1620.93,563.447],[1620.93,665.927],[1612.14,563.154],[1612.14,664.394]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1620.93,668.965],[1620.93,771.445],[1612.14,667.395],[1612.14,768.635]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1620.93,780.719],[1620.93,883.199],[1612.14,777.796],[1612.14,879.036]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1620.93,450.212],[1620.93,347.732],[1777.18,450.382],[1777.18,348.096]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1620.93,559.282],[1620.93,456.802],[1777.18,559.244],[1777.18,456.958]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1620.93,563.446],[1620.93,665.927],[1777.18,563.401],[1777.18,665.686]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1620.93,668.965],[1620.93,771.445],[1777.18,668.719],[1777.18,771.004]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1620.93,780.719],[1620.93,883.199],[1777.18,780.26],[1777.18,882.545]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1766.88,451.419],[1766.88,350.327],[1886.28,451.547],[1886.28,350.602]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1766.88,667.207],[1766.88,768.299],[1886.28,667.021],[1886.28,767.966]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1766.88,777.447],[1766.88,878.538],[1886.28,777.1],[1886.28,878.045]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1766.88,559.01],[1766.88,457.919],[1886.28,558.982],[1886.28,458.037]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:46,
                    verts:[[1766.88,563.119],[1766.88,664.21],[1886.28,563.084],[1886.28,664.028]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[235.82,447.368],[235.82,341.614],[105.236,446.835],[105.236,340.468]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[235.82,559.922],[235.82,454.168],[105.236,560.042],[105.236,453.675]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[235.82,564.219],[235.82,669.973],[105.236,564.364],[105.236,670.731]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[235.82,673.109],[235.82,778.862],[105.236,673.885],[105.236,780.252]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[235.82,788.432],[235.82,894.186],[105.236,789.877],[105.236,896.244]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[398.164,446.932],[398.164,340.677],[229.948,446.238],[229.948,339.184]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[398.164,560.02],[398.164,453.765],[229.948,560.176],[229.948,453.122]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[398.164,564.338],[398.164,670.593],[229.948,564.526],[229.948,671.581]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[398.164,673.743],[398.164,779.998],[229.948,674.755],[229.948,781.809]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[398.164,789.613],[398.164,895.868],[229.948,791.496],[229.948,898.551]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[528.136,448.598],[528.136,344.261],[402.095,448.084],[402.095,343.155]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[528.136,559.645],[528.136,455.307],[402.095,559.76],[402.095,454.831]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[528.136,563.885],[528.136,668.223],[402.095,564.025],[402.095,668.954]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[528.136,671.316],[528.136,775.654],[402.095,672.065],[402.095,776.994]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[528.136,785.096],[402.095,786.489],[528.136,889.433],[402.095,891.418]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[653.011,449.07],[653.011,345.274],[527.232,448.557],[527.232,344.171]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[653.011,559.539],[653.011,455.744],[527.232,559.654],[527.232,455.268]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[653.011,563.757],[653.011,667.552],[527.232,563.896],[527.232,668.282]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[653.011,670.63],[527.232,671.377],[653.011,774.425],[527.232,775.763]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[653.011,783.817],[527.232,785.209],[653.011,887.613],[527.232,889.594]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[652.284,447.982],[814.275,448.65],[652.284,342.934],[814.275,344.372]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[652.284,559.784],[814.275,559.633],[652.284,454.736],[814.275,455.355]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[652.284,564.053],[814.275,563.871],[652.284,669.1],[814.275,668.149]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[652.284,672.215],[814.275,671.241],[652.284,777.263],[814.275,775.519]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[652.284,786.768],[814.275,784.955],[652.284,891.816],[814.275,889.233]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[813.037,449.76],[813.037,346.759],[935.573,450.26],[935.573,347.834]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[813.037,563.569],[813.037,666.57],[935.573,563.434],[935.573,665.859]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[813.037,669.624],[813.037,772.625],[935.573,668.896],[935.573,771.322]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[813.037,781.945],[935.573,780.59],[813.037,884.946],[935.573,883.016]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[813.037,559.384],[813.037,456.383],[935.573,559.271],[935.573,456.845]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1061.64,466.813],[1061.64,380.334],[1046.59,469.943],[1046.59,387.202]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1061.64,558.852],[1061.64,472.374],[1046.59,558.005],[1046.59,475.264]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1061.64,562.367],[1061.64,648.845],[1046.59,561.368],[1046.59,644.109]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1061.64,651.409],[1061.64,737.888],[1046.59,646.563],[1046.59,729.304]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1061.64,745.714],[1061.64,832.192],[1046.59,736.791],[1046.59,819.533]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1119.73,451.011],[1119.73,349.45],[1109.86,453.153],[1109.86,354.057]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1119.73,559.102],[1119.73,457.541],[1109.86,558.62],[1109.86,459.525]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1119.73,563.229],[1119.73,664.79],[1109.86,562.647],[1109.86,661.743]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1119.73,667.802],[1119.73,769.362],[1109.86,664.681],[1109.86,763.777]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1119.73,778.553],[1119.73,880.114],[1109.86,772.744],[1109.86,871.839]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1118.89,450.97],[1118.89,349.362],[1238.08,451.456],[1238.08,350.408]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1118.89,559.111],[1118.89,457.503],[1238.08,559.002],[1238.08,457.953]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1118.89,563.241],[1118.89,664.849],[1238.08,563.109],[1238.08,664.157]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1118.89,667.861],[1118.89,769.47],[1238.08,667.153],[1238.08,768.202]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1118.89,778.664],[1118.89,880.272],[1238.08,777.346],[1238.08,878.394]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1143.11,470.275],[1143.11,387.93],[1139.08,470.922],[1139.08,389.348]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1143.11,561.262],[1143.11,643.607],[1139.08,561.056],[1139.08,642.629]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1143.11,646.049],[1143.11,728.394],[1139.08,645.048],[1139.08,726.622]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1143.11,735.846],[1143.11,818.191],[1139.08,734.003],[1139.08,815.577]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1244.24,450.425],[1244.24,348.19],[1238.08,451.456],[1238.08,350.408]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1244.24,559.234],[1244.24,456.999],[1238.08,559.002],[1238.08,457.953]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1244.24,563.389],[1244.24,665.624],[1238.08,563.109],[1238.08,664.157]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1244.24,668.655],[1244.24,770.89],[1238.08,667.153],[1238.08,768.202]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1244.24,780.142],[1244.24,882.377],[1238.08,777.346],[1238.08,878.394]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1244.24,450.425],[1244.24,348.19],[1397.7,451.059],[1397.7,349.553]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1244.24,559.234],[1244.24,456.999],[1397.7,559.091],[1397.7,457.585]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1244.24,563.389],[1244.24,665.624],[1397.7,563.216],[1397.7,664.723]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1244.24,668.655],[1244.24,770.89],[1397.7,667.732],[1397.7,769.238]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1244.24,780.142],[1244.24,882.377],[1397.7,778.424],[1397.7,879.93]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1389.54,452.111],[1389.54,351.815],[1504.72,452.58],[1504.72,352.825]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1389.54,666.2],[1389.54,766.495],[1504.72,665.516],[1504.72,765.271]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1389.54,775.571],[1389.54,875.866],[1504.72,774.297],[1504.72,874.052]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1389.54,558.855],[1389.54,458.559],[1504.72,558.749],[1504.72,458.994]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1389.54,562.931],[1389.54,663.226],[1504.72,562.803],[1504.72,662.558]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1455.64,470.624],[1455.64,389.444],[1448.54,471.281],[1448.54,390.876]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1455.64,560.324],[1455.64,641.505],[1448.54,560.123],[1448.54,640.527]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1455.64,643.912],[1455.64,725.092],[1448.54,642.911],[1448.54,723.315]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1455.64,732.438],[1455.64,813.619],[1448.54,730.591],[1448.54,810.996]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1507,452.589],[1507,352.845],[1620.52,453.052],[1620.52,353.841]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1507,558.747],[1507,459.003],[1620.52,558.643],[1620.52,459.432]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1507,562.8],[1507,662.545],[1620.52,562.675],[1620.52,661.886]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1507,665.502],[1507,765.246],[1620.52,664.828],[1620.52,764.039]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1507,774.272],[1507,874.016],[1620.52,773.017],[1620.52,872.228]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1631.35,452.023],[1631.35,351.627],[1620.52,453.052],[1620.52,353.841]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1631.35,558.875],[1631.35,458.478],[1620.52,558.643],[1620.52,459.432]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1631.35,562.954],[1631.35,663.35],[1620.52,562.675],[1620.52,661.886]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1631.35,666.327],[1631.35,766.723],[1620.52,664.828],[1620.52,764.039]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1631.35,775.808],[1631.35,876.204],[1620.52,773.017],[1620.52,872.228]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1631.35,452.023],[1631.35,351.627],[1779.36,452.634],[1779.36,352.941]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1631.35,558.875],[1631.35,458.478],[1779.36,558.737],[1779.36,459.044]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1631.35,562.954],[1631.35,663.35],[1779.36,562.788],[1779.36,662.481]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1631.35,666.327],[1631.35,766.723],[1779.36,665.437],[1779.36,765.13]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1631.35,775.808],[1631.35,876.204],[1779.36,774.151],[1779.36,873.844]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1767.29,453.615],[1767.29,355.051],[1879.47,454.072],[1879.47,356.035]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1767.29,562.522],[1767.29,661.086],[1879.47,562.398],[1879.47,660.435]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1767.29,664.008],[1767.29,762.572],[1879.47,663.342],[1879.47,761.379]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1767.29,771.492],[1767.29,870.056],[1879.47,770.251],[1879.47,868.288]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:47,
                    verts:[[1767.29,558.516],[1767.29,459.952],[1879.47,558.414],[1879.47,460.376]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[251.323,444.776],[251.323,336.038],[114.916,443.796],[114.916,333.931]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[251.323,560.505],[251.323,451.767],[114.916,560.725],[114.916,450.86]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[251.323,564.924],[251.323,673.661],[114.916,565.19],[114.916,675.055]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[251.323,676.885],[251.323,785.622],[114.916,678.312],[114.916,788.177]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[251.323,795.462],[251.323,904.2],[114.916,798.119],[114.916,907.984]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[421.802,444.859],[421.802,336.217],[247.859,443.594],[247.859,333.498]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[421.802,560.486],[421.802,451.844],[247.859,560.771],[247.859,450.674]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[421.802,564.901],[421.802,673.543],[247.859,565.245],[247.859,675.342]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[421.802,676.764],[421.802,785.406],[247.859,678.606],[247.859,788.703]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[421.802,795.237],[247.859,798.666],[421.802,903.878],[247.859,908.763]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[552.154,446.975],[423.145,446.049],[552.154,340.77],[423.145,338.778]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[552.154,560.01],[552.154,453.804],[423.145,560.218],[423.145,452.947]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[552.154,564.326],[423.145,564.578],[552.154,670.532],[423.145,671.849]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[552.154,673.68],[423.145,675.03],[552.154,779.886],[423.145,782.301]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[552.154,789.497],[423.145,792.008],[552.154,895.702],[423.145,899.279]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[551.323,446.93],[678.963,447.847],[551.323,340.672],[678.963,342.644]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[551.323,560.02],[551.323,453.762],[678.963,559.814],[678.963,454.611]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[551.323,564.338],[551.323,670.596],[678.963,564.089],[678.963,669.292]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[551.323,673.747],[678.963,672.411],[551.323,780.004],[678.963,777.614]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[551.323,789.62],[678.963,787.134],[551.323,895.877],[678.963,892.337]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[650.538,467.82],[650.538,382.544],[649.366,468.506],[649.366,384.047]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[650.538,562.045],[650.538,647.321],[649.366,561.827],[649.366,646.285]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[650.538,649.85],[650.538,735.126],[649.366,648.789],[649.366,733.247]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[650.538,742.842],[650.538,828.119],[649.366,740.89],[649.366,825.348]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[680.783,446.742],[680.783,340.267],[678.962,447.847],[678.962,342.644]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[680.783,560.063],[680.783,453.588],[678.962,559.814],[678.962,454.611]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[680.783,564.39],[680.783,670.864],[678.962,564.089],[678.962,669.292]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[680.783,674.021],[680.783,780.496],[678.962,672.411],[678.962,777.614]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[680.783,790.131],[680.783,896.606],[678.962,787.134],[678.962,892.337]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[680.784,446.742],[680.784,340.267],[843.54,447.925],[843.54,342.812]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[680.784,560.063],[680.784,453.588],[843.54,559.796],[843.54,454.683]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[680.784,564.39],[680.784,670.864],[843.54,564.068],[843.54,669.181]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[680.784,674.021],[680.784,780.496],[843.54,672.298],[843.54,777.411]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[680.784,790.131],[680.784,896.606],[843.54,786.923],[843.54,892.036]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[839.692,449.04],[839.692,345.21],[961.658,449.915],[961.658,347.093]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[839.692,670.674],[839.692,774.503],[961.658,669.398],[961.658,772.22]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[839.692,783.899],[839.692,887.729],[961.658,781.525],[961.658,884.347]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[839.692,559.546],[839.692,455.716],[961.658,559.349],[961.658,456.526]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[839.692,563.765],[839.692,667.595],[961.658,563.527],[961.658,666.349]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1055.11,466.842],[1055.11,380.397],[1032.6,469.936],[1032.6,387.185]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1055.11,558.845],[1055.11,472.4],[1032.6,558.007],[1032.6,475.256]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1055.11,562.358],[1055.11,648.802],[1032.6,561.37],[1032.6,644.121]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1055.11,651.365],[1055.11,737.81],[1032.6,646.575],[1032.6,729.326]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1055.11,745.632],[1055.11,832.077],[1032.6,736.814],[1032.6,819.565]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1127.49,470.491],[1127.49,388.404],[1121.96,471.126],[1121.96,389.797]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1127.49,557.857],[1127.49,475.769],[1121.96,557.685],[1121.96,476.356]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1127.49,561.193],[1127.49,643.281],[1121.96,560.99],[1121.96,642.32]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1127.49,645.715],[1127.49,727.802],[1121.96,644.731],[1121.96,726.061]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1127.49,735.23],[1127.49,817.318],[1121.96,733.42],[1121.96,814.75]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1143.07,451.218],[1143.07,349.895],[1128.35,453.326],[1128.35,354.43]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1143.07,559.056],[1143.07,457.733],[1128.35,558.581],[1128.35,459.685]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1143.07,563.173],[1143.07,664.496],[1128.35,562.6],[1128.35,661.496]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1143.07,667.5],[1143.07,768.823],[1128.35,664.429],[1128.35,763.325]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1143.07,777.992],[1143.07,879.315],[1128.35,772.274],[1128.35,871.17]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1142.33,451.174],[1142.33,349.802],[1258.55,452.009],[1258.55,351.597]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1142.33,559.065],[1142.33,457.693],[1258.55,558.878],[1258.55,458.465]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1142.33,563.185],[1142.33,664.558],[1258.55,562.958],[1258.55,663.37]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1142.33,667.564],[1142.33,768.936],[1258.55,666.348],[1258.55,766.76]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1142.33,778.11],[1142.33,879.482],[1258.55,775.846],[1258.55,876.258]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1266.98,451.003],[1266.98,349.432],[1258.56,452.009],[1258.56,351.597]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1266.98,559.104],[1266.98,457.534],[1258.56,558.878],[1258.56,458.465]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1266.98,563.232],[1266.98,664.802],[1258.56,562.958],[1258.56,663.37]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1266.98,667.814],[1266.98,769.384],[1258.56,666.348],[1258.56,766.76]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1266.98,778.575],[1266.98,880.145],[1258.56,775.846],[1258.56,876.258]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1266.98,451.003],[1266.98,349.432],[1415.17,452.08],[1415.17,351.75]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1266.98,559.104],[1266.98,457.534],[1415.17,558.862],[1415.17,458.531]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1266.98,563.232],[1266.98,664.802],[1415.17,562.939],[1415.17,663.269]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1266.98,667.814],[1266.98,769.384],[1415.17,666.244],[1415.17,766.575]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1266.98,778.575],[1266.98,880.145],[1415.17,775.654],[1415.17,875.984]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1404.83,453.096],[1404.83,353.936],[1515.15,453.888],[1515.15,355.639]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1404.83,562.663],[1404.83,661.824],[1515.15,562.448],[1515.15,660.697]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1404.83,664.764],[1404.83,763.924],[1515.15,663.61],[1515.15,761.859]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1404.83,772.898],[1404.83,872.058],[1515.15,770.75],[1515.15,868.999]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1404.83,558.633],[1404.83,459.472],[1515.15,558.455],[1515.15,460.206]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1430.8,471.55],[1430.8,391.464],[1422.38,472.182],[1422.38,392.843]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1430.8,560.04],[1430.8,640.126],[1422.38,559.846],[1422.38,639.185]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1430.8,642.5],[1430.8,722.586],[1422.38,641.537],[1422.38,720.876]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1430.8,729.833],[1430.8,809.919],[1422.38,728.055],[1422.38,807.394]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1517.32,453.904],[1517.32,355.672],[1625.22,454.678],[1625.22,357.338]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1517.32,558.451],[1517.32,460.22],[1625.22,558.277],[1625.22,460.937]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1517.32,562.443],[1517.32,660.675],[1625.22,562.233],[1625.22,659.573]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1517.32,663.587],[1517.32,761.819],[1625.22,662.459],[1625.22,759.799]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1517.32,770.708],[1517.32,868.939],[1625.22,768.607],[1625.22,865.947]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1637.91,453.699],[1637.91,355.232],[1625.22,454.678],[1625.22,357.338]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1637.91,558.497],[1637.91,460.031],[1625.22,558.277],[1625.22,460.937]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1637.91,562.499],[1637.91,660.966],[1625.22,562.233],[1625.22,659.573]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1637.91,663.885],[1637.91,762.352],[1625.22,662.459],[1625.22,759.799]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1637.91,771.263],[1637.91,869.729],[1625.22,768.607],[1625.22,865.947]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1637.92,453.699],[1637.92,355.232],[1777.24,454.712],[1777.24,357.411]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1637.92,558.497],[1637.92,460.031],[1777.24,558.27],[1777.24,460.968]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1637.92,562.499],[1637.92,660.966],[1777.24,562.224],[1777.24,659.525]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1637.92,663.885],[1637.92,762.352],[1777.24,662.41],[1777.24,759.711]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1637.92,771.263],[1637.92,869.729],[1777.24,768.516],[1777.24,865.817]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1763.6,455.636],[1763.6,359.398],[1868.4,456.389],[1868.4,361.017]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1763.6,661.064],[1763.6,757.302],[1868.4,659.967],[1868.4,755.339]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1763.6,766.01],[1763.6,862.248],[1868.4,763.969],[1868.4,859.341]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1763.6,558.062],[1763.6,461.824],[1868.4,557.892],[1868.4,462.521]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:48,
                    verts:[[1763.6,561.973],[1763.6,658.211],[1868.4,561.768],[1868.4,657.14]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[272.091,441.986],[272.091,330.038],[130.479,440.506],[130.479,326.854]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[272.091,561.132],[272.091,449.184],[130.479,561.465],[130.479,447.814]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[272.091,565.682],[272.091,677.63],[130.479,566.084],[130.479,679.736]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[272.091,680.949],[130.479,683.105],[272.091,792.897],[130.479,796.757]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[272.091,803.027],[130.479,807.042],[272.091,914.975],[130.479,920.693]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[271.27,440.756],[449.892,442.647],[271.27,327.392],[449.892,331.459]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[271.27,561.409],[271.27,448.045],[449.892,560.984],[449.892,449.796]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[271.27,566.016],[449.892,565.502],[271.27,679.38],[449.892,676.69]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[271.27,682.741],[449.892,679.987],[271.27,796.105],[449.892,791.175]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[271.27,806.363],[449.892,801.236],[271.27,919.727],[449.892,912.424]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[448.46,443.871],[448.46,334.093],[579.573,445.241],[579.573,337.04]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[448.46,678.203],[448.46,787.981],[579.573,676.207],[579.573,784.409]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[448.46,797.915],[579.573,794.2],[448.46,907.693],[579.573,902.401]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[448.46,560.708],[448.46,450.93],[579.573,560.4],[579.573,452.198]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[448.46,565.169],[448.46,674.948],[579.573,564.797],[579.573,672.999]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[578.826,445.192],[578.826,336.934],[707.406,446.536],[707.406,339.825]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[578.826,560.411],[578.826,452.153],[707.406,560.109],[707.406,453.398]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[578.826,564.81],[578.826,673.068],[707.406,564.445],[707.406,671.156]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[578.826,676.278],[578.826,784.536],[707.406,674.32],[707.406,781.031]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[578.826,794.333],[578.826,902.591],[707.406,790.688],[707.406,897.399]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[637.539,466.747],[637.539,380.189],[634.665,467.44],[634.665,381.711]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[637.539,562.388],[637.539,648.945],[634.665,562.166],[634.665,647.896]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[637.539,651.512],[637.539,738.069],[634.665,650.438],[634.665,736.168]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[637.539,745.902],[637.539,832.459],[634.665,743.925],[634.665,829.655]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[711.869,445.419],[711.869,337.423],[707.405,446.536],[707.405,339.825]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[711.869,560.36],[711.869,452.363],[707.405,560.109],[707.405,453.398]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[711.869,564.749],[711.869,672.746],[707.405,564.445],[707.405,671.156]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[711.869,675.948],[711.869,783.944],[707.405,674.32],[707.405,781.031]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[711.869,793.717],[711.869,901.714],[707.405,790.688],[707.405,897.399]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[711.869,445.419],[711.869,337.423],[874.126,447.137],[874.126,341.116]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[711.869,560.36],[711.869,452.363],[874.126,559.974],[874.126,453.954]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[711.869,564.749],[711.869,672.746],[874.126,564.282],[874.126,670.302]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[711.869,675.948],[711.869,783.944],[874.126,673.446],[874.126,779.466]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[711.869,793.717],[711.869,901.714],[874.126,789.06],[874.126,895.08]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[867.628,448.251],[867.628,343.513],[988.102,449.51],[988.102,346.221]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[867.628,671.823],[867.628,776.56],[988.102,669.989],[988.102,773.278]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[867.628,786.038],[867.628,890.776],[988.102,782.624],[988.102,885.914]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[867.628,559.723],[867.628,454.985],[988.102,559.44],[988.102,456.151]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[867.628,563.979],[867.628,668.717],[988.102,563.637],[988.102,666.926]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1048.09,466.761],[1048.09,380.22],[1018.19,469.809],[1018.19,386.907]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1048.09,558.866],[1048.09,472.325],[1018.19,558.042],[1018.19,475.14]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1048.09,562.383],[1048.09,648.924],[1018.19,561.411],[1018.19,644.312]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1048.09,651.49],[1048.09,738.031],[1018.19,646.77],[1018.19,729.672]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1048.09,745.862],[1048.09,832.403],[1018.19,737.174],[1018.19,820.076]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1111.12,470.588],[1111.12,388.615],[1104.1,471.21],[1104.1,389.98]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1111.12,557.831],[1111.12,475.859],[1104.1,557.663],[1104.1,476.433]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1111.12,561.162],[1111.12,643.135],[1104.1,560.964],[1104.1,642.193]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1111.12,645.565],[1111.12,727.537],[1104.1,644.602],[1104.1,725.831]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1111.12,734.955],[1111.12,816.927],[1104.1,733.182],[1104.1,814.411]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1165.45,451.363],[1165.45,350.207],[1145.98,453.428],[1145.98,354.65]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1165.45,559.023],[1165.45,457.867],[1145.98,558.558],[1145.98,459.78]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1165.45,563.134],[1165.45,664.29],[1145.98,562.573],[1145.98,661.351]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1165.45,667.289],[1165.45,768.445],[1145.98,664.28],[1145.98,763.059]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1165.45,777.598],[1165.45,878.754],[1145.98,771.997],[1145.98,870.776]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1164.82,451.317],[1164.82,350.109],[1277.3,452.493],[1277.3,352.638]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1164.82,559.033],[1164.82,457.825],[1277.3,558.769],[1277.3,458.914]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1164.82,563.146],[1164.82,664.354],[1277.3,562.827],[1277.3,662.682]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1164.82,667.355],[1164.82,768.564],[1277.3,665.642],[1277.3,765.498]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1164.82,777.722],[1164.82,878.93],[1277.3,774.533],[1277.3,874.389]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1287.89,451.516],[1287.89,350.536],[1277.3,452.493],[1277.3,352.638]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1287.89,558.989],[1287.89,458.009],[1277.3,558.769],[1277.3,458.914]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1287.89,563.092],[1287.89,664.072],[1277.3,562.827],[1277.3,662.682]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1287.89,667.066],[1287.89,768.046],[1277.3,665.642],[1277.3,765.498]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1287.89,777.184],[1287.89,878.164],[1277.3,774.533],[1277.3,874.389]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1287.89,451.516],[1287.89,350.536],[1429.92,453.019],[1429.92,353.769]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1287.89,558.989],[1287.89,458.009],[1429.92,558.65],[1429.92,459.401]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1287.89,563.092],[1287.89,664.072],[1429.92,562.684],[1429.92,661.934]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1287.89,667.066],[1287.89,768.046],[1429.92,664.876],[1429.92,764.126]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1287.89,777.184],[1287.89,878.164],[1429.92,773.107],[1429.92,872.357]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1404.44,472.334],[1404.44,393.176],[1394.77,472.94],[1394.77,394.499]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1404.44,559.799],[1404.44,638.957],[1394.77,559.613],[1394.77,638.054]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1404.44,641.305],[1404.44,720.463],[1394.77,640.38],[1394.77,718.821]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1404.44,727.626],[1404.44,806.784],[1394.77,725.919],[1394.77,804.361]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1417.53,453.996],[1417.53,355.871],[1522.45,455.092],[1522.45,358.229]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1417.53,663.453],[1417.53,761.578],[1522.45,661.856],[1522.45,758.719]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1417.53,770.457],[1417.53,868.582],[1522.45,767.484],[1522.45,864.348]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1417.53,558.431],[1417.53,460.306],[1522.45,558.184],[1522.45,461.321]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1417.53,562.418],[1417.53,660.543],[1522.45,562.12],[1522.45,658.984]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1524.5,455.114],[1524.5,358.275],[1626.35,456.178],[1626.35,360.564]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1524.5,558.179],[1524.5,461.34],[1626.35,557.94],[1626.35,462.326]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1524.5,562.115],[1524.5,658.953],[1626.35,561.825],[1626.35,657.44]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1524.5,661.825],[1524.5,758.663],[1626.35,660.274],[1626.35,755.888]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1524.5,767.426],[1524.5,864.265],[1626.35,764.541],[1626.35,860.155]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1640.74,455.25],[1640.74,358.569],[1626.35,456.178],[1626.35,360.564]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1640.74,558.149],[1640.74,461.467],[1626.35,557.94],[1626.35,462.326]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1640.74,562.078],[1640.74,658.759],[1626.35,561.826],[1626.35,657.44]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1640.74,661.626],[1640.74,758.307],[1626.35,660.274],[1626.35,755.888]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1640.74,767.056],[1640.74,863.738],[1626.35,764.541],[1626.35,860.155]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1640.74,455.25],[1640.74,358.569],[1771.03,456.629],[1771.03,361.535]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1640.74,558.149],[1640.74,461.467],[1771.03,557.838],[1771.03,462.744]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1640.74,562.078],[1640.74,658.759],[1771.03,561.703],[1771.03,656.797]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1640.74,661.626],[1640.74,758.307],[1771.03,659.617],[1771.03,754.712]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1640.74,767.056],[1640.74,863.738],[1771.03,763.317],[1771.03,858.411]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1755.98,457.497],[1755.98,363.4],[1853.3,458.514],[1853.3,365.588]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1755.98,561.467],[1755.98,655.564],[1853.3,561.191],[1853.3,654.116]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1755.98,658.354],[1755.98,752.45],[1853.3,656.872],[1853.3,749.797]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1755.98,760.965],[1755.98,855.061],[1853.3,758.206],[1853.3,851.132]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:49,
                    verts:[[1755.98,557.643],[1755.98,463.547],[1853.3,557.414],[1853.3,464.489]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[150.59,449.654],[150.59,346.532],[149.28,457.459],[149.28,363.319]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[150.59,559.407],[150.59,456.285],[149.28,557.652],[149.28,463.512]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[150.59,563.598],[150.59,666.72],[149.28,561.477],[149.28,655.617]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[150.59,669.778],[150.59,772.9],[149.28,658.408],[149.28,752.548]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[150.59,782.232],[150.59,885.354],[149.28,761.067],[149.28,855.207]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[152.721,436.958],[152.721,319.224],[151.035,447.007],[151.035,340.838]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[152.721,562.263],[152.721,444.529],[151.035,560.003],[151.035,453.834]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[152.721,567.048],[152.721,684.782],[151.035,564.317],[151.035,670.486]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[152.721,688.273],[152.721,806.008],[151.035,673.634],[151.035,779.803]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[152.721,816.662],[152.721,934.396],[151.035,789.41],[151.035,895.579]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[152.721,436.958],[298.718,438.999],[152.721,319.224],[298.718,323.614]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[152.721,562.263],[152.721,444.529],[298.718,561.804],[298.718,446.419]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[152.721,567.048],[152.721,684.782],[298.718,566.493],[298.718,681.879]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[152.721,688.273],[298.718,685.3],[152.721,806.008],[298.718,800.686]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[152.721,816.662],[298.718,811.127],[152.721,934.396],[298.718,926.512]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[266.542,458.769],[266.542,366.137],[265.234,459.572],[265.234,367.865]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[266.542,561.121],[266.542,653.753],[265.234,560.903],[265.234,652.611]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[266.542,656.5],[266.542,749.132],[265.234,655.33],[265.234,747.037]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[266.542,757.514],[266.542,850.146],[265.234,755.336],[265.234,847.043]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[300.792,437.724],[300.792,320.871],[298.717,438.999],[298.717,323.614]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[300.792,562.091],[300.792,445.238],[298.717,561.804],[298.717,446.418]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[300.792,566.84],[300.792,683.693],[298.717,566.493],[298.717,681.879]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[300.792,687.157],[300.792,804.01],[298.717,685.3],[298.717,800.686]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[300.792,814.584],[300.792,931.437],[298.717,811.127],[298.717,926.513]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[300.793,437.724],[300.793,320.871],[482.807,440.302],[482.807,326.416]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[300.793,562.091],[300.793,445.238],[482.807,561.511],[482.807,447.625]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[300.793,566.84],[300.793,683.693],[482.807,566.139],[482.807,680.026]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[300.793,687.157],[300.793,804.01],[482.807,683.402],[482.807,797.289]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[300.793,814.584],[300.793,931.437],[482.807,807.594],[482.807,921.481]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[478.407,441.556],[478.407,329.112],[610.618,443.403],[610.618,333.086]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[478.407,681.576],[478.407,794.02],[610.618,678.885],[610.618,789.202]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[478.407,804.195],[478.407,916.638],[610.618,799.185],[610.618,909.502]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[478.407,561.229],[478.407,448.786],[610.618,560.814],[610.618,450.496]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[478.407,565.799],[478.407,678.242],[610.618,565.297],[610.618,675.614]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[609.966,443.35],[609.966,332.973],[738.448,445.146],[738.448,336.836]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[609.966,560.825],[609.966,450.448],[738.448,560.421],[738.448,452.111]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[609.966,565.311],[609.966,675.689],[738.448,564.823],[738.448,673.134]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[609.966,678.961],[609.966,789.339],[738.448,676.345],[738.448,784.656]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[609.966,799.327],[609.966,909.705],[738.448,794.457],[738.448,902.767]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[625.587,465.524],[625.587,377.507],[620.938,466.224],[620.938,379.042]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[625.587,562.778],[625.587,650.795],[620.938,562.555],[620.938,649.737]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[625.587,653.405],[625.587,741.422],[620.938,652.322],[620.938,739.504]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[625.587,749.387],[625.587,837.404],[620.938,747.393],[620.938,834.575]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[745.638,444.024],[745.638,334.421],[738.447,445.146],[738.447,336.836]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[745.638,560.674],[745.638,451.071],[738.447,560.421],[738.447,452.111]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[745.638,565.128],[745.638,674.731],[738.447,564.823],[738.447,673.134]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[745.638,677.98],[745.638,787.583],[738.447,676.345],[738.447,784.656]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[745.638,797.501],[745.638,907.103],[738.447,794.457],[738.447,902.767]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[745.639,444.024],[745.639,334.421],[906.02,446.295],[906.02,339.307]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[745.639,560.674],[745.639,451.071],[906.02,560.163],[906.02,453.174]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[745.639,565.128],[745.639,674.731],[906.02,564.511],[906.02,671.499]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[745.639,677.98],[745.639,787.583],[906.02,674.672],[906.02,781.66]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[745.639,797.501],[745.639,907.103],[906.02,791.342],[906.02,898.33]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[896.842,447.402],[896.842,341.688],[1014.85,449.051],[1014.85,345.235]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[896.842,673.059],[896.842,778.773],[1014.85,670.656],[1014.85,774.473]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[896.842,788.339],[896.842,894.053],[1014.85,783.867],[1014.85,887.683]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[896.842,559.914],[896.842,454.2],[1014.85,559.543],[1014.85,455.727]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[896.842,564.21],[896.842,669.924],[1014.85,563.762],[1014.85,667.578]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1040.56,466.575],[1040.56,379.813],[1003.3,469.567],[1003.3,386.377]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1040.56,562.442],[1040.56,649.205],[1003.3,561.488],[1003.3,644.678]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1040.56,651.777],[1040.56,738.54],[1003.3,647.145],[1003.3,730.336]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1040.56,746.391],[1040.56,833.154],[1003.3,737.864],[1003.3,821.055]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1040.56,558.917],[1040.56,472.154],[1003.3,558.107],[1003.3,474.916]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1093.94,470.569],[1093.94,388.575],[1085.46,471.177],[1085.46,389.907]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1093.94,557.836],[1093.94,475.841],[1085.46,557.672],[1085.46,476.402]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1093.94,561.168],[1093.94,643.163],[1085.46,560.974],[1085.46,642.244]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1093.94,645.594],[1093.94,727.588],[1085.46,644.653],[1085.46,725.923]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1093.94,735.008],[1093.94,817.003],[1085.46,733.277],[1085.46,814.546]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1186.79,451.454],[1186.79,350.404],[1162.7,453.466],[1162.7,354.732]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1186.79,559.002],[1186.79,457.952],[1162.7,558.55],[1162.7,459.815]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1186.79,563.109],[1186.79,664.16],[1162.7,562.562],[1162.7,661.297]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1186.79,667.156],[1186.79,768.206],[1162.7,664.225],[1162.7,762.959]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1186.79,777.35],[1186.79,878.401],[1162.7,771.894],[1162.7,870.629]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1186.27,451.407],[1186.27,350.301],[1294.25,452.916],[1294.25,353.548]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1186.27,559.013],[1186.27,457.908],[1294.25,558.674],[1294.25,459.305]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1186.27,563.122],[1186.27,664.227],[1294.25,562.712],[1294.25,662.08]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1186.27,667.225],[1186.27,768.33],[1294.25,665.026],[1294.25,764.394]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1186.27,777.479],[1186.27,878.585],[1294.25,773.386],[1294.25,872.754]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1306.91,451.972],[1306.91,351.518],[1294.25,452.916],[1294.25,353.548]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1306.91,558.886],[1306.91,458.431],[1294.25,558.674],[1294.25,459.305]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1306.91,562.968],[1306.91,663.423],[1294.25,562.712],[1294.25,662.08]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1306.91,666.401],[1306.91,766.856],[1294.25,665.026],[1294.25,764.394]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1306.91,775.946],[1306.91,876.4],[1294.25,773.386],[1294.25,872.754]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1306.91,451.972],[1306.91,351.518],[1441.91,453.884],[1441.91,355.63]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1306.91,558.886],[1306.91,458.431],[1441.91,558.456],[1441.91,460.202]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1306.91,562.968],[1306.91,663.423],[1441.91,562.449],[1441.91,660.703]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1306.91,666.401],[1306.91,766.856],[1441.91,663.616],[1441.91,761.871]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1306.91,775.946],[1306.91,876.4],[1441.91,770.762],[1441.91,869.016]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1376.48,472.986],[1376.48,394.598],[1365.62,473.566],[1365.62,395.864]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1376.48,559.599],[1376.48,637.987],[1365.62,559.421],[1365.62,637.122]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1376.48,640.311],[1376.48,718.699],[1365.62,639.426],[1365.62,717.128]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1376.48,725.792],[1376.48,804.18],[1365.62,724.159],[1365.62,801.86]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1427.6,454.819],[1427.6,357.64],[1526.61,456.202],[1526.61,360.616]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1427.6,662.255],[1427.6,759.433],[1526.61,660.239],[1526.61,755.826]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1427.6,768.227],[1427.6,865.405],[1526.61,764.475],[1526.61,860.061]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1427.6,558.246],[1427.6,461.067],[1526.61,557.934],[1526.61,462.348]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1427.6,562.195],[1427.6,659.373],[1526.61,561.819],[1526.61,657.405]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1528.54,456.229],[1528.54,360.674],[1623.96,457.562],[1623.96,363.542]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1528.54,557.928],[1528.54,462.373],[1623.96,557.628],[1623.96,463.608]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1528.54,561.812],[1528.54,657.367],[1623.96,561.449],[1623.96,655.47]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1528.54,660.2],[1528.54,755.755],[1623.96,658.258],[1623.96,752.278]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1528.54,764.402],[1528.54,859.957],[1623.96,760.786],[1623.96,854.807]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1639.9,456.688],[1639.9,361.66],[1623.96,457.562],[1623.96,363.542]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1639.9,557.825],[1639.9,462.798],[1623.96,557.628],[1623.96,463.608]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1639.9,561.687],[1639.9,656.714],[1623.96,561.449],[1623.96,655.47]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1639.9,659.532],[1639.9,754.559],[1623.96,658.258],[1623.96,752.278]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1639.9,763.158],[1639.9,858.186],[1623.96,760.786],[1623.96,854.807]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1639.9,456.688],[1639.9,361.66],[1760.84,458.4],[1760.84,365.344]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1639.9,557.825],[1639.9,462.798],[1760.84,557.44],[1760.84,464.384]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1639.9,561.687],[1639.9,656.714],[1760.84,561.222],[1760.84,654.278]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1639.9,659.532],[1639.9,754.559],[1760.84,657.037],[1760.84,750.093]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1639.9,763.158],[1639.9,858.186],[1760.84,758.513],[1760.84,851.57]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1744.55,459.211],[1744.55,367.088],[1834.32,460.466],[1834.32,369.787]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1744.55,655.856],[1744.55,747.979],[1834.32,654.028],[1834.32,744.706]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1744.55,756.315],[1744.55,848.438],[1834.32,752.912],[1834.32,843.59]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1744.55,557.258],[1744.55,465.134],[1834.32,556.975],[1834.32,466.297]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:50,
                    verts:[[1744.55,561.001],[1744.55,653.124],[1834.32,560.66],[1834.32,651.339]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[149.891,446.374],[149.891,339.477],[129.805,454.493],[129.805,356.939]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[149.891,560.145],[149.891,453.248],[129.805,558.319],[129.805,460.765]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[149.891,564.489],[149.891,671.387],[129.805,562.283],[129.805,659.837]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[149.891,674.556],[149.891,781.454],[129.805,662.73],[129.805,760.284]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[149.891,791.127],[149.891,898.024],[129.805,769.111],[129.805,866.665]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[182.595,433.156],[182.595,311.046],[156.707,443.62],[156.707,333.551]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[182.595,563.119],[182.595,441.008],[156.707,560.765],[156.707,450.697]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[182.595,568.081],[182.595,690.191],[156.707,565.238],[156.707,675.306]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[182.595,693.812],[182.595,815.923],[156.707,678.569],[156.707,788.638]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[182.595,826.972],[182.595,949.083],[156.707,798.598],[156.707,908.666]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[182.595,433.156],[182.595,311.046],[331.903,435.824],[331.903,316.784]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[182.595,563.119],[182.595,441.008],[331.903,562.518],[331.903,443.478]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[182.595,568.081],[182.595,690.191],[331.903,567.356],[331.903,686.396]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[182.595,693.812],[182.595,815.923],[331.903,689.925],[331.903,808.965]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[182.595,826.972],[182.595,949.083],[331.903,819.737],[331.903,938.777]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[250.758,456.204],[250.758,360.62],[247.46,457.032],[247.46,362.401]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[250.758,561.818],[250.758,657.403],[247.46,561.593],[247.46,656.224]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[250.758,660.237],[250.758,755.821],[247.46,659.03],[247.46,753.661]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[250.758,764.47],[250.758,860.054],[247.46,762.224],[247.46,856.855]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[337.134,434.51],[337.134,313.958],[331.902,435.824],[331.902,316.784]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[337.134,562.814],[337.134,442.262],[331.902,562.518],[331.902,443.478]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[337.134,567.713],[337.134,688.265],[331.902,567.356],[331.902,686.396]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[337.134,691.84],[337.134,812.392],[331.902,689.926],[331.902,808.966]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[337.134,823.301],[337.134,943.853],[331.902,819.737],[331.902,938.778]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[337.134,434.51],[337.134,313.958],[520.959,437.84],[520.959,321.119]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[337.134,562.814],[337.134,442.262],[520.959,562.065],[520.959,445.345]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[337.134,567.713],[337.134,688.265],[520.959,566.808],[520.959,683.529]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[337.134,691.84],[337.134,812.392],[520.959,686.99],[520.959,803.71]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[337.134,823.301],[337.134,943.853],[520.959,814.272],[520.959,930.992]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[513.402,439.115],[513.402,323.862],[645.529,441.475],[645.529,328.938]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[513.402,566.462],[513.402,681.715],[645.529,565.821],[645.529,678.357]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[513.402,685.132],[513.402,800.384],[645.529,681.694],[645.529,794.231]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[513.402,810.814],[513.402,926.066],[645.529,804.414],[645.529,916.951]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[513.402,561.778],[513.402,446.525],[645.529,561.247],[645.529,448.711]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[614.813,464.15],[614.813,374.492],[608.31,464.853],[608.31,376.034]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[614.813,563.216],[614.813,652.874],[608.31,562.992],[608.31,651.811]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[614.813,655.533],[614.813,745.19],[608.31,654.444],[608.31,743.263]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[614.813,753.304],[614.813,842.962],[608.31,751.3],[608.31,840.119]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[644.984,441.419],[644.984,328.817],[772.192,443.691],[772.192,333.706]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[644.984,561.26],[644.984,448.659],[772.192,560.749],[772.192,450.763]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[644.984,565.836],[644.984,678.437],[772.192,565.218],[772.192,675.204]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[644.984,681.776],[644.984,794.377],[772.192,678.465],[772.192,788.45]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[644.984,804.566],[644.984,917.168],[772.192,798.402],[772.192,908.388]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[782.184,442.571],[782.184,331.296],[772.191,443.691],[772.191,333.706]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[782.184,561.001],[782.184,449.726],[772.191,560.749],[772.191,450.763]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[782.184,565.523],[782.184,676.798],[772.191,565.218],[772.191,675.204]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[782.184,680.097],[782.184,791.372],[772.191,678.465],[772.191,788.45]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[782.184,801.441],[782.184,912.716],[772.191,798.402],[772.191,908.388]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[782.185,442.571],[782.185,331.296],[939.189,445.415],[939.189,337.412]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[782.185,561.001],[782.185,449.726],[939.189,560.361],[939.189,452.359]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[782.185,565.523],[782.185,676.798],[939.189,564.75],[939.189,672.752]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[782.185,680.097],[782.185,791.372],[939.189,675.955],[939.189,783.957]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[782.185,801.441],[782.185,912.716],[939.189,793.73],[939.189,901.732]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[927.319,446.507],[927.319,339.763],[1041.84,448.553],[1041.84,344.162]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[927.319,564.453],[927.319,671.198],[1041.84,563.897],[1041.84,668.288]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[927.319,674.362],[927.319,781.107],[1041.84,671.383],[1041.84,775.773]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[927.319,790.766],[927.319,897.51],[1041.84,785.219],[1041.84,889.61]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[927.319,560.115],[927.319,453.371],[1041.84,559.655],[1041.84,455.265]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1032.48,466.29],[1032.48,379.186],[987.912,469.213],[987.912,385.599]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1032.48,562.534],[1032.48,649.637],[987.912,561.601],[987.912,645.215]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1032.48,652.22],[1032.48,739.324],[987.912,647.694],[987.912,731.308]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1032.48,747.206],[1032.48,834.309],[987.912,738.874],[987.912,822.488]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1075.89,470.44],[1075.89,388.291],[1065.97,471.03],[1065.97,389.586]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1075.89,557.871],[1075.89,475.722],[1065.97,557.711],[1065.97,476.267]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1075.89,561.209],[1075.89,643.359],[1065.97,561.021],[1065.97,642.465]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1075.89,645.794],[1075.89,727.943],[1065.97,644.88],[1065.97,726.324]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1075.89,735.377],[1075.89,817.526],[1065.97,733.694],[1065.97,815.138]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1206.99,451.503],[1206.99,350.508],[1178.43,453.45],[1178.43,354.697]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1206.99,558.992],[1206.99,457.997],[1178.43,558.553],[1178.43,459.8]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1206.99,563.096],[1206.99,664.091],[1178.43,562.567],[1178.43,661.32]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1206.99,667.085],[1206.99,768.08],[1178.43,664.248],[1178.43,763.001]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1206.99,777.219],[1206.99,878.214],[1178.43,771.937],[1178.43,870.691]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1206.59,451.454],[1206.59,350.402],[1309.29,453.289],[1309.29,354.349]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1206.59,559.003],[1206.59,457.951],[1309.29,558.59],[1309.29,459.65]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1206.59,563.109],[1206.59,664.161],[1309.29,562.611],[1309.29,661.55]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1206.59,667.157],[1206.59,768.209],[1309.29,664.484],[1309.29,763.423]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1206.59,777.353],[1206.59,878.404],[1309.29,772.376],[1309.29,871.316]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1323.93,452.383],[1323.93,352.401],[1309.29,453.289],[1309.29,354.349]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1323.93,558.794],[1323.93,458.811],[1309.29,558.59],[1309.29,459.65]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1323.93,562.857],[1323.93,662.839],[1309.29,562.611],[1309.29,661.55]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1323.93,665.803],[1323.93,765.785],[1309.29,664.484],[1309.29,763.423]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1323.93,774.833],[1323.93,874.815],[1309.29,772.376],[1309.29,871.316]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1323.93,452.383],[1323.93,352.401],[1451.06,454.685],[1451.06,357.353]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1323.93,558.794],[1323.93,458.811],[1451.06,558.276],[1451.06,460.944]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1323.93,562.857],[1323.93,662.839],[1451.06,562.231],[1451.06,659.563]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1323.93,665.803],[1323.93,765.785],[1451.06,662.449],[1451.06,759.781]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1323.93,774.833],[1323.93,874.815],[1451.06,768.588],[1451.06,865.921]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1346.84,473.513],[1346.84,395.749],[1334.83,474.066],[1334.83,396.956]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1346.84,559.437],[1346.84,637.201],[1334.83,559.267],[1334.83,636.377]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1346.84,639.507],[1346.84,717.27],[1334.83,638.663],[1334.83,715.773]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1346.84,724.307],[1346.84,802.071],[1334.83,722.75],[1334.83,799.86]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1434.97,455.574],[1434.97,359.265],[1527.59,457.228],[1527.59,362.823]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1434.97,661.154],[1434.97,757.464],[1527.59,658.745],[1527.59,753.15]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1434.97,766.179],[1434.97,862.488],[1527.59,761.693],[1527.59,856.098]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1434.97,558.076],[1434.97,461.766],[1527.59,557.704],[1527.59,463.298]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1434.97,561.99],[1434.97,658.299],[1527.59,561.54],[1527.59,655.945]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1529.39,457.26],[1529.39,362.892],[1618.05,458.844],[1618.05,366.298]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1529.39,557.696],[1529.39,463.328],[1618.05,557.34],[1618.05,464.794]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1529.39,561.531],[1529.39,655.9],[1618.05,561.101],[1618.05,653.647]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1529.39,658.698],[1529.39,753.066],[1618.05,656.391],[1618.05,748.937]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1529.39,761.605],[1529.39,855.974],[1618.05,757.311],[1618.05,849.857]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1635.37,458.023],[1635.37,364.533],[1618.05,458.844],[1618.05,366.298]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1635.37,557.525],[1635.37,464.035],[1618.05,557.34],[1618.05,464.794]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1635.37,561.324],[1635.37,654.814],[1618.05,561.101],[1618.05,653.647]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1635.37,657.586],[1635.37,751.076],[1618.05,656.391],[1618.05,748.937]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1635.37,759.536],[1635.37,853.026],[1618.05,757.312],[1618.05,849.857]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1635.37,458.023],[1635.37,364.533],[1746.72,460.04],[1746.72,368.871]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1635.37,557.525],[1635.37,464.035],[1746.72,557.071],[1746.72,465.902]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1635.37,561.324],[1635.37,654.814],[1746.72,560.776],[1746.72,651.945]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1635.37,657.586],[1635.37,751.076],[1746.72,654.648],[1746.72,745.817]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1635.37,759.536],[1635.37,853.026],[1746.72,754.067],[1746.72,845.235]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1729.34,460.794],[1729.34,370.493],[1811.53,462.263],[1811.53,373.652]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1729.34,560.571],[1729.34,650.872],[1811.53,560.172],[1811.53,648.783]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1729.34,653.55],[1729.34,743.851],[1811.53,651.41],[1811.53,740.021]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1729.34,752.022],[1729.34,842.324],[1811.53,748.04],[1811.53,836.651]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:51,
                    verts:[[1729.34,556.901],[1729.34,466.6],[1811.53,556.571],[1811.53,467.96]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[154.633,442.8],[154.633,331.788],[113.721,451.21],[113.721,349.878]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[154.633,560.949],[154.633,449.938],[113.721,559.057],[113.721,457.725]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[154.633,565.461],[154.633,676.472],[113.721,563.175],[113.721,664.507]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[154.633,679.764],[154.633,790.775],[113.721,667.512],[113.721,768.844]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[154.633,800.821],[154.633,911.832],[113.721,778.014],[113.721,879.346]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[221.203,429.115],[221.203,302.353],[168.511,439.947],[168.511,325.652]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[221.203,564.028],[221.203,437.266],[168.511,561.591],[168.511,447.296]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[221.203,569.179],[221.203,695.941],[168.511,566.236],[168.511,680.531]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[221.203,699.699],[221.203,826.462],[168.511,683.92],[168.511,798.215]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[221.203,837.932],[221.203,964.694],[168.511,808.558],[168.511,922.853]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[221.203,429.115],[221.203,302.353],[372.421,432.481],[372.421,309.592]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[221.203,564.028],[221.203,437.266],[372.421,563.271],[372.421,440.382]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[221.203,569.179],[221.203,695.941],[372.421,568.265],[372.421,691.153]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[221.203,699.7],[221.203,826.462],[372.421,694.796],[372.421,817.685]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[221.203,837.932],[221.203,964.694],[372.421,828.805],[372.421,951.693]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[237.99,453.374],[237.99,354.532],[232.517,454.224],[232.517,356.362]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[237.99,562.587],[237.99,661.429],[232.517,562.356],[232.517,660.219]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[237.99,664.359],[237.99,763.201],[232.517,663.12],[232.517,760.983]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[237.99,772.145],[237.99,870.986],[232.517,769.838],[232.517,867.701]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[381.072,431.136],[381.072,306.7],[372.42,432.481],[372.42,309.592]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[381.072,563.573],[381.072,439.137],[372.42,563.271],[372.42,440.382]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[381.072,568.63],[381.072,693.066],[372.42,568.265],[372.42,691.153]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[381.072,696.755],[381.072,821.191],[372.42,694.796],[372.42,817.685]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[381.072,832.451],[381.072,956.887],[372.42,828.805],[372.42,951.693]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[381.073,431.136],[381.073,306.7],[564.772,435.284],[564.772,315.622]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[381.073,563.573],[381.073,439.137],[564.772,562.64],[564.772,442.978]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[381.073,568.63],[381.073,693.066],[564.772,567.503],[564.772,687.165]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[381.073,696.755],[381.073,821.191],[564.772,690.713],[564.772,810.375]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[381.073,832.451],[381.073,956.887],[564.772,821.203],[564.772,940.866]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[553.882,436.571],[553.882,318.391],[684.543,439.478],[684.543,324.643]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[553.882,688.837],[553.882,807.018],[684.543,684.603],[684.543,799.438]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[553.882,817.712],[553.882,935.892],[684.543,809.829],[684.543,924.664]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[553.882,562.35],[553.882,444.17],[684.543,561.697],[684.543,446.862]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[553.882,567.153],[553.882,685.333],[684.543,566.363],[684.543,681.198]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[605.401,462.624],[605.401,371.144],[596.962,463.327],[596.962,372.686]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[605.401,563.703],[605.401,655.183],[596.962,563.479],[596.962,654.12]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[605.401,657.896],[605.401,749.376],[596.962,656.807],[596.962,747.448]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[605.401,757.654],[605.401,849.134],[596.962,755.65],[596.962,846.291]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[684.118,439.418],[684.118,324.515],[808.723,442.192],[808.723,330.48]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[684.118,561.71],[684.118,446.806],[808.723,561.086],[808.723,449.375]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[684.118,566.379],[684.118,681.283],[808.723,565.626],[808.723,677.337]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[684.118,684.69],[684.118,799.593],[808.723,680.649],[808.723,792.361]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[684.118,809.991],[684.118,924.894],[808.723,802.47],[808.723,914.181]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[821.567,441.082],[821.567,328.093],[808.722,442.192],[808.722,330.48]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[821.567,561.336],[821.567,448.347],[808.722,561.086],[808.722,449.375]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[821.567,565.927],[821.567,678.916],[808.722,565.626],[808.722,677.337]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[821.567,682.266],[821.567,795.255],[808.722,680.649],[808.722,792.361]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[821.567,805.48],[821.567,918.469],[808.722,802.47],[808.722,914.181]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[821.568,441.082],[821.568,328.093],[973.56,444.514],[973.56,335.474]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[821.568,561.336],[821.568,448.347],[973.56,560.564],[973.56,451.525]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[821.568,565.927],[821.568,678.916],[973.56,564.995],[973.56,674.034]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[821.568,682.266],[821.568,795.255],[973.56,677.267],[973.56,786.306]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[821.568,805.48],[821.568,918.469],[973.56,796.173],[973.56,905.212]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[959.009,445.584],[959.009,337.776],[1068.95,448.03],[1068.95,343.037]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[959.009,564.704],[959.009,672.511],[1068.95,564.04],[1068.95,669.032]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[959.009,675.708],[959.009,783.515],[1068.95,672.145],[1068.95,777.137]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[959.009,793.271],[959.009,901.078],[1068.95,786.638],[1068.95,891.63]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1023.84,465.91],[1023.84,378.353],[971.996,468.751],[971.996,384.585]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1023.84,562.655],[1023.84,650.212],[971.996,561.748],[971.996,645.914]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1023.84,652.808],[1023.84,740.365],[971.996,648.41],[971.996,732.575]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1023.84,748.288],[1023.84,835.845],[971.996,740.191],[971.996,824.357]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[959.009,560.323],[959.009,452.516],[1068.95,559.773],[1068.95,454.78]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1056.93,470.205],[1056.93,387.775],[1045.58,470.776],[1045.58,389.028]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1056.93,561.284],[1056.93,643.714],[1045.58,561.102],[1045.58,642.85]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1056.93,646.158],[1056.93,728.588],[1045.58,645.274],[1045.58,727.022]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1056.93,736.047],[1056.93,818.477],[1045.58,734.419],[1045.58,816.167]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1225.9,451.522],[1225.9,350.549],[1193.04,453.393],[1193.04,354.574]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1225.9,558.987],[1225.9,458.014],[1193.04,558.566],[1193.04,459.747]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1225.9,563.091],[1225.9,664.064],[1193.04,562.582],[1193.04,661.401]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1225.9,667.057],[1225.9,768.03],[1193.04,664.331],[1193.04,763.151]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1225.9,777.167],[1225.9,878.141],[1193.04,772.093],[1193.04,870.912]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1225.63,451.471],[1225.63,350.439],[1322.28,453.622],[1322.28,355.067]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1225.63,558.999],[1225.63,457.967],[1322.28,558.515],[1322.28,459.959]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1225.63,563.104],[1225.63,664.136],[1322.28,562.52],[1322.28,661.075]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1225.63,667.131],[1225.63,768.163],[1322.28,663.997],[1322.28,762.553]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1225.63,777.305],[1225.63,878.337],[1322.28,771.471],[1322.28,870.026]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1315.4,473.924],[1315.4,396.647],[1302.31,474.449],[1302.31,397.792]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1315.4,559.311],[1315.4,636.588],[1302.31,559.15],[1302.31,635.806]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1315.4,638.88],[1315.4,716.157],[1302.31,638.079],[1302.31,714.736]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1315.4,723.15],[1315.4,800.427],[1302.31,721.673],[1302.31,798.329]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1338.78,452.76],[1338.78,353.211],[1322.29,453.622],[1322.29,355.067]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1338.78,558.709],[1338.78,459.16],[1322.29,558.515],[1322.29,459.959]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1338.78,562.754],[1338.78,662.303],[1322.29,562.52],[1322.29,661.075]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1338.78,665.254],[1338.78,764.802],[1322.29,663.997],[1322.29,762.553]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1338.78,773.811],[1338.78,873.359],[1322.29,771.471],[1322.29,870.026]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1338.78,452.76],[1338.78,353.211],[1457.25,455.435],[1457.25,358.965]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1338.78,558.709],[1338.78,459.16],[1457.25,558.107],[1457.25,461.638]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1338.78,562.754],[1338.78,662.303],[1457.25,562.027],[1457.25,658.497]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1338.78,665.254],[1338.78,764.802],[1457.25,661.357],[1457.25,757.827]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1338.78,773.811],[1338.78,873.359],[1457.25,766.556],[1457.25,863.026]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1439.52,456.273],[1439.52,360.769],[1525.32,458.182],[1525.32,364.875]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1439.52,660.135],[1439.52,755.639],[1525.32,657.355],[1525.32,750.662]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1439.52,764.282],[1439.52,859.786],[1525.32,759.106],[1525.32,852.413]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1439.52,561.8],[1439.52,657.304],[1525.32,561.281],[1525.32,654.588]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1439.52,557.918],[1439.52,462.414],[1525.32,557.489],[1525.32,464.182]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1526.98,458.219],[1526.98,364.954],[1608.56,460.034],[1608.56,368.858]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1526.98,557.481],[1526.98,464.216],[1608.56,557.072],[1608.56,465.896]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1526.98,561.271],[1526.98,654.536],[1608.56,560.778],[1608.56,651.954]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1526.98,657.301],[1526.98,750.566],[1608.56,654.657],[1608.56,745.833]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1526.98,759.005],[1526.98,852.27],[1608.56,754.083],[1608.56,845.259]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1627.11,459.27],[1627.11,367.214],[1608.56,460.034],[1608.56,368.858]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1627.11,557.244],[1627.11,465.189],[1608.56,557.072],[1608.56,465.896]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1627.11,560.985],[1627.11,653.041],[1608.56,560.778],[1608.56,651.954]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1627.11,655.77],[1627.11,747.826],[1608.56,654.657],[1608.56,745.833]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1627.11,756.156],[1627.11,848.211],[1608.56,754.083],[1608.56,845.259]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1627.11,459.27],[1627.11,367.214],[1728.66,461.563],[1728.66,372.146]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1627.11,557.244],[1627.11,465.189],[1728.66,556.729],[1728.66,467.312]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1627.11,560.985],[1627.11,653.041],[1728.66,560.362],[1728.66,649.779]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1627.11,655.77],[1627.11,747.826],[1728.66,652.43],[1728.66,741.847]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1627.11,756.156],[1627.11,848.211],[1728.66,749.938],[1728.66,839.354]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1710.33,462.259],[1710.33,373.645],[1784.92,463.919],[1784.92,377.216]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1710.33,651.415],[1710.33,740.03],[1784.92,648.997],[1784.92,735.701]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1710.33,748.048],[1710.33,836.663],[1784.92,743.546],[1784.92,830.25]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1710.33,556.572],[1710.33,467.957],[1784.92,556.198],[1784.92,469.494]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:52,
                    verts:[[1710.33,560.173],[1710.33,648.788],[1784.92,559.722],[1784.92,646.426]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[165.868,438.931],[165.868,323.467],[101.869,447.595],[101.869,342.102]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[165.868,561.82],[165.868,446.355],[101.869,559.871],[101.869,454.378]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[165.868,566.512],[165.868,681.976],[101.869,564.158],[101.869,669.65]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[165.868,685.4],[165.868,800.864],[101.869,672.778],[101.869,778.27]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[165.868,811.312],[165.868,926.777],[101.869,787.817],[101.869,893.309]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[269.759,424.867],[269.759,293.215],[187.552,435.996],[187.552,317.153]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[269.759,564.983],[269.759,433.332],[187.552,562.48],[187.552,443.637]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[269.759,570.333],[269.759,701.985],[187.552,567.31],[187.552,686.152]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[269.759,705.888],[269.759,837.54],[187.552,689.676],[187.552,808.519]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[269.759,849.453],[269.759,981.104],[187.552,819.273],[187.552,938.116]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[228.908,450.27],[228.908,347.857],[221.056,451.139],[221.056,349.726]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[228.908,563.431],[228.908,665.844],[221.056,563.195],[221.056,664.608]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[228.908,668.881],[228.908,771.294],[221.056,667.615],[221.056,769.028]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[228.908,780.562],[228.908,882.975],[221.056,778.205],[221.056,879.619]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[269.759,424.867],[269.759,293.215],[421.091,429.003],[421.091,302.113]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[269.759,564.983],[269.759,433.332],[421.091,564.053],[421.091,437.162]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[269.759,570.333],[269.759,701.985],[421.091,569.209],[421.091,696.1]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[269.759,705.888],[269.759,837.54],[421.091,699.862],[421.091,826.753]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[269.759,849.453],[269.759,981.104],[421.091,838.235],[421.091,965.125]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[433.414,427.64],[433.414,299.179],[421.09,429.003],[421.09,302.113]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[433.414,564.359],[433.414,435.899],[421.09,564.053],[421.09,437.162]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[433.414,569.58],[433.414,698.04],[421.09,569.209],[421.09,696.1]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[433.414,701.849],[433.414,830.309],[421.09,699.862],[421.09,826.753]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[433.414,841.933],[433.414,970.393],[421.09,838.235],[421.09,965.126]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[433.414,427.64],[433.414,299.18],[614.646,432.67],[614.646,310]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[433.414,564.359],[433.414,435.899],[614.646,563.228],[614.646,440.558]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[433.414,569.58],[433.414,698.04],[614.646,568.213],[614.646,690.883]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[433.414,701.849],[433.414,830.309],[614.646,694.52],[614.646,817.191]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[433.414,841.933],[433.414,970.393],[614.646,828.291],[614.646,950.961]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[597.594,460.948],[597.594,367.468],[587.132,461.647],[587.132,369]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[597.594,564.238],[597.594,657.718],[587.132,564.015],[587.132,656.661]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[597.594,660.49],[597.594,753.97],[587.132,659.408],[587.132,752.055]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[597.594,762.429],[597.594,855.91],[587.132,760.438],[587.132,853.085]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[600.271,433.958],[600.271,312.77],[727.86,437.444],[727.86,320.267]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[600.271,692.645],[600.271,813.833],[727.86,687.567],[727.86,804.743]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[600.271,824.799],[600.271,945.987],[727.86,815.346],[727.86,932.522]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[600.271,562.938],[600.271,441.75],[727.86,562.154],[727.86,444.978]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[600.271,567.863],[600.271,689.051],[727.86,566.916],[727.86,684.092]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[727.568,437.381],[727.568,320.132],[848.076,440.675],[848.076,327.218]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[727.568,562.168],[727.568,444.92],[848.076,561.427],[848.076,447.97]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[727.568,566.933],[727.568,684.182],[848.076,566.038],[848.076,679.495]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[727.568,687.658],[727.568,804.907],[848.076,682.859],[848.076,796.317]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[727.568,815.516],[727.568,932.765],[848.076,806.583],[848.076,920.041]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[863.796,439.586],[863.796,324.875],[848.075,440.675],[848.075,327.217]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[863.796,561.672],[863.796,446.962],[848.075,561.427],[848.075,447.97]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[863.796,566.334],[863.796,681.044],[848.075,566.038],[848.075,679.495]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[863.796,684.446],[863.796,799.156],[848.075,682.859],[848.075,796.317]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[863.796,809.536],[863.796,924.247],[848.075,806.583],[848.075,920.041]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[863.796,439.586],[863.796,324.875],[1009.01,443.617],[1009.01,333.545]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[863.796,561.672],[863.796,446.962],[1009.01,560.766],[1009.01,450.694]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[863.796,566.334],[863.796,681.044],[1009.01,565.239],[1009.01,675.31]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[863.796,684.445],[863.796,799.156],[1009.01,678.574],[1009.01,788.645]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[863.796,809.536],[863.796,924.247],[1009.01,798.605],[1009.01,908.677]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1014.59,465.444],[1014.59,377.331],[955.538,468.186],[955.538,383.345]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1014.59,562.803],[1014.59,650.917],[955.538,561.929],[955.538,646.769]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1014.59,653.529],[1014.59,741.643],[955.538,649.284],[955.538,734.125]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1014.59,749.616],[1014.59,837.729],[955.538,741.802],[955.538,826.642]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[991.814,444.655],[991.814,335.778],[1096.03,447.502],[1096.03,341.902]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[991.814,677.061],[991.814,785.938],[1096.03,672.913],[1096.03,778.513]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[991.814,795.79],[991.814,904.667],[1096.03,788.069],[1096.03,893.668]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[991.814,560.532],[991.814,451.655],[1096.03,559.892],[1096.03,454.292]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[991.814,564.957],[991.814,673.833],[1096.03,564.183],[1096.03,669.782]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1037,469.869],[1037,387.039],[1024.24,470.418],[1024.24,388.243]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1037,561.391],[1037,644.222],[1024.24,561.216],[1024.24,643.391]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1037,646.677],[1037,729.508],[1024.24,645.827],[1024.24,728.002]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1037,737.003],[1037,819.833],[1024.24,735.438],[1024.24,817.613]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1243.34,451.527],[1243.34,350.56],[1206.4,453.309],[1206.4,354.393]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1243.34,558.986],[1243.34,458.019],[1206.4,558.585],[1206.4,459.669]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1243.34,563.089],[1243.34,664.056],[1206.4,562.605],[1206.4,661.521]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1243.34,667.05],[1243.34,768.017],[1206.4,664.454],[1206.4,763.37]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1243.34,777.153],[1243.34,878.12],[1206.4,772.321],[1206.4,871.237]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1243.19,451.475],[1243.19,350.448],[1333.06,453.932],[1333.06,355.732]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1243.19,558.998],[1243.19,457.971],[1333.06,558.445],[1333.06,460.246]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1243.19,563.103],[1243.19,664.13],[1333.06,562.436],[1333.06,660.635]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1243.19,667.125],[1243.19,768.152],[1333.06,663.547],[1333.06,761.746]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1243.19,777.294],[1243.19,878.321],[1333.06,770.632],[1333.06,868.832]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1282.07,474.227],[1282.07,397.307],[1267.94,474.721],[1267.94,398.387]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1282.07,559.218],[1282.07,636.138],[1267.94,559.066],[1267.94,635.4]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1282.07,638.418],[1282.07,715.338],[1267.94,637.664],[1267.94,713.998]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1282.07,722.299],[1282.07,799.218],[1267.94,720.906],[1267.94,797.24]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1351.28,453.117],[1351.28,353.98],[1333.06,453.932],[1333.06,355.732]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1351.28,558.628],[1351.28,459.492],[1333.06,558.445],[1333.06,460.246]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1351.28,562.657],[1351.28,661.794],[1333.06,562.436],[1333.06,660.635]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1351.28,664.733],[1351.28,763.87],[1333.06,663.547],[1333.06,761.746]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1351.28,772.841],[1351.28,871.978],[1333.06,770.632],[1333.06,868.832]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1351.28,453.117],[1351.28,353.98],[1460.34,456.144],[1460.34,360.492]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1351.28,558.628],[1351.28,459.492],[1460.34,557.947],[1460.34,462.295]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1351.28,562.657],[1351.28,661.794],[1460.34,561.835],[1460.34,657.487]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1351.28,664.733],[1351.28,763.87],[1460.34,660.323],[1460.34,755.976]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1351.28,772.841],[1351.28,871.978],[1460.34,764.632],[1460.34,860.284]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1441.11,456.929],[1441.11,362.18],[1519.67,459.076],[1519.67,366.797]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1441.11,561.621],[1441.11,656.37],[1519.67,561.038],[1519.67,653.317]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1441.11,659.18],[1441.11,753.929],[1519.67,656.053],[1519.67,748.332]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1441.11,762.503],[1441.11,857.252],[1519.67,756.683],[1519.67,848.962]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1441.11,557.771],[1441.11,463.022],[1519.67,557.288],[1519.67,465.009]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1521.19,459.117],[1521.19,366.886],[1595.42,461.145],[1595.42,371.248]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1521.19,557.279],[1521.19,465.047],[1595.42,556.822],[1595.42,466.925]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1521.19,561.027],[1521.19,653.258],[1595.42,560.476],[1595.42,650.373]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1521.19,655.993],[1521.19,748.224],[1595.42,653.038],[1595.42,742.935]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1521.19,756.57],[1521.19,848.801],[1595.42,751.07],[1595.42,840.967]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1615.05,460.439],[1615.05,369.729],[1595.42,461.145],[1595.42,371.248]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1615.05,556.981],[1615.05,466.271],[1595.42,556.823],[1595.42,466.925]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1615.05,560.668],[1615.05,651.378],[1595.42,560.476],[1595.42,650.373]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1615.05,654.067],[1615.05,744.777],[1595.42,653.038],[1595.42,742.935]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1615.05,752.986],[1615.05,843.696],[1595.42,751.07],[1595.42,840.967]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1615.05,460.439],[1615.05,369.729],[1706.63,462.981],[1706.63,375.197]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1615.05,556.981],[1615.05,466.271],[1706.63,556.41],[1706.63,468.625]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1615.05,560.668],[1615.05,651.378],[1706.63,559.977],[1706.63,647.761]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1615.05,654.067],[1615.05,744.777],[1706.63,650.364],[1706.63,738.148]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1615.05,752.986],[1615.05,843.696],[1706.63,746.092],[1706.63,833.876]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1687.5,463.62],[1687.5,376.572],[1754.48,465.451],[1754.48,380.51]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1687.5,649.433],[1687.5,736.481],[1754.48,646.765],[1754.48,731.706]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1687.5,744.358],[1687.5,831.407],[1754.48,739.393],[1754.48,824.334]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1687.5,559.803],[1687.5,646.852],[1754.48,559.306],[1754.48,644.247]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:53,
                    verts:[[1687.5,556.266],[1687.5,469.217],[1754.48,555.854],[1754.48,470.913]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[184.832,434.781],[184.832,314.541],[95.3078,443.639],[95.3078,333.594]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[184.832,562.753],[184.832,442.513],[95.3078,560.76],[95.3078,450.715]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[184.832,567.639],[184.832,687.88],[95.3078,565.232],[95.3078,675.278]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[184.832,691.445],[184.832,811.685],[95.3078,678.541],[95.3078,788.586]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[184.832,822.566],[184.832,942.806],[95.3078,798.544],[95.3078,908.59]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[224.348,446.891],[224.348,340.588],[213.896,447.772],[213.896,342.484]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[224.348,560.029],[224.348,453.726],[213.896,559.831],[213.896,454.542]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[224.348,564.349],[224.348,670.652],[213.896,564.109],[213.896,669.398]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[224.348,673.804],[224.348,780.106],[213.896,672.52],[213.896,777.808]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[224.348,789.726],[224.348,896.028],[213.896,787.336],[213.896,892.624]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[329.503,420.467],[329.503,283.752],[215.094,431.787],[215.094,308.101]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[329.503,565.973],[329.503,429.258],[215.094,563.427],[215.094,439.74]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[329.503,571.529],[329.503,708.244],[215.094,568.453],[215.094,692.14]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[329.503,712.297],[329.503,849.013],[215.094,695.807],[215.094,819.493]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[329.503,861.384],[329.503,998.099],[215.094,830.686],[215.094,954.372]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[329.502,420.467],[329.502,283.752],[478.691,425.445],[478.691,294.459]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[329.502,565.973],[329.502,429.258],[478.691,564.853],[478.691,433.867]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[329.502,571.529],[329.502,708.244],[478.691,570.176],[478.691,701.162]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[329.502,712.298],[329.502,849.013],[478.691,705.046],[478.691,836.031]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[329.502,861.384],[329.502,998.099],[478.691,847.884],[478.691,978.87]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[494.905,424.078],[494.905,291.519],[478.691,425.445],[478.691,294.459]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[494.905,565.161],[494.905,432.601],[478.691,564.853],[478.691,433.867]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[494.905,570.548],[494.905,703.107],[478.691,570.176],[478.691,701.162]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[494.905,707.037],[494.905,839.597],[478.691,705.046],[478.691,836.031]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[494.905,851.592],[494.905,984.151],[478.691,847.884],[478.691,978.87]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[494.905,424.078],[494.905,291.519],[670.884,430.049],[670.884,304.362]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[494.905,565.161],[494.905,432.601],[670.884,563.818],[670.884,438.13]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[494.905,570.548],[494.905,703.107],[670.884,568.925],[670.884,694.613]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[494.905,707.037],[494.905,839.597],[670.884,698.339],[670.884,824.026]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[494.905,851.592],[494.905,984.151],[670.884,835.4],[670.884,961.087]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[591.688,459.13],[591.688,363.478],[579.117,459.818],[579.117,364.989]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[591.688,564.818],[591.688,660.47],[579.117,564.599],[579.117,659.428]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[591.688,663.306],[591.688,758.957],[579.117,662.24],[579.117,757.069]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[591.688,767.613],[591.688,863.264],[579.117,765.65],[579.117,860.479]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[652.913,431.322],[652.913,307.099],[775.592,435.413],[775.592,315.899]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[652.913,568.579],[652.913,692.802],[775.592,567.468],[775.592,686.982]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[652.913,696.485],[652.913,820.707],[775.592,690.525],[775.592,810.039]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[652.913,831.948],[652.913,956.17],[775.592,820.854],[775.592,940.367]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[652.913,563.531],[652.913,439.309],[775.592,562.611],[775.592,443.097]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[775.445,435.347],[775.445,315.758],[890.201,439.176],[890.201,323.994]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[775.445,562.626],[775.445,443.036],[890.201,561.764],[890.201,446.582]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[775.445,567.486],[775.445,687.075],[890.201,566.445],[890.201,681.627]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[775.445,690.621],[775.445,810.21],[890.201,685.043],[890.201,800.225]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[775.445,821.032],[775.445,940.621],[890.201,810.648],[890.201,925.83]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[908.779,438.12],[908.779,321.723],[890.201,439.176],[890.201,323.994]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[908.779,562.002],[908.779,445.605],[890.201,561.764],[890.201,446.582]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[908.779,566.732],[908.779,683.129],[890.201,566.445],[890.201,681.628]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[908.779,686.58],[908.779,802.978],[890.201,685.043],[890.201,800.225]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[908.779,813.511],[908.779,929.908],[890.201,810.648],[890.201,925.83]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[908.779,438.12],[908.779,321.723],[1045.33,442.753],[1045.33,331.688]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[908.779,562.002],[908.779,445.605],[1045.33,560.96],[1045.33,449.895]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[908.779,566.732],[908.779,683.129],[1045.33,565.473],[1045.33,676.538]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[908.779,686.58],[908.779,802.978],[1045.33,679.831],[1045.33,790.896]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[908.779,813.511],[908.779,929.908],[1045.33,800.947],[1045.33,912.012]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1004.73,464.901],[1004.73,376.14],[938.54,467.525],[938.54,381.895]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1004.73,562.977],[1004.73,651.738],[938.54,562.14],[938.54,647.769]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1004.73,654.37],[1004.73,743.131],[938.54,650.308],[938.54,735.937]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1004.73,751.163],[1004.73,839.924],[938.54,743.686],[938.54,829.315]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1016.07,561.528],[1016.07,644.87],[1001.92,561.361],[1001.92,644.079]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1016.07,469.44],[1016.07,386.098],[1001.92,469.964],[1001.92,387.246]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1016.07,647.342],[1016.07,730.684],[1001.92,646.531],[1001.92,729.249]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1016.07,738.226],[1016.07,821.568],[1001.92,736.734],[1001.92,819.451]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1025.56,443.749],[1025.56,333.829],[1122.87,446.993],[1122.87,340.808]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1025.56,678.382],[1025.56,788.301],[1122.87,673.654],[1122.87,779.839]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1025.56,798.248],[1025.56,908.167],[1122.87,789.448],[1122.87,895.633]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1025.56,560.736],[1025.56,450.816],[1122.87,560.006],[1122.87,453.821]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1025.56,565.203],[1025.56,675.122],[1122.87,564.321],[1122.87,670.506]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1259.07,451.536],[1259.07,350.58],[1218.31,453.215],[1218.31,354.191]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1259.07,558.984],[1259.07,458.028],[1218.31,558.606],[1218.31,459.582]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1259.07,563.087],[1259.07,664.043],[1218.31,562.631],[1218.31,661.655]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1259.07,667.036],[1259.07,767.992],[1218.31,664.591],[1218.31,763.615]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1259.07,777.128],[1259.07,878.084],[1218.31,772.576],[1218.31,871.6]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1246.75,474.427],[1246.75,397.744],[1231.62,474.89],[1231.62,398.754]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1246.75,559.157],[1246.75,635.84],[1231.62,559.014],[1231.62,635.15]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1246.75,638.113],[1246.75,714.796],[1231.62,637.407],[1231.62,713.542]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1246.75,721.735],[1246.75,798.418],[1231.62,720.432],[1231.62,796.567]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1259.05,451.484],[1259.05,350.467],[1341.41,454.231],[1341.41,356.377]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1259.05,558.996],[1259.05,457.979],[1341.41,558.378],[1341.41,460.523]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1259.05,563.101],[1259.05,664.118],[1341.41,562.354],[1341.41,660.209]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1259.05,667.113],[1259.05,768.13],[1341.41,663.11],[1341.41,760.964]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1259.05,777.271],[1259.05,878.288],[1341.41,769.819],[1341.41,867.674]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1361.2,453.471],[1361.2,354.741],[1341.41,454.231],[1341.41,356.377]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1361.2,558.549],[1361.2,459.819],[1341.41,558.378],[1341.41,460.523]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1361.2,562.561],[1361.2,661.291],[1341.41,562.354],[1341.41,660.209]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1361.2,664.218],[1361.2,762.948],[1341.41,663.11],[1341.41,760.964]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1361.2,771.882],[1361.2,870.612],[1341.41,769.819],[1341.41,867.674]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1361.2,453.471],[1361.2,354.741],[1460.13,456.827],[1460.13,361.961]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1361.2,558.549],[1361.2,459.819],[1460.13,557.794],[1460.13,462.927]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1361.2,562.561],[1361.2,661.291],[1460.13,561.649],[1460.13,656.516]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1361.2,664.218],[1361.2,762.948],[1460.13,659.328],[1460.13,754.195]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1361.2,771.883],[1361.2,870.612],[1460.13,762.78],[1460.13,857.646]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1439.56,457.554],[1439.56,363.525],[1510.51,459.92],[1510.51,368.613]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1439.56,561.451],[1439.56,655.481],[1510.51,560.809],[1510.51,652.115]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1439.56,658.269],[1439.56,752.299],[1510.51,654.823],[1510.51,746.129]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1439.56,760.808],[1439.56,854.838],[1510.51,754.392],[1510.51,845.699]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1439.56,557.63],[1439.56,463.6],[1510.51,557.098],[1510.51,465.791]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1511.88,459.966],[1511.88,368.711],[1578.52,462.188],[1578.52,373.492]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1511.88,557.088],[1511.88,465.833],[1578.52,556.588],[1578.52,467.891]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1511.88,560.796],[1511.88,652.05],[1578.52,560.192],[1578.52,648.889]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1511.88,654.756],[1511.88,746.01],[1578.52,651.518],[1578.52,740.215]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1511.88,754.268],[1511.88,845.523],[1578.52,748.241],[1578.52,836.937]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1599.08,461.542],[1599.08,372.101],[1578.52,462.188],[1578.52,373.492]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1599.08,556.733],[1599.08,467.293],[1578.52,556.588],[1578.52,467.891]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1599.08,560.368],[1599.08,649.809],[1578.52,560.192],[1578.52,648.889]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1599.08,652.461],[1599.08,741.901],[1578.52,651.519],[1578.52,740.215]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1599.08,749.995],[1599.08,839.436],[1578.52,748.241],[1578.52,836.937]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1599.08,461.542],[1599.08,372.101],[1680.57,464.307],[1680.57,378.048]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1599.08,556.733],[1599.08,467.293],[1680.57,556.111],[1680.57,469.853]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1599.08,560.368],[1599.08,649.809],[1680.57,559.617],[1680.57,645.875]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1599.08,652.461],[1599.08,741.901],[1680.57,648.433],[1680.57,734.691]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1599.08,749.995],[1599.08,839.436],[1680.57,742.497],[1680.57,828.755]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1660.78,464.888],[1660.78,379.298],[1720.18,466.87],[1720.18,383.562]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1660.78,559.459],[1660.78,645.048],[1720.18,558.92],[1720.18,642.228]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1660.78,647.586],[1660.78,733.175],[1720.18,644.698],[1720.18,728.007]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1660.78,740.92],[1660.78,826.51],[1720.18,735.545],[1720.18,818.853]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:54,
                    verts:[[1660.78,555.981],[1660.78,470.391],[1720.18,555.535],[1720.18,472.227]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[212.927,430.382],[212.927,305.078],[95.352,439.344],[95.352,324.355]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[212.927,563.743],[212.927,438.439],[95.352,561.727],[95.352,446.738]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[212.927,568.835],[212.927,694.139],[95.352,566.4],[95.352,681.388]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[212.927,697.854],[212.927,823.158],[95.352,684.798],[95.352,799.787]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[212.927,834.497],[212.927,959.801],[95.352,810.192],[95.352,925.181]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[225.325,443.243],[225.325,332.742],[212.044,444.129],[212.044,334.646]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[225.325,565.34],[225.325,675.841],[212.044,565.1],[212.044,674.582]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[225.325,679.117],[225.325,789.618],[212.044,677.828],[212.044,787.31]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[225.325,799.618],[225.325,910.119],[212.044,797.217],[212.044,906.699]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[225.325,560.849],[225.325,450.348],[212.044,560.65],[212.044,451.168]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[401.599,416],[401.599,274.143],[252.529,427.363],[252.529,298.585]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[401.599,566.978],[401.599,425.121],[252.529,564.422],[252.529,435.643]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[401.599,572.743],[401.599,714.6],[252.529,569.655],[252.529,698.434]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[401.599,718.806],[401.599,860.662],[252.529,702.252],[252.529,831.03]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[401.599,873.499],[401.599,1015.36],[252.529,842.684],[252.529,971.462]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[401.598,416],[401.598,274.143],[545.881,421.881],[545.881,286.792]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[401.598,566.978],[401.598,425.121],[545.881,565.655],[545.881,430.567]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[401.598,572.743],[401.598,714.6],[545.881,571.145],[545.881,706.233]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[401.598,718.806],[401.598,860.662],[545.881,710.239],[545.881,845.327]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[401.598,873.499],[401.598,1015.36],[545.881,857.551],[545.881,992.639]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[566.145,420.53],[566.145,283.887],[545.88,421.881],[545.88,286.792]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[566.145,565.959],[566.145,429.316],[545.88,565.655],[545.88,430.567]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[566.145,571.512],[566.145,708.155],[545.88,571.145],[545.88,706.233]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[566.145,712.206],[566.145,848.849],[545.88,710.239],[545.88,845.327]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[566.145,861.214],[566.145,997.856],[545.88,857.551],[545.88,992.64]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[566.146,420.53],[566.146,283.887],[733.635,427.484],[733.635,298.845]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[566.146,565.959],[566.146,429.316],[733.635,564.394],[733.635,435.756]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[566.146,571.512],[566.146,708.155],[733.635,569.622],[733.635,698.261]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[566.146,712.206],[566.146,848.849],[733.635,702.075],[733.635,830.714]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[566.146,861.214],[566.146,997.856],[733.635,842.355],[733.635,970.994]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[588.041,457.179],[588.041,359.199],[573.285,457.851],[573.285,360.673]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[588.041,565.441],[588.041,663.421],[573.285,565.226],[573.285,662.405]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[588.041,666.326],[588.041,764.306],[573.285,665.286],[573.285,762.464]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[588.041,773.172],[588.041,871.152],[573.285,771.258],[573.285,868.436]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[712.02,428.724],[712.02,301.512],[827.728,433.437],[827.728,311.649]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[712.02,569.285],[712.02,696.498],[827.728,568.005],[827.728,689.792]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[712.02,700.269],[712.02,827.482],[827.728,693.403],[827.728,815.191]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[712.02,838.993],[712.02,966.205],[827.728,826.212],[827.728,948]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[712.02,564.116],[712.02,436.903],[827.728,563.055],[827.728,441.268]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[827.739,433.369],[827.739,311.503],[934.943,437.738],[934.943,320.901]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[827.739,563.071],[827.739,441.205],[934.943,562.088],[934.943,445.251]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[827.739,568.023],[827.739,689.889],[934.943,566.836],[934.943,683.673]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[827.739,693.503],[827.739,815.369],[934.943,687.137],[934.943,803.974]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[827.739,826.396],[827.739,948.262],[934.943,814.547],[934.943,931.384]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[994.229,464.292],[994.229,374.804],[921.031,466.776],[921.031,380.252]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[994.229,563.171],[994.229,652.659],[921.031,562.379],[921.031,648.902]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[994.229,655.312],[994.229,744.8],[921.031,651.467],[921.031,737.991]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[994.229,752.898],[994.229,842.386],[921.031,745.82],[921.031,832.344]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[956.308,436.73],[956.308,318.732],[934.942,437.738],[934.942,320.901]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[956.308,562.315],[956.308,444.317],[934.942,562.088],[934.942,445.251]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[956.308,567.11],[956.308,685.108],[934.942,566.836],[934.942,683.673]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[956.308,688.607],[956.308,806.605],[934.942,687.137],[934.942,803.974]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[956.308,817.282],[956.308,935.28],[934.942,814.547],[934.942,931.384]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[956.308,436.73],[956.308,318.732],[1082.21,441.957],[1082.21,329.976]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[956.308,562.315],[956.308,444.317],[1082.21,561.139],[1082.21,449.158]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[956.308,567.11],[956.308,685.108],[1082.21,565.69],[1082.21,677.671]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[956.308,688.607],[956.308,806.604],[1082.21,680.991],[1082.21,792.972]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[956.308,817.282],[956.308,935.28],[1082.21,803.105],[1082.21,915.087]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[994.13,561.693],[994.13,645.65],[978.62,561.535],[978.62,644.903]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1060,442.898],[1060,331.999],[1149.17,446.53],[1149.17,339.812]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1060,565.434],[1060,676.333],[1149.17,564.447],[1149.17,671.165]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1060,679.621],[1060,790.519],[1149.17,674.329],[1149.17,781.047]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1060,800.554],[1060,911.453],[1149.17,790.704],[1149.17,897.422]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1060,560.927],[1060,450.029],[1149.17,560.11],[1149.17,453.392]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1209.34,474.53],[1209.34,397.97],[1193.26,474.96],[1193.26,398.907]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1209.34,556.013],[1209.34,479.453],[1193.26,555.902],[1193.26,479.85]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1209.34,559.125],[1209.34,635.685],[1193.26,558.993],[1193.26,635.046]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1209.34,637.955],[1209.34,714.515],[1193.26,637.301],[1193.26,713.353]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1209.34,721.443],[1209.34,798.003],[1193.26,720.235],[1193.26,796.288]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1272.85,451.569],[1272.85,350.65],[1228.56,453.13],[1228.56,354.007]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1272.85,558.977],[1272.85,458.058],[1228.56,558.626],[1228.56,459.503]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1272.85,563.078],[1272.85,663.997],[1228.56,562.654],[1228.56,661.776]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1272.85,666.989],[1272.85,767.908],[1228.56,664.715],[1228.56,763.838]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1272.85,777.04],[1272.85,877.959],[1228.56,772.808],[1228.56,871.93]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1272.96,451.516],[1272.96,350.535],[1347.09,454.537],[1347.09,357.034]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1272.96,558.989],[1272.96,458.008],[1347.09,558.309],[1347.09,460.806]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1272.96,563.092],[1272.96,664.073],[1347.09,562.271],[1347.09,659.774]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1272.96,667.067],[1272.96,768.047],[1347.09,662.665],[1347.09,760.168]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1272.96,777.185],[1272.96,878.165],[1347.09,768.991],[1347.09,866.493]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1368.3,453.836],[1368.3,355.526],[1347.09,454.537],[1347.09,357.034]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1368.3,558.467],[1368.3,460.157],[1347.09,558.309],[1347.09,460.806]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1368.3,562.462],[1368.3,660.772],[1347.09,562.271],[1347.09,659.774]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1368.3,663.687],[1368.3,761.996],[1347.09,662.665],[1347.09,760.168]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1368.3,770.893],[1368.3,869.202],[1347.09,768.991],[1347.09,866.493]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1368.3,453.836],[1368.3,355.526],[1456.45,457.496],[1456.45,363.398]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1368.3,558.467],[1368.3,460.157],[1456.45,557.643],[1456.45,463.546]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1368.3,562.462],[1368.3,660.772],[1456.45,561.467],[1456.45,655.565]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1368.3,663.687],[1368.3,761.996],[1456.45,658.355],[1456.45,752.453]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1368.3,770.893],[1368.3,869.203],[1456.45,760.968],[1456.45,855.065]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1434.71,458.161],[1434.71,364.829],[1497.71,460.727],[1497.71,370.348]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1434.71,657.386],[1434.71,750.718],[1497.71,653.648],[1497.71,744.026]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1434.71,759.163],[1434.71,852.495],[1497.71,752.205],[1497.71,842.583]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1434.71,557.494],[1434.71,464.162],[1497.71,556.917],[1497.71,466.538]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1434.71,561.287],[1434.71,654.619],[1497.71,560.589],[1497.71,650.968]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1498.92,460.776],[1498.92,370.454],[1557.78,463.174],[1557.78,375.611]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1498.92,556.906],[1498.92,466.584],[1557.78,556.366],[1557.78,468.804]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1498.92,560.576],[1498.92,650.898],[1557.78,559.925],[1557.78,647.487]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1498.92,653.576],[1498.92,743.898],[1557.78,650.083],[1557.78,737.646]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1498.92,752.071],[1498.92,842.393],[1557.78,745.569],[1557.78,833.132]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1579.11,462.588],[1579.11,374.352],[1557.78,463.174],[1557.78,375.611]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1579.11,556.498],[1579.11,468.262],[1557.78,556.366],[1557.78,468.804]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1579.11,560.084],[1579.11,648.32],[1557.78,559.925],[1557.78,647.487]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1579.11,650.936],[1579.11,739.172],[1557.78,650.083],[1557.78,737.646]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1579.11,747.156],[1579.11,835.392],[1557.78,745.569],[1557.78,833.132]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1579.11,462.588],[1579.11,374.352],[1650.43,465.55],[1650.43,380.722]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1579.11,556.498],[1579.11,468.262],[1650.43,555.832],[1650.43,471.004]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1579.11,560.084],[1579.11,648.32],[1650.43,559.279],[1650.43,644.107]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1579.11,650.936],[1579.11,739.172],[1650.43,646.622],[1650.43,731.45]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1579.11,747.156],[1579.11,835.392],[1650.43,739.126],[1650.43,823.954]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1630.1,466.072],[1630.1,381.846],[1681.97,468.186],[1681.97,386.393]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1630.1,645.86],[1630.1,730.087],[1681.97,642.781],[1681.97,724.574]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1630.1,737.708],[1630.1,821.935],[1681.97,731.975],[1681.97,813.768]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1630.1,555.714],[1630.1,471.488],[1681.97,555.239],[1681.97,473.446]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:55,
                    verts:[[1630.1,559.137],[1630.1,643.363],[1681.97,558.563],[1681.97,640.355]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[251.659,425.787],[251.659,295.194],[103.562,434.728],[103.562,314.425]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[251.659,564.776],[251.659,434.184],[103.562,562.765],[103.562,442.463]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[251.659,570.083],[251.659,700.676],[103.562,567.654],[103.562,687.956]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[251.659,704.548],[251.659,835.141],[103.562,691.523],[103.562,811.826]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[251.659,846.959],[251.659,977.552],[103.562,822.712],[103.562,943.014]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[233.029,439.348],[233.029,324.364],[216.69,440.225],[216.69,326.251]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[233.029,566.398],[233.029,681.383],[216.69,566.16],[216.69,680.135]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[233.029,684.792],[233.029,799.776],[216.69,683.514],[216.69,797.489]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[233.029,810.181],[233.029,925.166],[216.69,807.802],[216.69,921.777]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[486.956,411.581],[486.956,264.638],[301.287,422.79],[301.287,288.749]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[486.956,567.972],[486.956,421.029],[301.287,565.45],[301.287,431.409]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[486.956,573.943],[486.956,720.886],[301.287,570.898],[301.287,704.939]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[486.956,725.243],[486.956,872.185],[301.287,708.913],[301.287,842.955]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[486.956,885.482],[486.956,1032.42],[301.287,855.084],[301.287,989.125]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[486.955,411.581],[486.955,264.638],[623.06,418.408],[623.06,279.322]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[486.955,567.972],[486.955,421.029],[623.06,566.436],[623.06,427.351]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[486.955,573.943],[486.955,720.886],[623.06,572.088],[623.06,711.174]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[486.955,725.243],[486.955,872.185],[623.06,715.298],[623.06,854.383]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[486.955,885.482],[486.955,1032.43],[623.06,866.969],[623.06,1006.05]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[587.071,455.114],[587.071,354.669],[570.063,455.76],[570.063,356.086]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[587.071,566.1],[587.071,666.545],[570.063,565.893],[570.063,665.568]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[587.071,669.523],[587.071,769.969],[570.063,668.523],[570.063,768.197]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[587.071,779.058],[587.071,879.503],[570.063,777.216],[570.063,876.89]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[647.439,417.099],[647.439,276.507],[623.059,418.408],[623.059,279.322]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[647.439,566.731],[647.439,426.139],[623.059,566.436],[623.059,427.351]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[647.439,572.444],[647.439,713.036],[623.059,572.088],[623.059,711.174]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[647.439,717.205],[647.439,857.797],[623.059,715.298],[623.059,854.383]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[647.439,870.519],[647.439,1011.11],[623.059,866.969],[623.059,1006.05]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[647.44,417.099],[647.44,276.507],[802.797,425.056],[802.797,293.623]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[647.44,566.731],[647.44,426.139],[802.797,564.941],[802.797,433.507]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[647.44,572.444],[647.44,713.036],[802.797,570.282],[802.797,701.715]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[647.44,717.205],[647.44,857.797],[802.797,705.612],[802.797,837.046]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[647.44,870.519],[647.44,1011.11],[802.797,848.939],[802.797,980.373]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[777.58,426.241],[777.58,296.171],[884.069,431.578],[884.069,307.651]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[777.58,703.886],[777.58,833.956],[884.069,696.111],[884.069,820.038]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[777.58,845.726],[777.58,975.796],[884.069,831.252],[884.069,955.179]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[777.58,569.96],[777.58,700.03],[884.069,568.51],[884.069,692.437]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[777.58,564.674],[777.58,434.604],[884.069,563.474],[884.069,439.547]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[884.249,431.508],[884.249,307.501],[981.997,436.411],[981.997,318.047]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[884.249,563.489],[884.249,439.482],[981.997,562.386],[981.997,444.022]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[884.249,568.529],[884.249,692.536],[981.997,567.196],[981.997,685.561]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[884.249,696.213],[884.249,820.22],[981.997,689.07],[981.997,807.434]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[884.249,831.441],[884.249,955.449],[981.997,818.145],[981.997,936.51]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[983.109,463.63],[983.109,373.351],[903.07,465.948],[903.07,378.437]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[983.109,563.382],[983.109,653.661],[903.07,562.643],[903.07,650.154]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[983.109,656.338],[983.109,746.616],[903.07,652.748],[903.07,740.26]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[983.109,754.786],[983.109,845.064],[903.07,748.178],[903.07,835.69]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[971.199,561.882],[971.199,646.549],[954.356,561.735],[954.356,645.853]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1006.01,435.465],[1006.01,316.011],[981.997,436.411],[981.997,318.047]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1006.01,562.599],[1006.01,443.146],[981.997,562.386],[981.997,444.022]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1006.01,567.454],[1006.01,686.907],[981.997,567.197],[981.997,685.561]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1006.01,690.449],[1006.01,809.903],[981.997,689.07],[981.997,807.435]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1006.01,820.712],[1006.01,940.166],[981.997,818.145],[981.997,936.51]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1006.01,435.465],[1006.01,316.011],[1119.28,441.266],[1119.28,328.489]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1006.01,562.599],[1006.01,443.146],[1119.28,561.294],[1119.28,448.518]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1006.01,567.454],[1006.01,686.907],[1119.28,565.877],[1119.28,678.654]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1006.01,690.449],[1006.01,809.903],[1119.28,681.998],[1119.28,794.775]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1006.01,820.712],[1006.01,940.166],[1119.28,804.98],[1119.28,917.756]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1094.79,442.14],[1094.79,330.368],[1174.62,446.141],[1174.62,338.975]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1094.79,565.64],[1094.79,677.411],[1174.62,564.553],[1174.62,671.719]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1094.79,680.725],[1094.79,792.497],[1174.62,674.896],[1174.62,782.062]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1094.79,802.611],[1094.79,914.382],[1174.62,791.759],[1174.62,898.925]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1094.79,561.098],[1094.79,449.326],[1174.62,560.198],[1174.62,453.032]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1169.81,474.543],[1169.81,397.998],[1152.83,474.936],[1152.83,398.855]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1169.81,559.121],[1169.81,635.666],[1152.83,559],[1152.83,635.081]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1169.81,637.935],[1169.81,714.481],[1152.83,637.337],[1152.83,713.417]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1169.81,721.407],[1169.81,797.953],[1152.83,720.302],[1152.83,796.383]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1284.38,451.644],[1284.38,350.811],[1236.92,453.071],[1236.92,353.882]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1284.38,558.96],[1284.38,458.127],[1236.92,558.639],[1236.92,459.449]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1284.38,563.058],[1284.38,663.89],[1236.92,562.67],[1236.92,661.859]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1284.38,666.88],[1284.38,767.713],[1236.92,664.8],[1236.92,763.99]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1284.38,776.837],[1284.38,877.67],[1236.92,772.965],[1236.92,872.155]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1284.62,451.59],[1284.62,350.696],[1349.88,454.864],[1349.88,357.737]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1284.62,558.972],[1284.62,458.078],[1349.88,558.236],[1349.88,461.109]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1284.62,563.072],[1284.62,663.966],[1349.88,562.183],[1349.88,659.309]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1284.62,666.958],[1284.62,767.852],[1349.88,662.189],[1349.88,759.316]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1284.62,776.981],[1284.62,877.875],[1349.88,768.105],[1349.88,865.231]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1372.33,454.228],[1372.33,356.369],[1349.88,454.864],[1349.88,357.737]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1372.33,558.379],[1372.33,460.52],[1349.88,558.235],[1349.88,461.109]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1372.33,562.355],[1372.33,660.214],[1349.88,562.183],[1349.88,659.309]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1372.33,663.116],[1372.33,760.975],[1349.88,662.189],[1349.88,759.316]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1372.33,769.83],[1372.33,867.689],[1349.88,768.105],[1349.88,865.231]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1372.33,454.228],[1372.33,356.369],[1449.12,458.161],[1449.12,364.828]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1372.33,558.379],[1372.33,460.52],[1449.12,557.494],[1449.12,464.162]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1372.33,562.355],[1372.33,660.214],[1449.12,561.287],[1449.12,654.619]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1372.33,663.116],[1372.33,760.975],[1449.12,657.386],[1449.12,750.718]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1372.33,769.83],[1372.33,867.689],[1449.12,759.164],[1449.12,852.496]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1426.38,458.76],[1426.38,366.117],[1481.15,461.505],[1481.15,372.022]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1426.38,656.513],[1426.38,749.156],[1481.15,652.514],[1481.15,741.997]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1426.38,757.539],[1426.38,850.181],[1481.15,750.095],[1481.15,839.578]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1426.38,557.359],[1426.38,464.717],[1481.15,556.742],[1481.15,467.258]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1426.38,561.124],[1426.38,653.766],[1481.15,560.378],[1481.15,649.861]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1482.2,461.557],[1482.2,372.135],[1533.11,464.109],[1533.11,377.623]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1482.2,556.73],[1482.2,467.307],[1533.11,556.156],[1533.11,469.67]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1482.2,560.364],[1482.2,649.786],[1533.11,559.67],[1533.11,646.156]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1482.2,652.438],[1482.2,741.86],[1533.11,648.72],[1533.11,735.206]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1482.2,749.952],[1482.2,839.375],[1533.11,743.032],[1533.11,829.518]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1555.07,463.587],[1555.07,376.501],[1533.11,464.109],[1533.11,377.623]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1555.07,556.273],[1555.07,469.187],[1533.11,556.156],[1533.11,469.67]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1555.07,559.812],[1555.07,646.899],[1533.11,559.67],[1533.11,646.156]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1555.07,649.481],[1555.07,736.567],[1533.11,648.72],[1533.11,735.206]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1555.07,744.448],[1555.07,831.534],[1533.11,743.032],[1533.11,829.518]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1555.07,463.587],[1555.07,376.501],[1616.19,466.718],[1616.19,383.235]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1555.07,556.273],[1555.07,469.187],[1616.19,555.569],[1616.19,472.086]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1555.07,559.812],[1555.07,646.899],[1616.19,558.962],[1616.19,642.445]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1555.07,649.481],[1555.07,736.567],[1616.19,644.92],[1616.19,728.403]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1555.07,744.448],[1555.07,831.534],[1616.19,735.957],[1616.19,819.44]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1595.46,467.181],[1595.46,384.232],[1639.87,469.409],[1639.87,389.023]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1595.46,644.245],[1595.46,727.194],[1639.87,641],[1639.87,721.386]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1595.46,734.7],[1595.46,817.65],[1639.87,728.66],[1639.87,809.046]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1595.46,558.836],[1595.46,641.785],[1639.87,558.23],[1639.87,638.616]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:56,
                    verts:[[1595.46,555.465],[1595.46,472.515],[1639.87,554.964],[1639.87,474.578]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[302.523,421.08],[302.523,285.07],[121.717,429.829],[121.717,303.89]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[302.523,565.835],[302.523,429.825],[121.717,563.867],[121.717,437.927]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[302.523,571.362],[302.523,707.372],[121.717,568.985],[121.717,694.925]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[302.523,711.405],[302.523,847.415],[121.717,698.659],[121.717,824.599]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[302.523,859.723],[302.523,995.732],[121.717,835.995],[121.717,961.935]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[248.787,435.243],[248.787,315.534],[229.179,436.097],[229.179,317.371]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[248.787,567.514],[248.787,687.223],[229.179,567.282],[229.179,686.008]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[248.787,690.772],[248.787,810.481],[229.179,689.528],[229.179,808.254]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[248.787,821.313],[248.787,941.022],[229.179,818.998],[229.179,937.723]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[585.996,407.362],[585.996,255.564],[362.696,418.168],[362.696,278.807]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[585.996,568.921],[585.996,417.123],[362.696,566.49],[362.696,427.129]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[585.996,575.09],[585.996,726.888],[362.696,572.154],[362.696,711.515]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[585.996,731.389],[585.996,883.187],[362.696,715.647],[362.696,855.008]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[585.996,896.923],[585.996,1048.72],[362.696,867.619],[362.696,1006.98]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[589.23,452.958],[589.23,349.94],[569.929,453.569],[569.929,351.279]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[589.23,566.787],[589.23,669.806],[569.929,566.593],[569.929,668.883]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[589.23,672.861],[589.23,775.879],[569.929,671.916],[569.929,774.206]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[589.23,785.201],[589.23,888.22],[569.929,783.462],[569.929,885.752]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[585.996,407.362],[585.996,255.564],[710.207,415.148],[710.207,272.312]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[585.996,568.921],[585.996,417.123],[710.207,567.169],[710.207,424.333]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[585.996,575.09],[585.996,726.888],[710.207,572.974],[710.207,715.811]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[585.996,731.389],[585.996,883.187],[710.207,720.046],[710.207,862.882]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[585.996,896.923],[585.996,1048.72],[710.207,875.808],[710.207,1018.64]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[738.634,413.91],[738.634,269.649],[710.207,415.148],[710.207,272.312]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[738.634,567.448],[738.634,423.186],[710.207,567.169],[710.207,424.333]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[738.634,573.31],[738.634,717.572],[710.207,572.974],[710.207,715.811]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[738.634,721.849],[738.634,866.111],[710.207,720.046],[710.207,862.883]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[738.634,879.165],[738.634,1023.43],[710.207,875.808],[710.207,1018.64]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[738.634,413.91],[738.634,269.649],[877.925,422.858],[877.925,288.893]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[738.634,567.448],[738.634,423.186],[877.925,565.435],[877.925,431.471]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[738.634,573.31],[738.634,717.572],[877.925,570.879],[877.925,704.843]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[738.634,721.849],[738.634,866.111],[877.925,708.815],[877.925,842.779]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[738.634,879.165],[738.634,1023.43],[877.925,854.902],[877.925,988.866]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[849.26,423.963],[849.26,291.272],[944.173,429.908],[944.173,304.058]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[849.26,570.579],[849.26,703.27],[944.173,568.964],[944.173,694.813]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[849.26,707.205],[849.26,839.896],[944.173,698.545],[944.173,824.394]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[849.26,851.903],[849.26,984.595],[944.173,835.782],[944.173,961.632]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[849.26,565.187],[849.26,432.495],[944.173,563.849],[944.173,438]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[971.391,462.928],[971.391,371.812],[884.751,465.054],[884.751,376.475]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[971.391,563.606],[971.391,654.722],[884.751,562.928],[884.751,651.507]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[971.391,657.424],[971.391,748.54],[884.751,654.133],[884.751,742.712]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[971.391,756.786],[971.391,847.902],[884.751,750.727],[884.751,839.306]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[944.529,429.837],[944.529,303.906],[1030.88,435.25],[1030.88,315.549]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[944.529,563.865],[944.529,437.934],[1030.88,562.648],[1030.88,442.947]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[944.529,568.983],[944.529,694.914],[1030.88,567.512],[1030.88,687.213]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[944.529,698.648],[944.529,824.579],[1030.88,690.762],[1030.88,810.462]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[944.529,835.974],[944.529,961.905],[1030.88,821.294],[1030.88,940.995]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1057.34,434.382],[1057.34,313.682],[1030.88,435.25],[1030.88,315.549]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1057.34,562.843],[1057.34,442.143],[1030.88,562.648],[1030.88,442.947]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1057.34,567.748],[1057.34,688.448],[1030.88,567.512],[1030.88,687.213]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1057.34,692.026],[1057.34,812.726],[1030.88,690.762],[1030.88,810.463]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1057.34,823.648],[1057.34,944.348],[1030.88,821.294],[1030.88,940.995]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1057.34,434.382],[1057.34,313.682],[1156,440.719],[1156,327.313]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1057.34,562.843],[1057.34,442.143],[1156,561.417],[1156,448.011]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1057.34,567.748],[1057.34,688.448],[1156,566.026],[1156,679.432]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1057.34,692.026],[1057.34,812.726],[1156,682.795],[1156,796.201]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1057.34,823.648],[1057.34,944.348],[1156,806.463],[1156,919.869]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1128.14,474.469],[1128.14,397.837],[1110.31,474.823],[1110.31,398.609]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1128.14,559.143],[1128.14,635.776],[1110.31,559.035],[1110.31,635.249]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1128.14,638.048],[1128.14,714.68],[1110.31,637.509],[1110.31,713.723]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1129.46,441.513],[1129.46,329.02],[1198.8,445.856],[1198.8,338.361]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1129.46,681.639],[1129.46,794.131],[1198.8,675.312],[1198.8,782.806]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1129.46,804.311],[1129.46,916.804],[1198.8,792.534],[1198.8,900.028]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1129.46,565.81],[1129.46,678.303],[1198.8,564.63],[1198.8,672.125]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1129.46,561.239],[1129.46,448.746],[1198.8,560.262],[1198.8,452.767]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1293.37,451.78],[1293.37,351.104],[1243.15,453.06],[1243.15,353.857]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1293.37,558.929],[1293.37,458.253],[1243.15,558.641],[1243.15,459.438]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1293.37,563.021],[1293.37,663.696],[1243.15,562.673],[1243.15,661.876]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1293.37,666.681],[1293.37,767.357],[1243.15,664.817],[1243.15,764.02]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1293.37,776.467],[1293.37,877.143],[1243.15,772.997],[1243.15,872.2]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1293.74,451.727],[1293.74,350.991],[1349.55,455.226],[1349.55,358.516]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1293.74,558.941],[1293.74,458.205],[1349.55,558.154],[1349.55,461.444]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1293.74,563.035],[1293.74,663.771],[1349.55,562.084],[1349.55,658.794]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1293.74,666.758],[1293.74,767.494],[1349.55,661.661],[1349.55,758.371]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1293.74,776.61],[1293.74,877.346],[1349.55,767.123],[1349.55,863.833]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1373.04,454.66],[1373.04,357.299],[1349.55,455.226],[1349.55,358.516]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1373.04,558.281],[1373.04,460.92],[1349.55,558.154],[1349.55,461.444]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1373.04,562.238],[1373.04,659.599],[1349.55,562.084],[1349.55,658.794]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1373.04,662.486],[1373.04,759.846],[1349.55,661.661],[1349.55,758.371]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1373.04,768.657],[1373.04,866.018],[1349.55,767.122],[1349.55,863.832]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1373.04,454.66],[1373.04,357.299],[1437.99,458.832],[1437.99,366.273]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1373.04,558.281],[1373.04,460.92],[1437.99,557.343],[1437.99,464.784]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1373.04,562.238],[1373.04,659.599],[1437.99,561.104],[1437.99,653.664]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1373.04,662.486],[1373.04,759.846],[1437.99,656.408],[1437.99,748.967]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1373.04,768.657],[1373.04,866.018],[1437.99,757.343],[1437.99,849.902]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1414.44,459.362],[1414.44,367.412],[1460.75,462.262],[1460.75,373.65]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1414.44,655.637],[1414.44,747.586],[1460.75,651.411],[1460.75,740.023]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1414.44,755.907],[1414.44,847.857],[1460.75,748.041],[1460.75,836.653]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1414.44,560.96],[1414.44,652.91],[1460.75,560.172],[1460.75,648.784]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1414.44,557.224],[1414.44,465.274],[1460.75,556.571],[1460.75,467.96]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1461.63,462.317],[1461.63,373.77],[1504.49,465.002],[1504.49,379.543]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1461.63,556.559],[1461.63,468.011],[1504.49,555.955],[1504.49,470.497]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1461.63,560.157],[1461.63,648.705],[1504.49,559.428],[1504.49,644.886]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1461.63,651.33],[1461.63,739.878],[1504.49,647.42],[1504.49,732.878]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1461.63,747.891],[1461.63,836.439],[1504.49,740.612],[1504.49,826.07]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1526.92,464.545],[1526.92,378.56],[1504.49,465.002],[1504.49,379.543]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1526.92,556.058],[1526.92,470.073],[1504.49,555.955],[1504.49,470.497]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1526.92,559.552],[1526.92,645.536],[1504.49,559.428],[1504.49,644.886]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1526.92,648.086],[1526.92,734.07],[1504.49,647.42],[1504.49,732.878]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1526.92,741.851],[1526.92,827.836],[1504.49,740.612],[1504.49,826.07]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1526.92,464.545],[1526.92,378.56],[1577.88,467.818],[1577.88,385.6]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1526.92,556.058],[1526.92,470.073],[1577.88,555.322],[1577.88,473.104]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1526.92,559.552],[1526.92,645.536],[1577.88,558.663],[1577.88,640.88]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1526.92,648.086],[1526.92,734.07],[1577.88,643.318],[1577.88,725.536]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1526.92,741.851],[1526.92,827.836],[1577.88,732.976],[1577.88,815.193]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1556.86,468.221],[1556.86,386.469],[1593.9,470.543],[1593.9,391.462]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1556.86,558.553],[1556.86,640.306],[1593.9,557.922],[1593.9,637.003]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1556.86,642.73],[1556.86,724.482],[1593.9,639.348],[1593.9,718.428]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1556.86,731.88],[1556.86,813.633],[1593.9,725.584],[1593.9,804.665]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:57,
                    verts:[[1556.86,555.231],[1556.86,473.478],[1593.9,554.708],[1593.9,475.628]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[366.841,416.38],[366.841,274.962],[151.742,424.719],[151.742,292.898]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[366.841,566.892],[366.841,425.474],[151.742,565.017],[151.742,433.195]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[366.841,572.639],[366.841,714.058],[151.742,570.373],[151.742,702.195]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[366.841,718.251],[366.841,859.67],[151.742,706.103],[151.742,837.925]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[366.841,872.467],[366.841,1013.89],[151.742,849.853],[151.742,981.675]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[274.008,430.99],[274.008,306.386],[250.967,431.801],[250.967,308.13]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[274.008,568.67],[274.008,693.274],[250.967,568.449],[250.967,692.12]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[274.008,696.968],[274.008,821.572],[250.967,695.787],[250.967,819.458]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[274.008,832.848],[274.008,957.452],[250.967,830.649],[250.967,954.32]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[698.4,403.527],[698.4,247.314],[437.795,413.63],[437.795,269.045]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[698.4,569.784],[698.4,413.571],[437.795,567.511],[437.795,422.926]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[698.4,576.132],[698.4,732.344],[437.795,573.387],[437.795,717.971]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[698.4,736.976],[698.4,893.188],[437.795,722.258],[437.795,866.843]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[698.4,907.324],[698.4,1063.54],[437.795,879.926],[437.795,1024.51]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[595,450.745],[595,345.084],[573.399,451.308],[573.399,346.319]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[595,567.494],[595,673.155],[573.399,567.314],[573.399,672.303]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[595,676.287],[595,781.948],[573.399,675.416],[573.399,780.405]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[595,791.51],[595,897.17],[573.399,789.906],[573.399,894.895]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[698.399,403.527],[698.399,247.314],[806.724,412.245],[806.724,266.066]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[698.399,569.784],[698.399,413.571],[806.724,567.823],[806.724,421.644]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[698.399,576.132],[698.399,732.344],[806.724,573.763],[806.724,719.942]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[698.399,736.976],[698.399,893.188],[806.724,724.276],[806.724,870.455]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[698.399,907.324],[698.399,1063.54],[806.724,883.683],[806.724,1029.86]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[838.958,411.11],[838.958,263.626],[806.723,412.245],[806.723,266.066]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[838.958,568.078],[838.958,420.593],[806.723,567.823],[806.723,421.644]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[838.958,574.071],[838.958,721.556],[806.723,573.763],[806.723,719.942]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[838.958,725.929],[838.958,873.413],[806.723,724.276],[806.723,870.455]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[838.958,886.759],[806.723,883.683],[838.958,1034.24],[806.723,1029.86]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[838.958,411.11],[838.958,263.626],[958.155,420.991],[958.155,284.878]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[838.958,568.078],[838.958,420.593],[958.155,565.855],[958.155,429.742]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[838.958,574.071],[838.958,721.556],[958.155,571.387],[958.155,707.499]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[838.958,725.928],[838.958,873.413],[958.155,711.535],[958.155,847.648]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[838.958,886.759],[838.958,1034.24],[958.155,859.965],[958.155,996.077]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[959.131,462.203],[959.131,370.221],[866.213,464.106],[866.213,374.396]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[959.131,563.838],[959.131,655.82],[866.213,563.23],[866.213,652.941]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[959.131,658.547],[959.131,750.529],[866.213,655.6],[866.213,745.311]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[926.334,421.991],[926.334,287.03],[1007.32,428.502],[1007.32,301.034]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[926.334,571.115],[926.334,706.076],[1007.32,569.346],[1007.32,696.813]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[926.334,710.077],[926.334,845.038],[1007.32,700.593],[1007.32,828.061]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[926.334,857.251],[926.334,992.212],[1007.32,839.595],[1007.32,967.063]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[959.131,758.853],[959.131,850.835],[866.213,753.429],[866.213,843.139]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[926.334,565.63],[926.334,430.669],[1007.32,564.166],[1007.32,436.698]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1007.85,428.431],[1007.85,300.882],[1080.93,434.312],[1080.93,313.532]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1007.85,564.182],[1007.85,436.632],[1080.93,562.858],[1080.93,442.078]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1007.85,569.365],[1007.85,696.914],[1080.93,567.767],[1080.93,688.547]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1007.85,700.696],[1007.85,828.245],[1080.93,692.128],[1080.93,812.908]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1007.85,839.787],[1007.85,967.336],[1080.93,823.837],[1080.93,944.617]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1084.41,474.313],[1084.41,397.497],[1065.78,474.625],[1065.78,398.176]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1084.41,559.191],[1084.41,636.008],[1065.78,559.096],[1065.78,635.544]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1084.41,638.286],[1084.41,715.103],[1065.78,637.811],[1065.78,714.26]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1109.54,433.539],[1109.54,311.869],[1080.93,434.312],[1080.93,313.532]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1109.54,563.032],[1109.54,441.362],[1080.93,562.858],[1080.93,442.078]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1109.54,567.977],[1109.54,689.647],[1080.93,567.767],[1080.93,688.547]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1109.54,693.254],[1109.54,814.924],[1080.93,692.128],[1080.93,812.908]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1109.54,825.934],[1080.93,823.838],[1109.54,947.604],[1080.93,944.618]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1109.54,433.539],[1109.54,311.869],[1191.78,440.355],[1191.78,326.531]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1109.54,563.032],[1109.54,441.362],[1191.78,561.499],[1191.78,447.674]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1109.54,567.977],[1109.54,689.647],[1191.78,566.125],[1191.78,679.95]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1109.54,693.254],[1109.54,814.924],[1191.78,683.325],[1191.78,797.149]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1109.54,825.934],[1109.54,947.604],[1191.78,807.449],[1191.78,921.274]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1163.47,441.056],[1163.47,328.038],[1221.26,445.702],[1221.26,338.031]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1163.47,565.934],[1163.47,678.953],[1221.26,564.672],[1221.26,672.343]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1163.47,682.304],[1163.47,795.322],[1221.26,675.535],[1221.26,783.206]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1163.47,805.549],[1163.47,918.568],[1221.26,792.949],[1221.26,900.62]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1163.47,561.341],[1163.47,448.323],[1221.26,560.296],[1221.26,452.625]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1299.53,451.995],[1299.53,351.568],[1247,453.113],[1247,353.971]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1299.53,558.881],[1299.53,458.453],[1247,558.629],[1247,459.487]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1299.53,562.962],[1299.53,663.39],[1247,562.658],[1247,661.8]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1299.53,666.367],[1299.53,766.795],[1247,664.74],[1247,763.882]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1299.53,775.883],[1299.53,876.311],[1247,772.854],[1247,871.996]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1300.01,451.944],[1300.01,351.456],[1345.89,455.636],[1345.89,359.398]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1300.01,558.892],[1300.01,458.405],[1345.89,558.062],[1345.89,461.824]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1300.01,562.976],[1300.01,663.463],[1345.89,561.973],[1345.89,658.211]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1300.01,666.443],[1300.01,766.93],[1345.89,661.064],[1345.89,757.302]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1300.01,776.023],[1300.01,876.51],[1345.89,766.011],[1345.89,862.249]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1370.21,455.146],[1370.21,358.344],[1345.89,455.636],[1345.89,359.398]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1370.21,558.172],[1370.21,461.37],[1345.89,558.062],[1345.89,461.824]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1370.21,562.106],[1370.21,658.908],[1345.89,561.973],[1345.89,658.211]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1370.21,661.778],[1370.21,758.58],[1345.89,661.064],[1345.89,757.302]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1370.21,767.34],[1345.89,766.011],[1370.21,864.142],[1345.89,862.249]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1370.21,455.146],[1370.21,358.343],[1422.96,459.518],[1422.96,367.748]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1370.21,558.172],[1370.21,461.37],[1422.96,557.189],[1422.96,465.419]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1370.21,562.106],[1370.21,658.908],[1422.96,560.918],[1422.96,652.688]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1370.21,661.778],[1370.21,758.58],[1422.96,655.409],[1422.96,747.179]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1370.21,767.34],[1370.21,864.142],[1422.96,755.483],[1422.96,847.253]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1398.78,459.974],[1398.78,368.729],[1436.48,463.004],[1436.48,375.247]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1398.78,654.744],[1398.78,745.989],[1436.48,650.33],[1436.48,738.087]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1398.78,754.246],[1398.78,845.491],[1436.48,746.028],[1436.48,833.785]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1398.78,560.794],[1398.78,652.039],[1436.48,559.971],[1436.48,647.728]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1398.78,557.086],[1398.78,465.841],[1436.48,556.404],[1436.48,468.647]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1437.2,463.062],[1437.2,375.372],[1471.94,465.856],[1471.94,381.38]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1437.2,556.391],[1437.2,468.701],[1471.94,555.763],[1471.94,471.287]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1437.2,559.955],[1437.2,647.645],[1471.94,559.196],[1471.94,643.671]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1437.2,650.245],[1437.2,737.936],[1471.94,646.176],[1471.94,730.651]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1437.2,745.871],[1437.2,833.562],[1471.94,738.295],[1471.94,822.771]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1494.7,465.465],[1494.7,380.54],[1471.94,465.856],[1471.94,381.38]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1494.7,555.851],[1494.7,470.926],[1471.94,555.763],[1471.94,471.287]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1494.7,559.302],[1494.7,644.227],[1471.94,559.196],[1471.94,643.671]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1494.7,646.745],[1494.7,731.67],[1471.94,646.176],[1471.94,730.651]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1494.7,739.355],[1471.94,738.295],[1494.7,824.28],[1471.94,822.771]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1494.7,465.465],[1494.7,380.54],[1535.56,468.852],[1535.56,387.825]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1494.7,555.851],[1494.7,470.926],[1535.56,555.089],[1535.56,474.062]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1494.7,559.302],[1494.7,644.227],[1535.56,558.382],[1535.56,639.409]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1494.7,646.745],[1494.7,731.67],[1535.56,641.811],[1535.56,722.838]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1494.7,739.355],[1494.7,824.28],[1535.56,730.171],[1535.56,811.198]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1514.38,469.196],[1514.38,388.564],[1544.17,471.593],[1544.17,393.72]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1514.38,558.288],[1514.38,638.92],[1544.17,557.637],[1544.17,635.509]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1514.38,641.31],[1514.38,721.942],[1544.17,637.818],[1544.17,715.691]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1514.38,729.238],[1514.38,809.87],[1544.17,722.738],[1544.17,800.61]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:58,
                    verts:[[1514.38,555.012],[1514.38,474.38],[1544.17,554.472],[1544.17,476.6]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[445.521,411.843],[445.521,265.203],[195.561,419.503],[195.561,281.677]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[445.521,567.913],[445.521,421.272],[195.561,566.19],[195.561,428.364]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[445.521,573.872],[445.521,720.513],[195.561,571.791],[195.561,709.616]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[445.521,724.861],[445.521,871.501],[195.561,713.703],[195.561,851.528]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[445.521,884.771],[445.521,1031.41],[195.561,864],[195.561,1001.83]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[310.069,426.675],[310.069,297.106],[283.507,427.419],[283.507,298.705]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[310.069,569.842],[310.069,699.412],[283.507,569.64],[283.507,698.354]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[310.069,703.253],[310.069,832.823],[283.507,702.17],[283.507,830.885]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[310.069,844.548],[310.069,974.118],[283.507,842.532],[283.507,971.246]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[822.844,400.282],[822.844,240.334],[527.074,409.344],[527.074,259.828]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[822.844,570.514],[822.844,410.566],[527.074,568.475],[527.074,418.958]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[822.844,577.014],[822.844,736.961],[527.074,574.551],[527.074,724.068]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[822.844,741.704],[822.844,901.651],[527.074,728.501],[527.074,878.018]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[822.844,916.125],[822.844,1076.07],[527.074,891.548],[527.074,1041.06]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[604.853,448.516],[604.853,340.193],[580.993,449.017],[580.993,341.293]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[604.853,568.205],[604.853,676.528],[580.993,568.045],[580.993,675.769]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[604.853,679.739],[604.853,788.062],[580.993,678.963],[580.993,786.687]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[604.853,797.864],[604.853,906.186],[580.993,796.435],[580.993,904.159]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[822.843,400.282],[822.843,240.334],[911.277,409.85],[911.277,260.915]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[822.843,570.514],[822.843,410.566],[911.277,568.361],[911.277,419.426]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[822.843,577.014],[822.843,736.961],[911.277,574.414],[911.277,723.349]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[822.843,741.704],[822.843,901.652],[911.277,727.765],[911.277,876.699]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[822.843,916.125],[822.843,1076.07],[911.277,890.177],[911.277,1039.11]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.414,461.471],[946.414,368.615],[847.64,463.12],[847.64,372.232]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.414,564.071],[946.414,656.927],[847.64,563.545],[847.64,654.433]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.414,659.681],[946.414,752.537],[847.64,657.127],[847.64,748.015]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.878,408.854],[946.878,258.772],[911.277,409.85],[911.277,260.915]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.878,568.585],[946.878,418.504],[911.277,568.361],[911.277,419.426]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.878,574.685],[946.878,724.766],[911.277,574.414],[911.277,723.349]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.878,729.216],[946.878,879.298],[911.277,727.765],[911.277,876.7]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.878,892.879],[911.277,890.177],[946.878,1042.96],[911.277,1039.11]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.878,408.854],[946.878,258.772],[1042.15,419.56],[1042.15,281.801]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.878,568.585],[946.878,418.504],[1042.15,566.177],[1042.15,428.418]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.878,574.685],[946.878,724.766],[1042.15,571.775],[1042.15,709.535]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.878,729.216],[946.878,879.298],[1042.15,713.619],[1042.15,851.379]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[946.878,892.879],[946.878,1042.96],[1042.15,863.844],[1042.15,1001.6]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1007.61,420.429],[1007.61,283.671],[1072.46,427.437],[1072.46,298.744]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1007.61,571.539],[1007.61,708.298],[1072.46,569.635],[1072.46,698.328]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1007.61,712.353],[1007.61,849.111],[1072.46,702.144],[1072.46,830.837]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1007.61,861.487],[1007.61,998.245],[1072.46,842.482],[1072.46,971.176]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1038.72,474.079],[1038.72,396.984],[1019.35,474.344],[1019.35,397.564]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1038.72,559.263],[1038.72,636.358],[1019.35,559.182],[1019.35,635.962]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1007.61,565.981],[1007.61,429.223],[1072.46,564.405],[1072.46,435.712]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1073.18,427.368],[1073.18,298.594],[1131.28,433.654],[1131.28,312.116]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1073.18,564.421],[1073.18,435.648],[1131.28,563.007],[1131.28,441.469]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1073.18,569.654],[1073.18,698.427],[1131.28,567.946],[1131.28,689.483]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1073.18,702.245],[1073.18,831.018],[1131.28,693.087],[1131.28,814.625]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1073.18,842.671],[1073.18,971.444],[1131.28,825.623],[1131.28,947.16]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1161.67,432.992],[1161.67,310.691],[1131.28,433.654],[1131.28,312.116]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1161.67,563.156],[1161.67,440.855],[1131.28,563.007],[1131.28,441.469]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1161.67,568.126],[1161.67,690.426],[1131.28,567.946],[1131.28,689.483]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1161.67,694.052],[1161.67,816.353],[1131.28,693.087],[1131.28,814.625]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1161.67,827.42],[1131.28,825.623],[1161.67,949.72],[1131.28,947.161]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1161.67,432.992],[1161.67,310.691],[1225.91,440.211],[1225.91,326.219]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1161.67,563.156],[1161.67,440.855],[1225.91,561.532],[1225.91,447.54]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1161.67,568.126],[1161.67,690.426],[1225.91,566.164],[1225.91,680.156]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1161.67,694.052],[1161.67,816.353],[1225.91,683.535],[1225.91,797.527]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1161.67,827.42],[1161.67,949.72],[1225.91,807.842],[1225.91,921.833]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1196.19,440.807],[1196.19,327.501],[1241.54,445.707],[1241.54,338.042]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1196.19,566.002],[1196.19,679.308],[1241.54,564.671],[1241.54,672.336]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1196.19,682.667],[1196.19,795.972],[1241.54,675.528],[1241.54,783.193]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1196.19,806.226],[1196.19,919.531],[1241.54,792.936],[1241.54,900.601]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1196.19,561.398],[1196.19,448.092],[1241.54,560.295],[1241.54,452.63]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1302.58,452.305],[1302.58,352.232],[1248.26,453.246],[1248.26,354.258]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1302.58,558.811],[1302.58,458.739],[1248.26,558.599],[1248.26,459.611]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1302.58,562.878],[1302.58,662.95],[1248.26,562.622],[1248.26,661.61]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1302.58,665.917],[1302.58,765.989],[1248.26,664.545],[1248.26,763.534]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1302.58,775.045],[1302.58,875.117],[1248.26,772.491],[1248.26,871.48]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1303.18,452.254],[1303.18,352.125],[1338.76,456.103],[1338.76,360.403]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1303.18,558.822],[1303.18,458.693],[1338.76,557.957],[1338.76,462.257]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1303.18,562.892],[1303.18,663.021],[1338.76,561.846],[1338.76,657.546]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1303.18,665.99],[1303.18,766.12],[1338.76,660.383],[1338.76,756.083]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1303.18,775.181],[1303.18,875.311],[1338.76,764.743],[1338.76,860.443]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1363.68,455.693],[1363.68,359.521],[1338.76,456.103],[1338.76,360.404]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1363.68,558.049],[1363.68,461.877],[1338.76,557.957],[1338.76,462.257]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1363.68,561.957],[1363.68,658.129],[1338.76,561.846],[1338.76,657.546]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1363.68,660.981],[1363.68,757.153],[1338.76,660.383],[1338.76,756.083]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1363.68,765.855],[1338.76,764.743],[1363.68,862.027],[1338.76,860.443]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1363.68,455.693],[1363.68,359.521],[1403.99,460.223],[1403.99,369.264]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1363.68,558.049],[1363.68,461.877],[1403.99,557.03],[1403.99,466.071]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1363.68,561.957],[1363.68,658.129],[1403.99,560.726],[1403.99,651.685]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1363.68,660.981],[1363.68,757.153],[1403.99,654.382],[1403.99,745.34]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1363.68,765.855],[1363.68,862.027],[1403.99,753.571],[1403.99,844.53]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1379.39,460.603],[1379.39,370.082],[1408.38,463.736],[1408.38,376.82]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1379.39,560.623],[1379.39,651.144],[1408.38,559.772],[1408.38,646.687]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1379.39,653.828],[1379.39,744.349],[1408.38,649.265],[1408.38,736.18]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1379.39,752.541],[1379.39,843.062],[1408.38,744.045],[1408.38,830.961]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1379.39,556.945],[1379.39,466.423],[1408.38,556.24],[1408.38,469.324]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1408.93,463.795],[1408.93,376.948],[1435.57,466.674],[1435.57,383.14]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1408.93,556.226],[1408.93,469.379],[1435.57,555.579],[1435.57,472.045]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1408.93,559.756],[1408.93,646.603],[1435.57,558.974],[1435.57,642.508]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1408.93,649.178],[1408.93,736.024],[1435.57,644.984],[1435.57,728.518]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1408.93,743.883],[1408.93,830.73],[1435.57,736.077],[1435.57,819.611]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1458.51,466.35],[1458.51,382.444],[1435.57,466.674],[1435.57,383.14]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1458.51,555.652],[1458.51,471.745],[1435.57,555.579],[1435.57,472.045]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1458.51,559.061],[1458.51,642.968],[1435.57,558.974],[1435.57,642.508]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1458.51,645.456],[1458.51,729.362],[1435.57,644.984],[1435.57,728.518]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1458.51,736.955],[1435.57,736.077],[1458.51,820.861],[1435.57,819.611]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1458.51,466.35],[1458.51,382.444],[1489.41,469.822],[1489.41,389.912]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1458.51,555.652],[1458.51,471.745],[1489.41,554.871],[1489.41,474.96]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1458.51,559.061],[1458.51,642.968],[1489.41,558.118],[1489.41,638.028]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1458.51,645.456],[1458.51,729.362],[1489.41,640.397],[1489.41,720.308]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1458.51,736.955],[1458.51,820.861],[1489.41,727.539],[1489.41,807.449]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1468.17,470.106],[1468.17,390.522],[1490.85,472.56],[1490.85,395.8]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1468.17,558.041],[1468.17,637.625],[1490.85,557.374],[1490.85,634.134]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1468.17,639.984],[1468.17,719.568],[1490.85,636.41],[1490.85,713.17]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1468.17,726.77],[1468.17,806.354],[1490.85,720.116],[1490.85,796.875]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:59,
                    verts:[[1468.17,554.807],[1468.17,475.223],[1490.85,554.255],[1490.85,477.495]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[538.782,407.657],[538.782,256.197],[254.87,414.326],[254.87,270.542]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[538.782,568.855],[538.782,417.395],[254.87,567.355],[254.87,423.571]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[538.782,575.01],[538.782,726.469],[254.87,573.198],[254.87,716.982]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[538.782,730.96],[538.782,882.419],[254.87,721.245],[254.87,865.029]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[538.782,896.125],[538.782,1047.58],[254.87,878.04],[254.87,1021.82]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[358.156,422.416],[358.156,287.944],[328.099,423.064],[328.099,289.337]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[358.156,570.999],[358.156,705.471],[328.099,570.823],[328.099,704.55]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[358.156,709.458],[358.156,843.931],[328.099,708.515],[328.099,842.242]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[358.156,856.099],[328.099,854.343],[358.156,990.571],[328.099,988.069]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[619.21,446.32],[619.21,335.376],[593.193,446.745],[593.193,336.31]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[619.21,564.397],[619.21,453.453],[593.193,564.282],[593.193,453.846]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[619.21,568.906],[619.21,679.849],[593.193,568.77],[593.193,679.206]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[619.21,683.139],[619.21,794.082],[593.193,682.48],[593.193,792.916]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[619.21,804.122],[593.193,802.909],[619.21,915.065],[593.193,913.345]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[956.824,397.837],[956.824,235.076],[630.196,405.509],[630.196,251.579]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[956.824,571.064],[956.824,408.302],[630.196,569.338],[630.196,415.407]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[956.824,577.678],[956.824,740.439],[630.196,575.593],[630.196,729.524]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[956.824,745.265],[956.824,908.026],[630.196,734.088],[630.196,888.019]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[956.824,922.754],[956.824,1085.52],[630.196,901.948],[630.196,1055.88]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[933.361,460.75],[933.361,367.032],[829.261,462.112],[829.261,370.022]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[933.361,564.301],[933.361,658.019],[829.261,563.867],[829.261,655.957]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[933.361,660.797],[933.361,754.515],[829.261,658.688],[829.261,750.778]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[956.824,397.837],[956.824,235.076],[1021.73,408.117],[1021.73,257.186]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[956.824,571.064],[956.824,408.302],[1021.73,568.751],[1021.73,417.821]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[956.824,577.678],[956.824,740.439],[1021.73,574.885],[1021.73,725.815]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[956.824,745.265],[956.824,908.026],[1021.73,730.29],[1021.73,881.22]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[956.824,922.754],[956.824,1085.52],[1021.73,894.878],[1021.73,1045.81]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[991.29,473.768],[991.29,396.306],[971.226,473.985],[971.226,396.779]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[991.29,559.359],[991.29,636.821],[971.226,559.292],[971.226,636.498]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[991.29,723.59],[991.29,801.052],[971.226,722.979],[971.226,800.184]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1060.04,407.291],[1021.73,408.116],[1060.04,255.41],[1021.73,257.186]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1060.04,568.937],[1060.04,417.056],[1021.73,568.751],[1021.73,417.821]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1060.04,575.109],[1060.04,726.99],[1021.73,574.885],[1021.73,725.815]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1060.04,731.493],[1021.73,730.29],[1060.04,883.373],[1021.73,881.22]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1060.04,897.117],[1021.73,894.878],[1060.04,1049],[1021.73,1045.81]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1060.04,407.291],[1060.04,255.41],[1128.09,418.662],[1128.09,279.87]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1060.04,568.937],[1060.04,417.056],[1128.09,566.379],[1128.09,427.587]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1060.04,575.109],[1060.04,726.99],[1128.09,572.019],[1128.09,710.812]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1060.04,731.493],[1060.04,883.373],[1128.09,714.927],[1128.09,853.719]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1060.04,897.117],[1060.04,1049],[1128.09,866.278],[1128.09,1005.07]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1091.43,419.376],[1091.43,281.406],[1138.29,426.785],[1138.29,297.341]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1091.43,571.825],[1091.43,709.796],[1138.29,569.812],[1138.29,699.256]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1091.43,713.886],[1091.43,851.857],[1138.29,703.094],[1138.29,832.538]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1091.43,864.342],[1091.43,1002.31],[1138.29,844.252],[1138.29,973.696]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1091.43,566.218],[1091.43,428.248],[1138.29,564.552],[1138.29,435.108]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1139.17,426.718],[1139.17,297.196],[1180.89,433.325],[1180.89,311.409]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1139.17,564.567],[1139.17,435.046],[1180.89,563.081],[1180.89,441.164]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1139.17,569.83],[1139.17,699.352],[1180.89,568.035],[1180.89,689.951]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1139.17,703.192],[1139.17,832.713],[1180.89,693.566],[1180.89,815.482]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1139.17,844.434],[1139.17,973.955],[1180.89,826.515],[1180.89,948.431]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1212.61,432.787],[1180.89,433.325],[1212.61,310.251],[1180.89,311.409]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1212.61,563.202],[1212.61,440.666],[1180.89,563.081],[1180.89,441.164]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1212.61,568.181],[1212.61,690.717],[1180.89,568.035],[1180.89,689.951]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1212.61,694.35],[1180.89,693.566],[1212.61,816.886],[1180.89,815.483]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1212.61,827.974],[1180.89,826.515],[1212.61,950.51],[1180.89,948.431]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1212.61,432.787],[1212.61,310.251],[1257.66,440.314],[1257.66,326.442]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1212.61,563.202],[1212.61,440.666],[1257.66,561.508],[1257.66,447.636]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1212.61,568.181],[1212.61,690.717],[1257.66,566.136],[1257.66,680.008]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1212.61,694.35],[1212.61,816.886],[1257.66,683.384],[1257.66,797.257]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1212.61,827.974],[1212.61,950.51],[1257.66,807.561],[1257.66,921.433]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1226.91,440.795],[1226.91,327.477],[1259.15,445.891],[1259.15,338.438]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1226.91,566.005],[1226.91,679.324],[1259.15,564.621],[1259.15,672.074]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1226.91,682.683],[1226.91,796.002],[1259.15,675.26],[1259.15,782.714]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1226.91,806.256],[1226.91,919.574],[1259.15,792.437],[1259.15,899.891]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1302.31,452.718],[1302.31,353.121],[1246.75,453.473],[1246.75,354.746]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1302.31,562.766],[1302.31,662.362],[1246.75,562.56],[1246.75,661.288]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1226.91,561.4],[1226.91,448.082],[1259.15,560.254],[1259.15,452.8]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1302.31,665.315],[1302.31,764.912],[1246.75,664.215],[1246.75,762.942]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1302.31,773.924],[1302.31,873.521],[1246.75,771.876],[1246.75,870.603]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1302.31,558.718],[1302.31,459.122],[1246.75,558.548],[1246.75,459.821]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1303.03,452.67],[1303.03,353.018],[1328.07,456.635],[1328.07,361.547]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1303.03,558.729],[1303.03,459.077],[1328.07,557.837],[1328.07,462.749]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1303.03,562.779],[1303.03,662.43],[1328.07,561.701],[1328.07,656.789]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1303.03,665.385],[1303.03,765.037],[1328.07,659.609],[1328.07,754.697]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1303.03,774.054],[1303.03,873.706],[1328.07,763.301],[1328.07,858.39]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1353.37,456.308],[1328.07,456.635],[1353.37,360.843],[1328.07,361.547]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1353.37,557.911],[1353.37,462.446],[1328.07,557.837],[1328.07,462.749]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1353.37,561.79],[1353.37,657.255],[1328.07,561.701],[1328.07,656.789]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1353.37,660.085],[1328.07,659.609],[1353.37,755.549],[1328.07,754.697]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1353.37,764.188],[1328.07,763.301],[1353.37,859.653],[1328.07,858.39]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1353.37,456.308],[1353.37,360.843],[1381.14,460.949],[1381.14,370.826]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1353.37,557.911],[1353.37,462.446],[1381.14,556.867],[1381.14,466.744]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1353.37,561.79],[1353.37,657.255],[1381.14,560.529],[1381.14,650.652]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1353.37,660.085],[1353.37,755.55],[1381.14,653.324],[1381.14,743.446]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1353.37,764.188],[1353.37,859.653],[1381.14,751.602],[1381.14,841.724]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1356.31,461.251],[1356.31,371.475],[1376.58,464.457],[1376.58,378.371]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1356.31,560.447],[1356.31,650.222],[1376.58,559.576],[1376.58,645.662]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1356.31,652.884],[1356.31,742.66],[1376.58,648.214],[1376.58,734.3]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1356.31,750.783],[1356.31,840.559],[1376.58,742.09],[1376.58,828.176]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1376.97,464.518],[1376.97,378.502],[1395.55,467.456],[1395.55,384.821]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1376.97,559.559],[1376.97,645.575],[1395.55,558.761],[1395.55,641.395]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1376.97,648.125],[1376.97,734.141],[1395.55,643.845],[1395.55,726.479]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1376.97,741.924],[1376.97,827.94],[1395.55,733.957],[1395.55,816.591]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1376.97,556.064],[1376.97,470.048],[1395.55,555.403],[1395.55,472.769]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.54,467.2],[1418.54,384.272],[1395.55,467.456],[1395.55,384.821]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.54,555.46],[1418.54,472.532],[1395.55,555.403],[1395.55,472.769]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.54,558.831],[1418.54,641.759],[1395.55,558.761],[1395.55,641.395]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.54,644.218],[1395.55,643.845],[1418.54,727.146],[1395.55,726.479]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.54,734.65],[1395.55,733.957],[1418.54,817.578],[1395.55,816.591]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.54,467.2],[1418.54,384.272],[1439.66,470.728],[1439.66,391.861]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.46,470.952],[1418.46,392.341],[1434.2,473.443],[1434.2,397.7]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.54,555.46],[1418.54,472.532],[1439.66,554.667],[1439.66,475.799]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.46,557.811],[1418.46,636.422],[1434.2,557.134],[1434.2,632.877]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.54,558.831],[1418.54,641.759],[1439.66,557.872],[1439.66,636.739]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.46,638.752],[1418.46,717.363],[1434.2,635.123],[1434.2,710.866]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.54,644.218],[1418.54,727.146],[1439.66,639.078],[1439.66,717.945]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.46,724.476],[1418.46,803.087],[1434.2,717.72],[1434.2,793.463]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:60,
                    verts:[[1418.54,734.65],[1418.54,817.578],[1439.66,725.082],[1439.66,803.949]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[645.875,404.032],[645.875,248.4],[330.847,409.375],[330.847,259.894]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[645.875,569.67],[645.875,414.039],[330.847,568.468],[330.847,418.987]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[645.875,575.995],[645.875,731.626],[330.847,574.543],[330.847,724.024]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[645.875,736.241],[645.875,891.872],[330.847,728.456],[330.847,877.937]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[645.875,905.956],[645.875,1061.59],[330.847,891.464],[330.847,1040.94]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[419.06,418.356],[419.06,279.211],[385.694,418.877],[385.694,280.331]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[419.06,572.102],[419.06,711.248],[385.694,571.961],[385.694,710.507]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[419.06,715.373],[419.06,854.518],[385.694,714.615],[385.694,853.16]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[419.06,867.11],[385.694,865.697],[419.06,1006.26],[385.694,1004.24]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[638.39,444.216],[638.39,330.761],[610.392,444.55],[610.392,331.494]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[638.39,569.577],[638.39,683.032],[610.392,569.47],[610.392,682.527]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[638.39,686.396],[638.39,799.851],[610.392,685.879],[610.392,798.935]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[638.39,810.118],[610.392,809.166],[638.39,923.573],[610.392,922.222]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1096.63,396.385],[1096.63,231.953],[745.754,402.337],[745.754,244.756]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1096.63,571.39],[1096.63,406.958],[745.754,570.051],[745.754,412.47]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1096.63,578.072],[1096.63,742.505],[745.754,576.455],[745.754,734.037]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1096.63,747.38],[1096.63,911.812],[745.754,738.709],[745.754,896.291]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1096.63,926.692],[1096.63,1091.12],[745.754,910.55],[745.754,1068.13]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[920.122,460.057],[920.122,365.513],[811.349,461.102],[811.349,367.805]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[920.122,564.522],[920.122,659.066],[811.349,564.189],[811.349,657.486]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[920.122,661.869],[920.122,756.413],[811.349,660.252],[811.349,753.549]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[942.39,473.384],[942.39,395.468],[921.701,473.549],[921.701,395.828]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[942.39,559.477],[942.39,637.393],[921.701,559.426],[921.701,637.147]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[942.39,724.669],[921.701,724.205],[942.39,802.585],[921.701,801.926]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1096.63,396.385],[1096.63,231.953],[1135.15,407.177],[1135.15,255.166]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1096.63,571.39],[1096.63,406.958],[1135.15,568.963],[1135.15,416.951]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1096.63,578.072],[1096.63,742.505],[1135.15,575.14],[1135.15,727.151]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1096.63,747.38],[1096.63,911.812],[1135.15,731.658],[1135.15,883.669]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1096.63,926.692],[1096.63,1091.12],[1135.15,897.425],[1135.15,1049.44]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.34,406.55],[1135.15,407.177],[1175.34,253.817],[1135.15,255.166]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.34,569.104],[1175.34,416.37],[1135.15,568.963],[1135.15,416.951]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.34,575.31],[1175.34,728.044],[1135.15,575.14],[1135.15,727.151]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.34,732.572],[1135.15,731.658],[1175.34,885.305],[1135.15,883.67]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.34,899.126],[1135.15,897.425],[1175.34,1051.86],[1135.15,1049.44]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.34,406.55],[1175.34,253.817],[1213.78,418.377],[1213.78,279.257]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.34,569.104],[1175.34,416.37],[1213.78,566.443],[1213.78,427.323]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.34,575.31],[1175.34,728.044],[1213.78,572.097],[1213.78,711.217]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.34,732.572],[1175.34,885.305],[1213.78,715.342],[1213.78,854.463]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.34,899.126],[1175.34,1051.86],[1213.78,867.052],[1213.78,1006.17]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.7,418.916],[1175.7,280.416],[1203.22,426.602],[1203.22,296.947]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.7,571.95],[1175.7,710.451],[1203.22,569.862],[1203.22,699.516]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.7,714.557],[1175.7,853.057],[1203.22,703.361],[1203.22,833.015]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1175.7,865.59],[1175.7,1004.09],[1203.22,844.747],[1203.22,974.402]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1204.27,426.539],[1204.27,296.811],[1228.63,433.365],[1228.63,311.494]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1204.27,569.879],[1204.27,699.607],[1228.63,568.024],[1228.63,689.895]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1204.27,703.453],[1204.27,833.18],[1228.63,693.509],[1228.63,815.379]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1204.27,844.919],[1204.27,974.647],[1228.63,826.408],[1228.63,948.279]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1204.27,564.607],[1204.27,434.88],[1228.63,563.072],[1228.63,441.201]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1261.17,432.962],[1228.63,433.365],[1261.17,310.627],[1228.63,311.494]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1261.17,563.162],[1261.17,440.828],[1228.63,563.072],[1228.63,441.201]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1261.17,568.134],[1261.17,690.468],[1228.63,568.024],[1228.63,689.895]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1261.17,694.096],[1228.63,693.509],[1261.17,816.43],[1228.63,815.38]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1261.17,827.5],[1228.63,826.408],[1261.17,949.835],[1228.63,948.279]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1298.6,453.241],[1298.6,354.248],[1242.35,453.802],[1242.35,355.454]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1298.6,562.623],[1298.6,661.617],[1242.35,562.471],[1242.35,660.819]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1298.6,664.552],[1298.6,763.546],[1242.35,663.735],[1242.35,762.083]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1298.6,772.504],[1242.35,770.983],[1298.6,871.498],[1242.35,869.331]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1254.94,441.045],[1254.94,328.014],[1273.64,446.269],[1273.64,339.25]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1254.94,565.937],[1254.94,678.968],[1273.64,564.518],[1273.64,671.537]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1254.94,682.319],[1254.94,795.35],[1273.64,674.71],[1273.64,781.729]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1254.94,805.578],[1254.94,918.609],[1273.64,791.414],[1273.64,898.433]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1261.17,432.962],[1261.17,310.627],[1286.28,440.687],[1286.28,327.243]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1261.17,563.162],[1261.17,440.828],[1286.28,561.425],[1286.28,447.981]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1261.17,568.134],[1261.17,690.468],[1286.28,566.035],[1286.28,679.478]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1261.17,694.096],[1261.17,816.43],[1286.28,682.842],[1286.28,796.286]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1261.17,827.5],[1261.17,949.835],[1286.28,806.551],[1286.28,919.995]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1298.6,558.6],[1298.6,459.607],[1242.35,558.474],[1242.35,460.126]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1299.42,453.196],[1299.42,354.15],[1313.83,457.233],[1313.83,362.833]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1299.42,558.611],[1299.42,459.565],[1313.83,557.703],[1313.83,463.303]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1299.42,562.636],[1299.42,661.682],[1313.83,561.539],[1313.83,655.938]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1299.42,664.618],[1299.42,763.664],[1313.83,658.737],[1313.83,753.137]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1299.42,772.627],[1299.42,871.673],[1313.83,761.679],[1313.83,856.079]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1339.27,456.992],[1313.83,457.233],[1339.27,362.314],[1313.83,362.833]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1339.27,557.757],[1339.27,463.079],[1313.83,557.703],[1313.83,463.303]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1339.27,561.604],[1339.27,656.282],[1313.83,561.539],[1313.83,655.938]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1339.27,659.089],[1313.83,658.737],[1339.27,753.767],[1313.83,753.137]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1339.27,762.334],[1313.83,761.679],[1339.27,857.012],[1313.83,856.079]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1329.68,461.918],[1329.68,372.91],[1341.31,465.166],[1341.31,379.897]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1329.68,560.266],[1329.68,649.273],[1341.31,559.383],[1341.31,644.652]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1329.68,651.912],[1329.68,740.92],[1341.31,647.18],[1341.31,732.449]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1329.68,748.974],[1329.68,837.982],[1341.31,740.165],[1341.31,825.434]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1339.27,456.992],[1339.27,362.314],[1354.56,461.696],[1354.56,372.432]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1339.27,557.757],[1339.27,463.079],[1354.56,556.699],[1354.56,467.435]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1339.27,561.604],[1339.27,656.282],[1354.56,560.326],[1354.56,649.59]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1339.27,659.089],[1339.27,753.767],[1354.56,652.236],[1354.56,741.5]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1339.27,762.334],[1339.27,857.012],[1354.56,749.577],[1354.56,838.84]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1341.54,465.228],[1341.54,380.03],[1352.18,468.2],[1352.18,386.422]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1341.54,559.366],[1341.54,644.564],[1352.18,558.559],[1352.18,640.337]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1341.54,647.09],[1341.54,732.288],[1352.18,642.761],[1352.18,724.539]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1341.54,739.998],[1341.54,825.195],[1352.18,731.939],[1352.18,813.717]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1375.08,468.012],[1352.18,468.2],[1375.08,386.018],[1352.18,386.422]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1375.08,558.61],[1375.08,640.604],[1352.18,558.559],[1352.18,640.337]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1375.08,643.035],[1352.18,642.761],[1375.08,725.028],[1352.18,724.539]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1375.08,732.448],[1352.18,731.939],[1375.08,814.442],[1352.18,813.717]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1375.08,555.278],[1375.08,473.284],[1352.18,555.236],[1352.18,473.458]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1365.58,471.731],[1365.58,394.018],[1374.55,474.242],[1374.55,399.418]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1365.58,557.599],[1365.58,635.313],[1374.55,556.917],[1374.55,631.741]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1365.58,637.617],[1365.58,715.33],[1374.55,633.959],[1374.55,708.783]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1365.58,722.362],[1365.58,800.076],[1374.55,715.554],[1374.55,790.378]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1375.08,468.012],[1375.08,386.018],[1386.64,471.567],[1386.64,393.666]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1375.08,555.278],[1375.08,473.284],[1386.64,554.478],[1386.64,476.576]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1375.08,558.61],[1375.08,640.604],[1386.64,557.644],[1386.64,635.545]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1375.08,643.035],[1375.08,725.028],[1386.64,637.855],[1386.64,715.757]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:61,
                    verts:[[1375.08,732.448],[1375.08,814.442],[1386.64,722.806],[1386.64,800.708]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[764.861,401.182],[764.861,242.271],[423.796,404.873],[423.796,250.209]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[764.861,570.311],[764.861,411.4],[423.796,569.481],[423.796,414.817]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[764.861,576.769],[764.861,735.68],[423.796,575.766],[423.796,730.43]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[764.861,740.392],[764.861,899.303],[423.796,735.016],[423.796,889.679]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[764.861,913.683],[764.861,1072.59],[423.796,903.675],[423.796,1058.34]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[492.949,414.66],[492.949,271.262],[456.653,415.022],[456.653,272.04]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[492.949,573.107],[492.949,716.505],[456.653,573.008],[456.653,715.99]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[492.949,720.757],[456.653,720.23],[492.949,864.156],[456.653,863.211]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[492.949,877.132],[456.653,876.15],[492.949,1020.53],[456.653,1019.13]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[662.557,442.267],[662.557,326.485],[632.837,442.495],[632.837,326.985]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[662.557,570.199],[662.557,685.981],[632.837,570.126],[632.837,685.636]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[662.557,689.414],[632.837,689.061],[662.557,805.196],[632.837,804.571]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[662.557,815.673],[632.837,815.024],[662.557,931.455],[632.837,930.534]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[906.883,459.411],[906.883,364.096],[794.212,460.108],[794.212,365.625]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[906.883,560.855],[906.883,465.54],[794.212,560.666],[794.212,466.183]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[906.883,564.729],[906.883,660.044],[794.212,564.506],[794.212,658.989]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[906.883,662.87],[906.883,758.185],[794.212,661.79],[794.212,756.273]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[906.883,766.81],[906.883,862.125],[794.212,764.823],[794.212,859.306]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[819.671,463.708],[819.671,373.523],[796.221,463.846],[796.221,373.826]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[819.671,563.357],[819.671,653.543],[796.221,563.313],[796.221,653.333]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[819.671,656.217],[796.221,656.003],[819.671,746.402],[796.221,746.023]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[819.671,754.563],[796.221,754.169],[819.671,844.748],[796.221,844.189]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1237.57,396.068],[1237.57,231.27],[871.132,400.032],[871.132,239.798]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1237.57,571.462],[1237.57,406.664],[871.132,570.57],[871.132,410.335]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1237.57,578.159],[1237.57,742.957],[871.132,577.081],[871.132,737.316]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1237.57,747.843],[1237.57,912.641],[871.132,742.067],[871.132,902.301]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1237.57,927.553],[1237.57,1092.35],[871.132,916.801],[871.132,1077.04]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1291.39,453.876],[1235.03,454.238],[1291.39,355.612],[1235.03,356.391]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1291.39,562.451],[1235.03,562.353],[1291.39,660.714],[1235.03,660.199]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1291.39,663.628],[1235.03,663.1],[1291.39,761.891],[1235.03,760.947]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1237.57,396.067],[1237.57,231.27],[1248.05,407.127],[1248.05,255.058]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1237.57,571.462],[1237.57,406.664],[1248.05,568.974],[1248.05,416.905]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1237.57,578.159],[1237.57,742.957],[1248.05,575.154],[1248.05,727.222]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1237.57,747.843],[1237.57,912.641],[1248.05,731.731],[1248.05,883.8]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1237.57,927.553],[1237.57,1092.35],[1248.05,897.561],[1248.05,1049.63]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1289.11,406.717],[1248.05,407.127],[1289.11,254.177],[1248.05,255.058]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1289.11,569.066],[1248.05,568.974],[1289.11,416.526],[1248.05,416.905]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1289.11,575.265],[1248.05,575.154],[1289.11,727.805],[1248.05,727.223]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1289.11,732.328],[1248.05,731.731],[1289.11,884.869],[1248.05,883.8]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1289.11,898.672],[1248.05,897.561],[1289.11,1051.21],[1248.05,1049.63]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1258.07,419.104],[1258.07,280.821],[1265.57,426.925],[1265.57,297.643]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1258.07,571.899],[1258.07,710.183],[1265.57,569.774],[1265.57,699.056]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1258.07,714.283],[1258.07,852.567],[1265.57,702.889],[1265.57,832.172]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1258.07,865.08],[1258.07,1003.36],[1265.57,843.87],[1265.57,973.153]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1266.75,426.867],[1266.75,297.517],[1273.32,433.795],[1273.32,312.42]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1266.75,569.79],[1266.75,699.14],[1273.32,567.907],[1273.32,689.282]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1266.75,702.975],[1266.75,832.324],[1273.32,692.881],[1273.32,814.256]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1266.75,844.029],[1266.75,973.379],[1273.32,825.24],[1273.32,946.615]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1306.13,433.534],[1273.32,433.795],[1306.13,311.859],[1273.32,312.42]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1306.13,567.978],[1273.32,567.907],[1306.13,689.654],[1273.32,689.283]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1306.13,693.261],[1273.32,692.881],[1306.13,814.937],[1273.32,814.257]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1306.13,825.947],[1273.32,825.24],[1306.13,947.623],[1273.32,946.615]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1289.11,406.717],[1289.11,254.177],[1296.75,418.754],[1296.75,280.066]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1289.11,569.066],[1289.11,416.526],[1296.75,566.358],[1296.75,427.671]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1289.11,575.265],[1289.11,727.805],[1296.75,571.995],[1296.75,710.682]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1289.11,732.328],[1289.11,884.869],[1296.75,714.794],[1296.75,853.481]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1289.11,898.672],[1289.11,1051.21],[1296.75,866.031],[1296.75,1004.72]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1292.3,562.462],[1292.3,660.775],[1296.15,561.359],[1296.15,654.995]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1321.5,561.401],[1296.15,561.359],[1321.5,655.216],[1296.15,654.995]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1321.5,457.741],[1296.15,457.896],[1321.5,363.926],[1296.15,364.26]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1306.13,563.034],[1273.32,562.975],[1306.13,441.358],[1273.32,441.6]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1321.5,657.997],[1296.15,657.771],[1321.5,751.812],[1296.15,751.407]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1321.5,760.301],[1296.15,759.88],[1321.5,854.116],[1296.15,853.517]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1306.13,433.535],[1306.13,311.859],[1311.09,441.336],[1311.09,328.64]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1306.13,563.034],[1306.13,441.358],[1311.09,561.279],[1311.09,448.582]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1306.13,567.978],[1306.13,689.654],[1311.09,565.858],[1311.09,678.555]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1306.13,693.261],[1306.13,814.937],[1311.09,681.896],[1311.09,794.592]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1306.13,825.947],[1306.13,947.622],[1311.09,804.79],[1311.09,917.486]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1328.51,468.782],[1305.8,468.902],[1328.51,387.675],[1305.8,387.933]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1321.5,557.588],[1296.15,557.553],[1321.5,463.773],[1296.15,463.917]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1309.93,557.407],[1309.93,634.303],[1312.31,556.724],[1312.31,630.73]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1328.51,558.401],[1305.8,558.368],[1328.51,639.508],[1305.8,639.337]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1328.51,641.913],[1305.8,641.738],[1328.51,723.02],[1305.8,722.707]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1328.51,730.359],[1305.8,730.034],[1328.51,811.467],[1305.8,811.003]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1321.5,457.741],[1321.5,363.926],[1324.49,462.459],[1324.49,374.074]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1321.5,557.588],[1321.5,463.773],[1324.49,556.527],[1324.49,468.142]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1321.5,561.401],[1321.5,655.216],[1324.49,560.119],[1324.49,648.504]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1321.5,657.997],[1321.5,751.812],[1324.49,651.125],[1324.49,739.51]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1321.5,760.301],[1321.5,854.116],[1324.49,747.508],[1324.49,835.893]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1328.51,555.105],[1305.8,555.078],[1328.51,473.997],[1305.8,474.108]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1328.51,468.782],[1328.51,387.675],[1330.76,472.336],[1330.76,395.319]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1328.51,555.105],[1328.51,473.997],[1330.76,554.305],[1330.76,477.288]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1328.51,558.401],[1328.51,639.508],[1330.76,557.435],[1330.76,634.452]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1328.51,641.913],[1328.51,723.02],[1330.76,636.735],[1330.76,713.752]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:62,
                    verts:[[1328.51,730.359],[1328.51,811.467],[1330.76,720.721],[1330.76,797.738]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[892.575,399.3],[892.575,238.223],[532.828,401.053],[532.828,241.994]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[892.575,570.734],[892.575,409.657],[532.828,570.34],[532.828,411.281]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[892.575,577.28],[892.575,738.358],[532.828,576.804],[532.828,735.863]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[892.575,743.133],[892.575,904.211],[532.828,740.58],[532.828,899.639]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[892.575,918.787],[892.575,1079.86],[532.828,914.032],[532.828,1073.09]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[579.164,411.504],[540.53,411.678],[579.164,264.473],[540.53,264.846]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[579.164,573.964],[579.164,720.996],[540.53,573.917],[540.53,720.748]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[579.164,725.355],[540.53,725.102],[579.164,872.386],[540.53,871.933]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[579.164,885.691],[540.53,885.22],[579.164,1032.72],[540.53,1032.05]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[691.667,440.537],[660.57,440.645],[691.667,322.69],[660.57,322.926]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[691.667,570.751],[691.667,688.598],[660.57,570.716],[660.57,688.435]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[691.667,692.092],[660.57,691.925],[691.667,809.939],[660.57,809.644]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[691.667,820.603],[660.57,820.296],[691.667,938.45],[660.57,938.015]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[794.392,462.878],[770.241,462.943],[794.392,371.702],[770.241,371.844]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[794.392,563.622],[794.392,654.798],[770.241,563.602],[770.241,654.701]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[794.392,657.502],[770.241,657.402],[794.392,748.678],[770.241,748.501]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[893.849,458.827],[893.849,362.815],[778.176,459.151],[778.176,363.526]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[893.849,564.915],[893.849,660.927],[778.176,564.811],[778.176,660.437]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[893.849,663.773],[893.849,759.785],[778.176,663.272],[778.176,758.897]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[893.849,561.013],[893.849,465.001],[778.176,560.925],[778.176,465.3]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[893.849,768.474],[893.849,864.486],[778.176,767.55],[778.176,863.176]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1002.56,398.764],[1374.4,396.952],[1002.56,237.07],[1374.4,233.172]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1002.56,570.855],[1002.56,409.161],[1374.4,571.263],[1374.4,407.483]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1002.56,577.426],[1374.4,577.918],[1002.56,739.12],[1374.4,741.698]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1002.56,743.914],[1374.4,746.554],[1002.56,905.608],[1374.4,910.334]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1002.56,920.24],[1374.4,925.154],[1002.56,1081.93],[1374.4,1088.93]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1224.83,454.779],[1280.74,454.616],[1224.83,357.554],[1280.74,357.205]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1224.83,562.206],[1280.74,562.25],[1224.83,659.43],[1280.74,659.661]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1224.83,662.313],[1280.74,662.55],[1224.83,759.537],[1280.74,759.961]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1275.23,458.619],[1300.27,458.55],[1275.23,365.815],[1300.27,365.666]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1275.23,561.162],[1300.27,561.181],[1275.23,653.966],[1300.27,654.065]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1275.23,656.718],[1300.27,656.819],[1275.23,749.522],[1300.27,749.703]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1313.83,434.621],[1346.37,434.504],[1313.83,314.197],[1346.37,313.945]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1313.83,567.683],[1346.37,567.715],[1313.83,688.108],[1346.37,688.274]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1313.83,691.678],[1346.37,691.848],[1313.83,812.103],[1346.37,812.407]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1313.83,823],[1346.37,823.317],[1313.83,943.425],[1346.37,943.876]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1356.62,408.008],[1397.52,407.824],[1356.62,256.952],[1397.52,256.556]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1356.62,574.914],[1397.52,574.964],[1356.62,725.97],[1397.52,726.232]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1356.62,730.449],[1397.52,730.717],[1356.62,881.504],[1397.52,881.984]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1356.62,895.173],[1397.52,895.672],[1356.62,1046.23],[1397.52,1046.94]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:63,
                    verts:[[1356.62,568.776],[1356.62,417.72],[1397.52,568.817],[1397.52,417.55]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[676.089,409.053],[635.914,409.015],[676.089,259.201],[635.914,259.119]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[676.089,568.541],[676.089,418.689],[635.914,568.549],[635.914,418.653]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[676.089,574.63],[635.914,574.641],[676.089,724.482],[635.914,724.536]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[676.089,728.925],[635.914,728.981],[676.089,878.777],[635.914,878.877]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[676.089,892.337],[635.914,892.441],[676.089,1042.19],[635.914,1042.34]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1024.79,398.525],[655.658,398.144],[1024.79,236.556],[655.658,235.737]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1024.79,570.909],[1024.79,408.94],[655.658,570.994],[655.658,408.587]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1024.79,577.491],[1024.79,739.46],[655.658,577.594],[655.658,740.002]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1024.79,744.262],[655.658,744.817],[1024.79,906.231],[655.658,907.225]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1024.79,920.888],[655.658,921.921],[1024.79,1082.86],[655.658,1084.33]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[725.433,439.088],[693.388,439.064],[725.433,319.511],[693.388,319.459]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[725.433,571.213],[693.388,571.221],[725.433,690.791],[693.388,690.826]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[725.433,694.336],[693.388,694.372],[725.433,813.913],[693.388,813.978]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[725.433,824.734],[693.388,824.801],[725.433,944.311],[693.388,944.406]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[770.058,462.068],[745.374,462.054],[770.058,369.925],[745.374,369.894]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[770.058,563.881],[745.374,563.885],[770.058,656.024],[745.374,656.045]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[770.058,658.756],[745.374,658.778],[770.058,750.899],[745.374,750.938]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[881.241,458.32],[763.572,458.251],[881.241,361.703],[763.572,361.55]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[881.241,565.077],[881.241,661.694],[763.572,565.099],[763.572,661.8]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[881.241,664.559],[763.572,664.667],[881.241,761.176],[763.572,761.367]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1135.42,398.64],[1135.42,236.802],[1501.96,399.018],[1501.96,237.616]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1135.42,570.883],[1135.42,409.046],[1501.96,570.798],[1501.96,409.396]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1135.42,577.46],[1135.42,739.297],[1501.96,577.357],[1501.96,738.759]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1135.42,744.096],[1135.42,905.933],[1501.96,743.545],[1501.96,904.947]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1135.42,920.578],[1135.42,1082.42],[1501.96,919.552],[1501.96,1080.95]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1205.93,470.164],[1227.91,470.175],[1205.93,390.647],[1227.91,390.671]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1205.93,558.025],[1205.93,637.542],[1227.91,558.022],[1227.91,637.526]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1205.93,726.612],[1227.91,726.582],[1205.93,806.129],[1227.91,806.086]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1211.9,455.418],[1211.9,358.93],[1266.82,455.452],[1266.82,359.002]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1211.9,562.032],[1211.9,658.521],[1266.82,562.023],[1266.82,658.472]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1211.9,661.381],[1211.9,757.87],[1266.82,661.332],[1266.82,757.782]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1251.39,459.393],[1275.91,459.407],[1251.39,367.478],[1275.91,367.509]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1251.39,560.952],[1251.39,652.866],[1275.91,560.948],[1275.91,652.846]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1251.39,655.591],[1275.91,655.57],[1251.39,747.506],[1275.91,747.468]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1349.2,435.826],[1380.94,435.85],[1349.2,316.788],[1380.94,316.84]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1349.2,567.356],[1349.2,686.394],[1380.94,567.349],[1380.94,686.359]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1349.2,689.923],[1380.94,689.888],[1349.2,808.961],[1380.94,808.898]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1349.2,819.733],[1380.94,819.668],[1349.2,938.771],[1380.94,938.678]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1457.23,409.797],[1496.92,409.835],[1457.23,260.802],[1496.92,260.883]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1457.23,574.428],[1457.23,723.424],[1496.92,574.418],[1496.92,723.37]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1457.23,727.841],[1496.92,727.786],[1457.23,876.837],[1496.92,876.738]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:64,
                    verts:[[1457.23,890.32],[1496.92,890.217],[1457.23,1039.32],[1496.92,1039.17]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[718.053,471.107],[718.053,390.497],[716.776,474.554],[716.776,398.021]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[718.053,556.9],[718.053,476.29],[716.776,556.007],[716.776,479.475]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[718.053,560.176],[718.053,640.786],[716.776,559.118],[716.776,635.651]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[718.053,643.176],[718.053,723.786],[716.776,637.92],[716.776,714.453]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[718.053,731.08],[718.053,811.69],[716.776,721.378],[716.776,797.911]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[718.053,471.107],[740.473,471.182],[718.053,390.497],[740.473,390.661]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[718.053,556.9],[740.473,556.881],[718.053,476.29],[740.473,476.359]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[718.053,560.176],[740.473,560.153],[718.053,640.786],[740.473,640.674]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[718.053,643.176],[740.473,643.061],[718.053,723.786],[740.473,723.583]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[718.053,731.08],[740.473,730.869],[718.053,811.69],[740.473,811.39]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[722.054,461.195],[722.054,368.009],[720.357,465.723],[720.357,377.943]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[722.054,560.372],[722.054,467.187],[720.357,559.147],[720.357,471.367]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[722.054,564.159],[722.054,657.345],[720.357,562.714],[720.357,650.495]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[722.054,660.108],[722.054,753.294],[720.357,653.097],[720.357,740.878]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[722.054,761.726],[722.054,854.912],[720.357,748.821],[720.357,836.601]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[722.054,461.195],[747.079,461.291],[722.054,368.009],[747.079,368.22]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[722.054,560.372],[747.079,560.346],[722.054,467.187],[747.079,467.275]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[722.054,564.159],[747.079,564.129],[722.054,657.345],[747.079,657.2]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[722.054,660.108],[747.079,659.959],[722.054,753.294],[747.079,753.031]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[722.054,761.726],[747.079,761.453],[722.054,854.912],[747.079,854.524]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[730.816,437.809],[730.816,316.705],[728,445.326],[728,333.196]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[730.816,566.7],[730.816,445.596],[728,564.666],[728,452.536]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[730.816,571.621],[730.816,692.726],[728,569.223],[728,681.353]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[730.816,696.316],[730.816,817.42],[728,684.678],[728,796.808]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[730.816,828.379],[730.816,949.483],[728,806.955],[728,919.085]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[730.816,437.809],[763.313,437.971],[730.816,316.705],[763.313,317.06]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[730.816,566.7],[763.313,566.656],[730.816,445.596],[763.313,445.745]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[730.816,571.621],[763.313,571.57],[730.816,692.726],[763.313,692.481]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[730.816,696.316],[763.313,696.065],[730.816,817.42],[763.313,816.976]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[730.816,828.379],[763.313,827.918],[730.816,949.483],[763.313,948.828]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[740.416,407.18],[740.416,255.173],[736.07,419.236],[736.07,281.105]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[740.416,568.962],[740.416,416.954],[736.07,566.25],[736.07,428.118]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[740.416,575.139],[740.416,727.147],[736.07,571.863],[736.07,709.995]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[740.416,731.653],[740.416,883.661],[736.07,714.091],[736.07,852.222]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[740.416,897.416],[740.416,1049.42],[736.07,864.722],[736.07,1002.85]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[740.416,407.18],[781.169,407.445],[740.416,255.173],[781.169,255.742]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[740.416,568.962],[781.169,568.902],[740.416,416.954],[781.169,417.199]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[740.416,575.139],[781.169,575.067],[740.416,727.147],[781.169,726.77]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[740.416,731.654],[781.169,731.268],[740.416,883.661],[781.169,882.971]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[740.416,897.416],[781.169,896.699],[740.416,1049.42],[781.169,1048.4]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[749.798,565.375],[749.798,663.109],[747.079,564.129],[747.079,657.2]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[750.714,565.363],[750.714,663.051],[869.282,565.21],[869.282,662.329]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[759.157,569.177],[759.157,681.136],[755.556,567.553],[755.556,673.434]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[767.972,431.279],[767.972,302.379],[763.313,437.971],[763.313,317.06]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[767.972,573.705],[767.972,702.605],[763.313,571.57],[763.313,692.481]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[767.972,706.427],[767.972,835.327],[763.313,696.066],[763.313,816.976]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[767.972,846.991],[767.972,975.891],[763.313,827.918],[763.313,948.828]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[750.714,457.424],[750.714,359.736],[869.282,457.901],[869.282,360.782]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[750.714,665.947],[869.282,665.208],[750.714,763.635],[869.282,762.327]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[774.424,419.463],[774.424,281.591],[769.244,427.065],[769.244,297.945]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[774.424,571.802],[774.424,709.673],[769.244,569.736],[769.244,698.857]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[774.424,713.761],[774.424,851.632],[769.244,702.685],[769.244,831.806]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[774.424,864.108],[774.424,1001.98],[769.244,843.49],[769.244,972.611]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[788.62,396.331],[788.62,231.836],[781.169,407.445],[781.169,255.742]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[788.62,571.402],[788.62,406.908],[781.169,568.902],[781.169,417.199]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[788.62,578.087],[788.62,742.582],[781.169,575.067],[781.169,726.77]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[788.62,747.459],[788.62,911.953],[781.169,731.268],[781.169,882.971]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[788.62,926.839],[788.62,1091.33],[781.169,896.699],[781.169,1048.4]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[788.62,396.331],[788.62,231.837],[1156.63,398.922],[1156.63,237.41]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[788.62,571.402],[788.62,406.908],[1156.63,570.82],[1156.63,409.307]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[788.62,578.087],[788.62,742.582],[1156.63,577.383],[1156.63,738.895]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[788.62,747.459],[788.62,911.953],[1156.63,743.684],[1156.63,905.196]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[788.62,926.839],[788.62,1091.33],[1156.63,919.812],[1156.63,1081.32]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1153.51,470.712],[1153.51,391.825],[1174.98,470.785],[1174.98,391.984]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1153.51,557.876],[1153.51,636.763],[1174.98,557.856],[1174.98,636.658]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1153.51,725.127],[1174.98,724.927],[1153.51,804.014],[1174.98,803.729]]
                },{
                    num:"403",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1153.51,554.671],[1153.51,475.784],[1174.98,554.654],[1174.98,475.852]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1153.51,639.102],[1174.98,638.994],[1153.51,717.989],[1174.98,717.796]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1196.48,456.145],[1196.48,360.493],[1249.9,456.368],[1249.9,360.973]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1196.48,557.947],[1196.48,462.295],[1249.9,557.897],[1249.9,462.502]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1196.48,561.834],[1196.48,657.486],[1249.9,561.774],[1249.9,657.169]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1196.48,660.322],[1196.48,755.974],[1249.9,659.997],[1249.9,755.392]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1196.48,764.63],[1196.48,860.282],[1249.9,764.024],[1249.9,859.419]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1225,460.205],[1225,369.225],[1248.83,460.299],[1248.83,369.429]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1225,560.731],[1225,651.711],[1248.83,560.706],[1248.83,651.576]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1225,654.409],[1248.83,654.27],[1225,745.388],[1248.83,745.141]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1225,753.621],[1248.83,753.364],[1225,844.601],[1248.83,844.234]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1264.72,399.683],[1264.72,239.047],[1615.82,402.155],[1615.82,244.364]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1264.72,570.648],[1264.72,410.012],[1615.82,570.092],[1615.82,412.301]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1264.72,577.176],[1264.72,737.813],[1615.82,576.505],[1615.82,734.296]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1264.72,742.576],[1264.72,903.212],[1615.82,738.974],[1615.82,896.765]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1264.72,917.748],[1264.72,1078.38],[1615.82,911.044],[1615.82,1068.84]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1378.7,437.374],[1378.7,320.118],[1409.17,437.531],[1409.17,320.456]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1378.7,566.935],[1378.7,684.191],[1409.17,566.892],[1409.17,683.967]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1378.7,687.668],[1409.17,687.438],[1378.7,804.924],[1409.17,804.514]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1378.7,815.535],[1409.17,815.108],[1378.7,932.791],[1409.17,932.183]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1546.75,412.414],[1546.75,266.431],[1584.34,412.658],[1584.34,266.956]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1546.75,573.717],[1546.75,719.701],[1584.34,573.651],[1584.34,719.353]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1546.75,724.029],[1584.34,723.674],[1546.75,870.013],[1584.34,869.376]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:65,
                    verts:[[1546.75,883.223],[1584.34,882.561],[1546.75,1029.21],[1584.34,1028.26]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[668.384,470.341],[668.384,388.825],[657.919,473.81],[657.919,396.398]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[668.384,557.098],[668.384,475.582],[657.919,556.2],[657.919,478.788]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[668.384,560.411],[668.384,641.927],[657.919,559.346],[657.919,636.758]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[668.384,644.344],[668.384,725.86],[657.919,639.054],[657.919,716.466]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[668.384,733.237],[668.384,814.753],[657.919,723.471],[657.919,800.884]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[668.384,470.341],[691.004,470.482],[668.384,388.825],[691.004,389.133]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[668.384,557.098],[668.384,475.582],[691.004,557.062],[691.004,475.713]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[668.384,560.411],[691.004,560.368],[668.384,641.927],[691.004,641.717]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[668.384,644.344],[691.004,644.129],[668.384,725.86],[691.004,725.478]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[668.384,733.237],[691.004,732.839],[668.384,814.753],[691.004,814.188]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[678.691,473.933],[678.691,396.666],[670.506,476.383],[670.506,402.015]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[678.691,559.308],[678.691,636.575],[670.506,558.556],[670.506,632.924]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[678.691,638.866],[678.691,716.133],[670.506,635.129],[670.506,709.498]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[678.691,723.125],[678.691,800.392],[670.506,716.227],[670.506,790.596]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.693,460.378],[700.693,366.217],[686.835,464.929],[686.835,376.201]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.693,560.593],[700.693,466.432],[686.835,559.362],[686.835,470.634]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.693,564.42],[700.693,658.581],[686.835,562.968],[686.835,651.696]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.693,661.373],[700.693,755.534],[686.835,654.327],[686.835,743.055]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.693,764.055],[700.693,858.216],[686.835,751.084],[686.835,839.812]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.819,467.554],[700.819,382.74],[691.004,470.482],[691.004,389.133]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.819,561.267],[700.819,646.08],[691.004,560.368],[691.004,641.717]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.819,648.595],[700.819,733.408],[691.004,644.129],[691.004,725.478]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.819,741.083],[700.819,825.896],[691.004,732.839],[691.004,814.188]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.693,460.378],[725.851,460.558],[700.693,366.217],[725.851,366.612]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[711.411,465.095],[711.411,376.564],[700.775,468.238],[700.775,383.461]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.693,560.593],[700.693,466.432],[725.851,560.545],[725.851,466.599]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[711.411,562.915],[711.411,651.445],[700.775,561.912],[700.775,646.689]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.693,564.42],[725.851,564.362],[700.693,658.581],[725.851,658.308]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[711.411,654.07],[711.411,742.6],[700.775,649.203],[700.775,733.98]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.693,661.373],[725.851,661.094],[700.693,755.534],[725.851,755.04]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[711.411,750.611],[711.411,839.142],[700.775,741.652],[700.775,826.429]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[700.693,764.054],[725.851,763.541],[700.693,858.215],[725.851,857.487]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[739.051,456.643],[739.051,358.024],[725.851,460.558],[725.851,366.612]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[739.051,561.604],[739.051,462.985],[725.851,560.545],[725.851,466.599]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[739.051,565.612],[739.051,664.231],[725.851,564.362],[725.851,658.308]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[739.051,667.155],[739.051,765.774],[725.851,661.094],[725.851,755.04]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[739.051,774.698],[739.051,873.318],[725.851,763.541],[725.851,857.487]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[739.876,456.685],[739.876,358.116],[858.182,457.576],[858.182,360.069]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[739.876,561.593],[739.876,463.023],[858.182,561.352],[858.182,463.845]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[739.876,565.598],[739.876,664.167],[858.182,565.314],[858.182,662.821]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[739.876,667.09],[739.876,765.659],[858.182,665.712],[858.182,763.218]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[739.876,774.579],[739.876,873.148],[858.182,772.042],[858.182,869.548]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[772.123,436.921],[772.123,314.757],[749.19,444.452],[749.19,331.279]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[772.123,566.94],[772.123,444.776],[749.19,564.903],[749.19,451.729]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[772.123,571.905],[772.123,694.069],[749.19,569.502],[749.19,682.675]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[772.123,697.691],[772.123,819.855],[749.19,686.031],[749.19,799.204]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[772.123,830.91],[772.123,953.074],[749.19,809.445],[749.19,922.619]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[780.341,444.721],[780.341,331.87],[763.113,449.813],[763.113,343.04]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[780.341,569.416],[780.341,682.268],[763.113,567.791],[763.113,674.564]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[780.341,685.614],[780.341,798.465],[763.113,677.73],[763.113,784.503]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[780.341,808.677],[780.341,921.529],[763.113,794.165],[763.113,900.939]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[772.124,436.921],[804.53,437.224],[772.124,314.757],[804.53,315.422]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[772.124,566.94],[772.124,444.776],[804.53,566.858],[804.53,445.056]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[772.124,571.905],[804.53,571.808],[772.124,694.069],[804.53,693.61]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[772.124,697.691],[804.53,697.222],[772.124,819.855],[804.53,819.024]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[772.124,830.91],[804.53,830.046],[772.124,953.074],[804.53,951.848]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[827.05,430.545],[827.05,300.769],[804.53,437.224],[804.53,315.422]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[827.05,568.665],[827.05,438.89],[804.53,566.858],[804.53,445.056]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[827.05,573.939],[827.05,703.715],[804.53,571.808],[804.53,693.61]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[827.05,707.563],[827.05,837.338],[804.53,697.222],[804.53,819.024]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[827.05,849.082],[827.05,978.858],[804.53,830.046],[804.53,951.849]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[850.809,406.273],[850.809,253.222],[815.479,418.31],[815.479,279.113]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[850.809,569.166],[850.809,416.114],[815.479,566.458],[815.479,427.261]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[850.809,575.386],[850.809,728.437],[815.479,572.115],[815.479,711.312]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[850.809,732.975],[850.809,886.027],[815.479,715.44],[815.479,854.637]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[850.809,899.876],[850.809,1052.93],[815.479,867.233],[815.479,1006.43]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[853.536,418.733],[853.536,280.021],[828.824,426.311],[828.824,296.321]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[853.536,572],[853.536,710.711],[828.824,569.941],[828.824,699.931]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[853.536,714.824],[853.536,853.536],[828.824,703.785],[828.824,833.775]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[853.536,866.088],[853.536,1004.8],[828.824,845.538],[828.824,975.528]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[850.809,406.273],[891.086,406.766],[850.809,253.222],[891.086,254.282]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[850.809,569.166],[850.809,416.114],[891.086,569.055],[891.086,416.571]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[850.809,575.386],[891.086,575.252],[850.809,728.437],[891.086,727.736]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[850.809,732.975],[891.086,732.257],[850.809,886.027],[891.086,884.741]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[850.809,899.876],[891.086,898.539],[850.809,1052.93],[891.086,1051.02]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[926.964,395.727],[926.964,230.537],[891.086,406.766],[891.086,254.282]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[926.964,571.538],[926.964,406.349],[891.086,569.055],[891.086,416.571]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[926.964,578.251],[926.964,743.441],[891.086,575.252],[891.086,727.736]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[926.964,748.339],[926.964,913.528],[891.086,732.257],[891.086,884.741]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[926.964,928.476],[926.964,1093.67],[891.086,898.539],[891.086,1051.02]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[926.964,395.727],[926.964,230.537],[1283.17,400.467],[1283.17,240.733]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[926.964,571.538],[926.964,406.349],[1283.17,570.472],[1283.17,410.738]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[926.964,578.251],[926.964,743.441],[1283.17,576.963],[1283.17,736.697]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[926.964,748.339],[926.964,913.528],[1283.17,741.433],[1283.17,901.167]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[926.964,928.476],[926.964,1093.67],[1283.17,915.622],[1283.17,1075.36]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1100.19,471.196],[1100.19,392.867],[1121.08,471.33],[1121.08,393.155]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1100.19,557.745],[1100.19,636.074],[1121.08,557.708],[1121.08,635.883]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1100.19,723.813],[1121.08,723.45],[1100.19,802.142],[1121.08,801.624]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1178.85,456.945],[1178.85,362.213],[1230.35,457.347],[1230.35,363.079]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1178.85,561.617],[1178.85,656.349],[1230.35,561.508],[1230.35,655.776]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1178.85,659.157],[1178.85,753.889],[1230.35,658.571],[1230.35,752.84]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1385.74,401.832],[1385.74,243.669],[1712.75,406.184],[1712.75,253.029]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1385.74,570.165],[1385.74,412.002],[1712.75,569.186],[1712.75,416.031]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1385.74,576.592],[1385.74,734.755],[1712.75,575.41],[1712.75,728.565]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1385.74,739.445],[1385.74,897.608],[1712.75,733.106],[1712.75,886.26]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1385.74,911.92],[1385.74,1070.08],[1712.75,900.119],[1712.75,1053.27]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1401.91,439.214],[1401.91,324.076],[1430.7,439.494],[1430.7,324.677]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1401.91,566.435],[1401.91,681.573],[1430.7,566.359],[1430.7,681.176]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1401.91,684.987],[1401.91,800.125],[1430.7,684.58],[1430.7,799.397]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1401.91,810.544],[1430.7,809.787],[1401.91,925.682],[1430.7,924.604]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1622.94,415.726],[1622.94,273.555],[1657.71,416.152],[1657.71,274.471]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1622.94,572.817],[1622.94,714.988],[1657.71,572.701],[1657.71,714.383]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1622.94,719.204],[1622.94,861.375],[1657.71,718.584],[1657.71,860.265]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:66,
                    verts:[[1622.94,874.24],[1657.71,873.086],[1622.94,1016.41],[1657.71,1014.77]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[620.355,469.522],[620.355,387.037],[600.422,472.985],[600.422,394.597]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[620.355,557.311],[620.355,474.825],[600.422,556.414],[600.422,478.025]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[620.355,560.663],[620.355,643.148],[600.422,559.599],[600.422,637.987]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[620.355,645.593],[620.355,728.078],[600.422,640.312],[600.422,718.7]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[620.355,735.542],[620.355,818.028],[600.422,725.793],[600.422,804.181]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[621.328,473.167],[621.328,394.995],[606.443,475.612],[606.443,400.332]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[621.328,559.543],[621.328,637.716],[606.443,558.792],[606.443,634.073]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[621.328,640.034],[621.328,718.206],[606.443,636.305],[606.443,711.585]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[621.328,725.28],[621.328,803.453],[606.443,718.397],[606.443,793.678]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[620.355,469.522],[643.064,469.73],[620.355,387.037],[643.064,387.492]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[620.355,557.311],[620.355,474.825],[643.064,557.256],[643.064,475.018]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[620.355,560.663],[620.355,643.148],[643.064,560.598],[643.064,642.837]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[620.355,645.593],[643.064,645.275],[620.355,728.078],[643.064,727.513]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[620.355,735.543],[643.064,734.955],[620.355,818.028],[643.064,817.193]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[660.838,466.816],[660.838,381.131],[643.064,469.731],[643.064,387.492]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[660.838,558.011],[660.838,472.326],[643.064,557.256],[643.064,475.018]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[660.838,561.493],[660.838,647.179],[643.064,560.598],[643.064,642.837]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[660.838,649.719],[660.838,735.404],[643.064,645.275],[643.064,727.513]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[660.838,743.158],[660.838,828.843],[643.064,734.955],[643.064,817.193]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[681.663,459.614],[681.663,364.541],[655.378,464.139],[655.378,374.468]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[681.663,560.8],[681.663,465.727],[655.378,559.576],[655.378,469.905]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[681.663,564.664],[681.663,659.737],[655.378,563.22],[655.378,652.891]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[681.663,662.555],[681.663,757.628],[655.378,655.55],[655.378,745.221]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[681.663,766.232],[681.663,861.304],[655.378,753.335],[655.378,843.006]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[679.946,464.383],[679.946,375.004],[660.712,467.508],[660.712,381.858]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[679.946,563.142],[679.946,652.521],[660.712,562.145],[660.712,647.795]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[679.946,655.171],[679.946,744.55],[660.712,650.334],[660.712,735.984]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[679.946,752.638],[679.946,842.018],[660.712,743.734],[660.712,829.383]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[681.663,459.614],[706.732,459.88],[681.663,364.541],[706.732,365.123]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[681.663,560.8],[681.663,465.727],[706.732,560.728],[706.732,465.972]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[681.663,564.664],[681.663,659.737],[706.732,564.579],[706.732,659.335]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[681.663,662.555],[706.732,662.145],[681.663,757.628],[706.732,756.901]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[681.663,766.232],[706.732,765.475],[681.663,861.304],[706.732,860.231]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[730.554,456.002],[730.554,356.618],[706.732,459.879],[706.732,365.123]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[730.554,561.777],[730.554,462.393],[706.732,560.728],[706.732,465.972]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[730.554,565.816],[730.554,665.201],[706.732,564.579],[706.732,659.335]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[730.554,668.147],[730.554,767.532],[706.732,662.145],[706.732,756.901]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[730.554,776.525],[730.554,875.91],[706.732,765.475],[706.732,860.231]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[731.279,456.047],[731.279,356.716],[848.126,457.348],[848.126,359.57]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[731.279,561.765],[731.279,462.434],[848.126,561.413],[848.126,463.635]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[731.279,565.802],[731.279,665.133],[848.126,565.387],[848.126,663.165]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[731.279,668.078],[731.279,767.409],[848.126,666.064],[848.126,763.842]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[731.279,776.397],[731.279,875.729],[848.126,772.69],[848.126,870.468]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[816.367,436.425],[816.367,313.669],[773.26,443.846],[773.26,329.949]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[803.95,444.24],[803.95,330.814],[773.062,449.258],[773.062,341.821]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[816.367,567.074],[816.367,444.318],[773.26,565.066],[773.26,451.17]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[803.95,569.569],[803.95,682.996],[773.062,567.968],[773.062,675.405]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[816.367,572.063],[816.367,694.819],[773.26,569.695],[773.26,683.592]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[803.95,686.359],[803.95,799.785],[773.062,678.59],[773.062,786.027]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[816.367,698.458],[816.367,821.214],[773.26,686.969],[773.26,800.866]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[803.95,810.049],[803.95,923.476],[773.062,795.749],[773.062,903.186]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[816.367,832.323],[816.367,955.078],[773.26,811.172],[773.26,925.069]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[816.367,436.425],[848.126,436.867],[816.367,313.669],[848.126,314.639]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[816.367,567.074],[816.367,444.318],[848.126,566.955],[848.126,444.726]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[816.367,572.063],[816.367,694.819],[848.126,571.922],[848.126,694.15]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[816.367,698.458],[848.126,697.774],[816.367,821.214],[848.126,820.003]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[816.367,832.323],[848.126,831.063],[816.367,955.079],[848.126,953.291]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[888.333,430.324],[888.333,300.283],[848.126,436.867],[848.126,314.639]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[888.333,568.725],[888.333,438.685],[848.126,566.955],[848.126,444.726]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[888.333,574.01],[888.333,704.05],[848.126,571.922],[848.126,694.15]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[888.333,707.906],[888.333,837.946],[848.126,697.774],[848.126,820.003]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[888.333,849.714],[888.333,979.754],[848.126,831.063],[848.126,953.291]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[934.497,418.69],[934.497,279.929],[890.58,426.09],[890.58,295.847]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[934.497,566.373],[934.497,427.612],[890.58,564.708],[890.58,434.465]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[934.497,572.012],[934.497,710.773],[890.58,570.001],[890.58,700.244]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[934.497,714.887],[934.497,853.648],[890.58,704.106],[890.58,834.349]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[934.497,866.205],[934.497,1004.97],[890.58,846.135],[890.58,976.378]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[963.353,406.331],[963.353,253.347],[897.58,418.078],[897.58,278.612]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[963.353,569.153],[963.353,416.168],[897.58,566.511],[897.58,427.045]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[963.353,575.37],[963.353,728.354],[897.58,572.178],[897.58,711.644]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[963.353,732.89],[963.353,885.875],[897.58,715.779],[897.58,855.244]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[963.353,899.719],[963.353,1052.7],[897.58,867.865],[897.58,1007.33]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[963.353,406.331],[1002.1,407.043],[963.353,253.347],[1002.1,254.877]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[963.353,569.153],[963.353,416.168],[1002.1,568.993],[1002.1,416.827]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[963.353,575.37],[963.353,728.354],[1002.1,575.177],[1002.1,727.342]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[963.353,732.89],[1002.1,731.854],[963.353,885.875],[1002.1,884.02]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[963.353,899.719],[1002.1,897.79],[963.353,1052.7],[1002.1,1049.96]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1065.4,396.356],[1065.4,231.89],[1002.1,407.043],[1002.1,254.877]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1065.4,571.397],[1065.4,406.931],[1002.1,568.993],[1002.1,416.827]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1065.4,578.08],[1065.4,742.546],[1002.1,575.177],[1002.1,727.342]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1065.4,747.423],[1065.4,911.889],[1002.1,731.854],[1002.1,884.02]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1065.4,926.771],[1065.4,1091.24],[1002.1,897.789],[1002.1,1049.96]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1046.55,471.612],[1046.55,393.762],[1066.78,471.804],[1066.78,394.174]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1046.55,557.632],[1046.55,635.481],[1066.78,557.58],[1066.78,635.209]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1046.55,722.684],[1066.78,722.166],[1046.55,800.534],[1066.78,799.796]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1065.4,396.356],[1065.4,231.89],[1400.01,403.053],[1400.01,246.296]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1065.4,571.397],[1065.4,406.931],[1400.01,569.89],[1400.01,413.133]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1065.4,578.08],[1065.4,742.546],[1400.01,576.261],[1400.01,733.018]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1065.4,747.423],[1065.4,911.888],[1400.01,737.666],[1400.01,894.423]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1065.4,926.771],[1065.4,1091.24],[1400.01,908.608],[1400.01,1065.37]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1159.38,457.799],[1159.38,364.051],[1208.57,458.368],[1208.57,365.275]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1159.38,561.385],[1159.38,655.133],[1208.57,561.23],[1208.57,654.324]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1159.38,657.912],[1159.38,751.66],[1208.57,657.084],[1208.57,750.177]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1418.69,441.285],[1418.69,328.53],[1445.5,441.672],[1445.5,329.362]]
                },{
                    num:"405",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1418.69,561.29],[1418.69,448.535],[1445.5,561.203],[1445.5,448.893]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1418.69,565.872],[1418.69,678.627],[1445.5,565.767],[1445.5,678.077]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1418.69,681.97],[1418.69,794.725],[1445.5,681.407],[1445.5,793.716]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1418.69,804.928],[1445.5,803.879],[1418.69,917.683],[1445.5,916.189]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1494.6,404.947],[1494.6,250.368],[1791.02,410.88],[1791.02,263.13]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1494.6,569.464],[1494.6,414.886],[1791.02,568.13],[1791.02,420.38]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1494.6,575.746],[1494.6,730.325],[1791.02,574.134],[1791.02,721.884]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1494.6,734.908],[1494.6,889.486],[1791.02,726.265],[1791.02,874.014]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1494.6,903.474],[1494.6,1058.05],[1791.02,887.384],[1791.02,1035.13]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1684.6,419.571],[1684.6,281.823],[1716.03,420.148],[1716.03,283.064]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1684.6,571.773],[1684.6,709.52],[1716.03,571.616],[1716.03,708.699]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1684.6,713.604],[1684.6,851.351],[1716.03,712.763],[1716.03,849.846]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:67,
                    verts:[[1684.6,863.816],[1716.03,862.251],[1684.6,1001.56],[1716.03,999.334]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[565.813,472.325],[565.813,393.155],[544.036,474.746],[544.036,398.44]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[565.813,556.585],[565.813,477.415],[544.036,555.958],[544.036,479.652]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[565.813,559.802],[565.813,638.971],[544.036,559.059],[544.036,635.364]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[565.813,641.319],[565.813,720.488],[544.036,637.627],[544.036,713.932]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[565.813,727.652],[565.813,806.821],[544.036,720.837],[544.036,797.143]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[574.516,468.654],[574.516,385.143],[544.859,472.082],[544.859,392.626]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[574.516,557.535],[574.516,474.024],[544.859,556.647],[544.859,477.191]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[574.516,560.929],[574.516,644.44],[544.859,559.876],[544.859,639.333]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[574.516,646.917],[574.516,730.428],[544.859,641.689],[544.859,721.145]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[574.516,737.985],[574.516,821.496],[544.859,728.335],[544.859,807.791]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[574.516,468.654],[574.516,385.143],[597.193,468.931],[597.193,385.748]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[574.516,557.535],[574.516,474.024],[597.193,557.463],[597.193,474.28]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[574.516,560.929],[574.516,644.44],[597.193,560.844],[597.193,644.027]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[574.516,646.917],[574.516,730.428],[597.193,646.494],[597.193,729.677]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[574.516,737.985],[597.193,737.204],[574.516,821.496],[597.193,820.388]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[623.069,466.059],[623.069,379.477],[597.192,468.931],[597.192,385.748]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[623.069,558.207],[623.069,471.626],[597.192,557.463],[597.192,474.28]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[623.069,561.726],[623.069,648.308],[597.192,560.844],[597.192,644.027]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[623.069,650.875],[623.069,737.456],[597.192,646.494],[597.192,729.677]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[623.069,745.291],[623.069,831.873],[597.192,737.204],[597.192,820.388]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[650.802,559.699],[650.802,469.484],[622.861,558.868],[622.861,472.321]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[650.802,563.365],[650.802,653.58],[622.861,562.385],[622.861,648.931]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[650.802,656.255],[650.802,746.47],[622.861,651.497],[622.861,738.043]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[650.802,754.634],[650.802,844.849],[622.861,745.875],[622.861,832.421]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[650.802,463.683],[650.802,373.468],[622.861,466.757],[622.861,380.21]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[665.271,458.911],[665.271,363],[626.43,463.36],[626.43,372.759]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[665.271,560.99],[665.271,465.078],[626.43,559.787],[626.43,469.185]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[665.271,564.888],[665.271,660.8],[626.43,563.468],[626.43,654.07]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[665.271,663.643],[665.271,759.555],[626.43,656.756],[626.43,747.357]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[665.271,768.234],[665.271,864.146],[626.43,755.556],[626.43,846.157]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[665.271,458.911],[665.271,363],[690.02,459.261],[690.02,363.767]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[665.271,560.99],[665.271,465.078],[690.02,560.896],[690.02,465.402]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[665.271,564.888],[665.271,660.8],[690.02,564.776],[690.02,660.27]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[665.271,663.643],[665.271,759.555],[690.02,663.102],[690.02,758.595]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[665.271,768.234],[690.02,767.237],[665.271,864.146],[690.02,862.731]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[724.454,455.469],[724.454,355.447],[690.02,459.261],[690.02,363.767]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[724.454,561.922],[724.454,461.9],[690.02,560.896],[690.02,465.402]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[724.454,565.986],[724.454,666.008],[690.02,564.776],[690.02,660.27]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[724.454,668.974],[724.454,768.996],[690.02,663.102],[690.02,758.596]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[724.454,778.047],[724.454,878.068],[690.02,767.237],[690.02,862.731]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[725.068,455.516],[725.068,355.551],[839.263,457.217],[839.263,359.282]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[725.068,561.909],[725.068,461.944],[839.263,561.449],[839.263,463.514]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[725.068,565.971],[725.068,665.937],[839.263,565.429],[839.263,663.363]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[725.068,668.901],[725.068,768.866],[839.263,666.267],[839.263,764.202]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[725.068,777.912],[725.068,877.877],[839.263,773.064],[839.263,870.998]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[829.478,444.03],[829.478,330.352],[785.208,448.899],[785.208,341.035]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[829.478,565.017],[829.478,451.339],[785.208,563.699],[785.208,455.835]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[829.478,569.636],[829.478,683.314],[785.208,568.083],[785.208,675.947]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[829.478,686.684],[829.478,800.362],[785.208,679.145],[785.208,787.01]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[829.478,810.649],[829.478,924.326],[785.208,796.77],[785.208,904.635]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[862.468,436.327],[862.468,313.453],[799.697,443.516],[799.697,329.225]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[862.468,567.101],[862.468,444.227],[799.697,565.156],[799.697,450.865]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[862.468,572.094],[862.468,694.968],[799.697,569.8],[799.697,684.092]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[862.468,698.611],[862.468,821.485],[799.697,687.48],[799.697,801.772]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[862.468,832.604],[862.468,955.477],[799.697,812.114],[799.697,926.405]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[862.469,436.327],[862.469,313.453],[893.037,436.9],[893.037,314.712]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[862.469,567.101],[862.469,444.227],[893.037,566.946],[893.037,444.757]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[862.469,572.094],[862.469,694.968],[893.037,571.911],[893.037,694.1]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[862.469,698.611],[862.469,821.485],[893.037,697.723],[893.037,819.912]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[862.469,832.604],[893.037,830.968],[862.469,955.477],[893.037,953.157]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[950.172,430.607],[950.172,300.906],[893.037,436.9],[893.037,314.712]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[950.172,568.648],[950.172,438.947],[893.037,566.946],[893.037,444.757]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[950.172,573.919],[950.172,703.621],[893.037,571.911],[893.037,694.1]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[950.172,707.466],[950.172,837.168],[893.037,697.723],[893.037,819.912]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[950.172,848.904],[950.172,978.606],[893.037,830.969],[893.037,953.157]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1014.91,419.316],[1014.91,281.276],[952.848,426.397],[952.848,296.508]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1014.91,566.232],[1014.91,428.192],[952.848,564.639],[952.848,434.749]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1014.91,571.842],[1014.91,709.882],[952.848,569.917],[952.848,699.807]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1014.91,713.975],[1014.91,852.015],[952.848,703.658],[952.848,833.548]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1014.91,864.506],[1014.91,1002.55],[952.848,845.302],[952.848,975.192]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1074.21,407.327],[1074.21,255.487],[979.922,418.529],[979.922,279.583]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1074.21,568.929],[1074.21,417.09],[979.922,566.409],[979.922,427.463]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1074.21,575.099],[1074.21,726.939],[979.922,572.055],[979.922,711.002]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1074.21,731.441],[1074.21,883.28],[979.922,715.121],[979.922,854.067]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1074.21,897.02],[1074.21,1048.86],[979.922,866.64],[979.922,1005.59]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[993.127,471.955],[993.127,394.5],[1012.64,472.201],[1012.64,395.028]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[993.127,557.538],[993.127,634.993],[1012.64,557.472],[1012.64,634.644]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1074.21,407.327],[1074.21,255.487],[1110.48,408.234],[1110.48,257.439]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1074.21,568.929],[1074.21,417.09],[1110.48,568.725],[1110.48,417.93]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1074.21,575.099],[1074.21,726.939],[1110.48,574.853],[1110.48,725.648]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1074.21,731.441],[1074.21,883.28],[1110.48,730.119],[1110.48,880.914]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1074.21,897.02],[1110.48,894.559],[1074.21,1048.86],[1110.48,1045.35]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1198.76,398.147],[1198.76,235.744],[1110.48,408.234],[1110.48,257.439]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1198.76,570.994],[1198.76,408.59],[1110.48,568.725],[1110.48,417.93]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1198.76,577.594],[1198.76,739.998],[1110.48,574.853],[1110.48,725.648]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1198.76,744.813],[1198.76,907.217],[1110.48,730.119],[1110.48,880.913]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1198.76,921.913],[1198.76,1084.32],[1110.48,894.559],[1110.48,1045.35]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1135.2,462.726],[1135.2,374.649],[1156.05,463.033],[1156.05,375.308]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1135.2,560.046],[1135.2,648.123],[1156.05,559.963],[1156.05,647.688]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1135.2,650.735],[1135.2,738.812],[1156.05,650.289],[1156.05,738.013]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1138.45,458.689],[1138.45,365.966],[1185.01,459.41],[1185.01,367.515]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1138.45,561.143],[1138.45,653.867],[1185.01,560.947],[1185.01,652.842]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1138.45,656.616],[1138.45,749.339],[1185.01,655.567],[1185.01,747.461]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1198.76,398.148],[1198.76,235.744],[1503.8,406.508],[1503.8,253.727]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1198.76,570.994],[1198.76,408.59],[1503.8,569.113],[1503.8,416.332]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1198.76,577.594],[1198.76,739.997],[1503.8,575.322],[1503.8,728.103]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1198.76,744.813],[1198.76,907.216],[1503.8,732.633],[1503.8,885.414]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1198.76,921.913],[1198.76,1084.32],[1503.8,899.239],[1503.8,1052.02]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1429.2,443.52],[1429.2,333.337],[1453.79,443.999],[1453.79,334.367]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1429.2,565.265],[1429.2,675.448],[1453.79,565.135],[1453.79,674.767]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1429.2,678.715],[1429.2,788.898],[1453.79,678.017],[1453.79,787.649]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1429.2,798.868],[1429.2,909.051],[1453.79,797.57],[1453.79,907.201]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1588.59,408.833],[1588.59,258.727],[1850.35,416.007],[1850.35,274.159]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1588.59,568.59],[1588.59,418.484],[1850.35,566.976],[1850.35,425.128]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1588.59,574.69],[1588.59,724.796],[1850.35,572.741],[1850.35,714.589]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1588.59,729.247],[1588.59,879.353],[1850.35,718.795],[1850.35,860.643]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1588.59,892.936],[1588.59,1043.04],[1850.35,873.479],[1850.35,1015.33]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1731.49,423.772],[1731.49,290.861],[1759.3,424.468],[1759.3,292.358]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1731.49,570.631],[1731.49,703.542],[1759.3,570.442],[1759.3,702.552]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1731.49,707.483],[1731.49,840.394],[1759.3,706.469],[1759.3,838.579]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:68,
                    verts:[[1731.49,852.421],[1731.49,985.332],[1759.3,850.534],[1759.3,982.644]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[512.666,471.408],[512.666,391.154],[483.81,473.785],[483.81,396.343]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[512.666,556.822],[512.666,476.568],[483.81,556.206],[483.81,478.764]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[512.666,560.083],[512.666,640.337],[483.81,559.354],[483.81,636.796]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[512.666,642.717],[512.666,722.97],[483.81,639.092],[483.81,716.534]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[512.666,730.233],[512.666,810.486],[483.81,723.542],[483.81,800.984]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[531.362,467.742],[531.362,383.152],[491.759,471.104],[491.759,390.491]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[531.362,557.771],[531.362,473.181],[491.759,556.901],[491.759,476.288]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[531.362,561.209],[531.362,645.799],[491.759,560.177],[491.759,640.79]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[531.362,648.307],[531.362,732.898],[491.759,643.18],[491.759,723.793]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[531.362,740.552],[531.362,825.142],[491.759,731.088],[491.759,811.701]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[531.362,467.742],[531.362,383.152],[553.875,468.088],[553.875,383.908]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[531.362,557.771],[531.362,473.181],[553.875,557.682],[553.875,473.501]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[531.362,561.209],[531.362,645.799],[553.875,561.103],[553.875,645.283]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[531.362,648.307],[531.362,732.898],[553.875,647.779],[553.875,731.96]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[531.362,740.552],[553.875,739.578],[531.362,825.142],[553.875,823.758]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[587.949,465.284],[587.949,377.787],[553.875,468.088],[553.875,383.908]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[587.949,558.408],[587.949,470.91],[553.875,557.682],[553.875,473.501]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[587.949,561.964],[587.949,649.461],[553.875,561.103],[553.875,645.283]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[587.949,652.055],[587.949,739.553],[553.875,647.779],[553.875,731.96]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[587.949,747.47],[587.949,834.968],[553.875,739.578],[553.875,823.758]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[624.343,462.998],[624.343,371.965],[587.657,465.989],[587.657,378.526]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[624.343,559.885],[624.343,468.851],[587.657,559.075],[587.657,471.613]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[624.343,563.584],[624.343,654.617],[587.657,562.63],[587.657,650.092]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[624.343,657.316],[624.343,748.35],[587.657,652.685],[587.657,740.148]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[624.343,756.587],[624.343,847.62],[587.657,748.063],[587.657,835.525]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[651.742,458.275],[651.742,361.602],[600.359,462.597],[600.359,371.084]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[651.742,561.162],[651.742,464.49],[600.359,559.993],[600.359,468.481]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[651.742,565.091],[651.742,661.763],[600.359,563.712],[600.359,655.224]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[651.742,664.629],[651.742,761.302],[600.359,657.938],[600.359,749.45]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[651.742,770.049],[651.742,866.722],[600.359,757.731],[600.359,849.244]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[651.741,458.275],[651.741,361.602],[675.936,458.707],[675.936,362.551]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[651.741,561.162],[651.741,464.49],[675.936,561.046],[675.936,464.89]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[651.741,565.091],[651.741,661.763],[675.936,564.953],[675.936,661.109]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[651.741,664.629],[651.741,761.302],[675.936,663.96],[675.936,760.115]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[651.741,770.049],[675.936,768.817],[651.741,866.721],[675.936,864.972]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[720.82,455.044],[720.82,354.515],[675.936,458.707],[675.936,362.551]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[720.82,562.037],[720.82,461.508],[675.936,561.046],[675.936,464.89]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[720.82,566.122],[720.82,666.651],[675.936,564.953],[675.936,661.109]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[720.82,669.631],[720.82,770.16],[675.936,663.96],[675.936,760.116]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[720.82,779.257],[720.82,879.786],[675.936,768.817],[675.936,864.972]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[721.315,455.093],[721.315,354.623],[831.697,457.176],[831.697,359.193]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[721.315,562.023],[721.315,461.553],[831.697,561.46],[831.697,463.476]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[721.315,566.106],[721.315,666.576],[831.697,565.442],[831.697,663.425]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[721.315,669.555],[721.315,770.025],[831.697,666.33],[831.697,764.314]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[721.315,779.117],[721.315,879.587],[831.697,773.18],[831.697,871.164]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[856.358,444.082],[856.358,330.467],[799.286,448.735],[799.286,340.675]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[856.358,565.003],[856.358,451.387],[799.286,563.744],[799.286,455.683]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[856.358,569.62],[856.358,683.235],[799.286,568.135],[799.286,676.195]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[856.358,686.604],[856.358,800.219],[799.286,679.399],[799.286,787.46]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[856.358,810.5],[856.358,924.115],[799.286,797.238],[799.286,905.299]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[909.303,436.61],[909.303,314.074],[827.911,443.456],[827.911,329.094]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[909.303,567.024],[909.303,444.489],[827.911,565.172],[827.911,450.809]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[909.303,572.004],[909.303,694.54],[827.911,569.819],[827.911,684.182]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[909.303,698.173],[909.303,820.708],[827.911,687.573],[827.911,801.935]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[909.303,831.797],[909.303,954.332],[827.911,812.284],[827.911,926.646]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[909.303,436.61],[909.303,314.074],[938.186,437.304],[938.186,315.597]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[909.303,567.024],[909.303,444.489],[938.186,566.837],[938.186,445.129]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[909.303,572.004],[909.303,694.54],[938.186,571.783],[938.186,693.49]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[909.303,698.173],[909.303,820.708],[938.186,697.098],[938.186,818.806]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[909.303,831.797],[938.186,829.819],[909.303,954.332],[938.186,951.526]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1010.97,431.363],[1010.97,302.564],[938.186,437.304],[938.186,315.596]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1010.97,568.444],[1010.97,439.645],[938.186,566.837],[938.186,445.129]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1010.97,573.678],[1010.97,702.477],[938.186,571.783],[938.186,693.49]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1010.97,706.296],[1010.97,835.095],[938.186,697.098],[938.186,818.806]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1010.97,846.75],[1010.97,975.549],[938.186,829.819],[938.186,951.526]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[940.401,472.221],[940.401,395.072],[959.135,472.517],[959.135,395.708]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[940.401,557.466],[940.401,634.616],[959.135,557.386],[959.135,634.194]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[940.401,636.903],[940.401,714.052],[959.135,636.472],[959.135,713.28]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1092.54,420.556],[1092.54,283.943],[1014.02,427.197],[1014.02,298.227]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1092.54,565.953],[1092.54,429.34],[1014.02,564.459],[1014.02,435.489]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1092.54,571.505],[1092.54,708.118],[1014.02,569.7],[1014.02,698.67]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1092.54,712.168],[1092.54,848.781],[1014.02,702.494],[1014.02,831.463]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1092.54,861.143],[1092.54,997.756],[1014.02,843.134],[1014.02,972.104]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1179.89,409.169],[1179.89,259.451],[1060.16,419.616],[1060.16,281.921]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1179.89,568.514],[1179.89,418.796],[1060.16,566.164],[1060.16,428.47]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1179.89,574.599],[1179.89,724.317],[1060.16,571.76],[1060.16,709.455]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1179.89,728.756],[1179.89,878.475],[1060.16,713.538],[1060.16,851.232]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1179.89,892.023],[1179.89,1041.74],[1060.16,863.692],[1060.16,1001.39]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1103.32,463.544],[1103.32,376.409],[1122.96,463.909],[1122.96,377.193]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1103.32,559.824],[1103.32,646.96],[1122.96,559.725],[1122.96,646.441]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1103.32,649.543],[1103.32,736.679],[1122.96,649.012],[1122.96,735.728]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1116.44,459.595],[1116.44,367.913],[1160.12,460.451],[1160.12,369.754]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1116.44,560.897],[1116.44,652.579],[1160.12,560.664],[1160.12,651.361]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1116.44,655.297],[1116.44,746.978],[1160.12,654.05],[1160.12,744.746]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1179.89,409.169],[1179.89,259.451],[1212.9,410.242],[1212.9,261.759]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1179.89,568.514],[1179.89,418.796],[1212.9,568.273],[1212.9,419.79]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1179.89,574.599],[1179.89,724.317],[1212.9,574.307],[1212.9,722.791]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1179.89,728.756],[1179.89,878.475],[1212.9,727.193],[1212.9,875.677]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1179.89,892.023],[1212.9,889.113],[1179.89,1041.74],[1212.9,1037.6]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1322.63,400.952],[1322.63,241.776],[1212.9,410.242],[1212.9,261.759]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1322.63,570.363],[1322.63,411.187],[1212.9,568.273],[1212.9,419.79]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1322.63,576.832],[1322.63,736.007],[1212.9,574.307],[1212.9,722.791]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1322.63,740.727],[1322.63,899.903],[1212.9,727.193],[1212.9,875.677]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1322.63,914.307],[1322.63,1073.48],[1212.9,889.113],[1212.9,1037.6]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1322.63,400.952],[1322.63,241.776],[1592.43,410.622],[1592.43,262.575]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1322.63,570.363],[1322.63,411.187],[1592.43,568.188],[1592.43,420.141]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1322.63,576.832],[1322.63,736.007],[1592.43,574.204],[1592.43,722.251]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1322.63,740.727],[1322.63,899.903],[1592.43,726.64],[1592.43,874.687]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1322.63,914.307],[1322.63,1073.48],[1592.43,888.083],[1592.43,1036.13]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1433.82,445.852],[1433.82,338.354],[1456.06,446.407],[1456.06,339.547]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1433.82,564.631],[1433.82,672.129],[1456.06,564.48],[1456.06,671.341]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1433.82,675.317],[1433.82,782.815],[1456.06,674.509],[1456.06,781.369]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1433.82,792.542],[1433.82,900.041],[1456.06,791.039],[1456.06,897.899]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1666.35,413.271],[1666.35,268.274],[1891.63,421.345],[1891.63,285.64]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1666.35,567.592],[1666.35,422.594],[1891.63,565.775],[1891.63,430.071]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1666.35,573.484],[1666.35,718.482],[1891.63,571.29],[1891.63,706.995]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1666.35,722.781],[1666.35,867.778],[1891.63,711.019],[1891.63,846.723]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1666.35,880.899],[1666.35,1025.9],[1891.63,859.003],[1891.63,994.708]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1764.23,428.165],[1764.23,300.31],[1788.33,428.948],[1788.33,301.995]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1764.23,569.437],[1764.23,697.293],[1788.33,569.224],[1788.33,696.178]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1764.23,701.083],[1764.23,828.939],[1788.33,699.942],[1788.33,826.896]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:69,
                    verts:[[1764.23,840.508],[1764.23,968.364],[1788.33,838.384],[1788.33,965.338]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[462.347,470.419],[462.347,388.996],[426.24,472.732],[426.24,394.044]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[462.347,557.078],[462.347,475.655],[426.24,556.479],[426.24,477.791]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[462.347,560.387],[462.347,641.81],[426.24,559.677],[426.24,638.365]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[462.347,644.225],[462.347,725.648],[426.24,640.698],[426.24,719.386]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[462.347,733.016],[462.347,814.439],[426.24,726.506],[426.24,805.194]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[491.32,466.789],[491.32,381.071],[441.591,470.054],[441.591,388.198]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[491.32,558.018],[491.32,472.301],[441.591,557.173],[441.591,475.317]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[491.32,561.502],[491.32,647.219],[441.591,560.499],[441.591,642.355]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[491.32,649.761],[491.32,735.479],[441.591,644.782],[441.591,726.638]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[491.32,743.235],[491.32,828.953],[441.591,734.045],[441.591,815.901]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[491.32,466.789],[491.32,381.071],[513.529,467.204],[513.529,381.977]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[491.32,558.018],[491.32,472.301],[513.529,557.911],[513.529,472.684]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[491.32,561.502],[491.32,647.219],[513.529,561.374],[513.529,646.601]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[491.32,649.761],[491.32,735.479],[513.529,649.128],[513.529,734.355]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[491.32,743.235],[491.32,828.953],[513.529,742.068],[513.529,827.295]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[555.842,464.496],[555.842,376.066],[513.529,467.204],[513.529,381.977]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[555.842,558.612],[555.842,470.182],[513.529,557.911],[513.529,472.684]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[555.842,562.206],[555.842,650.635],[513.529,561.374],[513.529,646.601]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[555.842,653.257],[555.842,741.687],[513.529,649.128],[513.529,734.355]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[555.842,749.689],[555.842,838.119],[513.529,742.068],[513.529,827.295]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[600.856,462.329],[600.856,370.497],[555.465,465.207],[555.465,376.811]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[600.856,560.065],[600.856,468.234],[555.465,559.287],[555.465,470.891]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[600.856,563.797],[600.856,655.629],[555.465,562.879],[555.465,651.275]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[600.856,658.352],[600.856,750.183],[555.465,653.896],[555.465,742.292]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[600.856,758.493],[600.856,850.325],[555.465,750.291],[555.465,838.687]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[641.217,457.704],[641.217,360.351],[577.458,461.852],[577.458,369.45]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[641.217,561.317],[641.217,463.964],[577.458,560.195],[577.458,467.793]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[641.217,565.273],[641.217,662.626],[577.458,563.95],[577.458,656.351]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[641.217,665.512],[641.217,762.865],[577.458,659.091],[577.458,751.492]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[641.217,771.675],[641.217,869.028],[577.458,759.854],[577.458,852.255]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[641.217,457.704],[641.217,360.352],[664.625,458.216],[664.625,361.474]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[641.217,561.317],[641.217,463.964],[664.625,561.178],[664.625,464.436]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[641.217,565.273],[641.217,662.626],[664.625,565.11],[664.625,661.852]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[641.217,665.512],[641.217,762.865],[664.625,664.72],[664.625,761.462]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[641.217,771.675],[664.625,770.216],[641.217,869.027],[664.625,866.958]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[719.645,454.725],[719.645,353.815],[664.626,458.216],[664.626,361.474]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[719.645,562.123],[719.645,461.213],[664.626,561.178],[664.626,464.436]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[719.645,566.224],[719.645,667.134],[664.626,565.11],[664.626,661.852]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[719.645,670.126],[719.645,771.035],[664.626,664.72],[664.626,761.462]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[719.645,780.167],[719.645,881.077],[664.626,770.216],[664.626,866.958]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[720.015,454.775],[720.015,353.926],[825.492,457.216],[825.492,359.279]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[720.015,562.109],[720.015,461.26],[825.492,561.449],[825.492,463.513]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[720.015,566.208],[720.015,667.057],[825.492,565.429],[825.492,663.365]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[720.015,670.047],[720.015,770.897],[825.492,666.269],[825.492,764.205]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[720.015,780.022],[720.015,880.872],[825.492,773.068],[825.492,871.004]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[884.012,444.377],[884.012,331.114],[814.98,448.754],[814.98,340.715]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[884.012,564.923],[884.012,451.66],[814.98,563.739],[814.98,455.7]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[884.012,569.526],[884.012,682.789],[814.98,568.129],[814.98,676.167]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[884.012,686.147],[884.012,799.411],[814.98,679.371],[814.98,787.409]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[884.012,809.66],[884.012,922.923],[814.98,797.186],[814.98,905.224]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[955.796,437.241],[955.796,315.46],[857.281,443.65],[857.281,329.518]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[955.796,566.854],[955.796,445.072],[857.281,565.12],[857.281,450.988]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[955.796,571.802],[955.796,693.584],[857.281,569.758],[857.281,683.889]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[955.796,697.195],[955.796,818.977],[857.281,687.273],[857.281,801.405]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[955.796,829.997],[955.796,951.778],[857.281,811.732],[857.281,925.864]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[888.791,472.405],[888.791,395.468],[906.693,472.749],[906.693,396.207]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[888.791,557.416],[888.791,634.354],[906.693,557.323],[906.693,633.865]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[888.791,636.635],[888.791,713.572],[906.693,636.134],[906.693,712.676]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[955.796,437.241],[955.796,315.46],[982.568,438.041],[982.568,317.214]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[955.796,566.854],[955.796,445.072],[982.568,566.637],[982.568,445.81]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[955.796,571.802],[955.796,693.584],[982.568,571.547],[982.568,692.375]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[955.796,697.195],[955.796,818.977],[982.568,695.957],[982.568,816.784]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[955.796,829.997],[982.568,827.718],[955.796,951.778],[982.568,948.545]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1069.32,432.536],[1069.32,305.136],[982.568,438.041],[982.568,317.214]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1069.32,568.127],[1069.32,440.727],[982.568,566.637],[982.568,445.81]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1069.32,573.304],[1069.32,700.703],[982.568,571.547],[982.568,692.375]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1069.32,704.481],[1069.32,831.88],[982.568,695.957],[982.568,816.784]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1069.32,843.409],[1069.32,970.808],[982.568,827.718],[982.568,948.545]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1071.21,464.326],[1071.21,378.09],[1089.57,464.743],[1089.57,378.987]]
                },{
                    num:"404",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1071.21,556.107],[1071.21,469.871],[1089.57,556.013],[1089.57,470.257]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1071.21,559.611],[1071.21,645.847],[1089.57,559.498],[1089.57,645.254]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1071.21,648.404],[1071.21,734.64],[1089.57,647.797],[1089.57,733.553]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1071.21,742.443],[1071.21,828.679],[1089.57,741.313],[1089.57,827.069]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1165.52,422.324],[1165.52,287.746],[1072.67,428.43],[1072.67,300.88]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1165.52,565.555],[1165.52,430.977],[1072.67,564.182],[1072.67,436.631]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1165.52,571.024],[1165.52,705.602],[1072.67,569.365],[1072.67,696.915]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1165.52,709.592],[1165.52,844.17],[1072.67,700.697],[1072.67,828.247]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1165.52,856.348],[1165.52,990.926],[1072.67,839.79],[1072.67,967.34]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1093.74,460.496],[1093.74,369.851],[1134.33,461.471],[1134.33,371.949]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1093.74,560.652],[1093.74,651.297],[1134.33,560.387],[1134.33,649.909]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1093.74,653.984],[1093.74,744.629],[1134.33,652.563],[1134.33,742.085]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1093.74,752.831],[1093.74,843.476],[1134.33,750.186],[1134.33,839.708]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1277.55,411.725],[1277.55,264.949],[1136.28,421.258],[1136.28,285.453]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1277.55,567.94],[1277.55,421.163],[1136.28,565.795],[1136.28,429.99]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1277.55,573.904],[1277.55,720.681],[1136.28,571.314],[1136.28,707.119]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1277.55,725.033],[1277.55,871.81],[1136.28,711.146],[1136.28,846.951]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1277.55,885.091],[1277.55,1031.87],[1136.28,859.24],[1136.28,995.045]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1277.55,411.725],[1277.55,264.949],[1306.73,412.928],[1306.73,267.535]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1277.55,567.94],[1277.55,421.163],[1306.73,567.669],[1306.73,422.276]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1277.55,573.904],[1277.55,720.681],[1306.73,573.577],[1306.73,718.97]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1277.55,725.033],[1277.55,871.81],[1306.73,723.281],[1306.73,868.673]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1277.55,885.091],[1277.55,1031.87],[1306.73,881.83],[1306.73,1027.22]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.74,404.567],[1433.74,249.553],[1306.73,412.928],[1306.73,267.535]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.74,569.55],[1433.74,414.535],[1306.73,567.669],[1306.73,422.276]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.74,575.849],[1433.74,730.864],[1306.73,573.577],[1306.73,718.97]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.74,735.46],[1433.74,890.475],[1306.73,723.281],[1306.73,868.673]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.74,904.502],[1433.74,1059.52],[1306.73,881.83],[1306.73,1027.22]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.1,448.221],[1433.1,343.449],[1452.94,448.836],[1452.94,344.771]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.1,563.987],[1433.1,668.759],[1452.94,563.821],[1452.94,667.885]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.1,671.866],[1433.1,776.638],[1452.94,670.971],[1452.94,775.035]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.74,404.567],[1433.74,249.553],[1665.11,415.175],[1665.11,272.368]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.74,569.55],[1433.74,414.535],[1665.11,567.164],[1665.11,424.357]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.74,575.849],[1433.74,730.864],[1665.11,572.967],[1665.11,715.774]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.74,735.46],[1433.74,890.475],[1665.11,720.008],[1665.11,862.815]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.74,904.502],[1433.74,1059.52],[1665.11,875.737],[1665.11,1018.54]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1433.1,786.118],[1433.1,890.89],[1452.94,784.452],[1452.94,888.517]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1727.74,418.045],[1727.74,278.543],[1916.6,426.704],[1916.6,297.167]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1727.74,566.518],[1727.74,427.015],[1916.6,564.57],[1916.6,435.033]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1727.74,572.187],[1727.74,711.689],[1916.6,569.834],[1916.6,699.371]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1727.74,715.826],[1727.74,855.328],[1916.6,703.212],[1916.6,832.749]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1727.74,867.952],[1727.74,1007.45],[1916.6,844.47],[1916.6,974.007]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1784.07,432.602],[1784.07,309.854],[1804.51,433.445],[1804.51,311.666]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1784.07,568.232],[1784.07,690.98],[1804.51,568.003],[1804.51,689.781]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1784.07,694.619],[1784.07,817.367],[1804.51,693.392],[1804.51,815.171]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:70,
                    verts:[[1784.07,828.475],[1784.07,951.223],[1804.51,826.19],[1804.51,947.969]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[415.24,469.36],[415.24,386.683],[371.727,471.587],[371.727,391.544]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[415.24,557.353],[415.24,474.676],[371.727,556.776],[371.727,476.733]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[415.24,560.712],[415.24,643.389],[371.727,560.029],[371.727,640.071]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[415.24,645.841],[415.24,728.517],[371.727,642.444],[371.727,722.487]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[415.24,735.999],[415.24,818.676],[371.727,729.73],[371.727,809.772]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[454.731,465.796],[454.731,378.905],[394.747,468.932],[394.747,385.75]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[454.731,558.275],[454.731,471.384],[394.747,557.463],[394.747,474.281]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[454.731,561.806],[454.731,648.698],[394.747,560.844],[394.747,644.026]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[454.731,651.275],[454.731,738.166],[394.747,646.492],[394.747,729.674]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[454.731,746.029],[454.731,832.921],[394.747,737.202],[394.747,820.384]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[454.731,465.796],[454.731,378.905],[476.49,466.279],[476.49,379.958]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[454.731,558.275],[454.731,471.384],[476.49,558.15],[476.49,471.829]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[454.731,561.806],[454.731,648.698],[476.49,561.658],[476.49,647.979]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[454.731,651.275],[454.731,738.166],[476.49,650.539],[476.49,736.86]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[454.731,746.029],[454.731,832.921],[476.49,744.671],[476.49,830.992]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[527.022,463.694],[527.022,374.316],[476.489,466.279],[476.489,379.958]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[527.022,558.82],[527.022,469.441],[476.489,558.15],[476.489,471.829]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[527.022,562.452],[527.022,651.83],[476.489,561.658],[476.489,647.979]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[527.022,654.48],[527.022,743.858],[476.489,650.539],[476.489,736.86]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[527.022,751.946],[527.022,841.325],[476.489,744.671],[476.489,830.992]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[580.537,461.676],[580.537,369.065],[526.561,464.411],[526.561,375.066]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[580.537,560.242],[580.537,467.631],[526.561,559.502],[526.561,470.156]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[580.537,564.006],[580.537,656.617],[526.561,563.133],[526.561,652.479]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[580.537,659.363],[580.537,751.974],[526.561,655.128],[526.561,744.474]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[580.537,760.354],[580.537,852.966],[526.561,752.559],[526.561,841.904]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[633.748,457.198],[633.748,359.24],[557.921,461.126],[557.921,367.857]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[633.748,561.454],[633.748,463.496],[557.921,560.391],[557.921,467.123]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[633.748,565.435],[633.748,663.392],[557.921,564.181],[557.921,657.45]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[633.748,666.297],[633.748,764.254],[557.921,660.215],[557.921,753.484]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[633.748,773.118],[633.748,871.076],[557.921,761.923],[557.921,855.192]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[633.747,457.198],[633.747,359.24],[656.146,457.784],[656.146,360.527]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[633.747,561.454],[633.747,463.496],[656.146,561.295],[656.146,464.038]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[633.747,565.435],[633.747,663.392],[656.146,565.248],[656.146,662.505]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[633.747,666.296],[633.747,764.254],[656.146,665.388],[656.146,762.646]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[633.747,773.118],[633.747,871.076],[656.146,771.447],[656.146,868.704]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[720.851,454.503],[720.851,353.328],[656.146,457.784],[656.146,360.527]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[720.851,562.183],[720.851,461.008],[656.146,561.295],[656.146,464.038]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[720.851,566.294],[720.851,667.469],[656.146,565.248],[656.146,662.505]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[720.851,670.469],[720.851,771.644],[656.146,665.388],[656.146,762.646]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[720.851,780.799],[720.851,881.973],[656.146,771.447],[656.146,868.704]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[721.093,454.554],[721.093,353.441],[820.663,457.323],[820.663,359.514]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[721.093,562.169],[721.093,461.056],[820.663,561.42],[820.663,463.612]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[721.093,566.278],[721.093,667.391],[820.663,565.395],[820.663,663.203]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[721.093,670.389],[721.093,771.502],[820.663,666.104],[820.663,763.912]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[721.093,780.652],[721.093,881.765],[820.663,772.763],[820.663,870.572]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[911.887,444.885],[911.887,332.229],[831.947,448.936],[831.947,341.116]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[911.887,564.785],[911.887,452.129],[831.947,563.689],[831.947,455.869]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[911.887,569.363],[911.887,682.02],[831.947,568.071],[831.947,675.891]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[911.887,685.36],[911.887,798.017],[831.947,679.088],[831.947,786.909]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[911.887,808.211],[911.887,920.868],[831.947,796.665],[831.947,904.486]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[838.632,472.504],[838.632,395.681],[855.653,472.892],[855.653,396.515]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[838.632,557.389],[838.632,634.212],[855.653,557.284],[855.653,633.661]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[838.632,636.49],[838.632,713.313],[855.653,635.925],[855.653,712.302]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[838.632,720.265],[838.632,797.088],[855.653,719.213],[855.653,795.59]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1000.99,438.175],[1000.99,317.507],[887.197,444.069],[887.197,330.439]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1000.99,566.601],[1000.99,445.933],[887.197,565.006],[887.197,451.376]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1000.99,571.505],[1000.99,692.172],[887.197,569.624],[887.197,683.254]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1000.99,695.75],[1000.99,816.418],[887.197,686.623],[887.197,800.254]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1000.99,827.337],[1000.99,948.005],[887.197,810.536],[887.197,924.167]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1000.99,438.175],[1000.99,317.507],[1025.31,439.063],[1025.31,319.456]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1000.99,566.601],[1000.99,445.933],[1025.31,566.361],[1025.31,446.754]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1000.99,571.505],[1000.99,692.172],[1025.31,571.221],[1025.31,690.828]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1000.99,695.75],[1000.99,816.418],[1025.31,694.375],[1025.31,813.982]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1000.99,827.337],[1000.99,948.005],[1025.31,824.805],[1025.31,944.412]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1124.09,434.054],[1124.09,308.467],[1025.31,439.063],[1025.31,319.456]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1124.09,567.716],[1124.09,442.129],[1025.31,566.361],[1025.31,446.754]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1124.09,572.82],[1124.09,698.407],[1025.31,571.221],[1025.31,690.828]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1124.09,702.13],[1124.09,827.717],[1025.31,694.375],[1025.31,813.982]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1124.09,839.081],[1124.09,964.668],[1025.31,824.805],[1025.31,944.412]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1039.24,465.059],[1039.24,379.666],[1056.26,465.521],[1056.26,380.661]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1039.24,559.412],[1039.24,644.805],[1056.26,559.287],[1056.26,644.147]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1039.24,647.337],[1039.24,732.73],[1056.26,646.663],[1056.26,731.524]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1039.24,740.458],[1039.24,825.851],[1056.26,739.203],[1056.26,824.063]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1070.66,461.374],[1070.66,371.74],[1108.02,462.453],[1108.02,374.06]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1070.66,560.414],[1070.66,650.048],[1108.02,560.12],[1108.02,648.513]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1070.66,652.705],[1070.66,742.339],[1108.02,651.134],[1108.02,739.526]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1070.66,750.45],[1070.66,840.084],[1108.02,747.525],[1108.02,835.917]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1232.42,424.517],[1232.42,292.462],[1127.67,430.023],[1127.67,304.306]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1232.42,565.062],[1232.42,433.008],[1127.67,563.823],[1127.67,438.106]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1232.42,570.428],[1232.42,702.483],[1127.67,568.932],[1127.67,694.649]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1232.42,706.398],[1232.42,838.453],[1127.67,698.377],[1127.67,824.094]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1232.42,850.402],[1232.42,982.457],[1127.67,835.47],[1127.67,961.187]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1365.22,414.834],[1365.22,271.636],[1206.69,423.352],[1206.69,289.958]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1365.22,567.24],[1365.22,424.042],[1206.69,565.324],[1206.69,431.929]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1365.22,573.059],[1365.22,716.258],[1206.69,570.745],[1206.69,704.139]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1365.22,720.503],[1365.22,863.702],[1206.69,708.095],[1206.69,841.489]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1365.22,876.66],[1365.22,1019.86],[1206.69,853.56],[1206.69,986.955]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1365.22,414.834],[1365.22,271.636],[1390.24,416.13],[1390.24,274.423]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1365.22,567.24],[1365.22,424.042],[1390.24,566.949],[1390.24,425.242]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1365.22,573.059],[1365.22,716.258],[1390.24,572.707],[1390.24,714.414]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1365.22,720.503],[1365.22,863.702],[1390.24,718.616],[1390.24,860.323]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1365.22,876.66],[1365.22,1019.86],[1390.24,873.146],[1390.24,1014.85]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1530.17,408.769],[1530.17,258.59],[1390.23,416.13],[1390.23,274.423]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1530.17,568.604],[1530.17,418.425],[1390.23,566.949],[1390.23,425.242]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1530.17,574.707],[1530.17,724.887],[1390.23,572.707],[1390.23,714.414]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1530.17,729.339],[1530.17,879.518],[1390.23,718.616],[1390.23,860.323]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1530.17,893.108],[1530.17,1043.29],[1390.23,873.146],[1390.23,1014.85]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1427.69,450.573],[1427.69,348.507],[1445.11,451.233],[1445.11,349.927]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1427.69,563.349],[1427.69,665.414],[1445.11,563.169],[1445.11,664.475]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1427.69,668.44],[1427.69,770.506],[1445.11,667.479],[1445.11,768.784]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1427.69,779.742],[1427.69,881.808],[1445.11,777.952],[1445.11,879.257]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1530.17,408.769],[1530.17,258.59],[1722.11,419.962],[1722.11,282.665]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1530.17,568.604],[1530.17,418.425],[1722.11,566.087],[1722.11,428.79]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1530.17,574.707],[1530.17,724.887],[1722.11,571.666],[1722.11,708.963]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1530.17,729.339],[1530.17,879.518],[1722.11,713.034],[1722.11,850.331]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1530.17,893.108],[1530.17,1043.29],[1722.11,862.755],[1722.11,1000.05]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1773.56,422.962],[1773.56,289.118],[1927.45,431.936],[1927.45,308.421]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1773.56,565.412],[1773.56,431.568],[1927.45,563.393],[1927.45,439.878]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1773.56,570.851],[1773.56,704.695],[1927.45,568.413],[1927.45,691.928]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1773.56,708.663],[1773.56,842.507],[1927.45,695.59],[1927.45,819.105]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1773.56,854.619],[1773.56,988.463],[1927.45,830.282],[1927.45,953.798]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1792.58,436.965],[1792.58,319.239],[1809.52,437.843],[1809.52,321.126]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1792.58,567.046],[1792.58,684.773],[1809.52,566.808],[1809.52,683.524]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1792.58,688.263],[1792.58,805.99],[1809.52,686.985],[1809.52,803.702]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:71,
                    verts:[[1792.58,816.643],[1792.58,934.369],[1809.52,814.264],[1809.52,930.98]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[371.649,468.229],[371.649,384.215],[320.6,470.349],[320.6,388.843]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[371.649,557.645],[371.649,473.631],[320.6,557.096],[320.6,475.59]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[371.649,561.06],[371.649,645.074],[320.6,560.408],[320.6,641.914]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[371.649,647.565],[371.649,731.579],[320.6,644.331],[320.6,725.837]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[371.649,739.182],[371.649,823.196],[320.6,733.213],[320.6,814.719]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[421.852,464.765],[421.852,376.652],[351.541,467.74],[351.541,383.148]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[421.852,558.543],[421.852,470.43],[351.541,557.772],[351.541,473.179]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[421.852,562.123],[421.852,650.236],[351.541,561.21],[351.541,645.802]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[421.852,652.848],[421.852,740.961],[351.541,648.31],[351.541,732.903]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[421.852,748.934],[421.852,837.046],[351.541,740.557],[351.541,825.15]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[421.852,464.765],[421.852,376.652],[443.007,465.313],[443.007,377.85]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[421.852,558.543],[421.852,470.43],[443.007,558.4],[443.007,470.937]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[421.852,562.123],[421.852,650.236],[443.007,561.955],[443.007,649.418]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[421.852,652.848],[421.852,740.961],[443.007,652.011],[443.007,739.475]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[421.852,748.934],[421.852,837.046],[443.007,747.389],[443.007,834.852]]
                },{
                    num:"502",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[501.68,462.878],[501.68,372.533],[443.007,465.313],[443.007,377.85]]
                },{
                    num:"402",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[501.68,559.031],[501.68,468.687],[443.007,558.4],[443.007,470.937]]
                },{
                    num:"302",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[501.68,562.703],[501.68,653.047],[443.007,561.955],[443.007,649.418]]
                },{
                    num:"202",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[501.68,655.726],[501.68,746.07],[443.007,652.011],[443.007,739.475]]
                },{
                    num:"102",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[501.68,754.245],[501.68,844.59],[443.007,747.389],[443.007,834.852]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[563.501,461.036],[563.501,367.66],[501.136,463.601],[501.136,373.287]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[563.501,560.415],[563.501,467.04],[501.136,559.721],[501.136,469.408]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[563.501,564.21],[563.501,657.586],[501.136,563.392],[501.136,653.705]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[563.501,660.354],[563.501,753.73],[501.136,656.383],[501.136,746.696]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[563.501,762.18],[563.501,855.556],[501.136,754.869],[501.136,845.183]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[629.307,456.749],[629.307,358.255],[541.86,460.416],[541.86,366.3]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[629.307,561.575],[629.307,463.082],[541.86,560.583],[541.86,466.467]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[629.307,565.578],[629.307,664.072],[541.86,564.408],[541.86,658.524]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[629.307,666.992],[629.307,765.485],[541.86,661.314],[541.86,755.43]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[629.307,774.398],[629.307,872.892],[541.86,763.947],[541.86,858.063]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[629.306,456.749],[629.306,358.255],[650.485,457.405],[650.485,359.694]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[629.306,561.575],[629.306,463.082],[650.485,561.398],[650.485,463.687]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[629.306,565.578],[629.306,664.072],[650.485,565.369],[650.485,663.079]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[629.306,666.992],[629.306,765.485],[650.485,665.976],[650.485,763.687]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[629.306,774.398],[629.306,872.892],[650.485,772.529],[650.485,870.24]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[724.306,454.366],[724.306,353.029],[650.485,457.405],[650.485,359.694]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[724.306,562.22],[724.306,460.882],[650.485,561.398],[650.485,463.687]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[724.306,566.338],[724.306,667.676],[650.485,565.369],[650.485,663.079]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[724.306,670.68],[724.306,772.018],[650.485,665.976],[650.485,763.687]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[724.306,781.188],[724.306,882.526],[650.485,772.529],[650.485,870.24]]
                },{
                    num:"501",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[724.417,454.418],[724.417,353.142],[817.19,457.481],[817.19,359.862]]
                },{
                    num:"401",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[724.417,562.206],[724.417,460.93],[817.19,561.377],[817.19,463.758]]
                },{
                    num:"301",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[724.417,566.322],[724.417,667.598],[817.19,565.344],[817.19,662.963]]
                },{
                    num:"201",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[724.417,670.6],[724.417,771.876],[817.19,665.857],[817.19,763.476]]
                },{
                    num:"101",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[724.417,781.041],[724.417,882.317],[817.19,772.31],[817.19,869.929]]
                },{
                    num:"503",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[790.181,472.515],[790.181,395.703],[806.272,472.944],[806.272,396.626]]
                },{
                    num:"303",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[790.181,557.386],[790.181,634.198],[806.272,557.27],[806.272,633.587]]
                },{
                    num:"203",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[790.181,636.475],[790.181,713.286],[806.272,635.85],[806.272,712.168]]
                },{
                    num:"103",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[790.181,720.237],[790.181,797.048],[806.272,719.074],[806.272,795.391]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[939.491,445.571],[939.491,333.734],[849.845,449.258],[849.845,341.823]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[939.491,564.6],[939.491,452.762],[849.845,563.602],[849.845,456.166]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[939.491,569.144],[939.491,680.982],[849.845,567.968],[849.845,675.404]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[939.491,684.298],[939.491,796.135],[849.845,678.589],[849.845,786.025]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[939.491,806.255],[939.491,918.093],[849.845,795.746],[849.845,903.182]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1044.12,439.354],[1044.12,320.095],[917.105,444.681],[917.105,331.78]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1044.12,566.282],[1044.12,447.023],[917.105,564.841],[917.105,451.94]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1044.12,571.128],[1044.12,690.388],[917.105,569.429],[917.105,682.33]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1044.12,693.923],[1044.12,813.183],[917.105,685.677],[917.105,798.578]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1044.12,823.975],[1044.12,943.234],[917.105,808.794],[917.105,921.695]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1007.71,465.729],[1007.71,381.108],[1023.34,466.232],[1023.34,382.189]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1007.71,559.23],[1007.71,643.851],[1023.34,559.094],[1023.34,643.136]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1007.71,646.36],[1007.71,730.981],[1023.34,645.628],[1023.34,729.67]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1007.71,738.639],[1007.71,823.26],[1023.34,737.275],[1023.34,821.318]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1044.12,439.354],[1044.12,320.095],[1065.74,440.314],[1065.74,322.201]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1044.12,566.282],[1044.12,447.023],[1065.74,566.022],[1065.74,447.909]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1044.12,571.128],[1044.12,690.388],[1065.74,570.822],[1065.74,688.935]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1044.12,693.923],[1044.12,813.183],[1065.74,692.437],[1065.74,810.551]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1044.12,823.975],[1044.12,943.234],[1065.74,821.239],[1065.74,939.352]]
                },{
                    num:"504",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1047.5,462.211],[1047.5,373.541],[1081.53,463.379],[1081.53,376.052]]
                },{
                    num:"304",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1047.5,560.186],[1047.5,648.856],[1081.53,559.869],[1081.53,647.195]]
                },{
                    num:"204",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1047.5,651.485],[1047.5,740.155],[1081.53,649.785],[1081.53,737.111]]
                },{
                    num:"104",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1047.5,748.179],[1047.5,836.849],[1081.53,745.013],[1081.53,832.34]]
                },{
                    num:"508",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1174.45,435.84],[1174.45,312.385],[1065.74,440.314],[1065.74,322.201]]
                },{
                    num:"408",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1174.45,567.233],[1174.45,443.778],[1065.74,566.022],[1065.74,447.909]]
                },{
                    num:"308",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1174.45,572.25],[1174.45,695.704],[1065.74,570.822],[1065.74,688.935]]
                },{
                    num:"208",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1174.45,699.365],[1174.45,822.819],[1065.74,692.437],[1065.74,810.551]]
                },{
                    num:"108",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1174.45,833.991],[1174.45,957.446],[1065.74,821.239],[1065.74,939.352]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1292.36,427.023],[1292.36,297.853],[1178.19,431.894],[1178.19,308.331]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1292.36,564.498],[1292.36,435.329],[1178.19,563.402],[1178.19,439.839]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1292.36,569.747],[1292.36,698.917],[1178.19,568.424],[1178.19,691.987]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1292.36,702.747],[1292.36,831.917],[1178.19,695.651],[1178.19,819.214]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1292.36,843.605],[1292.36,972.775],[1178.19,830.396],[1178.19,953.959]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1441.79,418.331],[1441.79,279.158],[1270.35,425.789],[1270.35,295.198]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1441.79,566.453],[1441.79,427.28],[1270.35,564.776],[1270.35,434.186]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1441.79,572.109],[1441.79,711.282],[1270.35,570.083],[1270.35,700.673]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1441.79,715.409],[1441.79,854.582],[1270.35,704.545],[1270.35,835.136]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1441.79,867.176],[1441.79,1006.35],[1270.35,846.953],[1270.35,977.543]]
                },{
                    num:"505",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1418.28,452.862],[1418.28,353.43],[1433.33,453.555],[1433.33,354.922]]
                },{
                    num:"305",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1418.28,562.727],[1418.28,662.158],[1433.33,562.538],[1433.33,661.171]]
                },{
                    num:"205",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1418.28,665.106],[1418.28,764.537],[1433.33,664.096],[1433.33,762.729]]
                },{
                    num:"105",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1418.28,773.534],[1418.28,872.965],[1433.33,771.654],[1433.33,870.288]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1441.79,418.332],[1441.79,279.158],[1462.53,419.685],[1462.53,282.07]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1441.79,566.453],[1441.79,427.28],[1462.53,566.149],[1462.53,428.534]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1441.79,572.109],[1441.79,711.282],[1462.53,571.741],[1462.53,709.356]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1441.79,715.409],[1441.79,854.582],[1462.53,713.437],[1462.53,851.052]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1441.79,867.176],[1441.79,1006.35],[1462.53,863.505],[1462.53,1001.12]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1611.2,413.338],[1611.2,268.418],[1462.52,419.685],[1462.52,282.07]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1611.2,567.577],[1611.2,422.656],[1462.52,566.149],[1462.52,428.534]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1611.2,573.466],[1611.2,718.386],[1462.52,571.741],[1462.52,709.356]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1611.2,722.683],[1611.2,867.604],[1462.52,713.437],[1462.52,851.052]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1611.2,880.718],[1611.2,1025.64],[1462.52,863.505],[1462.52,1001.12]]
                },{
                    num:"507",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1611.2,413.338],[1611.2,268.418],[1764.47,424.809],[1764.47,293.091]]
                },{
                    num:"407",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1611.2,567.577],[1611.2,422.656],[1764.47,564.996],[1764.47,433.278]]
                },{
                    num:"307",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1611.2,573.466],[1611.2,718.386],[1764.47,570.349],[1764.47,702.067]]
                },{
                    num:"207",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1611.2,722.683],[1611.2,867.604],[1764.47,705.972],[1764.47,837.69]]
                },{
                    num:"107",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1611.2,880.718],[1611.2,1025.64],[1764.47,849.609],[1764.47,981.327]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1791.48,441.165],[1791.48,328.272],[1805.15,442.058],[1805.15,330.192]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1791.48,561.317],[1791.48,448.424],[1805.15,561.116],[1805.15,449.251]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1791.48,565.905],[1791.48,678.798],[1805.15,565.662],[1805.15,677.528]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1791.48,682.145],[1791.48,795.038],[1805.15,680.845],[1805.15,792.71]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1791.48,805.254],[1791.48,918.147],[1805.15,802.833],[1805.15,914.698]]
                },{
                    num:"506",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1805.25,427.861],[1805.25,299.656],[1926.48,436.934],[1926.48,319.171]]
                },{
                    num:"406",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1805.25,564.31],[1805.25,436.105],[1926.48,562.269],[1926.48,444.506]]
                },{
                    num:"306",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1805.25,569.52],[1805.25,697.725],[1926.48,567.054],[1926.48,684.817]]
                },{
                    num:"206",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1805.25,701.526],[1805.25,829.731],[1926.48,688.309],[1926.48,806.072]]
                },{
                    num:"106",
                    tipo:"TorreG",
                    frame:72,
                    verts:[[1805.25,841.333],[1805.25,969.538],[1926.48,816.728],[1926.48,934.491]]
                },
                ],
                [
                
                ]
        ]
    }
}